import { api } from "../createApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiMetaCompat: build.query<
      GetApiMetaCompatApiResponse,
      GetApiMetaCompatApiArg
    >({
      query: () => ({ url: `/api/meta/compat` }),
    }),
    postApiV1AccountsAddReason: build.mutation<
      PostApiV1AccountsAddReasonApiResponse,
      PostApiV1AccountsAddReasonApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/add-reason`,
        method: "POST",
        body: queryArg.signupReasonParams,
      }),
    }),
    postApiV1AccountsAuthenticateEmail: build.mutation<
      PostApiV1AccountsAuthenticateEmailApiResponse,
      PostApiV1AccountsAuthenticateEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/authenticate/email`,
        method: "POST",
        body: queryArg.authRequest,
      }),
    }),
    postApiV1AccountsAuthenticatePhone: build.mutation<
      PostApiV1AccountsAuthenticatePhoneApiResponse,
      PostApiV1AccountsAuthenticatePhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/authenticate/phone`,
        method: "POST",
        body: queryArg.authPhoneRequest,
      }),
    }),
    putApiV1AccountsChangeName: build.mutation<
      PutApiV1AccountsChangeNameApiResponse,
      PutApiV1AccountsChangeNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/change/name`,
        method: "PUT",
        params: {
          id: queryArg.id,
          name: queryArg.name,
          username: queryArg.username,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1AccountsCheckCaptcha: build.mutation<
      PostApiV1AccountsCheckCaptchaApiResponse,
      PostApiV1AccountsCheckCaptchaApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/check-captcha`,
        method: "POST",
        body: queryArg.captchaVerificationParams,
      }),
    }),
    postApiV1AccountsConfirmEmail: build.mutation<
      PostApiV1AccountsConfirmEmailApiResponse,
      PostApiV1AccountsConfirmEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/confirm-email`,
        method: "POST",
        body: queryArg.codeVerificationParams,
      }),
    }),
    postApiV1AccountsConfirmPhone: build.mutation<
      PostApiV1AccountsConfirmPhoneApiResponse,
      PostApiV1AccountsConfirmPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/confirm-phone`,
        method: "POST",
        body: queryArg.codeVerificationParams,
      }),
    }),
    deleteApiV1AccountsDelete: build.mutation<
      DeleteApiV1AccountsDeleteApiResponse,
      DeleteApiV1AccountsDeleteApiArg
    >({
      query: () => ({ url: `/api/v1/accounts/delete`, method: "DELETE" }),
    }),
    postApiV1AccountsEmailChangeConfirm: build.mutation<
      PostApiV1AccountsEmailChangeConfirmApiResponse,
      PostApiV1AccountsEmailChangeConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/email/change/confirm`,
        method: "POST",
        body: queryArg.confirmationCodeRequest,
      }),
    }),
    postApiV1AccountsEmailChangeRequest: build.mutation<
      PostApiV1AccountsEmailChangeRequestApiResponse,
      PostApiV1AccountsEmailChangeRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/email/change/request`,
        method: "POST",
        body: queryArg.emailChangeRequest,
      }),
    }),
    putApiV1AccountsEmailChangeResendCode: build.mutation<
      PutApiV1AccountsEmailChangeResendCodeApiResponse,
      PutApiV1AccountsEmailChangeResendCodeApiArg
    >({
      query: () => ({
        url: `/api/v1/accounts/email/change/resend-code`,
        method: "PUT",
      }),
    }),
    postApiV1AccountsFinishCreating: build.mutation<
      PostApiV1AccountsFinishCreatingApiResponse,
      PostApiV1AccountsFinishCreatingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/finish-creating`,
        method: "POST",
        body: queryArg.finishCreatingAccountParams,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1AccountsGetTokenByHash: build.mutation<
      PutApiV1AccountsGetTokenByHashApiResponse,
      PutApiV1AccountsGetTokenByHashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/get-token/${queryArg.hash}`,
        method: "PUT",
      }),
    }),
    postApiV1AccountsLoginsAddEmailPassword: build.mutation<
      PostApiV1AccountsLoginsAddEmailPasswordApiResponse,
      PostApiV1AccountsLoginsAddEmailPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/logins/add-email-password`,
        method: "POST",
        body: queryArg.addEmailRequest,
      }),
    }),
    postApiV1AccountsLoginsAddEmailPasswordConfirm: build.mutation<
      PostApiV1AccountsLoginsAddEmailPasswordConfirmApiResponse,
      PostApiV1AccountsLoginsAddEmailPasswordConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/logins/add-email-password/confirm`,
        method: "POST",
        body: queryArg.confirmationCodeRequest,
      }),
    }),
    putApiV1AccountsLoginsAddEmailPasswordResendCode: build.mutation<
      PutApiV1AccountsLoginsAddEmailPasswordResendCodeApiResponse,
      PutApiV1AccountsLoginsAddEmailPasswordResendCodeApiArg
    >({
      query: () => ({
        url: `/api/v1/accounts/logins/add-email-password/resend-code`,
        method: "PUT",
      }),
    }),
    postApiV1AccountsLoginsAddPhone: build.mutation<
      PostApiV1AccountsLoginsAddPhoneApiResponse,
      PostApiV1AccountsLoginsAddPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/logins/add-phone`,
        method: "POST",
        body: queryArg.addPhoneRequest,
      }),
    }),
    deleteApiV1AccountsLoginsRemoveEmailPassword: build.mutation<
      DeleteApiV1AccountsLoginsRemoveEmailPasswordApiResponse,
      DeleteApiV1AccountsLoginsRemoveEmailPasswordApiArg
    >({
      query: () => ({
        url: `/api/v1/accounts/logins/remove-email-password`,
        method: "DELETE",
      }),
    }),
    deleteApiV1AccountsLoginsRemovePhone: build.mutation<
      DeleteApiV1AccountsLoginsRemovePhoneApiResponse,
      DeleteApiV1AccountsLoginsRemovePhoneApiArg
    >({
      query: () => ({
        url: `/api/v1/accounts/logins/remove-phone`,
        method: "DELETE",
      }),
    }),
    postApiV1AccountsPasswordChangeConfirm: build.mutation<
      PostApiV1AccountsPasswordChangeConfirmApiResponse,
      PostApiV1AccountsPasswordChangeConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/password/change/confirm`,
        method: "POST",
        body: queryArg.confirmationCodeRequest,
      }),
    }),
    postApiV1AccountsPasswordChangeRequest: build.mutation<
      PostApiV1AccountsPasswordChangeRequestApiResponse,
      PostApiV1AccountsPasswordChangeRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/password/change/request`,
        method: "POST",
        body: queryArg.passwordChangeRequest,
      }),
    }),
    putApiV1AccountsPasswordChangeResendCode: build.mutation<
      PutApiV1AccountsPasswordChangeResendCodeApiResponse,
      PutApiV1AccountsPasswordChangeResendCodeApiArg
    >({
      query: () => ({
        url: `/api/v1/accounts/password/change/resend-code`,
        method: "PUT",
      }),
    }),
    postApiV1AccountsPasswordRecover: build.mutation<
      PostApiV1AccountsPasswordRecoverApiResponse,
      PostApiV1AccountsPasswordRecoverApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/password/recover`,
        method: "POST",
        body: queryArg.passwordRecoveryRequest,
      }),
    }),
    postApiV1AccountsPasswordRecoverChange: build.mutation<
      PostApiV1AccountsPasswordRecoverChangeApiResponse,
      PostApiV1AccountsPasswordRecoverChangeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/password/recover/change`,
        method: "POST",
        body: queryArg.passwordRecoveryChange,
      }),
    }),
    postApiV1AccountsPasswordRecoverCheckCode: build.mutation<
      PostApiV1AccountsPasswordRecoverCheckCodeApiResponse,
      PostApiV1AccountsPasswordRecoverCheckCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/password/recover/check-code`,
        method: "POST",
        body: queryArg.passwordRecoveryCode,
      }),
    }),
    postApiV1AccountsPhoneChangeConfirmAuth: build.mutation<
      PostApiV1AccountsPhoneChangeConfirmAuthApiResponse,
      PostApiV1AccountsPhoneChangeConfirmAuthApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/phone/change/confirm/auth`,
        method: "POST",
        body: queryArg.confirmationCodeRequest,
      }),
    }),
    postApiV1AccountsPhoneChangeConfirmNewPhone: build.mutation<
      PostApiV1AccountsPhoneChangeConfirmNewPhoneApiResponse,
      PostApiV1AccountsPhoneChangeConfirmNewPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/phone/change/confirm/new-phone`,
        method: "POST",
        body: queryArg.confirmationCodeRequest,
      }),
    }),
    postApiV1AccountsPhoneChangeNewPhone: build.mutation<
      PostApiV1AccountsPhoneChangeNewPhoneApiResponse,
      PostApiV1AccountsPhoneChangeNewPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/phone/change/new-phone`,
        method: "POST",
        body: queryArg.addPhoneRequest,
      }),
    }),
    putApiV1AccountsPhoneChangeRequest: build.mutation<
      PutApiV1AccountsPhoneChangeRequestApiResponse,
      PutApiV1AccountsPhoneChangeRequestApiArg
    >({
      query: () => ({
        url: `/api/v1/accounts/phone/change/request`,
        method: "PUT",
      }),
    }),
    putApiV1AccountsPhoneChangeResendCodeAuth: build.mutation<
      PutApiV1AccountsPhoneChangeResendCodeAuthApiResponse,
      PutApiV1AccountsPhoneChangeResendCodeAuthApiArg
    >({
      query: () => ({
        url: `/api/v1/accounts/phone/change/resend-code/auth`,
        method: "PUT",
      }),
    }),
    putApiV1AccountsPhoneChangeResendCodeNewPhone: build.mutation<
      PutApiV1AccountsPhoneChangeResendCodeNewPhoneApiResponse,
      PutApiV1AccountsPhoneChangeResendCodeNewPhoneApiArg
    >({
      query: () => ({
        url: `/api/v1/accounts/phone/change/resend-code/new-phone`,
        method: "PUT",
      }),
    }),
    getApiV1AccountsProfile: build.query<
      GetApiV1AccountsProfileApiResponse,
      GetApiV1AccountsProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/profile`,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1AccountsResendCodeByHash: build.mutation<
      PutApiV1AccountsResendCodeByHashApiResponse,
      PutApiV1AccountsResendCodeByHashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/resend-code/${queryArg.hash}`,
        method: "PUT",
      }),
    }),
    putApiV1AccountsResendEmailByHash: build.mutation<
      PutApiV1AccountsResendEmailByHashApiResponse,
      PutApiV1AccountsResendEmailByHashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/resend-email/${queryArg.hash}`,
        method: "PUT",
      }),
    }),
    postApiV1AccountsSignup: build.mutation<
      PostApiV1AccountsSignupApiResponse,
      PostApiV1AccountsSignupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/signup`,
        method: "POST",
        body: queryArg.accountCreate,
      }),
    }),
    postApiV1AccountsSignupPhone: build.mutation<
      PostApiV1AccountsSignupPhoneApiResponse,
      PostApiV1AccountsSignupPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/signup-phone`,
        method: "POST",
        body: queryArg.phoneSignup,
      }),
    }),
    postApiV1AccountsUserReselectUser: build.mutation<
      PostApiV1AccountsUserReselectUserApiResponse,
      PostApiV1AccountsUserReselectUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/accounts/user/reselect-user`,
        method: "POST",
        params: {
          userId: queryArg.userId,
          userName: queryArg.userName,
        },
      }),
    }),
    getApiV1AccountsUsersOwnedGroups: build.query<
      GetApiV1AccountsUsersOwnedGroupsApiResponse,
      GetApiV1AccountsUsersOwnedGroupsApiArg
    >({
      query: () => ({ url: `/api/v1/accounts/users-owned-groups` }),
    }),
    getApiV1AddressesSuggest: build.query<
      GetApiV1AddressesSuggestApiResponse,
      GetApiV1AddressesSuggestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/addresses/suggest`,
        params: {
          lang: queryArg.lang,
          text: queryArg.text,
        },
      }),
    }),
    getApiV1AdminAccountByAccountId: build.query<
      GetApiV1AdminAccountByAccountIdApiResponse,
      GetApiV1AdminAccountByAccountIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/account/${queryArg.accountId}`,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1AdminAuditLog: build.query<
      GetApiV1AdminAuditLogApiResponse,
      GetApiV1AdminAuditLogApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/audit_log`,
        params: {
          accountId: queryArg.accountId,
          action: queryArg.action,
          appId: queryArg.appId,
          domainSearch: queryArg.domainSearch,
          email: queryArg.email,
          group: queryArg.group,
          groupId: queryArg.groupId,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          ruleId: queryArg.ruleId,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          userId: queryArg.userId,
          username: queryArg.username,
        },
      }),
    }),
    putApiV1AdminChangeEmail: build.mutation<
      PutApiV1AdminChangeEmailApiResponse,
      PutApiV1AdminChangeEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/change/email`,
        method: "PUT",
        params: {
          email: queryArg.email,
          id: queryArg.id,
          username: queryArg.username,
        },
      }),
    }),
    putApiV1AdminChangePassword: build.mutation<
      PutApiV1AdminChangePasswordApiResponse,
      PutApiV1AdminChangePasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/change/password`,
        method: "PUT",
        params: {
          id: queryArg.id,
          password: queryArg.password,
          username: queryArg.username,
        },
      }),
    }),
    putApiV1AdminChangeRoleAssign: build.mutation<
      PutApiV1AdminChangeRoleAssignApiResponse,
      PutApiV1AdminChangeRoleAssignApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/change/role/assign`,
        method: "PUT",
        params: {
          id: queryArg.id,
          role: queryArg.role,
          username: queryArg.username,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1AdminChangeRoleRevoke: build.mutation<
      PutApiV1AdminChangeRoleRevokeApiResponse,
      PutApiV1AdminChangeRoleRevokeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/change/role/revoke`,
        method: "PUT",
        params: {
          id: queryArg.id,
          role: queryArg.role,
          username: queryArg.username,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1AdminClearApErrors: build.mutation<
      PostApiV1AdminClearApErrorsApiResponse,
      PostApiV1AdminClearApErrorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/clear-ap-errors`,
        method: "POST",
        params: {
          domain: queryArg.domain,
        },
      }),
    }),
    postApiV1AdminCreateAccount: build.mutation<
      PostApiV1AdminCreateAccountApiResponse,
      PostApiV1AdminCreateAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/create-account`,
        method: "POST",
        body: queryArg.accountCreate,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1AdminCreateUser: build.mutation<
      PostApiV1AdminCreateUserApiResponse,
      PostApiV1AdminCreateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/create-user`,
        method: "POST",
        body: queryArg.userCreate,
        params: {
          account_id: queryArg.accountId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    deleteApiV1AdminDelete: build.mutation<
      DeleteApiV1AdminDeleteApiResponse,
      DeleteApiV1AdminDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/delete`,
        method: "DELETE",
        params: {
          email: queryArg.email,
          id: queryArg.id,
          username: queryArg.username,
        },
      }),
    }),
    deleteApiV1AdminDeleteUser: build.mutation<
      DeleteApiV1AdminDeleteUserApiResponse,
      DeleteApiV1AdminDeleteUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/delete-user`,
        method: "DELETE",
        params: {
          id: queryArg.id,
          username: queryArg.username,
        },
      }),
    }),
    getApiV1AdminDomainAllow: build.query<
      GetApiV1AdminDomainAllowApiResponse,
      GetApiV1AdminDomainAllowApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/domain-allow`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1AdminDomainAllow: build.mutation<
      PostApiV1AdminDomainAllowApiResponse,
      PostApiV1AdminDomainAllowApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/domain-allow`,
        method: "POST",
        body: queryArg.allowedDomainReq,
      }),
    }),
    deleteApiV1AdminDomainAllowByDomain: build.mutation<
      DeleteApiV1AdminDomainAllowByDomainApiResponse,
      DeleteApiV1AdminDomainAllowByDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/domain-allow/${queryArg.domain}`,
        method: "DELETE",
      }),
    }),
    putApiV1AdminDomainBlock: build.mutation<
      PutApiV1AdminDomainBlockApiResponse,
      PutApiV1AdminDomainBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/domain-block`,
        method: "PUT",
        body: queryArg.blockDomainReq,
      }),
    }),
    getApiV1AdminDomainBlock: build.query<
      GetApiV1AdminDomainBlockApiResponse,
      GetApiV1AdminDomainBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/domain-block`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1AdminDomainBlock: build.mutation<
      PostApiV1AdminDomainBlockApiResponse,
      PostApiV1AdminDomainBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/domain-block`,
        method: "POST",
        body: queryArg.blockDomainReq,
      }),
    }),
    deleteApiV1AdminDomainBlockByDomain: build.mutation<
      DeleteApiV1AdminDomainBlockByDomainApiResponse,
      DeleteApiV1AdminDomainBlockByDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/domain-block/${queryArg.domain}`,
        method: "DELETE",
      }),
    }),
    getApiV1AdminEmailAllow: build.query<
      GetApiV1AdminEmailAllowApiResponse,
      GetApiV1AdminEmailAllowApiArg
    >({
      query: () => ({ url: `/api/v1/admin/email-allow` }),
    }),
    postApiV1AdminEmailAllow: build.mutation<
      PostApiV1AdminEmailAllowApiResponse,
      PostApiV1AdminEmailAllowApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/email-allow`,
        method: "POST",
        body: queryArg.allowedDomainReq,
      }),
    }),
    deleteApiV1AdminEmailAllowByDomain: build.mutation<
      DeleteApiV1AdminEmailAllowByDomainApiResponse,
      DeleteApiV1AdminEmailAllowByDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/email-allow/${queryArg.domain}`,
        method: "DELETE",
      }),
    }),
    getApiV1AdminEmailBlock: build.query<
      GetApiV1AdminEmailBlockApiResponse,
      GetApiV1AdminEmailBlockApiArg
    >({
      query: () => ({ url: `/api/v1/admin/email-block` }),
    }),
    postApiV1AdminEmailBlock: build.mutation<
      PostApiV1AdminEmailBlockApiResponse,
      PostApiV1AdminEmailBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/email-block`,
        method: "POST",
        body: queryArg.blockEmailRequest,
      }),
    }),
    deleteApiV1AdminEmailBlockByPattern: build.mutation<
      DeleteApiV1AdminEmailBlockByPatternApiResponse,
      DeleteApiV1AdminEmailBlockByPatternApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/email-block/${queryArg.pattern}`,
        method: "DELETE",
      }),
    }),
    putApiV1AdminEmbeddingsDisable: build.mutation<
      PutApiV1AdminEmbeddingsDisableApiResponse,
      PutApiV1AdminEmbeddingsDisableApiArg
    >({
      query: () => ({ url: `/api/v1/admin/embeddings/disable`, method: "PUT" }),
    }),
    putApiV1AdminEmbeddingsEnable: build.mutation<
      PutApiV1AdminEmbeddingsEnableApiResponse,
      PutApiV1AdminEmbeddingsEnableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/embeddings/enable`,
        method: "PUT",
        params: {
          batchDelayMs: queryArg.batchDelayMs,
          modelId: queryArg.modelId,
        },
      }),
    }),
    getApiV1AdminEmbeddingsEstimateCost: build.query<
      GetApiV1AdminEmbeddingsEstimateCostApiResponse,
      GetApiV1AdminEmbeddingsEstimateCostApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/embeddings/estimate-cost`,
        params: {
          modelId: queryArg.modelId,
        },
      }),
    }),
    deleteApiV1AdminEmbeddingsRecalculation: build.mutation<
      DeleteApiV1AdminEmbeddingsRecalculationApiResponse,
      DeleteApiV1AdminEmbeddingsRecalculationApiArg
    >({
      query: () => ({
        url: `/api/v1/admin/embeddings/recalculation`,
        method: "DELETE",
      }),
    }),
    getApiV1AdminEmbeddingsStatus: build.query<
      GetApiV1AdminEmbeddingsStatusApiResponse,
      GetApiV1AdminEmbeddingsStatusApiArg
    >({
      query: () => ({ url: `/api/v1/admin/embeddings/status` }),
    }),
    getApiV1AdminFaspRemoteBackfills: build.query<
      GetApiV1AdminFaspRemoteBackfillsApiResponse,
      GetApiV1AdminFaspRemoteBackfillsApiArg
    >({
      query: () => ({ url: `/api/v1/admin/fasp-remote/backfills` }),
    }),
    getApiV1AdminFaspRemoteBlocklist: build.query<
      GetApiV1AdminFaspRemoteBlocklistApiResponse,
      GetApiV1AdminFaspRemoteBlocklistApiArg
    >({
      query: () => ({ url: `/api/v1/admin/fasp-remote/blocklist` }),
    }),
    deleteApiV1AdminFaspRemoteBlocklistByDomain: build.mutation<
      DeleteApiV1AdminFaspRemoteBlocklistByDomainApiResponse,
      DeleteApiV1AdminFaspRemoteBlocklistByDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/blocklist/${queryArg.domain}`,
        method: "DELETE",
      }),
    }),
    postApiV1AdminFaspRemoteBlocklistByDomain: build.mutation<
      PostApiV1AdminFaspRemoteBlocklistByDomainApiResponse,
      PostApiV1AdminFaspRemoteBlocklistByDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/blocklist/${queryArg.domain}`,
        method: "POST",
      }),
    }),
    deleteApiV1AdminFaspRemoteConfig: build.mutation<
      DeleteApiV1AdminFaspRemoteConfigApiResponse,
      DeleteApiV1AdminFaspRemoteConfigApiArg
    >({
      query: () => ({
        url: `/api/v1/admin/fasp-remote/config`,
        method: "DELETE",
      }),
    }),
    getApiV1AdminFaspRemoteConfig: build.query<
      GetApiV1AdminFaspRemoteConfigApiResponse,
      GetApiV1AdminFaspRemoteConfigApiArg
    >({
      query: () => ({ url: `/api/v1/admin/fasp-remote/config` }),
    }),
    postApiV1AdminFaspRemoteConfig: build.mutation<
      PostApiV1AdminFaspRemoteConfigApiResponse,
      PostApiV1AdminFaspRemoteConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/config`,
        method: "POST",
        body: queryArg.configureFaspRemoteRequest,
      }),
    }),
    postApiV1AdminFaspRemoteRecoverState: build.mutation<
      PostApiV1AdminFaspRemoteRecoverStateApiResponse,
      PostApiV1AdminFaspRemoteRecoverStateApiArg
    >({
      query: () => ({
        url: `/api/v1/admin/fasp-remote/recover-state`,
        method: "POST",
      }),
    }),
    getApiV1AdminFaspRemoteRegistrations: build.query<
      GetApiV1AdminFaspRemoteRegistrationsApiResponse,
      GetApiV1AdminFaspRemoteRegistrationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/registrations`,
        params: {
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          status: queryArg.status,
        },
      }),
    }),
    postApiV1AdminFaspRemoteRegistrationsByServerIdApprove: build.mutation<
      PostApiV1AdminFaspRemoteRegistrationsByServerIdApproveApiResponse,
      PostApiV1AdminFaspRemoteRegistrationsByServerIdApproveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/registrations/${queryArg.serverId}/approve`,
        method: "POST",
      }),
    }),
    postApiV1AdminFaspRemoteRegistrationsByServerIdBackfill: build.mutation<
      PostApiV1AdminFaspRemoteRegistrationsByServerIdBackfillApiResponse,
      PostApiV1AdminFaspRemoteRegistrationsByServerIdBackfillApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/registrations/${queryArg.serverId}/backfill`,
        method: "POST",
        body: queryArg.backfillRequest1,
      }),
    }),
    postApiV1AdminFaspRemoteRegistrationsByServerIdBlock: build.mutation<
      PostApiV1AdminFaspRemoteRegistrationsByServerIdBlockApiResponse,
      PostApiV1AdminFaspRemoteRegistrationsByServerIdBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/registrations/${queryArg.serverId}/block`,
        method: "POST",
      }),
    }),
    postApiV1AdminFaspRemoteRegistrationsByServerIdDecline: build.mutation<
      PostApiV1AdminFaspRemoteRegistrationsByServerIdDeclineApiResponse,
      PostApiV1AdminFaspRemoteRegistrationsByServerIdDeclineApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/registrations/${queryArg.serverId}/decline`,
        method: "POST",
      }),
    }),
    postApiV1AdminFaspRemoteRegistrationsByServerIdRecoverState: build.mutation<
      PostApiV1AdminFaspRemoteRegistrationsByServerIdRecoverStateApiResponse,
      PostApiV1AdminFaspRemoteRegistrationsByServerIdRecoverStateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/registrations/${queryArg.serverId}/recover-state`,
        method: "POST",
      }),
    }),
    postApiV1AdminFaspRemoteRotateTokenConfirm: build.mutation<
      PostApiV1AdminFaspRemoteRotateTokenConfirmApiResponse,
      PostApiV1AdminFaspRemoteRotateTokenConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/rotate-token/confirm`,
        method: "POST",
        body: queryArg.tokenRotationConfirmRequest,
      }),
    }),
    postApiV1AdminFaspRemoteRotateTokenRequest: build.mutation<
      PostApiV1AdminFaspRemoteRotateTokenRequestApiResponse,
      PostApiV1AdminFaspRemoteRotateTokenRequestApiArg
    >({
      query: () => ({
        url: `/api/v1/admin/fasp-remote/rotate-token/request`,
        method: "POST",
      }),
    }),
    getApiV1AdminFaspRemoteStats: build.query<
      GetApiV1AdminFaspRemoteStatsApiResponse,
      GetApiV1AdminFaspRemoteStatsApiArg
    >({
      query: () => ({ url: `/api/v1/admin/fasp-remote/stats` }),
    }),
    getApiV1AdminFaspRemoteSubscriptions: build.query<
      GetApiV1AdminFaspRemoteSubscriptionsApiResponse,
      GetApiV1AdminFaspRemoteSubscriptionsApiArg
    >({
      query: () => ({ url: `/api/v1/admin/fasp-remote/subscriptions` }),
    }),
    postApiV1AdminFaspRemoteTokenRecover: build.mutation<
      PostApiV1AdminFaspRemoteTokenRecoverApiResponse,
      PostApiV1AdminFaspRemoteTokenRecoverApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/token/recover`,
        method: "POST",
        body: queryArg.tokenRecoverRequest,
      }),
    }),
    postApiV1AdminFaspRemoteTokenRecoverConfirm: build.mutation<
      PostApiV1AdminFaspRemoteTokenRecoverConfirmApiResponse,
      PostApiV1AdminFaspRemoteTokenRecoverConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp-remote/token/recover/confirm`,
        method: "POST",
        body: queryArg.tokenRecoverConfirmRequest,
      }),
    }),
    getApiV1AdminFaspRemoteUpdate: build.query<
      GetApiV1AdminFaspRemoteUpdateApiResponse,
      GetApiV1AdminFaspRemoteUpdateApiArg
    >({
      query: () => ({ url: `/api/v1/admin/fasp-remote/update` }),
    }),
    getApiV1AdminFaspDefaults: build.query<
      GetApiV1AdminFaspDefaultsApiResponse,
      GetApiV1AdminFaspDefaultsApiArg
    >({
      query: () => ({ url: `/api/v1/admin/fasp/defaults` }),
    }),
    putApiV1AdminFaspDefaultsByCapability: build.mutation<
      PutApiV1AdminFaspDefaultsByCapabilityApiResponse,
      PutApiV1AdminFaspDefaultsByCapabilityApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/defaults/${queryArg.capability}`,
        method: "PUT",
        body: queryArg.setDefaultRequest,
      }),
    }),
    deleteApiV1AdminFaspDefaultsByCapability: build.mutation<
      DeleteApiV1AdminFaspDefaultsByCapabilityApiResponse,
      DeleteApiV1AdminFaspDefaultsByCapabilityApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/defaults/${queryArg.capability}`,
        method: "DELETE",
      }),
    }),
    getApiV1AdminFaspDefaultsByCapability: build.query<
      GetApiV1AdminFaspDefaultsByCapabilityApiResponse,
      GetApiV1AdminFaspDefaultsByCapabilityApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/defaults/${queryArg.capability}`,
      }),
    }),
    getApiV1AdminFaspProviders: build.query<
      GetApiV1AdminFaspProvidersApiResponse,
      GetApiV1AdminFaspProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/providers`,
        params: {
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          state: queryArg.state,
          states: queryArg.states,
        },
      }),
    }),
    getApiV1AdminFaspProvidersByFaspId: build.query<
      GetApiV1AdminFaspProvidersByFaspIdApiResponse,
      GetApiV1AdminFaspProvidersByFaspIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/providers/${queryArg.faspId}`,
      }),
    }),
    postApiV1AdminFaspProvidersByFaspIdAccept: build.mutation<
      PostApiV1AdminFaspProvidersByFaspIdAcceptApiResponse,
      PostApiV1AdminFaspProvidersByFaspIdAcceptApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/providers/${queryArg.faspId}/accept`,
        method: "POST",
      }),
    }),
    postApiV1AdminFaspProvidersByFaspIdBackfill: build.mutation<
      PostApiV1AdminFaspProvidersByFaspIdBackfillApiResponse,
      PostApiV1AdminFaspProvidersByFaspIdBackfillApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/providers/${queryArg.faspId}/backfill`,
        method: "POST",
        body: queryArg.backfillRequest,
      }),
    }),
    postApiV1AdminFaspProvidersByFaspIdBlock: build.mutation<
      PostApiV1AdminFaspProvidersByFaspIdBlockApiResponse,
      PostApiV1AdminFaspProvidersByFaspIdBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/providers/${queryArg.faspId}/block`,
        method: "POST",
      }),
    }),
    postApiV1AdminFaspProvidersByFaspIdCapabilities: build.mutation<
      PostApiV1AdminFaspProvidersByFaspIdCapabilitiesApiResponse,
      PostApiV1AdminFaspProvidersByFaspIdCapabilitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/providers/${queryArg.faspId}/capabilities`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV1AdminFaspProvidersByFaspIdDecline: build.mutation<
      PostApiV1AdminFaspProvidersByFaspIdDeclineApiResponse,
      PostApiV1AdminFaspProvidersByFaspIdDeclineApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/fasp/providers/${queryArg.faspId}/decline`,
        method: "POST",
      }),
    }),
    getApiV1AdminFederation: build.query<
      GetApiV1AdminFederationApiResponse,
      GetApiV1AdminFederationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/federation`,
        params: {
          blockState: queryArg.blockState,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          search: queryArg.search,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          unavailable: queryArg.unavailable,
          untilId: queryArg.untilId,
          warning: queryArg.warning,
        },
      }),
    }),
    putApiV1AdminFederationConfig: build.mutation<
      PutApiV1AdminFederationConfigApiResponse,
      PutApiV1AdminFederationConfigApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/federation/config`,
        method: "PUT",
        body: queryArg.federationConfigRequest,
      }),
    }),
    getApiV1AdminFederationConfig: build.query<
      GetApiV1AdminFederationConfigApiResponse,
      GetApiV1AdminFederationConfigApiArg
    >({
      query: () => ({ url: `/api/v1/admin/federation/config` }),
    }),
    getApiV1AdminFederationMetricsOperations: build.query<
      GetApiV1AdminFederationMetricsOperationsApiResponse,
      GetApiV1AdminFederationMetricsOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/federation/metrics/operations`,
        params: {
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFederationMetricsRunningAverageSingle: build.query<
      GetApiV1AdminFederationMetricsRunningAverageSingleApiResponse,
      GetApiV1AdminFederationMetricsRunningAverageSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/federation/metrics/running-average-single`,
        params: {
          operation: queryArg.operation,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFederationMetricsRunningAveragesAll: build.query<
      GetApiV1AdminFederationMetricsRunningAveragesAllApiResponse,
      GetApiV1AdminFederationMetricsRunningAveragesAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/federation/metrics/running-averages-all`,
        params: {
          operations: queryArg.operations,
          window: queryArg.window,
        },
      }),
    }),
    putApiV1AdminFederationMode: build.mutation<
      PutApiV1AdminFederationModeApiResponse,
      PutApiV1AdminFederationModeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/federation/mode`,
        method: "PUT",
        body: queryArg.federationModeRequest,
      }),
    }),
    getApiV1AdminFederationMode: build.query<
      GetApiV1AdminFederationModeApiResponse,
      GetApiV1AdminFederationModeApiArg
    >({
      query: () => ({ url: `/api/v1/admin/federation/mode` }),
    }),
    getApiV1AdminFederationByDomain: build.query<
      GetApiV1AdminFederationByDomainApiResponse,
      GetApiV1AdminFederationByDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/federation/${queryArg.domain}`,
      }),
    }),
    postApiV1AdminFeedClearUserFeed: build.mutation<
      PostApiV1AdminFeedClearUserFeedApiResponse,
      PostApiV1AdminFeedClearUserFeedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/clear-user-feed`,
        method: "POST",
        params: {
          userId: queryArg.userId,
          username: queryArg.username,
        },
      }),
    }),
    getApiV1AdminFeedCountUserFeed: build.query<
      GetApiV1AdminFeedCountUserFeedApiResponse,
      GetApiV1AdminFeedCountUserFeedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/count-user-feed`,
        params: {
          userId: queryArg.userId,
          username: queryArg.username,
        },
      }),
    }),
    getApiV1AdminFeedDiagnose: build.query<
      GetApiV1AdminFeedDiagnoseApiResponse,
      GetApiV1AdminFeedDiagnoseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/diagnose`,
        params: {
          limit: queryArg.limit,
          skipExactMatch: queryArg.skipExactMatch,
          skipFull: queryArg.skipFull,
          skipOrderMismatch: queryArg.skipOrderMismatch,
          userId: queryArg.userId,
          username: queryArg.username,
        },
      }),
    }),
    getApiV1AdminFeedMetricsGlobalAllOperation: build.query<
      GetApiV1AdminFeedMetricsGlobalAllOperationApiResponse,
      GetApiV1AdminFeedMetricsGlobalAllOperationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/global-all-operation`,
        params: {
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsGlobalSingle: build.query<
      GetApiV1AdminFeedMetricsGlobalSingleApiResponse,
      GetApiV1AdminFeedMetricsGlobalSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/global-single`,
        params: {
          operation: queryArg.operation,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsHistory: build.query<
      GetApiV1AdminFeedMetricsHistoryApiResponse,
      GetApiV1AdminFeedMetricsHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/history`,
        params: {
          limit: queryArg.limit,
          operation: queryArg.operation,
          userId: queryArg.userId,
        },
      }),
    }),
    getApiV1AdminFeedMetricsHistoryAll: build.query<
      GetApiV1AdminFeedMetricsHistoryAllApiResponse,
      GetApiV1AdminFeedMetricsHistoryAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/history/all`,
        params: {
          limit: queryArg.limit,
          userId: queryArg.userId,
        },
      }),
    }),
    getApiV1AdminFeedMetricsRunningAverageSingle: build.query<
      GetApiV1AdminFeedMetricsRunningAverageSingleApiResponse,
      GetApiV1AdminFeedMetricsRunningAverageSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/running-average-single`,
        params: {
          operation: queryArg.operation,
          userId: queryArg.userId,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsRunningAveragesAll: build.query<
      GetApiV1AdminFeedMetricsRunningAveragesAllApiResponse,
      GetApiV1AdminFeedMetricsRunningAveragesAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/running-averages-all`,
        params: {
          userId: queryArg.userId,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsSlowestOperations: build.query<
      GetApiV1AdminFeedMetricsSlowestOperationsApiResponse,
      GetApiV1AdminFeedMetricsSlowestOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/slowest-operations`,
        params: {
          limit: queryArg.limit,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsSlowestUsers: build.query<
      GetApiV1AdminFeedMetricsSlowestUsersApiResponse,
      GetApiV1AdminFeedMetricsSlowestUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/slowest-users`,
        params: {
          limit: queryArg.limit,
          operation: queryArg.operation,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsSlowestUsersAll: build.query<
      GetApiV1AdminFeedMetricsSlowestUsersAllApiResponse,
      GetApiV1AdminFeedMetricsSlowestUsersAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/slowest-users-all`,
        params: {
          limit: queryArg.limit,
          sortDesc: queryArg.sortDesc,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsSlowestUsersSingle: build.query<
      GetApiV1AdminFeedMetricsSlowestUsersSingleApiResponse,
      GetApiV1AdminFeedMetricsSlowestUsersSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/slowest-users-single`,
        params: {
          limit: queryArg.limit,
          operation: queryArg.operation,
          sortDesc: queryArg.sortDesc,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsSummary: build.query<
      GetApiV1AdminFeedMetricsSummaryApiResponse,
      GetApiV1AdminFeedMetricsSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/summary`,
        params: {
          includeUserCounts: queryArg.includeUserCounts,
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsUserCountAll: build.query<
      GetApiV1AdminFeedMetricsUserCountAllApiResponse,
      GetApiV1AdminFeedMetricsUserCountAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/user-count-all`,
        params: {
          window: queryArg.window,
        },
      }),
    }),
    getApiV1AdminFeedMetricsUserCountSingle: build.query<
      GetApiV1AdminFeedMetricsUserCountSingleApiResponse,
      GetApiV1AdminFeedMetricsUserCountSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/metrics/user-count-single`,
        params: {
          operation: queryArg.operation,
          window: queryArg.window,
        },
      }),
    }),
    postApiV1AdminFeedRegenerateUserFeed: build.mutation<
      PostApiV1AdminFeedRegenerateUserFeedApiResponse,
      PostApiV1AdminFeedRegenerateUserFeedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/feed/regenerate-user-feed`,
        method: "POST",
        params: {
          clear: queryArg.clear,
          userId: queryArg.userId,
          username: queryArg.username,
        },
      }),
    }),
    getApiV1AdminGroupsSearch: build.query<
      GetApiV1AdminGroupsSearchApiResponse,
      GetApiV1AdminGroupsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/groups/search`,
        params: {
          accountId: queryArg.accountId,
          displayName: queryArg.displayName,
          domain: queryArg.domain,
          email: queryArg.email,
          joinMode: queryArg.joinMode,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          privacy: queryArg.privacy,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          userId: queryArg.userId,
          username: queryArg.username,
          visibility: queryArg.visibility,
        },
      }),
    }),
    getApiV1AdminGroupsUserByUserId: build.query<
      GetApiV1AdminGroupsUserByUserIdApiResponse,
      GetApiV1AdminGroupsUserByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/groups/user/${queryArg.userId}`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          roles: queryArg.roles,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1AdminGroupsByAccountId: build.query<
      GetApiV1AdminGroupsByAccountIdApiResponse,
      GetApiV1AdminGroupsByAccountIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/groups/${queryArg.accountId}`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1AdminGroupsByGroupIdCategories: build.query<
      GetApiV1AdminGroupsByGroupIdCategoriesApiResponse,
      GetApiV1AdminGroupsByGroupIdCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/groups/${queryArg.groupId}/categories`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1AdminGroupsByGroupIdChannels: build.query<
      GetApiV1AdminGroupsByGroupIdChannelsApiResponse,
      GetApiV1AdminGroupsByGroupIdChannelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/groups/${queryArg.groupId}/channels`,
      }),
    }),
    getApiV1AdminGroupsByGroupIdEvents: build.query<
      GetApiV1AdminGroupsByGroupIdEventsApiResponse,
      GetApiV1AdminGroupsByGroupIdEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/groups/${queryArg.groupId}/events`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          withTranslation: queryArg.withTranslation,
        },
      }),
    }),
    getApiV1AdminImpersonate: build.query<
      GetApiV1AdminImpersonateApiResponse,
      GetApiV1AdminImpersonateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/impersonate`,
        params: {
          username: queryArg.username,
        },
      }),
    }),
    getApiV1AdminLinkService: build.query<
      GetApiV1AdminLinkServiceApiResponse,
      GetApiV1AdminLinkServiceApiArg
    >({
      query: () => ({ url: `/api/v1/admin/link-service` }),
    }),
    postApiV1AdminLinkServiceConfigure: build.mutation<
      PostApiV1AdminLinkServiceConfigureApiResponse,
      PostApiV1AdminLinkServiceConfigureApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/link-service/configure`,
        method: "POST",
        body: queryArg.configureRequest,
      }),
    }),
    postApiV1AdminPostsDelete: build.mutation<
      PostApiV1AdminPostsDeleteApiResponse,
      PostApiV1AdminPostsDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/posts/delete`,
        method: "POST",
        body: queryArg.postDelete,
      }),
    }),
    deleteApiV1AdminPurge: build.mutation<
      DeleteApiV1AdminPurgeApiResponse,
      DeleteApiV1AdminPurgeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/purge`,
        method: "DELETE",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    postApiV1AdminRegenerateKeys: build.mutation<
      PostApiV1AdminRegenerateKeysApiResponse,
      PostApiV1AdminRegenerateKeysApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regenerate-keys`,
        method: "POST",
        params: {
          userId: queryArg.userId,
          username: queryArg.username,
        },
      }),
    }),
    postApiV1AdminRegenerateKeysAll: build.mutation<
      PostApiV1AdminRegenerateKeysAllApiResponse,
      PostApiV1AdminRegenerateKeysAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regenerate-keys-all`,
        method: "POST",
        params: {
          batch: queryArg.batch,
        },
      }),
    }),
    postApiV1AdminReleaseUsername: build.mutation<
      PostApiV1AdminReleaseUsernameApiResponse,
      PostApiV1AdminReleaseUsernameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/release-username`,
        method: "POST",
        params: {
          username: queryArg.username,
        },
      }),
    }),
    getApiV1AdminReportsEligibleAssignees: build.query<
      GetApiV1AdminReportsEligibleAssigneesApiResponse,
      GetApiV1AdminReportsEligibleAssigneesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/eligible-assignees`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AdminReportsList: build.query<
      GetApiV1AdminReportsListApiResponse,
      GetApiV1AdminReportsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/list`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          open: queryArg.open,
          scope: queryArg.scope,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          state: queryArg.state,
          targetId: queryArg.targetId,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1AdminReportsReportedGroups: build.query<
      GetApiV1AdminReportsReportedGroupsApiResponse,
      GetApiV1AdminReportsReportedGroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/reported-groups`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          open: queryArg.open,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1AdminReportsReportedPosts: build.query<
      GetApiV1AdminReportsReportedPostsApiResponse,
      GetApiV1AdminReportsReportedPostsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/reported-posts`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          open: queryArg.open,
          scope: queryArg.scope,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1AdminReportsReportedUsers: build.query<
      GetApiV1AdminReportsReportedUsersApiResponse,
      GetApiV1AdminReportsReportedUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/reported-users`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          open: queryArg.open,
          scope: queryArg.scope,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1AdminReportsByReportId: build.query<
      GetApiV1AdminReportsByReportIdApiResponse,
      GetApiV1AdminReportsByReportIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AdminReportsByReportIdAddNote: build.mutation<
      PostApiV1AdminReportsByReportIdAddNoteApiResponse,
      PostApiV1AdminReportsByReportIdAddNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}/add-note`,
        method: "POST",
        params: {
          note: queryArg.note,
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AdminReportsByReportIdAssign: build.mutation<
      PostApiV1AdminReportsByReportIdAssignApiResponse,
      PostApiV1AdminReportsByReportIdAssignApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}/assign`,
        method: "POST",
        params: {
          scope: queryArg.scope,
          userId: queryArg.userId,
        },
      }),
    }),
    deleteApiV1AdminReportsByReportIdDelete: build.mutation<
      DeleteApiV1AdminReportsByReportIdDeleteApiResponse,
      DeleteApiV1AdminReportsByReportIdDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}/delete`,
        method: "DELETE",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AdminReportsByReportIdDismiss: build.mutation<
      PostApiV1AdminReportsByReportIdDismissApiResponse,
      PostApiV1AdminReportsByReportIdDismissApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}/dismiss`,
        method: "POST",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AdminReportsByReportIdRemoveNote: build.mutation<
      PostApiV1AdminReportsByReportIdRemoveNoteApiResponse,
      PostApiV1AdminReportsByReportIdRemoveNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}/remove-note`,
        method: "POST",
        params: {
          index: queryArg.index,
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AdminReportsByReportIdReopen: build.mutation<
      PostApiV1AdminReportsByReportIdReopenApiResponse,
      PostApiV1AdminReportsByReportIdReopenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}/reopen`,
        method: "POST",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AdminReportsByReportIdResolve: build.mutation<
      PostApiV1AdminReportsByReportIdResolveApiResponse,
      PostApiV1AdminReportsByReportIdResolveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}/resolve`,
        method: "POST",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AdminReportsByReportIdUnassign: build.mutation<
      PostApiV1AdminReportsByReportIdUnassignApiResponse,
      PostApiV1AdminReportsByReportIdUnassignApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/reports/${queryArg.reportId}/unassign`,
        method: "POST",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AdminRestartApDelivery: build.mutation<
      PostApiV1AdminRestartApDeliveryApiResponse,
      PostApiV1AdminRestartApDeliveryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/restart-ap-delivery`,
        method: "POST",
        params: {
          domain: queryArg.domain,
        },
      }),
    }),
    getApiV1AdminSearch: build.query<
      GetApiV1AdminSearchApiResponse,
      GetApiV1AdminSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/search`,
        params: {
          accountId: queryArg.accountId,
          actorType: queryArg.actorType,
          country: queryArg.country,
          displayName: queryArg.displayName,
          domain: queryArg.domain,
          email: queryArg.email,
          ip: queryArg.ip,
          kind: queryArg.kind,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          role: queryArg.role,
          search: queryArg.search,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          state: queryArg.state,
          untilId: queryArg.untilId,
          userId: queryArg.userId,
          username: queryArg.username,
        },
      }),
    }),
    putApiV1AdminSignupRequestsApproveByHash: build.mutation<
      PutApiV1AdminSignupRequestsApproveByHashApiResponse,
      PutApiV1AdminSignupRequestsApproveByHashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/signup_requests/approve/${queryArg.hash}`,
        method: "PUT",
      }),
    }),
    deleteApiV1AdminSignupRequestsDeleteByHash: build.mutation<
      DeleteApiV1AdminSignupRequestsDeleteByHashApiResponse,
      DeleteApiV1AdminSignupRequestsDeleteByHashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/signup_requests/delete/${queryArg.hash}`,
        method: "DELETE",
      }),
    }),
    getApiV1AdminSignupRequestsList: build.query<
      GetApiV1AdminSignupRequestsListApiResponse,
      GetApiV1AdminSignupRequestsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/signup_requests/list`,
        params: {
          email: queryArg.email,
          hash: queryArg.hash,
          ip: queryArg.ip,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    putApiV1AdminSignupRequestsRejectByHash: build.mutation<
      PutApiV1AdminSignupRequestsRejectByHashApiResponse,
      PutApiV1AdminSignupRequestsRejectByHashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/signup_requests/reject/${queryArg.hash}`,
        method: "PUT",
        params: {
          reason: queryArg.reason,
        },
      }),
    }),
    getApiV1AdminUploadsJobsQueueByQueueName: build.query<
      GetApiV1AdminUploadsJobsQueueByQueueNameApiResponse,
      GetApiV1AdminUploadsJobsQueueByQueueNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/uploads/jobs/queue/${queryArg.queueName}`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          uploadType: queryArg.uploadType,
        },
      }),
    }),
    getApiV1AdminUploadsJobsSummary: build.query<
      GetApiV1AdminUploadsJobsSummaryApiResponse,
      GetApiV1AdminUploadsJobsSummaryApiArg
    >({
      query: () => ({ url: `/api/v1/admin/uploads/jobs/summary` }),
    }),
    getApiV1AdminUploadsSearch: build.query<
      GetApiV1AdminUploadsSearchApiResponse,
      GetApiV1AdminUploadsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/uploads/search`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          tag: queryArg.tag,
          untilId: queryArg.untilId,
          uploadType: queryArg.uploadType,
          userId: queryArg.userId,
        },
      }),
    }),
    getApiV1AdminUploadsStorageByUserId: build.query<
      GetApiV1AdminUploadsStorageByUserIdApiResponse,
      GetApiV1AdminUploadsStorageByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/uploads/storage/${queryArg.userId}`,
      }),
    }),
    getApiV1AdminUploadsByUploadIdLogs: build.query<
      GetApiV1AdminUploadsByUploadIdLogsApiResponse,
      GetApiV1AdminUploadsByUploadIdLogsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/uploads/${queryArg.uploadId}/logs`,
      }),
    }),
    postApiV1AdminUserChangeState: build.mutation<
      PostApiV1AdminUserChangeStateApiResponse,
      PostApiV1AdminUserChangeStateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/user/change-state`,
        method: "POST",
        body: queryArg.changeUserState,
      }),
    }),
    postApiV1AdminUserChangeStateBulk: build.mutation<
      PostApiV1AdminUserChangeStateBulkApiResponse,
      PostApiV1AdminUserChangeStateBulkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/user/change-state-bulk`,
        method: "POST",
        body: queryArg.changeUserStateBulk,
      }),
    }),
    getApiV1AdminUserByUserId: build.query<
      GetApiV1AdminUserByUserIdApiResponse,
      GetApiV1AdminUserByUserIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/admin/user/${queryArg.userId}` }),
    }),
    getApiV1AiAgents: build.query<
      GetApiV1AiAgentsApiResponse,
      GetApiV1AiAgentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1AiAgents: build.mutation<
      PostApiV1AiAgentsApiResponse,
      PostApiV1AiAgentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents`,
        method: "POST",
        body: queryArg.aiAgentCreate,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiAgentsPosts: build.query<
      GetApiV1AiAgentsPostsApiResponse,
      GetApiV1AiAgentsPostsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/posts`,
        params: {
          limit: queryArg.limit,
          ownerId: queryArg.ownerId,
          since: queryArg.since,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1AiAgentsByAgentId: build.query<
      GetApiV1AiAgentsByAgentIdApiResponse,
      GetApiV1AiAgentsByAgentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/${queryArg.agentId}`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    deleteApiV1AiAgentsByAgentId: build.mutation<
      DeleteApiV1AiAgentsByAgentIdApiResponse,
      DeleteApiV1AiAgentsByAgentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/${queryArg.agentId}`,
        method: "DELETE",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1AiAgentsByAgentIdDisable: build.mutation<
      PutApiV1AiAgentsByAgentIdDisableApiResponse,
      PutApiV1AiAgentsByAgentIdDisableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/${queryArg.agentId}/disable`,
        method: "PUT",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1AiAgentsByAgentIdEnable: build.mutation<
      PutApiV1AiAgentsByAgentIdEnableApiResponse,
      PutApiV1AiAgentsByAgentIdEnableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/${queryArg.agentId}/enable`,
        method: "PUT",
        params: {
          scope: queryArg.scope,
          version: queryArg.version,
        },
      }),
    }),
    putApiV1AiAgentsByAgentIdProfile: build.mutation<
      PutApiV1AiAgentsByAgentIdProfileApiResponse,
      PutApiV1AiAgentsByAgentIdProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/${queryArg.agentId}/profile`,
        method: "PUT",
        body: queryArg.aiAgentProfileUpdate,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1AiAgentsByAgentIdUser: build.mutation<
      PutApiV1AiAgentsByAgentIdUserApiResponse,
      PutApiV1AiAgentsByAgentIdUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/${queryArg.agentId}/user`,
        method: "PUT",
        body: queryArg.userUpdate,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiAgentsByAgentIdVersions: build.query<
      GetApiV1AiAgentsByAgentIdVersionsApiResponse,
      GetApiV1AiAgentsByAgentIdVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/${queryArg.agentId}/versions`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiAgentsByAgentIdVersionsAndVersion: build.query<
      GetApiV1AiAgentsByAgentIdVersionsAndVersionApiResponse,
      GetApiV1AiAgentsByAgentIdVersionsAndVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-agents/${queryArg.agentId}/versions/${queryArg.version}`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiModels: build.query<
      GetApiV1AiModelsApiResponse,
      GetApiV1AiModelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-models`,
        params: {
          sortBy: queryArg.sortBy,
          builtInTools: queryArg.builtInTools,
          capabilities: queryArg.capabilities,
          deprecated: queryArg.deprecated,
          enabled: queryArg.enabled,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          maxContextWindow: queryArg.maxContextWindow,
          maxInputPrice: queryArg.maxInputPrice,
          maxMaxOutputTokens: queryArg.maxMaxOutputTokens,
          maxOutputPrice: queryArg.maxOutputPrice,
          minContextWindow: queryArg.minContextWindow,
          minMaxOutputTokens: queryArg.minMaxOutputTokens,
          modalities: queryArg.modalities,
          offset: queryArg.offset,
          openWeights: queryArg.openWeights,
          providerId: queryArg.providerId,
          scope: queryArg.scope,
          search: queryArg.search,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1AiModelsByModelId: build.query<
      GetApiV1AiModelsByModelIdApiResponse,
      GetApiV1AiModelsByModelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-models/${queryArg.modelId}`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiModelsByModelIdAgents: build.query<
      GetApiV1AiModelsByModelIdAgentsApiResponse,
      GetApiV1AiModelsByModelIdAgentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-models/${queryArg.modelId}/agents`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    deleteApiV1AiModelsByModelIdConfigure: build.mutation<
      DeleteApiV1AiModelsByModelIdConfigureApiResponse,
      DeleteApiV1AiModelsByModelIdConfigureApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-models/${queryArg.modelId}/configure`,
        method: "DELETE",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1AiModelsByModelIdDisable: build.mutation<
      PutApiV1AiModelsByModelIdDisableApiResponse,
      PutApiV1AiModelsByModelIdDisableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-models/${queryArg.modelId}/disable`,
        method: "PUT",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1AiModelsByModelIdEnable: build.mutation<
      PutApiV1AiModelsByModelIdEnableApiResponse,
      PutApiV1AiModelsByModelIdEnableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-models/${queryArg.modelId}/enable`,
        method: "PUT",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiModelsByModelIdMigrationPath: build.query<
      GetApiV1AiModelsByModelIdMigrationPathApiResponse,
      GetApiV1AiModelsByModelIdMigrationPathApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-models/${queryArg.modelId}/migration-path`,
      }),
    }),
    getApiV1AiModelsByModelIdResolve: build.query<
      GetApiV1AiModelsByModelIdResolveApiResponse,
      GetApiV1AiModelsByModelIdResolveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-models/${queryArg.modelId}/resolve`,
      }),
    }),
    getApiV1AiProviders: build.query<
      GetApiV1AiProvidersApiResponse,
      GetApiV1AiProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-providers`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiProvidersByProviderId: build.query<
      GetApiV1AiProvidersByProviderIdApiResponse,
      GetApiV1AiProvidersByProviderIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-providers/${queryArg.providerId}`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiProvidersByProviderIdAgents: build.query<
      GetApiV1AiProvidersByProviderIdAgentsApiResponse,
      GetApiV1AiProvidersByProviderIdAgentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-providers/${queryArg.providerId}/agents`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    deleteApiV1AiProvidersByProviderIdConfigure: build.mutation<
      DeleteApiV1AiProvidersByProviderIdConfigureApiResponse,
      DeleteApiV1AiProvidersByProviderIdConfigureApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-providers/${queryArg.providerId}/configure`,
        method: "DELETE",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1AiProvidersByProviderIdConfigure: build.mutation<
      PutApiV1AiProvidersByProviderIdConfigureApiResponse,
      PutApiV1AiProvidersByProviderIdConfigureApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-providers/${queryArg.providerId}/configure`,
        method: "PUT",
        body: queryArg.aiScopedProviderConfigure,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1AiProvidersByProviderIdModels: build.query<
      GetApiV1AiProvidersByProviderIdModelsApiResponse,
      GetApiV1AiProvidersByProviderIdModelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/ai-providers/${queryArg.providerId}/models`,
        params: {
          enabled: queryArg.enabled,
          includeDeprecated: queryArg.includeDeprecated,
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1Apps: build.mutation<
      PostApiV1AppsApiResponse,
      PostApiV1AppsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps`,
        method: "POST",
        body: queryArg.body,
        params: {
          enable: queryArg.enable,
        },
      }),
    }),
    getApiV1Apps: build.query<GetApiV1AppsApiResponse, GetApiV1AppsApiArg>({
      query: () => ({ url: `/api/v1/apps` }),
    }),
    getApiV1AppsEnabled: build.query<
      GetApiV1AppsEnabledApiResponse,
      GetApiV1AppsEnabledApiArg
    >({
      query: () => ({ url: `/api/v1/apps/enabled` }),
    }),
    getApiV1AppsInstalled: build.query<
      GetApiV1AppsInstalledApiResponse,
      GetApiV1AppsInstalledApiArg
    >({
      query: () => ({ url: `/api/v1/apps/installed` }),
    }),
    getApiV1AppsUser: build.query<
      GetApiV1AppsUserApiResponse,
      GetApiV1AppsUserApiArg
    >({
      query: () => ({ url: `/api/v1/apps/user` }),
    }),
    deleteApiV1AppsUserByAppId: build.mutation<
      DeleteApiV1AppsUserByAppIdApiResponse,
      DeleteApiV1AppsUserByAppIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/user/${queryArg.appId}`,
        method: "DELETE",
      }),
    }),
    putApiV1AppsUserByAppId: build.mutation<
      PutApiV1AppsUserByAppIdApiResponse,
      PutApiV1AppsUserByAppIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/user/${queryArg.appId}`,
        method: "PUT",
      }),
    }),
    putApiV1AppsByAppId: build.mutation<
      PutApiV1AppsByAppIdApiResponse,
      PutApiV1AppsByAppIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}`,
        method: "PUT",
        body: queryArg.body,
        params: {
          enable: queryArg.enable,
        },
      }),
    }),
    getApiV1AppsByAppId: build.query<
      GetApiV1AppsByAppIdApiResponse,
      GetApiV1AppsByAppIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/apps/${queryArg.appId}` }),
    }),
    deleteApiV1AppsByAppId: build.mutation<
      DeleteApiV1AppsByAppIdApiResponse,
      DeleteApiV1AppsByAppIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}`,
        method: "DELETE",
      }),
    }),
    getApiV1AppsByAppIdData: build.query<
      GetApiV1AppsByAppIdDataApiResponse,
      GetApiV1AppsByAppIdDataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/data`,
        params: {
          owner: queryArg.owner,
          tags: queryArg.tags,
          type: queryArg["type"],
        },
      }),
    }),
    postApiV1AppsByAppIdData: build.mutation<
      PostApiV1AppsByAppIdDataApiResponse,
      PostApiV1AppsByAppIdDataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/data`,
        method: "POST",
        body: queryArg.dataCreate,
      }),
    }),
    putApiV1AppsByAppIdDataAndId: build.mutation<
      PutApiV1AppsByAppIdDataAndIdApiResponse,
      PutApiV1AppsByAppIdDataAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/data/${queryArg.id}`,
        method: "PUT",
        body: queryArg.dataCreate,
      }),
    }),
    deleteApiV1AppsByAppIdDataAndId: build.mutation<
      DeleteApiV1AppsByAppIdDataAndIdApiResponse,
      DeleteApiV1AppsByAppIdDataAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/data/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    putApiV1AppsByAppIdDefault: build.mutation<
      PutApiV1AppsByAppIdDefaultApiResponse,
      PutApiV1AppsByAppIdDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/default`,
        method: "PUT",
      }),
    }),
    putApiV1AppsByAppIdDisable: build.mutation<
      PutApiV1AppsByAppIdDisableApiResponse,
      PutApiV1AppsByAppIdDisableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/disable`,
        method: "PUT",
      }),
    }),
    putApiV1AppsByAppIdEnable: build.mutation<
      PutApiV1AppsByAppIdEnableApiResponse,
      PutApiV1AppsByAppIdEnableApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/enable`,
        method: "PUT",
      }),
    }),
    getApiV1AppsByAppIdStats: build.query<
      GetApiV1AppsByAppIdStatsApiResponse,
      GetApiV1AppsByAppIdStatsApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/apps/${queryArg.appId}/stats` }),
    }),
    putApiV1AppsByAppIdUserDefault: build.mutation<
      PutApiV1AppsByAppIdUserDefaultApiResponse,
      PutApiV1AppsByAppIdUserDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/user-default`,
        method: "PUT",
      }),
    }),
    deleteApiV1AppsByAppIdUserDefault: build.mutation<
      DeleteApiV1AppsByAppIdUserDefaultApiResponse,
      DeleteApiV1AppsByAppIdUserDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/apps/${queryArg.appId}/user-default`,
        method: "DELETE",
      }),
    }),
    getApiV1AsyncRefreshesById: build.query<
      GetApiV1AsyncRefreshesByIdApiResponse,
      GetApiV1AsyncRefreshesByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/async_refreshes/${queryArg.id}` }),
    }),
    getApiV1Block: build.query<GetApiV1BlockApiResponse, GetApiV1BlockApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/block`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1BlockBy: build.query<
      GetApiV1BlockByApiResponse,
      GetApiV1BlockByApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/block/by`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    deleteApiV1BlockByUserId: build.mutation<
      DeleteApiV1BlockByUserIdApiResponse,
      DeleteApiV1BlockByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/block/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    postApiV1BlockByUserId: build.mutation<
      PostApiV1BlockByUserIdApiResponse,
      PostApiV1BlockByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/block/${queryArg.userId}`,
        method: "POST",
      }),
    }),
    getApiV1CustomEmojis: build.query<
      GetApiV1CustomEmojisApiResponse,
      GetApiV1CustomEmojisApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis`,
        params: {
          category: queryArg.category,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          shortcode: queryArg.shortcode,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    deleteApiV1CustomEmojis: build.mutation<
      DeleteApiV1CustomEmojisApiResponse,
      DeleteApiV1CustomEmojisApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis`,
        method: "DELETE",
        params: {
          category: queryArg.category,
          shortcode: queryArg.shortcode,
        },
      }),
    }),
    postApiV1CustomEmojis: build.mutation<
      PostApiV1CustomEmojisApiResponse,
      PostApiV1CustomEmojisApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis`,
        method: "POST",
        body: queryArg.emoji,
        params: {
          overwrite: queryArg.overwrite,
        },
      }),
    }),
    getApiV1CustomEmojisCategories: build.query<
      GetApiV1CustomEmojisCategoriesApiResponse,
      GetApiV1CustomEmojisCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis/categories`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          q: queryArg.q,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1CustomEmojisExport: build.query<
      GetApiV1CustomEmojisExportApiResponse,
      GetApiV1CustomEmojisExportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis/export`,
        params: {
          category: queryArg.category,
        },
      }),
    }),
    postApiV1CustomEmojisImport: build.mutation<
      PostApiV1CustomEmojisImportApiResponse,
      PostApiV1CustomEmojisImportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis/import`,
        method: "POST",
        body: queryArg.body,
        params: {
          category: queryArg.category,
          domain: queryArg.domain,
          overwrite: queryArg.overwrite,
          visible: queryArg.visible,
        },
      }),
    }),
    postApiV1CustomEmojisImportUpload: build.mutation<
      PostApiV1CustomEmojisImportUploadApiResponse,
      PostApiV1CustomEmojisImportUploadApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis/import/upload`,
        method: "POST",
        params: {
          category: queryArg.category,
          domain: queryArg.domain,
          overwrite: queryArg.overwrite,
          uploadId: queryArg.uploadId,
          visible: queryArg.visible,
        },
      }),
    }),
    getApiV1CustomEmojisSearch: build.query<
      GetApiV1CustomEmojisSearchApiResponse,
      GetApiV1CustomEmojisSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis/search`,
        params: {
          category: queryArg.category,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          shortcode: queryArg.shortcode,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1CustomEmojisUpload: build.mutation<
      PostApiV1CustomEmojisUploadApiResponse,
      PostApiV1CustomEmojisUploadApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis/upload`,
        method: "POST",
        params: {
          category: queryArg.category,
          domain: queryArg.domain,
          overwrite: queryArg.overwrite,
          shortcode: queryArg.shortcode,
          uploadId: queryArg.uploadId,
          visible: queryArg.visible,
        },
      }),
    }),
    patchApiV1CustomEmojisByShortcode: build.mutation<
      PatchApiV1CustomEmojisByShortcodeApiResponse,
      PatchApiV1CustomEmojisByShortcodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/custom_emojis/${queryArg.shortcode}`,
        method: "PATCH",
        body: queryArg.emojiPatchRequest,
      }),
    }),
    getApiV1Data: build.query<GetApiV1DataApiResponse, GetApiV1DataApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/data`,
        params: {
          owner: queryArg.owner,
          tags: queryArg.tags,
          type: queryArg["type"],
        },
      }),
    }),
    postApiV1Data: build.mutation<
      PostApiV1DataApiResponse,
      PostApiV1DataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/data`,
        method: "POST",
        body: queryArg.dataCreate,
      }),
    }),
    putApiV1DataById: build.mutation<
      PutApiV1DataByIdApiResponse,
      PutApiV1DataByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/data/${queryArg.id}`,
        method: "PUT",
        body: queryArg.dataCreate,
      }),
    }),
    deleteApiV1DataById: build.mutation<
      DeleteApiV1DataByIdApiResponse,
      DeleteApiV1DataByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/data/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    putApiV1Devices: build.mutation<
      PutApiV1DevicesApiResponse,
      PutApiV1DevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/devices`,
        method: "PUT",
        body: queryArg.deviceRegistrationRequest,
      }),
    }),
    getApiV1Devices: build.query<
      GetApiV1DevicesApiResponse,
      GetApiV1DevicesApiArg
    >({
      query: () => ({ url: `/api/v1/devices` }),
    }),
    deleteApiV1DevicesAll: build.mutation<
      DeleteApiV1DevicesAllApiResponse,
      DeleteApiV1DevicesAllApiArg
    >({
      query: () => ({ url: `/api/v1/devices/all`, method: "DELETE" }),
    }),
    getApiV1DevicesVapidPublicKey: build.query<
      GetApiV1DevicesVapidPublicKeyApiResponse,
      GetApiV1DevicesVapidPublicKeyApiArg
    >({
      query: () => ({ url: `/api/v1/devices/vapid-public-key` }),
    }),
    deleteApiV1DevicesByDeviceId: build.mutation<
      DeleteApiV1DevicesByDeviceIdApiResponse,
      DeleteApiV1DevicesByDeviceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/devices/${queryArg.deviceId}`,
        method: "DELETE",
      }),
    }),
    getApiV1DomainBlock: build.query<
      GetApiV1DomainBlockApiResponse,
      GetApiV1DomainBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/domain-block`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1Drafts: build.query<
      GetApiV1DraftsApiResponse,
      GetApiV1DraftsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/drafts`,
        params: {
          ownerId: queryArg.ownerId,
        },
      }),
    }),
    postApiV1Drafts: build.mutation<
      PostApiV1DraftsApiResponse,
      PostApiV1DraftsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/drafts`,
        method: "POST",
        body: queryArg.createDraftRequest,
        params: {
          ownerId: queryArg.ownerId,
        },
      }),
    }),
    getApiV1DraftsPostByPostId: build.query<
      GetApiV1DraftsPostByPostIdApiResponse,
      GetApiV1DraftsPostByPostIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/drafts/post/${queryArg.postId}` }),
    }),
    putApiV1DraftsByDraftId: build.mutation<
      PutApiV1DraftsByDraftIdApiResponse,
      PutApiV1DraftsByDraftIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/drafts/${queryArg.draftId}`,
        method: "PUT",
        body: queryArg.updateDraftRequest,
      }),
    }),
    getApiV1DraftsByDraftId: build.query<
      GetApiV1DraftsByDraftIdApiResponse,
      GetApiV1DraftsByDraftIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/drafts/${queryArg.draftId}` }),
    }),
    deleteApiV1DraftsByDraftId: build.mutation<
      DeleteApiV1DraftsByDraftIdApiResponse,
      DeleteApiV1DraftsByDraftIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/drafts/${queryArg.draftId}`,
        method: "DELETE",
      }),
    }),
    postApiV1DraftsByDraftIdPublish: build.mutation<
      PostApiV1DraftsByDraftIdPublishApiResponse,
      PostApiV1DraftsByDraftIdPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/drafts/${queryArg.draftId}/publish`,
        method: "POST",
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1Events: build.query<
      GetApiV1EventsApiResponse,
      GetApiV1EventsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events`,
        params: {
          groupId: queryArg.groupId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          organizerId: queryArg.organizerId,
          username: queryArg.username,
          withTranslation: queryArg.withTranslation,
        },
      }),
    }),
    postApiV1Events: build.mutation<
      PostApiV1EventsApiResponse,
      PostApiV1EventsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events`,
        method: "POST",
        body: queryArg.createEvent,
      }),
    }),
    getApiV1EventsCalendarGByGroupnameIcs: build.query<
      GetApiV1EventsCalendarGByGroupnameIcsApiResponse,
      GetApiV1EventsCalendarGByGroupnameIcsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/calendar/g/${queryArg.groupname}.ics`,
      }),
    }),
    getApiV1EventsCalendarPByIdIcs: build.query<
      GetApiV1EventsCalendarPByIdIcsApiResponse,
      GetApiV1EventsCalendarPByIdIcsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/calendar/p/${queryArg.id}.ics`,
      }),
    }),
    getApiV1EventsCalendarUByUsernameIcs: build.query<
      GetApiV1EventsCalendarUByUsernameIcsApiResponse,
      GetApiV1EventsCalendarUByUsernameIcsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/calendar/u/${queryArg.username}.ics`,
      }),
    }),
    getApiV1EventsMy: build.query<
      GetApiV1EventsMyApiResponse,
      GetApiV1EventsMyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/my`,
        params: {
          limit: queryArg.limit,
          notRespondedOnly: queryArg.notRespondedOnly,
          offset: queryArg.offset,
          organizedOnly: queryArg.organizedOnly,
          past: queryArg.past,
          withTranslation: queryArg.withTranslation,
        },
      }),
    }),
    getApiV1EventsSearch: build.query<
      GetApiV1EventsSearchApiResponse,
      GetApiV1EventsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/search`,
        params: {
          cancelled: queryArg.cancelled,
          distanceMeters: queryArg.distanceMeters,
          endTime: queryArg.endTime,
          faspHydrate: queryArg.faspHydrate,
          groupId: queryArg.groupId,
          lastId: queryArg.lastId,
          latitude: queryArg.latitude,
          limit: queryArg.limit,
          longitude: queryArg.longitude,
          mode: queryArg.mode,
          offset: queryArg.offset,
          order: queryArg.order,
          q: queryArg.q,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          startTime: queryArg.startTime,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1EventsSettings: build.query<
      GetApiV1EventsSettingsApiResponse,
      GetApiV1EventsSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/settings`,
        params: {
          ownerId: queryArg.ownerId,
        },
      }),
    }),
    postApiV1EventsSettingsRegeneratePrivateId: build.mutation<
      PostApiV1EventsSettingsRegeneratePrivateIdApiResponse,
      PostApiV1EventsSettingsRegeneratePrivateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/settings/regeneratePrivateId`,
        method: "POST",
        params: {
          ownerId: queryArg.ownerId,
        },
      }),
    }),
    postApiV1EventsSettingsUpdate: build.mutation<
      PostApiV1EventsSettingsUpdateApiResponse,
      PostApiV1EventsSettingsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/settings/update`,
        method: "POST",
        body: queryArg.updateEventsSettings,
        params: {
          ownerId: queryArg.ownerId,
        },
      }),
    }),
    putApiV1EventsByEventId: build.mutation<
      PutApiV1EventsByEventIdApiResponse,
      PutApiV1EventsByEventIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}`,
        method: "PUT",
        body: queryArg.updateEvent,
      }),
    }),
    getApiV1EventsByEventId: build.query<
      GetApiV1EventsByEventIdApiResponse,
      GetApiV1EventsByEventIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}`,
        params: {
          withTranslation: queryArg.withTranslation,
        },
      }),
    }),
    deleteApiV1EventsByEventId: build.mutation<
      DeleteApiV1EventsByEventIdApiResponse,
      DeleteApiV1EventsByEventIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}`,
        method: "DELETE",
      }),
    }),
    getApiV1EventsByEventIdIcs: build.query<
      GetApiV1EventsByEventIdIcsApiResponse,
      GetApiV1EventsByEventIdIcsApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}.ics` }),
    }),
    postApiV1EventsByEventIdAccept: build.mutation<
      PostApiV1EventsByEventIdAcceptApiResponse,
      PostApiV1EventsByEventIdAcceptApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/accept`,
        method: "POST",
      }),
    }),
    getApiV1EventsByEventIdAttendees: build.query<
      GetApiV1EventsByEventIdAttendeesApiResponse,
      GetApiV1EventsByEventIdAttendeesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/attendees`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    deleteApiV1EventsByEventIdAttendeesAndUserId: build.mutation<
      DeleteApiV1EventsByEventIdAttendeesAndUserIdApiResponse,
      DeleteApiV1EventsByEventIdAttendeesAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/attendees/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    postApiV1EventsByEventIdAttendeesAndUserId: build.mutation<
      PostApiV1EventsByEventIdAttendeesAndUserIdApiResponse,
      PostApiV1EventsByEventIdAttendeesAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/attendees/${queryArg.userId}`,
        method: "POST",
      }),
    }),
    postApiV1EventsByEventIdCancel: build.mutation<
      PostApiV1EventsByEventIdCancelApiResponse,
      PostApiV1EventsByEventIdCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/cancel`,
        method: "POST",
      }),
    }),
    postApiV1EventsByEventIdInterested: build.mutation<
      PostApiV1EventsByEventIdInterestedApiResponse,
      PostApiV1EventsByEventIdInterestedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/interested`,
        method: "POST",
      }),
    }),
    postApiV1EventsByEventIdJoin: build.mutation<
      PostApiV1EventsByEventIdJoinApiResponse,
      PostApiV1EventsByEventIdJoinApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/join`,
        method: "POST",
      }),
    }),
    deleteApiV1EventsByEventIdJoinOrInterested: build.mutation<
      DeleteApiV1EventsByEventIdJoinOrInterestedApiResponse,
      DeleteApiV1EventsByEventIdJoinOrInterestedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/joinOrInterested`,
        method: "DELETE",
      }),
    }),
    postApiV1EventsByEventIdMaybe: build.mutation<
      PostApiV1EventsByEventIdMaybeApiResponse,
      PostApiV1EventsByEventIdMaybeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/maybe`,
        method: "POST",
      }),
    }),
    getApiV1EventsByEventIdMutual: build.query<
      GetApiV1EventsByEventIdMutualApiResponse,
      GetApiV1EventsByEventIdMutualApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/mutual`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    postApiV1EventsByEventIdReject: build.mutation<
      PostApiV1EventsByEventIdRejectApiResponse,
      PostApiV1EventsByEventIdRejectApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/reject`,
        method: "POST",
      }),
    }),
    postApiV1EventsByEventIdTranslate: build.mutation<
      PostApiV1EventsByEventIdTranslateApiResponse,
      PostApiV1EventsByEventIdTranslateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/translate`,
        method: "POST",
        params: {
          lang: queryArg.lang,
        },
      }),
    }),
    postApiV1FaspClear: build.mutation<
      PostApiV1FaspClearApiResponse,
      PostApiV1FaspClearApiArg
    >({
      query: () => ({ url: `/api/v1/fasp/clear`, method: "POST" }),
    }),
    postApiV1FaspRegistration: build.mutation<
      PostApiV1FaspRegistrationApiResponse,
      PostApiV1FaspRegistrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/fasp/registration`,
        method: "POST",
        body: queryArg.registrationRequest,
      }),
    }),
    postApiV1FaspByProviderIdCapabilities: build.mutation<
      PostApiV1FaspByProviderIdCapabilitiesApiResponse,
      PostApiV1FaspByProviderIdCapabilitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/fasp/${queryArg.providerId}/capabilities`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV1FaspByProviderIdDebugCall: build.mutation<
      PostApiV1FaspByProviderIdDebugCallApiResponse,
      PostApiV1FaspByProviderIdDebugCallApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/fasp/${queryArg.providerId}/debug-call`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV1FaspByProviderIdRequestBackfill: build.mutation<
      PostApiV1FaspByProviderIdRequestBackfillApiResponse,
      PostApiV1FaspByProviderIdRequestBackfillApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/fasp/${queryArg.providerId}/request_backfill`,
        method: "POST",
        params: {
          category: queryArg.category,
        },
      }),
    }),
    postApiV1FederationTokens: build.mutation<
      PostApiV1FederationTokensApiResponse,
      PostApiV1FederationTokensApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/federation/tokens`,
        method: "POST",
        body: queryArg.groupFederationTokenRequest,
      }),
    }),
    getApiV1Geo: build.query<GetApiV1GeoApiResponse, GetApiV1GeoApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/geo`,
        params: {
          latitude: queryArg.latitude,
          longitude: queryArg.longitude,
        },
      }),
    }),
    getApiV1Groups: build.query<
      GetApiV1GroupsApiResponse,
      GetApiV1GroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1Groups: build.mutation<
      PostApiV1GroupsApiResponse,
      PostApiV1GroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups`,
        method: "POST",
        body: queryArg.groupCreate,
      }),
    }),
    getApiV1GroupsApps: build.query<
      GetApiV1GroupsAppsApiResponse,
      GetApiV1GroupsAppsApiArg
    >({
      query: () => ({ url: `/api/v1/groups/apps` }),
    }),
    getApiV1GroupsInvites: build.query<
      GetApiV1GroupsInvitesApiResponse,
      GetApiV1GroupsInvitesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/invites`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          status: queryArg.status,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsMemberByUserId: build.query<
      GetApiV1GroupsMemberByUserIdApiResponse,
      GetApiV1GroupsMemberByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/member/${queryArg.userId}`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsMemberByUserIdGroups: build.query<
      GetApiV1GroupsMemberByUserIdGroupsApiResponse,
      GetApiV1GroupsMemberByUserIdGroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/member/${queryArg.userId}/groups`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsMyGroups: build.query<
      GetApiV1GroupsMyGroupsApiResponse,
      GetApiV1GroupsMyGroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/my-groups`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsNameByGroupname: build.query<
      GetApiV1GroupsNameByGroupnameApiResponse,
      GetApiV1GroupsNameByGroupnameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/name/${queryArg.groupname}`,
      }),
    }),
    getApiV1GroupsOwned: build.query<
      GetApiV1GroupsOwnedApiResponse,
      GetApiV1GroupsOwnedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/owned`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsPinned: build.query<
      GetApiV1GroupsPinnedApiResponse,
      GetApiV1GroupsPinnedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/pinned`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsSearch: build.query<
      GetApiV1GroupsSearchApiResponse,
      GetApiV1GroupsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/search`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          substring: queryArg.substring,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsUsersByUserIdMutual: build.query<
      GetApiV1GroupsUsersByUserIdMutualApiResponse,
      GetApiV1GroupsUsersByUserIdMutualApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/users/${queryArg.userId}/mutual`,
      }),
    }),
    putApiV1GroupsByGroupId: build.mutation<
      PutApiV1GroupsByGroupIdApiResponse,
      PutApiV1GroupsByGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}`,
        method: "PUT",
        body: queryArg.groupUpdate,
      }),
    }),
    getApiV1GroupsByGroupId: build.query<
      GetApiV1GroupsByGroupIdApiResponse,
      GetApiV1GroupsByGroupIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/groups/${queryArg.groupId}` }),
    }),
    deleteApiV1GroupsByGroupId: build.mutation<
      DeleteApiV1GroupsByGroupIdApiResponse,
      DeleteApiV1GroupsByGroupIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}`,
        method: "DELETE",
      }),
    }),
    getApiV1GroupsByGroupIdApps: build.query<
      GetApiV1GroupsByGroupIdAppsApiResponse,
      GetApiV1GroupsByGroupIdAppsApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/groups/${queryArg.groupId}/apps` }),
    }),
    deleteApiV1GroupsByGroupIdAppsAndAppId: build.mutation<
      DeleteApiV1GroupsByGroupIdAppsAndAppIdApiResponse,
      DeleteApiV1GroupsByGroupIdAppsAndAppIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/apps/${queryArg.appId}`,
        method: "DELETE",
      }),
    }),
    putApiV1GroupsByGroupIdAppsAndAppId: build.mutation<
      PutApiV1GroupsByGroupIdAppsAndAppIdApiResponse,
      PutApiV1GroupsByGroupIdAppsAndAppIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/apps/${queryArg.appId}`,
        method: "PUT",
      }),
    }),
    getApiV1GroupsByGroupIdBlocks: build.query<
      GetApiV1GroupsByGroupIdBlocksApiResponse,
      GetApiV1GroupsByGroupIdBlocksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/blocks`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    deleteApiV1GroupsByGroupIdBlocks: build.mutation<
      DeleteApiV1GroupsByGroupIdBlocksApiResponse,
      DeleteApiV1GroupsByGroupIdBlocksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/blocks`,
        method: "DELETE",
        params: {
          type: queryArg["type"],
          value: queryArg.value,
        },
      }),
    }),
    postApiV1GroupsByGroupIdBlocks: build.mutation<
      PostApiV1GroupsByGroupIdBlocksApiResponse,
      PostApiV1GroupsByGroupIdBlocksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/blocks`,
        method: "POST",
        body: queryArg.groupBlockCreateRequest,
      }),
    }),
    putApiV1GroupsByGroupIdBranding: build.mutation<
      PutApiV1GroupsByGroupIdBrandingApiResponse,
      PutApiV1GroupsByGroupIdBrandingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/branding`,
        method: "PUT",
        body: queryArg.groupBrandingUpdate,
      }),
    }),
    getApiV1GroupsByGroupIdCategories: build.query<
      GetApiV1GroupsByGroupIdCategoriesApiResponse,
      GetApiV1GroupsByGroupIdCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/categories`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1GroupsByGroupIdCategories: build.mutation<
      PostApiV1GroupsByGroupIdCategoriesApiResponse,
      PostApiV1GroupsByGroupIdCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/categories`,
        method: "POST",
        body: queryArg.categoryCreate,
      }),
    }),
    getApiV1GroupsByGroupIdCategoriesNameAndCategoryName: build.query<
      GetApiV1GroupsByGroupIdCategoriesNameAndCategoryNameApiResponse,
      GetApiV1GroupsByGroupIdCategoriesNameAndCategoryNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/categories/name/${queryArg.categoryName}`,
      }),
    }),
    putApiV1GroupsByGroupIdCategoriesAndCategoryId: build.mutation<
      PutApiV1GroupsByGroupIdCategoriesAndCategoryIdApiResponse,
      PutApiV1GroupsByGroupIdCategoriesAndCategoryIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/categories/${queryArg.categoryId}`,
        method: "PUT",
        body: queryArg.categoryUpdate,
      }),
    }),
    getApiV1GroupsByGroupIdCategoriesAndCategoryId: build.query<
      GetApiV1GroupsByGroupIdCategoriesAndCategoryIdApiResponse,
      GetApiV1GroupsByGroupIdCategoriesAndCategoryIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/categories/${queryArg.categoryId}`,
      }),
    }),
    deleteApiV1GroupsByGroupIdCategoriesAndCategoryId: build.mutation<
      DeleteApiV1GroupsByGroupIdCategoriesAndCategoryIdApiResponse,
      DeleteApiV1GroupsByGroupIdCategoriesAndCategoryIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/categories/${queryArg.categoryId}`,
        method: "DELETE",
      }),
    }),
    getApiV1GroupsByGroupIdChannels: build.query<
      GetApiV1GroupsByGroupIdChannelsApiResponse,
      GetApiV1GroupsByGroupIdChannelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels`,
        params: {
          full: queryArg.full,
          userType: queryArg.userType,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1GroupsByGroupIdChannels: build.mutation<
      PostApiV1GroupsByGroupIdChannelsApiResponse,
      PostApiV1GroupsByGroupIdChannelsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels`,
        method: "POST",
        body: queryArg.body,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1GroupsByGroupIdChannelsAutoSubscribe: build.query<
      GetApiV1GroupsByGroupIdChannelsAutoSubscribeApiResponse,
      GetApiV1GroupsByGroupIdChannelsAutoSubscribeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/auto-subscribe`,
      }),
    }),
    getApiV1GroupsByGroupIdChannelsLookup: build.query<
      GetApiV1GroupsByGroupIdChannelsLookupApiResponse,
      GetApiV1GroupsByGroupIdChannelsLookupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/lookup`,
        params: {
          full: queryArg.full,
          username: queryArg.username,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1GroupsByGroupIdChannelsPrimary: build.query<
      GetApiV1GroupsByGroupIdChannelsPrimaryApiResponse,
      GetApiV1GroupsByGroupIdChannelsPrimaryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/primary`,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1GroupsByGroupIdChannelsPublic: build.query<
      GetApiV1GroupsByGroupIdChannelsPublicApiResponse,
      GetApiV1GroupsByGroupIdChannelsPublicApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/public`,
      }),
    }),
    putApiV1GroupsByGroupIdChannelsAndChannelId: build.mutation<
      PutApiV1GroupsByGroupIdChannelsAndChannelIdApiResponse,
      PutApiV1GroupsByGroupIdChannelsAndChannelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/${queryArg.channelId}`,
        method: "PUT",
        body: queryArg.body,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1GroupsByGroupIdChannelsAndChannelId: build.query<
      GetApiV1GroupsByGroupIdChannelsAndChannelIdApiResponse,
      GetApiV1GroupsByGroupIdChannelsAndChannelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/${queryArg.channelId}`,
        params: {
          full: queryArg.full,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    deleteApiV1GroupsByGroupIdChannelsAndChannelId: build.mutation<
      DeleteApiV1GroupsByGroupIdChannelsAndChannelIdApiResponse,
      DeleteApiV1GroupsByGroupIdChannelsAndChannelIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/${queryArg.channelId}`,
        method: "DELETE",
      }),
    }),
    putApiV1GroupsByGroupIdChannelsAndChannelIdAutoSubscribe: build.mutation<
      PutApiV1GroupsByGroupIdChannelsAndChannelIdAutoSubscribeApiResponse,
      PutApiV1GroupsByGroupIdChannelsAndChannelIdAutoSubscribeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/${queryArg.channelId}/auto-subscribe`,
        method: "PUT",
        params: {
          isAutoSubscribe: queryArg.isAutoSubscribe,
          subscribeExistingMembers: queryArg.subscribeExistingMembers,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1GroupsByGroupIdChannelsAndChannelIdPrimary: build.mutation<
      PutApiV1GroupsByGroupIdChannelsAndChannelIdPrimaryApiResponse,
      PutApiV1GroupsByGroupIdChannelsAndChannelIdPrimaryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/${queryArg.channelId}/primary`,
        method: "PUT",
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1GroupsByGroupIdChannelsAndChannelIdUsername: build.mutation<
      PutApiV1GroupsByGroupIdChannelsAndChannelIdUsernameApiResponse,
      PutApiV1GroupsByGroupIdChannelsAndChannelIdUsernameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/channels/${queryArg.channelId}/username`,
        method: "PUT",
        body: queryArg.body,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1GroupsByGroupIdDetails: build.query<
      GetApiV1GroupsByGroupIdDetailsApiResponse,
      GetApiV1GroupsByGroupIdDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/details`,
      }),
    }),
    postApiV1GroupsByGroupIdFederationToken: build.mutation<
      PostApiV1GroupsByGroupIdFederationTokenApiResponse,
      PostApiV1GroupsByGroupIdFederationTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/federation-token`,
        method: "POST",
      }),
    }),
    putApiV1GroupsByGroupIdForum: build.mutation<
      PutApiV1GroupsByGroupIdForumApiResponse,
      PutApiV1GroupsByGroupIdForumApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/forum`,
        method: "PUT",
        body: queryArg.forumUpdate,
      }),
    }),
    getApiV1GroupsByGroupIdForum: build.query<
      GetApiV1GroupsByGroupIdForumApiResponse,
      GetApiV1GroupsByGroupIdForumApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/forum`,
      }),
    }),
    deleteApiV1GroupsByGroupIdForum: build.mutation<
      DeleteApiV1GroupsByGroupIdForumApiResponse,
      DeleteApiV1GroupsByGroupIdForumApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/forum`,
        method: "DELETE",
      }),
    }),
    deleteApiV1GroupsByGroupIdForumHard: build.mutation<
      DeleteApiV1GroupsByGroupIdForumHardApiResponse,
      DeleteApiV1GroupsByGroupIdForumHardApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/forum/hard`,
        method: "DELETE",
      }),
    }),
    getApiV1GroupsByGroupIdForumStats: build.query<
      GetApiV1GroupsByGroupIdForumStatsApiResponse,
      GetApiV1GroupsByGroupIdForumStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/forum/stats`,
      }),
    }),
    getApiV1GroupsByGroupIdForumTags: build.query<
      GetApiV1GroupsByGroupIdForumTagsApiResponse,
      GetApiV1GroupsByGroupIdForumTagsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/forum/tags`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsByGroupIdForumTagsSearch: build.query<
      GetApiV1GroupsByGroupIdForumTagsSearchApiResponse,
      GetApiV1GroupsByGroupIdForumTagsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/forum/tags/search`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          q: queryArg.q,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1GroupsByGroupIdInvite: build.query<
      GetApiV1GroupsByGroupIdInviteApiResponse,
      GetApiV1GroupsByGroupIdInviteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/invite`,
      }),
    }),
    getApiV1GroupsByGroupIdInvites: build.query<
      GetApiV1GroupsByGroupIdInvitesApiResponse,
      GetApiV1GroupsByGroupIdInvitesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/invites`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          status: queryArg.status,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1GroupsByGroupIdInvites: build.mutation<
      PostApiV1GroupsByGroupIdInvitesApiResponse,
      PostApiV1GroupsByGroupIdInvitesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/invites`,
        method: "POST",
        body: queryArg.groupInviteCreate,
      }),
    }),
    postApiV1GroupsByGroupIdInvitesAccept: build.mutation<
      PostApiV1GroupsByGroupIdInvitesAcceptApiResponse,
      PostApiV1GroupsByGroupIdInvitesAcceptApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/invites/accept`,
        method: "POST",
      }),
    }),
    postApiV1GroupsByGroupIdInvitesReject: build.mutation<
      PostApiV1GroupsByGroupIdInvitesRejectApiResponse,
      PostApiV1GroupsByGroupIdInvitesRejectApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/invites/reject`,
        method: "POST",
      }),
    }),
    deleteApiV1GroupsByGroupIdInvitesAndGroupInviteId: build.mutation<
      DeleteApiV1GroupsByGroupIdInvitesAndGroupInviteIdApiResponse,
      DeleteApiV1GroupsByGroupIdInvitesAndGroupInviteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/invites/${queryArg.groupInviteId}`,
        method: "DELETE",
      }),
    }),
    postApiV1GroupsByGroupIdJoin: build.mutation<
      PostApiV1GroupsByGroupIdJoinApiResponse,
      PostApiV1GroupsByGroupIdJoinApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/join`,
        method: "POST",
        params: {
          answerToken: queryArg.answerToken,
        },
      }),
    }),
    deleteApiV1GroupsByGroupIdJoin: build.mutation<
      DeleteApiV1GroupsByGroupIdJoinApiResponse,
      DeleteApiV1GroupsByGroupIdJoinApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/join`,
        method: "DELETE",
      }),
    }),
    getApiV1GroupsByGroupIdJoinRequests: build.query<
      GetApiV1GroupsByGroupIdJoinRequestsApiResponse,
      GetApiV1GroupsByGroupIdJoinRequestsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/join-requests`,
        params: {
          createdFrom: queryArg.createdFrom,
          createdTo: queryArg.createdTo,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          status: queryArg.status,
          untilId: queryArg.untilId,
          username: queryArg.username,
        },
      }),
    }),
    deleteApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestId: build.mutation<
      DeleteApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdApiResponse,
      DeleteApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/join-requests/${queryArg.groupJoinRequestId}`,
        method: "DELETE",
        params: {
          purge: queryArg.purge,
          reason: queryArg.reason,
        },
      }),
    }),
    putApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestId: build.mutation<
      PutApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdApiResponse,
      PutApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/join-requests/${queryArg.groupJoinRequestId}`,
        method: "PUT",
        params: {
          reason: queryArg.reason,
        },
      }),
    }),
    putApiV1GroupsByGroupIdMemberSettings: build.mutation<
      PutApiV1GroupsByGroupIdMemberSettingsApiResponse,
      PutApiV1GroupsByGroupIdMemberSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/member-settings`,
        method: "PUT",
        body: queryArg.groupMemberSettings,
      }),
    }),
    getApiV1GroupsByGroupIdMemberSettings: build.query<
      GetApiV1GroupsByGroupIdMemberSettingsApiResponse,
      GetApiV1GroupsByGroupIdMemberSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/member-settings`,
        params: {
          keys: queryArg.keys,
        },
      }),
    }),
    deleteApiV1GroupsByGroupIdMemberSettings: build.mutation<
      DeleteApiV1GroupsByGroupIdMemberSettingsApiResponse,
      DeleteApiV1GroupsByGroupIdMemberSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/member-settings`,
        method: "DELETE",
        params: {
          keys: queryArg.keys,
        },
      }),
    }),
    getApiV1GroupsByGroupIdMembers: build.query<
      GetApiV1GroupsByGroupIdMembersApiResponse,
      GetApiV1GroupsByGroupIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/members`,
        params: {
          actorType: queryArg.actorType,
          createdAfter: queryArg.createdAfter,
          displayName: queryArg.displayName,
          domain: queryArg.domain,
          limit: queryArg.limit,
          offset: queryArg.offset,
          order: queryArg.order,
          role: queryArg.role,
          sort: queryArg.sort,
          username: queryArg.username,
        },
      }),
    }),
    postApiV1GroupsByGroupIdMembers: build.mutation<
      PostApiV1GroupsByGroupIdMembersApiResponse,
      PostApiV1GroupsByGroupIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/members`,
        method: "POST",
        body: queryArg.groupMemberCreate,
      }),
    }),
    getApiV1GroupsByGroupIdMembersSearch: build.query<
      GetApiV1GroupsByGroupIdMembersSearchApiResponse,
      GetApiV1GroupsByGroupIdMembersSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/members/search`,
        params: {
          actorType: queryArg.actorType,
          country: queryArg.country,
          createdAfter: queryArg.createdAfter,
          displayName: queryArg.displayName,
          domain: queryArg.domain,
          ip: queryArg.ip,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          role: queryArg.role,
          roles: queryArg.roles,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          username: queryArg.username,
        },
      }),
    }),
    putApiV1GroupsByGroupIdMembersAndMemberId: build.mutation<
      PutApiV1GroupsByGroupIdMembersAndMemberIdApiResponse,
      PutApiV1GroupsByGroupIdMembersAndMemberIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/members/${queryArg.memberId}`,
        method: "PUT",
        body: queryArg.groupMemberUpdate,
      }),
    }),
    deleteApiV1GroupsByGroupIdMembersAndMemberId: build.mutation<
      DeleteApiV1GroupsByGroupIdMembersAndMemberIdApiResponse,
      DeleteApiV1GroupsByGroupIdMembersAndMemberIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/members/${queryArg.memberId}`,
        method: "DELETE",
        params: {
          reason: queryArg.reason,
        },
      }),
    }),
    postApiV1GroupsByGroupIdMembersAndNewOwnerIdTransferOwnership:
      build.mutation<
        PostApiV1GroupsByGroupIdMembersAndNewOwnerIdTransferOwnershipApiResponse,
        PostApiV1GroupsByGroupIdMembersAndNewOwnerIdTransferOwnershipApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1/groups/${queryArg.groupId}/members/${queryArg.newOwnerId}/transfer-ownership`,
          method: "POST",
        }),
      }),
    deleteApiV1GroupsByGroupIdMembership: build.mutation<
      DeleteApiV1GroupsByGroupIdMembershipApiResponse,
      DeleteApiV1GroupsByGroupIdMembershipApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/membership`,
        method: "DELETE",
      }),
    }),
    getApiV1GroupsByGroupIdMembership: build.query<
      GetApiV1GroupsByGroupIdMembershipApiResponse,
      GetApiV1GroupsByGroupIdMembershipApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/membership`,
      }),
    }),
    deleteApiV1GroupsByGroupIdPin: build.mutation<
      DeleteApiV1GroupsByGroupIdPinApiResponse,
      DeleteApiV1GroupsByGroupIdPinApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/pin`,
        method: "DELETE",
      }),
    }),
    putApiV1GroupsByGroupIdPin: build.mutation<
      PutApiV1GroupsByGroupIdPinApiResponse,
      PutApiV1GroupsByGroupIdPinApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/pin`,
        method: "PUT",
        params: {
          pin: queryArg.pin,
        },
      }),
    }),
    getApiV1GroupsByGroupIdQuestions: build.query<
      GetApiV1GroupsByGroupIdQuestionsApiResponse,
      GetApiV1GroupsByGroupIdQuestionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/questions`,
      }),
    }),
    postApiV1GroupsByGroupIdQuestions: build.mutation<
      PostApiV1GroupsByGroupIdQuestionsApiResponse,
      PostApiV1GroupsByGroupIdQuestionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/questions`,
        method: "POST",
        body: queryArg.questionCreate,
      }),
    }),
    postApiV1GroupsByGroupIdQuestionsAnswers: build.mutation<
      PostApiV1GroupsByGroupIdQuestionsAnswersApiResponse,
      PostApiV1GroupsByGroupIdQuestionsAnswersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/questions/answers`,
        method: "POST",
        body: queryArg.questionAnswerCreate,
      }),
    }),
    putApiV1GroupsByGroupIdQuestionsAndQuestionId: build.mutation<
      PutApiV1GroupsByGroupIdQuestionsAndQuestionIdApiResponse,
      PutApiV1GroupsByGroupIdQuestionsAndQuestionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/questions/${queryArg.questionId}`,
        method: "PUT",
        body: queryArg.questionUpdate,
      }),
    }),
    deleteApiV1GroupsByGroupIdQuestionsAndQuestionId: build.mutation<
      DeleteApiV1GroupsByGroupIdQuestionsAndQuestionIdApiResponse,
      DeleteApiV1GroupsByGroupIdQuestionsAndQuestionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/questions/${queryArg.questionId}`,
        method: "DELETE",
      }),
    }),
    getApiV1GroupsByGroupIdRules: build.query<
      GetApiV1GroupsByGroupIdRulesApiResponse,
      GetApiV1GroupsByGroupIdRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/rules`,
      }),
    }),
    postApiV1GroupsByGroupIdRules: build.mutation<
      PostApiV1GroupsByGroupIdRulesApiResponse,
      PostApiV1GroupsByGroupIdRulesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/rules`,
        method: "POST",
        params: {
          hint: queryArg.hint,
          ordering: queryArg.ordering,
          text: queryArg.text,
        },
      }),
    }),
    postApiV1GroupsByGroupIdRulesReorder: build.mutation<
      PostApiV1GroupsByGroupIdRulesReorderApiResponse,
      PostApiV1GroupsByGroupIdRulesReorderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/rules/reorder`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiV1GroupsByGroupIdRulesAndId: build.mutation<
      DeleteApiV1GroupsByGroupIdRulesAndIdApiResponse,
      DeleteApiV1GroupsByGroupIdRulesAndIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/rules/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    putApiV1GroupsByGroupIdRulesAndRuleId: build.mutation<
      PutApiV1GroupsByGroupIdRulesAndRuleIdApiResponse,
      PutApiV1GroupsByGroupIdRulesAndRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/rules/${queryArg.ruleId}`,
        method: "PUT",
        body: queryArg.ruleUpdate,
      }),
    }),
    putApiV1GroupsByGroupIdSettings: build.mutation<
      PutApiV1GroupsByGroupIdSettingsApiResponse,
      PutApiV1GroupsByGroupIdSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/settings`,
        method: "PUT",
        body: queryArg.groupSettings,
      }),
    }),
    getApiV1GroupsByGroupIdSettings: build.query<
      GetApiV1GroupsByGroupIdSettingsApiResponse,
      GetApiV1GroupsByGroupIdSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/settings`,
        params: {
          keys: queryArg.keys,
        },
      }),
    }),
    deleteApiV1GroupsByGroupIdSettings: build.mutation<
      DeleteApiV1GroupsByGroupIdSettingsApiResponse,
      DeleteApiV1GroupsByGroupIdSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/settings`,
        method: "DELETE",
        params: {
          keys: queryArg.keys,
        },
      }),
    }),
    getApiV1GroupsByGroupIdUsers: build.query<
      GetApiV1GroupsByGroupIdUsersApiResponse,
      GetApiV1GroupsByGroupIdUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/groups/${queryArg.groupId}/users`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          order: queryArg.order,
          role: queryArg.role,
          sort: queryArg.sort,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1Import: build.query<
      GetApiV1ImportApiResponse,
      GetApiV1ImportApiArg
    >({
      query: () => ({ url: `/api/v1/import` }),
    }),
    postApiV1Import: build.mutation<
      PostApiV1ImportApiResponse,
      PostApiV1ImportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/import`,
        method: "POST",
        body: queryArg.body,
        params: {
          overwrite: queryArg.overwrite,
          type: queryArg["type"],
        },
      }),
    }),
    postApiV1ImportStartById: build.mutation<
      PostApiV1ImportStartByIdApiResponse,
      PostApiV1ImportStartByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/import/start/${queryArg.id}`,
        method: "POST",
      }),
    }),
    getApiV1ImportById: build.query<
      GetApiV1ImportByIdApiResponse,
      GetApiV1ImportByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/import/${queryArg.id}` }),
    }),
    getApiV1Instance: build.query<
      GetApiV1InstanceApiResponse,
      GetApiV1InstanceApiArg
    >({
      query: () => ({ url: `/api/v1/instance` }),
    }),
    getApiV1InstanceCountries: build.query<
      GetApiV1InstanceCountriesApiResponse,
      GetApiV1InstanceCountriesApiArg
    >({
      query: () => ({ url: `/api/v1/instance/countries` }),
    }),
    getApiV1InstanceDomains: build.query<
      GetApiV1InstanceDomainsApiResponse,
      GetApiV1InstanceDomainsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/instance/domains`,
        params: {
          domain: queryArg.domain,
          limit: queryArg.limit,
          software: queryArg.software,
        },
      }),
    }),
    getApiV1InstanceExtendedDescription: build.query<
      GetApiV1InstanceExtendedDescriptionApiResponse,
      GetApiV1InstanceExtendedDescriptionApiArg
    >({
      query: () => ({ url: `/api/v1/instance/extended_description` }),
    }),
    getApiV1InstanceSupportedLanguages: build.query<
      GetApiV1InstanceSupportedLanguagesApiResponse,
      GetApiV1InstanceSupportedLanguagesApiArg
    >({
      query: () => ({ url: `/api/v1/instance/supported_languages` }),
    }),
    getApiV1InstanceTimezones: build.query<
      GetApiV1InstanceTimezonesApiResponse,
      GetApiV1InstanceTimezonesApiArg
    >({
      query: () => ({ url: `/api/v1/instance/timezones` }),
    }),
    deleteApiV1JobsClear: build.mutation<
      DeleteApiV1JobsClearApiResponse,
      DeleteApiV1JobsClearApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/clear`,
        method: "DELETE",
        params: {
          listKind: queryArg.listKind,
          queue: queryArg.queue,
        },
      }),
    }),
    getApiV1JobsDlq: build.query<
      GetApiV1JobsDlqApiResponse,
      GetApiV1JobsDlqApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/dlq`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    deleteApiV1JobsJob: build.mutation<
      DeleteApiV1JobsJobApiResponse,
      DeleteApiV1JobsJobApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/job`,
        method: "DELETE",
        params: {
          jobHash: queryArg.jobHash,
          listKind: queryArg.listKind,
          queue: queryArg.queue,
        },
      }),
    }),
    getApiV1JobsListJobs: build.query<
      GetApiV1JobsListJobsApiResponse,
      GetApiV1JobsListJobsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/list-jobs`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    getApiV1JobsListStats: build.query<
      GetApiV1JobsListStatsApiResponse,
      GetApiV1JobsListStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/list-stats`,
        params: {
          queue: queryArg.queue,
        },
      }),
    }),
    getApiV1JobsListStatsAll: build.query<
      GetApiV1JobsListStatsAllApiResponse,
      GetApiV1JobsListStatsAllApiArg
    >({
      query: () => ({ url: `/api/v1/jobs/list-stats-all` }),
    }),
    getApiV1JobsLists: build.query<
      GetApiV1JobsListsApiResponse,
      GetApiV1JobsListsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/lists`,
        params: {
          limit: queryArg.limit,
          listKind: queryArg.listKind,
          offset: queryArg.offset,
          queue: queryArg.queue,
        },
      }),
    }),
    getApiV1JobsProcesses: build.query<
      GetApiV1JobsProcessesApiResponse,
      GetApiV1JobsProcessesApiArg
    >({
      query: () => ({ url: `/api/v1/jobs/processes` }),
    }),
    getApiV1JobsRedisInfo: build.query<
      GetApiV1JobsRedisInfoApiResponse,
      GetApiV1JobsRedisInfoApiArg
    >({
      query: () => ({ url: `/api/v1/jobs/redis-info` }),
    }),
    postApiV1JobsRetry: build.mutation<
      PostApiV1JobsRetryApiResponse,
      PostApiV1JobsRetryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/retry`,
        method: "POST",
        params: {
          jobHash: queryArg.jobHash,
          queue: queryArg.queue,
        },
      }),
    }),
    postApiV1JobsRetryAll: build.mutation<
      PostApiV1JobsRetryAllApiResponse,
      PostApiV1JobsRetryAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/retry-all`,
        method: "POST",
        params: {
          queue: queryArg.queue,
        },
      }),
    }),
    getApiV1JobsStats: build.query<
      GetApiV1JobsStatsApiResponse,
      GetApiV1JobsStatsApiArg
    >({
      query: () => ({ url: `/api/v1/jobs/stats` }),
    }),
    getApiV1JobsStatsPerDay: build.query<
      GetApiV1JobsStatsPerDayApiResponse,
      GetApiV1JobsStatsPerDayApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/jobs/stats-per-day`,
        params: {
          lastDays: queryArg.lastDays,
          queue: queryArg.queue,
        },
      }),
    }),
    getApiV1JobsSummary: build.query<
      GetApiV1JobsSummaryApiResponse,
      GetApiV1JobsSummaryApiArg
    >({
      query: () => ({ url: `/api/v1/jobs/summary` }),
    }),
    getApiV1JobsWorkers: build.query<
      GetApiV1JobsWorkersApiResponse,
      GetApiV1JobsWorkersApiArg
    >({
      query: () => ({ url: `/api/v1/jobs/workers` }),
    }),
    getApiV1Links: build.query<GetApiV1LinksApiResponse, GetApiV1LinksApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/links`,
        params: {
          url: queryArg.url,
        },
      }),
    }),
    getApiV1Lists: build.query<GetApiV1ListsApiResponse, GetApiV1ListsApiArg>({
      query: () => ({ url: `/api/v1/lists` }),
    }),
    postApiV1Lists: build.mutation<
      PostApiV1ListsApiResponse,
      PostApiV1ListsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/lists`,
        method: "POST",
        body: queryArg.userListCreate,
      }),
    }),
    putApiV1ListsByListId: build.mutation<
      PutApiV1ListsByListIdApiResponse,
      PutApiV1ListsByListIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/lists/${queryArg.listId}`,
        method: "PUT",
        body: queryArg.userListCreate,
      }),
    }),
    getApiV1ListsByListId: build.query<
      GetApiV1ListsByListIdApiResponse,
      GetApiV1ListsByListIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/lists/${queryArg.listId}` }),
    }),
    deleteApiV1ListsByListId: build.mutation<
      DeleteApiV1ListsByListIdApiResponse,
      DeleteApiV1ListsByListIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/lists/${queryArg.listId}`,
        method: "DELETE",
      }),
    }),
    getApiV1ListsByListIdUsers: build.query<
      GetApiV1ListsByListIdUsersApiResponse,
      GetApiV1ListsByListIdUsersApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/lists/${queryArg.listId}/users` }),
    }),
    deleteApiV1ListsByListIdUsersAndUserId: build.mutation<
      DeleteApiV1ListsByListIdUsersAndUserIdApiResponse,
      DeleteApiV1ListsByListIdUsersAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/lists/${queryArg.listId}/users/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    postApiV1ListsByListIdUsersAndUserId: build.mutation<
      PostApiV1ListsByListIdUsersAndUserIdApiResponse,
      PostApiV1ListsByListIdUsersAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/lists/${queryArg.listId}/users/${queryArg.userId}`,
        method: "POST",
      }),
    }),
    putApiV1Markdown: build.mutation<
      PutApiV1MarkdownApiResponse,
      PutApiV1MarkdownApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/markdown`,
        method: "PUT",
        body: queryArg.body,
        params: {
          skipAutolink: queryArg.skipAutolink,
        },
      }),
    }),
    getApiV1Metrics: build.query<
      GetApiV1MetricsApiResponse,
      GetApiV1MetricsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/metrics`,
        params: {
          from: queryArg["from"],
          period: queryArg.period,
          to: queryArg.to,
        },
      }),
    }),
    getApiV1MetricsTotals: build.query<
      GetApiV1MetricsTotalsApiResponse,
      GetApiV1MetricsTotalsApiArg
    >({
      query: () => ({ url: `/api/v1/metrics/totals` }),
    }),
    getApiV1Mute: build.query<GetApiV1MuteApiResponse, GetApiV1MuteApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/mute`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    deleteApiV1MuteByUserId: build.mutation<
      DeleteApiV1MuteByUserIdApiResponse,
      DeleteApiV1MuteByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/mute/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    postApiV1MuteByUserId: build.mutation<
      PostApiV1MuteByUserIdApiResponse,
      PostApiV1MuteByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/mute/${queryArg.userId}`,
        method: "POST",
        params: {
          duration: queryArg.duration,
        },
      }),
    }),
    getApiV1NamesCheck: build.query<
      GetApiV1NamesCheckApiResponse,
      GetApiV1NamesCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/names/check`,
        params: {
          name: queryArg.name,
          nameScope: queryArg.nameScope,
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1Notes: build.mutation<
      PutApiV1NotesApiResponse,
      PutApiV1NotesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notes`,
        method: "PUT",
        body: queryArg.noteUpdate,
      }),
    }),
    getApiV1Notes: build.query<GetApiV1NotesApiResponse, GetApiV1NotesApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/notes`,
        params: {
          userIds: queryArg.userIds,
        },
      }),
    }),
    deleteApiV1NotesByUserId: build.mutation<
      DeleteApiV1NotesByUserIdApiResponse,
      DeleteApiV1NotesByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notes/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getApiV1Notifications: build.query<
      GetApiV1NotificationsApiResponse,
      GetApiV1NotificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notifications`,
        params: {
          excludeTypes: queryArg.excludeTypes,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          status: queryArg.status,
          types: queryArg.types,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1NotificationsCount: build.query<
      GetApiV1NotificationsCountApiResponse,
      GetApiV1NotificationsCountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notifications/count`,
        params: {
          excludeTypes: queryArg.excludeTypes,
          status: queryArg.status,
          types: queryArg.types,
        },
      }),
    }),
    postApiV1NotificationsMarkAll: build.mutation<
      PostApiV1NotificationsMarkAllApiResponse,
      PostApiV1NotificationsMarkAllApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notifications/mark-all`,
        method: "POST",
        params: {
          status: queryArg.status,
          type: queryArg["type"],
        },
      }),
    }),
    getApiV1NotificationsById: build.query<
      GetApiV1NotificationsByIdApiResponse,
      GetApiV1NotificationsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notifications/${queryArg.id}`,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1NotificationsByIdMark: build.mutation<
      PostApiV1NotificationsByIdMarkApiResponse,
      PostApiV1NotificationsByIdMarkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notifications/${queryArg.id}/mark`,
        method: "POST",
        params: {
          status: queryArg.status,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1Passkeys: build.query<
      GetApiV1PasskeysApiResponse,
      GetApiV1PasskeysApiArg
    >({
      query: () => ({ url: `/api/v1/passkeys` }),
    }),
    getApiV1PasskeysBeginAuth: build.query<
      GetApiV1PasskeysBeginAuthApiResponse,
      GetApiV1PasskeysBeginAuthApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/passkeys/begin-auth`,
        params: {
          username: queryArg.username,
        },
      }),
    }),
    getApiV1PasskeysBeginRegister: build.query<
      GetApiV1PasskeysBeginRegisterApiResponse,
      GetApiV1PasskeysBeginRegisterApiArg
    >({
      query: () => ({ url: `/api/v1/passkeys/begin-register` }),
    }),
    postApiV1PasskeysFinishAuth: build.mutation<
      PostApiV1PasskeysFinishAuthApiResponse,
      PostApiV1PasskeysFinishAuthApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/passkeys/finish-auth`,
        method: "POST",
        body: queryArg.jsonObject,
      }),
    }),
    postApiV1PasskeysFinishRegister: build.mutation<
      PostApiV1PasskeysFinishRegisterApiResponse,
      PostApiV1PasskeysFinishRegisterApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/passkeys/finish-register`,
        method: "POST",
        body: queryArg.jsonObject,
      }),
    }),
    deleteApiV1PasskeysByCredentialId: build.mutation<
      DeleteApiV1PasskeysByCredentialIdApiResponse,
      DeleteApiV1PasskeysByCredentialIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/passkeys/${queryArg.credentialId}`,
        method: "DELETE",
      }),
    }),
    postApiV1PollsByPollIdRefresh: build.mutation<
      PostApiV1PollsByPollIdRefreshApiResponse,
      PostApiV1PollsByPollIdRefreshApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/polls/${queryArg.pollId}/refresh`,
        method: "POST",
      }),
    }),
    postApiV1PollsByPollIdVote: build.mutation<
      PostApiV1PollsByPollIdVoteApiResponse,
      PostApiV1PollsByPollIdVoteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/polls/${queryArg.pollId}/vote`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiV1Posts: build.query<GetApiV1PostsApiResponse, GetApiV1PostsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/posts`,
        params: {
          all: queryArg.all,
          bookmarkedOnly: queryArg.bookmarkedOnly,
          forumTags: queryArg.forumTags,
          includeBookmarkStatus: queryArg.includeBookmarkStatus,
          includeComments: queryArg.includeComments,
          includeFollowStatus: queryArg.includeFollowStatus,
          includePinnedStatus: queryArg.includePinnedStatus,
          includeReply: queryArg.includeReply,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          limitFirstLevelComments: queryArg.limitFirstLevelComments,
          limitPerLevelComments: queryArg.limitPerLevelComments,
          limitSecondLevelComments: queryArg.limitSecondLevelComments,
          listId: queryArg.listId,
          maxLevel: queryArg.maxLevel,
          minLevel: queryArg.minLevel,
          offset: queryArg.offset,
          ownerId: queryArg.ownerId,
          pinned: queryArg.pinned,
          repostKind: queryArg.repostKind,
          repostOf: queryArg.repostOf,
          repostsOnly: queryArg.repostsOnly,
          search: queryArg.search,
          skipReposts: queryArg.skipReposts,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          tag: queryArg.tag,
          untilId: queryArg.untilId,
          userId: queryArg.userId,
          username: queryArg.username,
          withRepostedBy: queryArg.withRepostedBy,
          withTranslation: queryArg.withTranslation,
          withTrends: queryArg.withTrends,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1Posts: build.mutation<
      PostApiV1PostsApiResponse,
      PostApiV1PostsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts`,
        method: "POST",
        body: queryArg.createPost,
        params: {
          ownerId: queryArg.ownerId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsBookmarked: build.query<
      GetApiV1PostsBookmarkedApiResponse,
      GetApiV1PostsBookmarkedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/bookmarked`,
        params: {
          includeComments: queryArg.includeComments,
          includePublisher: queryArg.includePublisher,
          includeReply: queryArg.includeReply,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          my: queryArg.my,
          offset: queryArg.offset,
          ownerId: queryArg.ownerId,
          search: queryArg.search,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsFeedsFollowing: build.query<
      GetApiV1PostsFeedsFollowingApiResponse,
      GetApiV1PostsFeedsFollowingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/feeds/following`,
        params: {
          ignoreCache: queryArg.ignoreCache,
          includeBookmarkStatus: queryArg.includeBookmarkStatus,
          includeFollowStatus: queryArg.includeFollowStatus,
          includePublisher: queryArg.includePublisher,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          withRepostedBy: queryArg.withRepostedBy,
          withTranslation: queryArg.withTranslation,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsFeedsPublic: build.query<
      GetApiV1PostsFeedsPublicApiResponse,
      GetApiV1PostsFeedsPublicApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/feeds/public`,
        params: {
          includeBookmarkStatus: queryArg.includeBookmarkStatus,
          includeFollowStatus: queryArg.includeFollowStatus,
          includePublisher: queryArg.includePublisher,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          local: queryArg.local,
          offset: queryArg.offset,
          skipReposts: queryArg.skipReposts,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          withRepostedBy: queryArg.withRepostedBy,
          withTranslation: queryArg.withTranslation,
          withTrends: queryArg.withTrends,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsLiked: build.query<
      GetApiV1PostsLikedApiResponse,
      GetApiV1PostsLikedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/liked`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          ownerId: queryArg.ownerId,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsMentioned: build.query<
      GetApiV1PostsMentionedApiResponse,
      GetApiV1PostsMentionedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/mentioned`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          ownerId: queryArg.ownerId,
          private: queryArg["private"],
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsMy: build.query<
      GetApiV1PostsMyApiResponse,
      GetApiV1PostsMyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/my`,
        params: {
          bookmarkedOnly: queryArg.bookmarkedOnly,
          includeBookmarkStatus: queryArg.includeBookmarkStatus,
          includeComments: queryArg.includeComments,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          ownerId: queryArg.ownerId,
          repostsOnly: queryArg.repostsOnly,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsPins: build.query<
      GetApiV1PostsPinsApiResponse,
      GetApiV1PostsPinsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/pins`,
        params: {
          ownerId: queryArg.ownerId,
          postOnly: queryArg.postOnly,
        },
      }),
    }),
    deleteApiV1PostsPinsByPostId: build.mutation<
      DeleteApiV1PostsPinsByPostIdApiResponse,
      DeleteApiV1PostsPinsByPostIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/pins/${queryArg.postId}`,
        method: "DELETE",
      }),
    }),
    postApiV1PostsPinsByPostId: build.mutation<
      PostApiV1PostsPinsByPostIdApiResponse,
      PostApiV1PostsPinsByPostIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/pins/${queryArg.postId}`,
        method: "POST",
      }),
    }),
    getApiV1PostsReplies: build.query<
      GetApiV1PostsRepliesApiResponse,
      GetApiV1PostsRepliesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/replies`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          ownerId: queryArg.ownerId,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          userId: queryArg.userId,
          username: queryArg.username,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsSubscriptions: build.query<
      GetApiV1PostsSubscriptionsApiResponse,
      GetApiV1PostsSubscriptionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/subscriptions`,
        params: {
          all: queryArg.all,
          ownerId: queryArg.ownerId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1PostsByPostId: build.mutation<
      PutApiV1PostsByPostIdApiResponse,
      PutApiV1PostsByPostIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}`,
        method: "PUT",
        body: queryArg.createPost,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsByPostId: build.query<
      GetApiV1PostsByPostIdApiResponse,
      GetApiV1PostsByPostIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}`,
        params: {
          includeBookmarkStatus: queryArg.includeBookmarkStatus,
          includePublisher: queryArg.includePublisher,
          limitFirstLevelComments: queryArg.limitFirstLevelComments,
          limitPerLevelComments: queryArg.limitPerLevelComments,
          limitSecondLevelComments: queryArg.limitSecondLevelComments,
          maxLevel: queryArg.maxLevel,
          minLevel: queryArg.minLevel,
          withComments: queryArg.withComments,
          withParents: queryArg.withParents,
          withRepostedBy: queryArg.withRepostedBy,
          withRootParent: queryArg.withRootParent,
          withTranslation: queryArg.withTranslation,
          withTrends: queryArg.withTrends,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    deleteApiV1PostsByPostId: build.mutation<
      DeleteApiV1PostsByPostIdApiResponse,
      DeleteApiV1PostsByPostIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}`,
        method: "DELETE",
      }),
    }),
    getApiV1PostsByPostIdActiveUsers: build.query<
      GetApiV1PostsByPostIdActiveUsersApiResponse,
      GetApiV1PostsByPostIdActiveUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/active-users`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    deleteApiV1PostsByPostIdBookmark: build.mutation<
      DeleteApiV1PostsByPostIdBookmarkApiResponse,
      DeleteApiV1PostsByPostIdBookmarkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/bookmark`,
        method: "DELETE",
      }),
    }),
    postApiV1PostsByPostIdBookmark: build.mutation<
      PostApiV1PostsByPostIdBookmarkApiResponse,
      PostApiV1PostsByPostIdBookmarkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/bookmark`,
        method: "POST",
      }),
    }),
    getApiV1PostsByPostIdCommenters: build.query<
      GetApiV1PostsByPostIdCommentersApiResponse,
      GetApiV1PostsByPostIdCommentersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/commenters`,
        params: {
          includeFollowedStatus: queryArg.includeFollowedStatus,
          includeFollowingStatus: queryArg.includeFollowingStatus,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          skipDuplicates: queryArg.skipDuplicates,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsByPostIdComments: build.query<
      GetApiV1PostsByPostIdCommentsApiResponse,
      GetApiV1PostsByPostIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/comments`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          limitFirstLevelComments: queryArg.limitFirstLevelComments,
          limitPerLevelComments: queryArg.limitPerLevelComments,
          maxLevel: queryArg.maxLevel,
          minLevel: queryArg.minLevel,
          offset: queryArg.offset,
          pinned: queryArg.pinned,
          skipDuplicates: queryArg.skipDuplicates,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1PostsByPostIdComments: build.mutation<
      PostApiV1PostsByPostIdCommentsApiResponse,
      PostApiV1PostsByPostIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/comments`,
        method: "POST",
        body: queryArg.createPost,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1PostsByPostIdCommentsAndCommentId: build.mutation<
      PutApiV1PostsByPostIdCommentsAndCommentIdApiResponse,
      PutApiV1PostsByPostIdCommentsAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/comments/${queryArg.commentId}`,
        method: "PUT",
        body: queryArg.createPost,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    deleteApiV1PostsByPostIdCommentsAndCommentId: build.mutation<
      DeleteApiV1PostsByPostIdCommentsAndCommentIdApiResponse,
      DeleteApiV1PostsByPostIdCommentsAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/comments/${queryArg.commentId}`,
        method: "DELETE",
      }),
    }),
    postApiV1PostsByPostIdDetach: build.mutation<
      PostApiV1PostsByPostIdDetachApiResponse,
      PostApiV1PostsByPostIdDetachApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/detach`,
        method: "POST",
      }),
    }),
    postApiV1PostsByPostIdDownvote: build.mutation<
      PostApiV1PostsByPostIdDownvoteApiResponse,
      PostApiV1PostsByPostIdDownvoteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/downvote`,
        method: "POST",
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsByPostIdEdits: build.query<
      GetApiV1PostsByPostIdEditsApiResponse,
      GetApiV1PostsByPostIdEditsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/edits`,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1PostsByPostIdInteractionPolicy: build.mutation<
      PutApiV1PostsByPostIdInteractionPolicyApiResponse,
      PutApiV1PostsByPostIdInteractionPolicyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/interaction-policy`,
        method: "PUT",
        body: queryArg.updateInteractionPolicy,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsByPostIdLikes: build.query<
      GetApiV1PostsByPostIdLikesApiResponse,
      GetApiV1PostsByPostIdLikesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/likes`,
        params: {
          includeFollowedStatus: queryArg.includeFollowedStatus,
          includeFollowingStatus: queryArg.includeFollowingStatus,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    deleteApiV1PostsByPostIdLikes: build.mutation<
      DeleteApiV1PostsByPostIdLikesApiResponse,
      DeleteApiV1PostsByPostIdLikesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/likes`,
        method: "DELETE",
      }),
    }),
    postApiV1PostsByPostIdLikes: build.mutation<
      PostApiV1PostsByPostIdLikesApiResponse,
      PostApiV1PostsByPostIdLikesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/likes`,
        method: "POST",
      }),
    }),
    postApiV1PostsByPostIdMute: build.mutation<
      PostApiV1PostsByPostIdMuteApiResponse,
      PostApiV1PostsByPostIdMuteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/mute`,
        method: "POST",
      }),
    }),
    getApiV1PostsByPostIdQuotes: build.query<
      GetApiV1PostsByPostIdQuotesApiResponse,
      GetApiV1PostsByPostIdQuotesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/quotes`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1PostsByPostIdQuotesAndQuoteAuthIdRevoke: build.mutation<
      PostApiV1PostsByPostIdQuotesAndQuoteAuthIdRevokeApiResponse,
      PostApiV1PostsByPostIdQuotesAndQuoteAuthIdRevokeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/quotes/${queryArg.quoteAuthId}/revoke`,
        method: "POST",
      }),
    }),
    postApiV1PostsByPostIdRefreshCard: build.mutation<
      PostApiV1PostsByPostIdRefreshCardApiResponse,
      PostApiV1PostsByPostIdRefreshCardApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/refresh-card`,
        method: "POST",
      }),
    }),
    deleteApiV1PostsByPostIdRepost: build.mutation<
      DeleteApiV1PostsByPostIdRepostApiResponse,
      DeleteApiV1PostsByPostIdRepostApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/repost`,
        method: "DELETE",
      }),
    }),
    postApiV1PostsByPostIdRepost: build.mutation<
      PostApiV1PostsByPostIdRepostApiResponse,
      PostApiV1PostsByPostIdRepostApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/repost`,
        method: "POST",
        body: queryArg.createPost,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsByPostIdReposts: build.query<
      GetApiV1PostsByPostIdRepostsApiResponse,
      GetApiV1PostsByPostIdRepostsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/reposts`,
        params: {
          includeFollowedStatus: queryArg.includeFollowedStatus,
          includeFollowingStatus: queryArg.includeFollowingStatus,
          kind: queryArg.kind,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          skipDuplicates: queryArg.skipDuplicates,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    putApiV1PostsByPostIdSubscription: build.mutation<
      PutApiV1PostsByPostIdSubscriptionApiResponse,
      PutApiV1PostsByPostIdSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/subscription`,
        method: "PUT",
      }),
    }),
    getApiV1PostsByPostIdSubscription: build.query<
      GetApiV1PostsByPostIdSubscriptionApiResponse,
      GetApiV1PostsByPostIdSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/subscription`,
      }),
    }),
    deleteApiV1PostsByPostIdSubscription: build.mutation<
      DeleteApiV1PostsByPostIdSubscriptionApiResponse,
      DeleteApiV1PostsByPostIdSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/subscription`,
        method: "DELETE",
      }),
    }),
    postApiV1PostsByPostIdTrackView: build.mutation<
      PostApiV1PostsByPostIdTrackViewApiResponse,
      PostApiV1PostsByPostIdTrackViewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/track-view`,
        method: "POST",
      }),
    }),
    postApiV1PostsByPostIdTranslate: build.mutation<
      PostApiV1PostsByPostIdTranslateApiResponse,
      PostApiV1PostsByPostIdTranslateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/translate`,
        method: "POST",
        params: {
          htmlContent: queryArg.htmlContent,
          lang: queryArg.lang,
        },
      }),
    }),
    postApiV1PostsByPostIdUnmute: build.mutation<
      PostApiV1PostsByPostIdUnmuteApiResponse,
      PostApiV1PostsByPostIdUnmuteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/unmute`,
        method: "POST",
      }),
    }),
    postApiV1PostsByPostIdUpvote: build.mutation<
      PostApiV1PostsByPostIdUpvoteApiResponse,
      PostApiV1PostsByPostIdUpvoteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/upvote`,
        method: "POST",
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1PostsByPostIdVotes: build.query<
      GetApiV1PostsByPostIdVotesApiResponse,
      GetApiV1PostsByPostIdVotesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/posts/${queryArg.postId}/votes`,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1Rbac: build.query<GetApiV1RbacApiResponse, GetApiV1RbacApiArg>({
      query: () => ({ url: `/api/v1/rbac` }),
    }),
    getApiV1RbacActorsByActorIdPermissions: build.query<
      GetApiV1RbacActorsByActorIdPermissionsApiResponse,
      GetApiV1RbacActorsByActorIdPermissionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rbac/actors/${queryArg.actorId}/permissions`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1RbacActorsByActorIdRoles: build.query<
      GetApiV1RbacActorsByActorIdRolesApiResponse,
      GetApiV1RbacActorsByActorIdRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rbac/actors/${queryArg.actorId}/roles`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1RbacRoles: build.query<
      GetApiV1RbacRolesApiResponse,
      GetApiV1RbacRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rbac/roles`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1RbacRoles: build.mutation<
      PostApiV1RbacRolesApiResponse,
      PostApiV1RbacRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rbac/roles`,
        method: "POST",
        body: queryArg.rbacRoleTemplate,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1RbacRolesByRoleId: build.mutation<
      PutApiV1RbacRolesByRoleIdApiResponse,
      PutApiV1RbacRolesByRoleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rbac/roles/${queryArg.roleId}`,
        method: "PUT",
        body: queryArg.rbacRoleTemplate,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    deleteApiV1RbacRolesByRoleName: build.mutation<
      DeleteApiV1RbacRolesByRoleNameApiResponse,
      DeleteApiV1RbacRolesByRoleNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rbac/roles/${queryArg.roleName}`,
        method: "DELETE",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1RbacByResource: build.query<
      GetApiV1RbacByResourceApiResponse,
      GetApiV1RbacByResourceApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/rbac/${queryArg.resource}` }),
    }),
    postApiV1Reports: build.mutation<
      PostApiV1ReportsApiResponse,
      PostApiV1ReportsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/reports`,
        method: "POST",
        body: queryArg.createReport,
      }),
    }),
    postApiV1ReportsByReportIdEditComment: build.mutation<
      PostApiV1ReportsByReportIdEditCommentApiResponse,
      PostApiV1ReportsByReportIdEditCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/reports/${queryArg.reportId}/edit-comment`,
        method: "POST",
        body: queryArg.editReportComment,
      }),
    }),
    putApiV1Rules: build.mutation<
      PutApiV1RulesApiResponse,
      PutApiV1RulesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rules`,
        method: "PUT",
        body: queryArg.rule,
      }),
    }),
    getApiV1Rules: build.query<GetApiV1RulesApiResponse, GetApiV1RulesApiArg>({
      query: () => ({ url: `/api/v1/rules` }),
    }),
    postApiV1Rules: build.mutation<
      PostApiV1RulesApiResponse,
      PostApiV1RulesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rules`,
        method: "POST",
        body: queryArg.ruleCreate,
      }),
    }),
    postApiV1RulesReorder: build.mutation<
      PostApiV1RulesReorderApiResponse,
      PostApiV1RulesReorderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rules/reorder`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiV1RulesById: build.mutation<
      DeleteApiV1RulesByIdApiResponse,
      DeleteApiV1RulesByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/rules/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getApiV1Search: build.query<
      GetApiV1SearchApiResponse,
      GetApiV1SearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/search`,
        params: {
          actorType: queryArg.actorType,
          fasp: queryArg.fasp,
          faspHydrated: queryArg.faspHydrated,
          filter: queryArg.filter,
          followStatus: queryArg.followStatus,
          followers: queryArg.followers,
          following: queryArg.following,
          groupId: queryArg.groupId,
          groupMemberRole: queryArg.groupMemberRole,
          includeRelations: queryArg.includeRelations,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          ownerId: queryArg.ownerId,
          q: queryArg.q,
          resolve: queryArg.resolve,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
          withComments: queryArg.withComments,
          withParent: queryArg.withParent,
          withRootParent: queryArg.withRootParent,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    deleteApiV1SessionsAll: build.mutation<
      DeleteApiV1SessionsAllApiResponse,
      DeleteApiV1SessionsAllApiArg
    >({
      query: () => ({ url: `/api/v1/sessions/all`, method: "DELETE" }),
    }),
    getApiV1SessionsList: build.query<
      GetApiV1SessionsListApiResponse,
      GetApiV1SessionsListApiArg
    >({
      query: () => ({ url: `/api/v1/sessions/list` }),
    }),
    putApiV1SessionsRevokeAll: build.mutation<
      PutApiV1SessionsRevokeAllApiResponse,
      PutApiV1SessionsRevokeAllApiArg
    >({
      query: () => ({ url: `/api/v1/sessions/revoke/all`, method: "PUT" }),
    }),
    putApiV1SessionsRevokeBySessionKey: build.mutation<
      PutApiV1SessionsRevokeBySessionKeyApiResponse,
      PutApiV1SessionsRevokeBySessionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/sessions/revoke/${queryArg.sessionKey}`,
        method: "PUT",
      }),
    }),
    deleteApiV1SessionsBySessionKey: build.mutation<
      DeleteApiV1SessionsBySessionKeyApiResponse,
      DeleteApiV1SessionsBySessionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/sessions/${queryArg.sessionKey}`,
        method: "DELETE",
      }),
    }),
    putApiV1Settings: build.mutation<
      PutApiV1SettingsApiResponse,
      PutApiV1SettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/settings`,
        method: "PUT",
        body: queryArg.platformSettings,
      }),
    }),
    getApiV1Settings: build.query<
      GetApiV1SettingsApiResponse,
      GetApiV1SettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/settings`,
        params: {
          keys: queryArg.keys,
        },
      }),
    }),
    deleteApiV1Settings: build.mutation<
      DeleteApiV1SettingsApiResponse,
      DeleteApiV1SettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/settings`,
        method: "DELETE",
        params: {
          keys: queryArg.keys,
        },
      }),
    }),
    getApiV1SettingsNames: build.query<
      GetApiV1SettingsNamesApiResponse,
      GetApiV1SettingsNamesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/settings/names`,
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    putApiV1SettingsUser: build.mutation<
      PutApiV1SettingsUserApiResponse,
      PutApiV1SettingsUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/settings/user`,
        method: "PUT",
        body: queryArg.userSettings,
      }),
    }),
    getApiV1SettingsUser: build.query<
      GetApiV1SettingsUserApiResponse,
      GetApiV1SettingsUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/settings/user`,
        params: {
          keys: queryArg.keys,
        },
      }),
    }),
    deleteApiV1SettingsUser: build.mutation<
      DeleteApiV1SettingsUserApiResponse,
      DeleteApiV1SettingsUserApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/settings/user`,
        method: "DELETE",
        params: {
          keys: queryArg.keys,
        },
      }),
    }),
    getApiV1Suggestions: build.query<
      GetApiV1SuggestionsApiResponse,
      GetApiV1SuggestionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/suggestions`,
        params: {
          language: queryArg.language,
          limit: queryArg.limit,
        },
      }),
    }),
    getApiV1TagsFeatured: build.query<
      GetApiV1TagsFeaturedApiResponse,
      GetApiV1TagsFeaturedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/featured`,
        params: {
          scope: queryArg.scope,
          userId: queryArg.userId,
        },
      }),
    }),
    deleteApiV1TagsFeaturedByName: build.mutation<
      DeleteApiV1TagsFeaturedByNameApiResponse,
      DeleteApiV1TagsFeaturedByNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/featured/${queryArg.name}`,
        method: "DELETE",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1TagsFeaturedByName: build.mutation<
      PostApiV1TagsFeaturedByNameApiResponse,
      PostApiV1TagsFeaturedByNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/featured/${queryArg.name}`,
        method: "POST",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1TagsFollowByName: build.mutation<
      PostApiV1TagsFollowByNameApiResponse,
      PostApiV1TagsFollowByNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/follow/${queryArg.name}`,
        method: "POST",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1TagsFollowed: build.query<
      GetApiV1TagsFollowedApiResponse,
      GetApiV1TagsFollowedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/followed`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    putApiV1TagsList: build.mutation<
      PutApiV1TagsListApiResponse,
      PutApiV1TagsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/list`,
        method: "PUT",
        body: queryArg.body,
        params: {
          scope: queryArg.scope,
          soft: queryArg.soft,
          type: queryArg["type"],
        },
      }),
    }),
    patchApiV1TagsList: build.mutation<
      PatchApiV1TagsListApiResponse,
      PatchApiV1TagsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/list`,
        method: "PATCH",
        body: queryArg.body,
        params: {
          scope: queryArg.scope,
          soft: queryArg.soft,
          type: queryArg["type"],
        },
      }),
    }),
    getApiV1TagsList: build.query<
      GetApiV1TagsListApiResponse,
      GetApiV1TagsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/list`,
        params: {
          scope: queryArg.scope,
          soft: queryArg.soft,
          type: queryArg["type"],
        },
      }),
    }),
    deleteApiV1TagsList: build.mutation<
      DeleteApiV1TagsListApiResponse,
      DeleteApiV1TagsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/list`,
        method: "DELETE",
        body: queryArg.body,
        params: {
          scope: queryArg.scope,
          soft: queryArg.soft,
          type: queryArg["type"],
        },
      }),
    }),
    putApiV1TagsPolicy: build.mutation<
      PutApiV1TagsPolicyApiResponse,
      PutApiV1TagsPolicyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/policy`,
        method: "PUT",
        body: queryArg.setTagPolicyRequest,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1TagsPolicy: build.query<
      GetApiV1TagsPolicyApiResponse,
      GetApiV1TagsPolicyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/policy`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1TagsReport: build.mutation<
      PostApiV1TagsReportApiResponse,
      PostApiV1TagsReportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/report`,
        method: "POST",
        body: queryArg.createTagReportRequest,
        params: {
          name: queryArg.name,
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1TagsReports: build.query<
      GetApiV1TagsReportsApiResponse,
      GetApiV1TagsReportsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/reports`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1TagsSearch: build.query<
      GetApiV1TagsSearchApiResponse,
      GetApiV1TagsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/search`,
        params: {
          limit: queryArg.limit,
          name: queryArg.name,
          offset: queryArg.offset,
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1TagsTrending: build.query<
      GetApiV1TagsTrendingApiResponse,
      GetApiV1TagsTrendingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/trending`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          scope: queryArg.scope,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
        },
      }),
    }),
    postApiV1TagsUnfollowByName: build.mutation<
      PostApiV1TagsUnfollowByNameApiResponse,
      PostApiV1TagsUnfollowByNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/unfollow/${queryArg.name}`,
        method: "POST",
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    getApiV1TagsByName: build.query<
      GetApiV1TagsByNameApiResponse,
      GetApiV1TagsByNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/${queryArg.name}`,
        params: {
          historySince: queryArg.historySince,
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1TranslateText: build.mutation<
      PostApiV1TranslateTextApiResponse,
      PostApiV1TranslateTextApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/translate/text`,
        method: "POST",
        body: queryArg.translationRequest,
      }),
    }),
    getApiV1TrendsEvents: build.query<
      GetApiV1TrendsEventsApiResponse,
      GetApiV1TrendsEventsApiArg
    >({
      query: () => ({ url: `/api/v1/trends/events` }),
    }),
    getApiV1TrendsLinks: build.query<
      GetApiV1TrendsLinksApiResponse,
      GetApiV1TrendsLinksApiArg
    >({
      query: () => ({ url: `/api/v1/trends/links` }),
    }),
    getApiV1TrendsPosts: build.query<
      GetApiV1TrendsPostsApiResponse,
      GetApiV1TrendsPostsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/trends/posts`,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1TrendsTags: build.query<
      GetApiV1TrendsTagsApiResponse,
      GetApiV1TrendsTagsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/trends/tags`,
        params: {
          scope: queryArg.scope,
        },
      }),
    }),
    postApiV1Uploads: build.mutation<
      PostApiV1UploadsApiResponse,
      PostApiV1UploadsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads`,
        method: "POST",
        body: queryArg.createUpload,
      }),
    }),
    getApiV1UploadsAttachedByEntityId: build.query<
      GetApiV1UploadsAttachedByEntityIdApiResponse,
      GetApiV1UploadsAttachedByEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/attached/${queryArg.entityId}`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1UploadsBatch: build.mutation<
      PostApiV1UploadsBatchApiResponse,
      PostApiV1UploadsBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/batch`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV1UploadsList: build.mutation<
      PostApiV1UploadsListApiResponse,
      PostApiV1UploadsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/list`,
        method: "POST",
        body: queryArg.uploadList,
      }),
    }),
    getApiV1UploadsOwnerByOwnerId: build.query<
      GetApiV1UploadsOwnerByOwnerIdApiResponse,
      GetApiV1UploadsOwnerByOwnerIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/owner/${queryArg.ownerId}`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1UploadsOwnerByOwnerIdStandalone: build.query<
      GetApiV1UploadsOwnerByOwnerIdStandaloneApiResponse,
      GetApiV1UploadsOwnerByOwnerIdStandaloneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/owner/${queryArg.ownerId}/standalone`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1UploadsSearch: build.query<
      GetApiV1UploadsSearchApiResponse,
      GetApiV1UploadsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/search`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          tag: queryArg.tag,
          untilId: queryArg.untilId,
          uploadType: queryArg.uploadType,
        },
      }),
    }),
    getApiV1UploadsUsages: build.query<
      GetApiV1UploadsUsagesApiResponse,
      GetApiV1UploadsUsagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/usages`,
        params: {
          ids: queryArg.ids,
        },
      }),
    }),
    getApiV1UploadsById: build.query<
      GetApiV1UploadsByIdApiResponse,
      GetApiV1UploadsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/uploads/${queryArg.id}` }),
    }),
    deleteApiV1UploadsById: build.mutation<
      DeleteApiV1UploadsByIdApiResponse,
      DeleteApiV1UploadsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    postApiV1UploadsByIdMeta: build.mutation<
      PostApiV1UploadsByIdMetaApiResponse,
      PostApiV1UploadsByIdMetaApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/${queryArg.id}/meta`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putApiV1UploadsByIdMeta: build.mutation<
      PutApiV1UploadsByIdMetaApiResponse,
      PutApiV1UploadsByIdMetaApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/${queryArg.id}/meta`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postApiV1UploadsByIdPrivacy: build.mutation<
      PostApiV1UploadsByIdPrivacyApiResponse,
      PostApiV1UploadsByIdPrivacyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/${queryArg.id}/privacy`,
        method: "POST",
        body: queryArg.updateUploadPrivacy,
      }),
    }),
    postApiV1UploadsByIdTags: build.mutation<
      PostApiV1UploadsByIdTagsApiResponse,
      PostApiV1UploadsByIdTagsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/${queryArg.id}/tags`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putApiV1UploadsByIdTags: build.mutation<
      PutApiV1UploadsByIdTagsApiResponse,
      PutApiV1UploadsByIdTagsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/${queryArg.id}/tags`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postApiV1UploadsByIdThumbnail: build.mutation<
      PostApiV1UploadsByIdThumbnailApiResponse,
      PostApiV1UploadsByIdThumbnailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/${queryArg.id}/thumbnail`,
        method: "POST",
        body: queryArg.changeVideoThumbnail,
      }),
    }),
    putApiV1UploadsByUploadIdOwner: build.mutation<
      PutApiV1UploadsByUploadIdOwnerApiResponse,
      PutApiV1UploadsByUploadIdOwnerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uploads/${queryArg.uploadId}/owner`,
        method: "PUT",
        body: queryArg.updateUploadOwner,
      }),
    }),
    getApiV1UserAlias: build.query<
      GetApiV1UserAliasApiResponse,
      GetApiV1UserAliasApiArg
    >({
      query: () => ({ url: `/api/v1/user-alias` }),
    }),
    deleteApiV1UserAlias: build.mutation<
      DeleteApiV1UserAliasApiResponse,
      DeleteApiV1UserAliasApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user-alias`,
        method: "DELETE",
        params: {
          uri: queryArg.uri,
        },
      }),
    }),
    postApiV1UserAlias: build.mutation<
      PostApiV1UserAliasApiResponse,
      PostApiV1UserAliasApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user-alias`,
        method: "POST",
        params: {
          acct: queryArg.acct,
        },
      }),
    }),
    getApiV1UserDomainBlock: build.query<
      GetApiV1UserDomainBlockApiResponse,
      GetApiV1UserDomainBlockApiArg
    >({
      query: () => ({ url: `/api/v1/user-domain-block` }),
    }),
    deleteApiV1UserDomainBlockByDomain: build.mutation<
      DeleteApiV1UserDomainBlockByDomainApiResponse,
      DeleteApiV1UserDomainBlockByDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user-domain-block/${queryArg.domain}`,
        method: "DELETE",
      }),
    }),
    postApiV1UserDomainBlockByDomain: build.mutation<
      PostApiV1UserDomainBlockByDomainApiResponse,
      PostApiV1UserDomainBlockByDomainApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/user-domain-block/${queryArg.domain}`,
        method: "POST",
      }),
    }),
    deleteApiV1Users: build.mutation<
      DeleteApiV1UsersApiResponse,
      DeleteApiV1UsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users`,
        method: "DELETE",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    postApiV1Users: build.mutation<
      PostApiV1UsersApiResponse,
      PostApiV1UsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users`,
        method: "POST",
        body: queryArg.userCreate,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1Users: build.query<GetApiV1UsersApiResponse, GetApiV1UsersApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/users`,
        params: {
          full: queryArg.full,
          includeBlockedByStatus: queryArg.includeBlockedByStatus,
          includeBlockedStatus: queryArg.includeBlockedStatus,
          includeFollowedStatus: queryArg.includeFollowedStatus,
          includeFollowingStatus: queryArg.includeFollowingStatus,
          includeMutedStatus: queryArg.includeMutedStatus,
          relations: queryArg.relations,
          username: queryArg.username,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1UsersConnections: build.query<
      GetApiV1UsersConnectionsApiResponse,
      GetApiV1UsersConnectionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/connections`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          status: queryArg.status,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1UsersFollowByUsername: build.mutation<
      PostApiV1UsersFollowByUsernameApiResponse,
      PostApiV1UsersFollowByUsernameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/follow/${queryArg.username}`,
        method: "POST",
        params: {
          domain: queryArg.domain,
          mutual: queryArg.mutual,
          scheme: queryArg.scheme,
        },
      }),
    }),
    postApiV1UsersFollowByUsernameAccept: build.mutation<
      PostApiV1UsersFollowByUsernameAcceptApiResponse,
      PostApiV1UsersFollowByUsernameAcceptApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/follow/${queryArg.username}/accept`,
        method: "POST",
      }),
    }),
    postApiV1UsersFollowByUsernamePend: build.mutation<
      PostApiV1UsersFollowByUsernamePendApiResponse,
      PostApiV1UsersFollowByUsernamePendApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/follow/${queryArg.username}/pend`,
        method: "POST",
      }),
    }),
    postApiV1UsersFollowByUsernameReject: build.mutation<
      PostApiV1UsersFollowByUsernameRejectApiResponse,
      PostApiV1UsersFollowByUsernameRejectApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/follow/${queryArg.username}/reject`,
        method: "POST",
      }),
    }),
    postApiV1UsersFollowByUsernameUndo: build.mutation<
      PostApiV1UsersFollowByUsernameUndoApiResponse,
      PostApiV1UsersFollowByUsernameUndoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/follow/${queryArg.username}/undo`,
        method: "POST",
        params: {
          domain: queryArg.domain,
          mutual: queryArg.mutual,
          scheme: queryArg.scheme,
        },
      }),
    }),
    getApiV1UsersFollowees: build.query<
      GetApiV1UsersFolloweesApiResponse,
      GetApiV1UsersFolloweesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/followees`,
        params: {
          anyStatus: queryArg.anyStatus,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          q: queryArg.q,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          status: queryArg.status,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1UsersFollowers: build.query<
      GetApiV1UsersFollowersApiResponse,
      GetApiV1UsersFollowersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/followers`,
        params: {
          anyStatus: queryArg.anyStatus,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          q: queryArg.q,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          status: queryArg.status,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1UsersInviteLinks: build.query<
      GetApiV1UsersInviteLinksApiResponse,
      GetApiV1UsersInviteLinksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/invite-links`,
        params: {
          active: queryArg.active,
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    postApiV1UsersInviteLinks: build.mutation<
      PostApiV1UsersInviteLinksApiResponse,
      PostApiV1UsersInviteLinksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/invite-links`,
        method: "POST",
        body: queryArg.signupInviteLinkCreate,
      }),
    }),
    putApiV1UsersInviteLinksDeactivateByCode: build.mutation<
      PutApiV1UsersInviteLinksDeactivateByCodeApiResponse,
      PutApiV1UsersInviteLinksDeactivateByCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/invite-links/deactivate/${queryArg.code}`,
        method: "PUT",
      }),
    }),
    getApiV1UsersProfile: build.query<
      GetApiV1UsersProfileApiResponse,
      GetApiV1UsersProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/profile`,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1UsersRelationships: build.query<
      GetApiV1UsersRelationshipsApiResponse,
      GetApiV1UsersRelationshipsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/relationships`,
        params: {
          filter: queryArg.filter,
          targets: queryArg.targets,
        },
      }),
    }),
    getApiV1UsersRemoteByUserNameFullFollowers: build.query<
      GetApiV1UsersRemoteByUserNameFullFollowersApiResponse,
      GetApiV1UsersRemoteByUserNameFullFollowersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/remote/${queryArg.userNameFull}/followers`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    getApiV1UsersRemoteByUserNameFullFollowing: build.query<
      GetApiV1UsersRemoteByUserNameFullFollowingApiResponse,
      GetApiV1UsersRemoteByUserNameFullFollowingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/remote/${queryArg.userNameFull}/following`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    getApiV1UsersRenameHistory: build.query<
      GetApiV1UsersRenameHistoryApiResponse,
      GetApiV1UsersRenameHistoryApiArg
    >({
      query: () => ({ url: `/api/v1/users/rename-history` }),
    }),
    putApiV1UsersByUserId: build.mutation<
      PutApiV1UsersByUserIdApiResponse,
      PutApiV1UsersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.userUpdate,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getApiV1UsersByUserId: build.query<
      GetApiV1UsersByUserIdApiResponse,
      GetApiV1UsersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/${queryArg.userId}`,
        params: {
          full: queryArg.full,
          includeBlockedByStatus: queryArg.includeBlockedByStatus,
          includeBlockedStatus: queryArg.includeBlockedStatus,
          includeFollowedStatus: queryArg.includeFollowedStatus,
          includeFollowingStatus: queryArg.includeFollowingStatus,
          includeMutedStatus: queryArg.includeMutedStatus,
          relations: queryArg.relations,
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    postApiV1UsersByUserIdDeepSync: build.mutation<
      PostApiV1UsersByUserIdDeepSyncApiResponse,
      PostApiV1UsersByUserIdDeepSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/${queryArg.userId}/deep-sync`,
        method: "POST",
      }),
    }),
    getApiV1UsersByUserIdFollowers: build.query<
      GetApiV1UsersByUserIdFollowersApiResponse,
      GetApiV1UsersByUserIdFollowersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/${queryArg.userId}/followers`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          q: queryArg.q,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    getApiV1UsersByUserIdFollowing: build.query<
      GetApiV1UsersByUserIdFollowingApiResponse,
      GetApiV1UsersByUserIdFollowingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/${queryArg.userId}/following`,
        params: {
          lastId: queryArg.lastId,
          limit: queryArg.limit,
          offset: queryArg.offset,
          q: queryArg.q,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          untilId: queryArg.untilId,
        },
      }),
    }),
    putApiV1UsersByUserIdMedia: build.mutation<
      PutApiV1UsersByUserIdMediaApiResponse,
      PutApiV1UsersByUserIdMediaApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/users/${queryArg.userId}/media`,
        method: "PUT",
        body: queryArg.userUpdateMedia,
        params: {
          htmlContent: queryArg.htmlContent,
        },
      }),
    }),
    getAuthorizeInteraction: build.query<
      GetAuthorizeInteractionApiResponse,
      GetAuthorizeInteractionApiArg
    >({
      query: (queryArg) => ({
        url: `/authorize_interaction`,
        params: {
          uri: queryArg.uri,
        },
      }),
    }),
    getRoot: build.query<GetRootApiResponse, GetRootApiArg>({
      query: (queryArg) => ({
        url: `/`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getUser: build.query<GetUserApiResponse, GetUserApiArg>({
      query: (queryArg) => ({
        url: `/@${queryArg.username}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getUserEvent: build.query<GetUserEventApiResponse, GetUserEventApiArg>({
      query: (queryArg) => ({
        url: `/@${queryArg.username}/events/${queryArg.eventId}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getUserPost: build.query<GetUserPostApiResponse, GetUserPostApiArg>({
      query: (queryArg) => ({
        url: `/@${queryArg.username}/posts/${queryArg.postId}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getAbout: build.query<GetAboutApiResponse, GetAboutApiArg>({
      query: (queryArg) => ({
        url: `/about`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getFeed: build.query<GetFeedApiResponse, GetFeedApiArg>({
      query: (queryArg) => ({
        url: `/feed`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getFeedDiscover: build.query<
      GetFeedDiscoverApiResponse,
      GetFeedDiscoverApiArg
    >({
      query: (queryArg) => ({
        url: `/feed/discover`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getFeedFollowing: build.query<
      GetFeedFollowingApiResponse,
      GetFeedFollowingApiArg
    >({
      query: (queryArg) => ({
        url: `/feed/following`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getGroup: build.query<GetGroupApiResponse, GetGroupApiArg>({
      query: (queryArg) => ({
        url: `/g/${queryArg.groupName}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getGroupChannel: build.query<
      GetGroupChannelApiResponse,
      GetGroupChannelApiArg
    >({
      query: (queryArg) => ({
        url: `/g/${queryArg.groupName}/@${queryArg.channelName}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getGroupChannelPost: build.query<
      GetGroupChannelPostApiResponse,
      GetGroupChannelPostApiArg
    >({
      query: (queryArg) => ({
        url: `/g/${queryArg.groupName}/@${queryArg.channelName}/posts/${queryArg.postId}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getGroupBot: build.query<GetGroupBotApiResponse, GetGroupBotApiArg>({
      query: (queryArg) => ({
        url: `/g/${queryArg.groupName}/bots/@${queryArg.botName}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getGroupEvent: build.query<GetGroupEventApiResponse, GetGroupEventApiArg>({
      query: (queryArg) => ({
        url: `/g/${queryArg.groupName}/events/${queryArg.eventId}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getGroupForumCategory: build.query<
      GetGroupForumCategoryApiResponse,
      GetGroupForumCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/g/${queryArg.groupName}/forum/c/${queryArg.categoryName}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getGroupForumPost: build.query<
      GetGroupForumPostApiResponse,
      GetGroupForumPostApiArg
    >({
      query: (queryArg) => ({
        url: `/g/${queryArg.groupName}/forum/posts/${queryArg.postId}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getForumTag: build.query<GetForumTagApiResponse, GetForumTagApiArg>({
      query: (queryArg) => ({
        url: `/g/${queryArg.groupName}/forum/tag/${queryArg.tagName}`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getPrivacy: build.query<GetPrivacyApiResponse, GetPrivacyApiArg>({
      query: (queryArg) => ({
        url: `/privacy`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
    getTerms: build.query<GetTermsApiResponse, GetTermsApiArg>({
      query: (queryArg) => ({
        url: `/terms`,
        params: {
          format: queryArg.format,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as api };
export type GetApiMetaCompatApiResponse =
  /** status 200 API compatibility information */ CompatResponse;
export type GetApiMetaCompatApiArg = void;
export type PostApiV1AccountsAddReasonApiResponse =
  /** status 200 Registration hash and next step */ RegistrationResponse;
export type PostApiV1AccountsAddReasonApiArg = {
  signupReasonParams: SignupReasonParams;
};
export type PostApiV1AccountsAuthenticateEmailApiResponse =
  /** status 200 Account, all account users and session key */ Token;
export type PostApiV1AccountsAuthenticateEmailApiArg = {
  authRequest: AuthRequest;
};
export type PostApiV1AccountsAuthenticatePhoneApiResponse =
  /** status 200 Session key */ Token;
export type PostApiV1AccountsAuthenticatePhoneApiArg = {
  authPhoneRequest: AuthPhoneRequest;
};
export type PutApiV1AccountsChangeNameApiResponse =
  /** status 200 OK */ AccountWithUser;
export type PutApiV1AccountsChangeNameApiArg = {
  /** id */
  id?: TypeId | null;
  /** name */
  name: string;
  /** username */
  username?: string | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PostApiV1AccountsCheckCaptchaApiResponse =
  /** status 200 Registration hash and next step */ RegistrationResponse;
export type PostApiV1AccountsCheckCaptchaApiArg = {
  captchaVerificationParams: CaptchaVerificationParams;
};
export type PostApiV1AccountsConfirmEmailApiResponse =
  /** status 200 Registration hash and next step */ RegistrationResponse;
export type PostApiV1AccountsConfirmEmailApiArg = {
  codeVerificationParams: CodeVerificationParams;
};
export type PostApiV1AccountsConfirmPhoneApiResponse =
  /** status 200 Registration hash and next step */ RegistrationResponse;
export type PostApiV1AccountsConfirmPhoneApiArg = {
  codeVerificationParams: CodeVerificationParams;
};
export type DeleteApiV1AccountsDeleteApiResponse = /** status 200 OK */ any;
export type DeleteApiV1AccountsDeleteApiArg = void;
export type PostApiV1AccountsEmailChangeConfirmApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsEmailChangeConfirmApiArg = {
  confirmationCodeRequest: ConfirmationCodeRequest;
};
export type PostApiV1AccountsEmailChangeRequestApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsEmailChangeRequestApiArg = {
  emailChangeRequest: EmailChangeRequest;
};
export type PutApiV1AccountsEmailChangeResendCodeApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AccountsEmailChangeResendCodeApiArg = void;
export type PostApiV1AccountsFinishCreatingApiResponse =
  /** status 200 Account, users and session key */ AccountWithUserAndToken;
export type PostApiV1AccountsFinishCreatingApiArg = {
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  finishCreatingAccountParams: FinishCreatingAccountParams;
};
export type PutApiV1AccountsGetTokenByHashApiResponse =
  /** status 200 Session key */ Token;
export type PutApiV1AccountsGetTokenByHashApiArg = {
  hash: string;
};
export type PostApiV1AccountsLoginsAddEmailPasswordApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsLoginsAddEmailPasswordApiArg = {
  addEmailRequest: AddEmailRequest;
};
export type PostApiV1AccountsLoginsAddEmailPasswordConfirmApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsLoginsAddEmailPasswordConfirmApiArg = {
  confirmationCodeRequest: ConfirmationCodeRequest;
};
export type PutApiV1AccountsLoginsAddEmailPasswordResendCodeApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AccountsLoginsAddEmailPasswordResendCodeApiArg = void;
export type PostApiV1AccountsLoginsAddPhoneApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsLoginsAddPhoneApiArg = {
  addPhoneRequest: AddPhoneRequest;
};
export type DeleteApiV1AccountsLoginsRemoveEmailPasswordApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1AccountsLoginsRemoveEmailPasswordApiArg = void;
export type DeleteApiV1AccountsLoginsRemovePhoneApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1AccountsLoginsRemovePhoneApiArg = void;
export type PostApiV1AccountsPasswordChangeConfirmApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsPasswordChangeConfirmApiArg = {
  confirmationCodeRequest: ConfirmationCodeRequest;
};
export type PostApiV1AccountsPasswordChangeRequestApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsPasswordChangeRequestApiArg = {
  passwordChangeRequest: PasswordChangeRequest;
};
export type PutApiV1AccountsPasswordChangeResendCodeApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AccountsPasswordChangeResendCodeApiArg = void;
export type PostApiV1AccountsPasswordRecoverApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsPasswordRecoverApiArg = {
  passwordRecoveryRequest: PasswordRecoveryRequest;
};
export type PostApiV1AccountsPasswordRecoverChangeApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsPasswordRecoverChangeApiArg = {
  passwordRecoveryChange: PasswordRecoveryChange;
};
export type PostApiV1AccountsPasswordRecoverCheckCodeApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsPasswordRecoverCheckCodeApiArg = {
  passwordRecoveryCode: PasswordRecoveryCode;
};
export type PostApiV1AccountsPhoneChangeConfirmAuthApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsPhoneChangeConfirmAuthApiArg = {
  confirmationCodeRequest: ConfirmationCodeRequest;
};
export type PostApiV1AccountsPhoneChangeConfirmNewPhoneApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsPhoneChangeConfirmNewPhoneApiArg = {
  confirmationCodeRequest: ConfirmationCodeRequest;
};
export type PostApiV1AccountsPhoneChangeNewPhoneApiResponse =
  /** status 200 OK */ any;
export type PostApiV1AccountsPhoneChangeNewPhoneApiArg = {
  addPhoneRequest: AddPhoneRequest;
};
export type PutApiV1AccountsPhoneChangeRequestApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AccountsPhoneChangeRequestApiArg = void;
export type PutApiV1AccountsPhoneChangeResendCodeAuthApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AccountsPhoneChangeResendCodeAuthApiArg = void;
export type PutApiV1AccountsPhoneChangeResendCodeNewPhoneApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AccountsPhoneChangeResendCodeNewPhoneApiArg = void;
export type GetApiV1AccountsProfileApiResponse =
  /** status 200 Account and users */ AccountWithUser;
export type GetApiV1AccountsProfileApiArg = {
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PutApiV1AccountsResendCodeByHashApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AccountsResendCodeByHashApiArg = {
  hash: string;
};
export type PutApiV1AccountsResendEmailByHashApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AccountsResendEmailByHashApiArg = {
  hash: string;
};
export type PostApiV1AccountsSignupApiResponse =
  /** status 200 Registration hash and next step. Hash can be used to resend confirmation email */ RegistrationResponse;
export type PostApiV1AccountsSignupApiArg = {
  accountCreate: AccountCreate;
};
export type PostApiV1AccountsSignupPhoneApiResponse =
  /** status 200 Registration hash and next step. Hash can be used to resend confirmation code */ RegistrationResponse;
export type PostApiV1AccountsSignupPhoneApiArg = {
  phoneSignup: PhoneSignup;
};
export type PostApiV1AccountsUserReselectUserApiResponse =
  /** status 200 Session key */ Token;
export type PostApiV1AccountsUserReselectUserApiArg = {
  /** User id */
  userId?: TypeId | null;
  /** Username */
  userName?: string | null;
};
export type GetApiV1AccountsUsersOwnedGroupsApiResponse =
  /** status 200 Account users with owned groups */ AccountUsersWithOwnedGroups;
export type GetApiV1AccountsUsersOwnedGroupsApiArg = void;
export type GetApiV1AddressesSuggestApiResponse =
  /** status 200 List of potential addresses matching the criteria */ AddressData[];
export type GetApiV1AddressesSuggestApiArg = {
  /** Language to use for the completion */
  lang?: Language | null;
  /** Address to complete */
  text: string;
};
export type GetApiV1AdminAccountByAccountIdApiResponse =
  /** status 200 Account details with associated users */ AccountWithUser;
export type GetApiV1AdminAccountByAccountIdApiArg = {
  accountId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1AdminAuditLogApiResponse =
  /** status 200 Successfully retrieved audit log entries */ AuditLogResult;
export type GetApiV1AdminAuditLogApiArg = {
  /** Filter by account ID (mutually exclusive with email parameter) */
  accountId?: string | null;
  /** Filter by specific actions (e.g., CREATE, UPDATE, DELETE). Multiple values allowed. */
  action?: AuditLogAction[] | null;
  /** Filter by application ID */
  appId?: string | null;
  /** Search for entries related to specific domains */
  domainSearch?: string | null;
  /** Filter by email address (mutually exclusive with accountId parameter) */
  email?: string | null;
  /** Filter by audit log groups (e.g., ACCOUNT, USER, APP). Multiple values allowed. */
  group?: AuditLogGroup[] | null;
  /** Filter by group ID */
  groupId?: string | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Filter by rule ID */
  ruleId?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Filter by user ID (mutually exclusive with username parameter) */
  userId?: string | null;
  /** Filter by username with optional domain (e.g., 'john' or '@john@example.com'). Mutually exclusive with userId parameter. */
  username?: string | null;
};
export type PutApiV1AdminChangeEmailApiResponse =
  /** status 200 Email address successfully changed */ string;
export type PutApiV1AdminChangeEmailApiArg = {
  /** New email address for the account. Must be a valid email format and unique in the system. */
  email: string;
  /** User ID whose email to change. Must be a valid USER type ID. Either username or id must be provided. */
  id?: TypeId | null;
  /** Username of the user whose email to change. Case-insensitive. Either username or id must be provided. */
  username?: string | null;
};
export type PutApiV1AdminChangePasswordApiResponse =
  /** status 200 Password successfully changed */ string;
export type PutApiV1AdminChangePasswordApiArg = {
  /** User ID whose password to change. Must be a valid USER type ID. Either username or id must be provided. */
  id?: TypeId | null;
  /** New password for the account. Should meet security requirements. */
  password: string;
  /** Username of the user whose password to change. Case-insensitive. Either username or id must be provided. */
  username?: string | null;
};
export type PutApiV1AdminChangeRoleAssignApiResponse =
  /** status 200 OK */ AccountWithUser;
export type PutApiV1AdminChangeRoleAssignApiArg = {
  /** User ID to assign the role to. Must be a valid USER type ID. Either username or id must be provided. */
  id?: TypeId | null;
  /** Role ID to assign in format 'Scope:RoleName' (e.g., 'System:ADMIN', 'Group:MODERATOR'). Must be a valid role. */
  role: RoleId;
  /** Username of the user to assign the role to. Case-insensitive. Either username or id must be provided. */
  username?: string | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PutApiV1AdminChangeRoleRevokeApiResponse =
  /** status 200 OK */ AccountWithUser;
export type PutApiV1AdminChangeRoleRevokeApiArg = {
  /** User ID to revoke the role from. Must be a valid USER type ID. Either username or id must be provided. */
  id?: TypeId | null;
  /** Role ID to revoke in format 'Scope:RoleName'. Must currently be assigned to the user. */
  role: RoleId;
  /** Username of the user to revoke the role from. Case-insensitive. Either username or id must be provided. */
  username?: string | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PostApiV1AdminClearApErrorsApiResponse =
  /** status 200 Delivery errors cleared successfully */ any;
export type PostApiV1AdminClearApErrorsApiArg = {
  /** Remote domain to clear errors for */
  domain: string;
};
export type PostApiV1AdminCreateAccountApiResponse =
  /** status 200 Account successfully created with initial user */ AccountWithUser;
export type PostApiV1AdminCreateAccountApiArg = {
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  accountCreate: AccountCreate;
};
export type PostApiV1AdminCreateUserApiResponse =
  /** status 200 User successfully created under existing account */ UserFull;
export type PostApiV1AdminCreateUserApiArg = {
  /** Account id to add user to */
  accountId?: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** JSON object with the user's data */
  userCreate: UserCreate;
};
export type DeleteApiV1AdminDeleteApiResponse =
  /** status 200 Account and all associated users successfully deleted */ any;
export type DeleteApiV1AdminDeleteApiArg = {
  /** Email of the account to delete */
  email?: string | null;
  /** Id of the account to delete */
  id?: TypeId | null;
  /** Username of the account to delete */
  username?: string | null;
};
export type DeleteApiV1AdminDeleteUserApiResponse =
  /** status 200 User successfully deleted */ string;
export type DeleteApiV1AdminDeleteUserApiArg = {
  /** User ID to delete. Must be a valid USER type ID. */
  id?: TypeId | null;
  /** Username of the user to delete. Case-insensitive. */
  username?: string | null;
};
export type GetApiV1AdminDomainAllowApiResponse =
  /** status 200 Successfully retrieved list of allowed domains */ AllowedDomain[];
export type GetApiV1AdminDomainAllowApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PostApiV1AdminDomainAllowApiResponse =
  /** status 200 Domain successfully added to allowlist */ any;
export type PostApiV1AdminDomainAllowApiArg = {
  /** Domain to add to the allowlist */
  allowedDomainReq: AllowedDomainReq;
};
export type DeleteApiV1AdminDomainAllowByDomainApiResponse =
  /** status 200 Domain successfully removed from allowlist */ any;
export type DeleteApiV1AdminDomainAllowByDomainApiArg = {
  /** Domain name to remove from the allowlist */
  domain: string;
};
export type PutApiV1AdminDomainBlockApiResponse =
  /** status 200 Domain block successfully updated */ any;
export type PutApiV1AdminDomainBlockApiArg = {
  /** Updated domain block configuration */
  blockDomainReq: BlockDomainReq;
};
export type GetApiV1AdminDomainBlockApiResponse =
  /** status 200 Successfully retrieved list of blocked domains */ BlockedDomain[];
export type GetApiV1AdminDomainBlockApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PostApiV1AdminDomainBlockApiResponse =
  /** status 200 Domain successfully blocked */ any;
export type PostApiV1AdminDomainBlockApiArg = {
  /** Domain block configuration */
  blockDomainReq: BlockDomainReq;
};
export type DeleteApiV1AdminDomainBlockByDomainApiResponse =
  /** status 200 Domain successfully unblocked */ any;
export type DeleteApiV1AdminDomainBlockByDomainApiArg = {
  /** Domain name to unblock */
  domain: string;
};
export type GetApiV1AdminEmailAllowApiResponse =
  /** status 200 Successfully retrieved list of allowed domains */ AllowedDomain[];
export type GetApiV1AdminEmailAllowApiArg = void;
export type PostApiV1AdminEmailAllowApiResponse =
  /** status 200 Domain successfully added to email allowlist */ any;
export type PostApiV1AdminEmailAllowApiArg = {
  /** Domain to add to the email allowlist */
  allowedDomainReq: AllowedDomainReq;
};
export type DeleteApiV1AdminEmailAllowByDomainApiResponse =
  /** status 200 Domain successfully removed from email allowlist */ any;
export type DeleteApiV1AdminEmailAllowByDomainApiArg = {
  /** Domain name to remove from the allowlist */
  domain: string;
};
export type GetApiV1AdminEmailBlockApiResponse =
  /** status 200 Successfully retrieved list of blocked email patterns */ EmailBlock[];
export type GetApiV1AdminEmailBlockApiArg = void;
export type PostApiV1AdminEmailBlockApiResponse =
  /** status 200 Email pattern successfully blocked */ any;
export type PostApiV1AdminEmailBlockApiArg = {
  /** Email pattern and reason for blocking */
  blockEmailRequest: BlockEmailRequest;
};
export type DeleteApiV1AdminEmailBlockByPatternApiResponse =
  /** status 200 Email pattern successfully unblocked */ any;
export type DeleteApiV1AdminEmailBlockByPatternApiArg = {
  /** Email pattern to unblock (will be normalized) */
  pattern: string;
};
export type PutApiV1AdminEmbeddingsDisableApiResponse =
  /** status 200 Embedding status after disabling */ EmbeddingStatus;
export type PutApiV1AdminEmbeddingsDisableApiArg = void;
export type PutApiV1AdminEmbeddingsEnableApiResponse =
  /** status 200 Embedding status with recalculation info */ EmbeddingStatus;
export type PutApiV1AdminEmbeddingsEnableApiArg = {
  /** Delay between batches in milliseconds (default: 100) */
  batchDelayMs?: number | null;
  /** Model ID to use for embeddings. Uses current model if not provided. */
  modelId?: TypeId | null;
};
export type GetApiV1AdminEmbeddingsEstimateCostApiResponse =
  /** status 200 Cost estimate for embedding generation */ EmbeddingCostEstimate;
export type GetApiV1AdminEmbeddingsEstimateCostApiArg = {
  /** Model ID to estimate cost for. Uses current model if not provided. */
  modelId?: TypeId | null;
};
export type DeleteApiV1AdminEmbeddingsRecalculationApiResponse =
  /** status 200 Embedding status after cancellation */ EmbeddingStatus;
export type DeleteApiV1AdminEmbeddingsRecalculationApiArg = void;
export type GetApiV1AdminEmbeddingsStatusApiResponse =
  /** status 200 Embedding system status */ EmbeddingStatus;
export type GetApiV1AdminEmbeddingsStatusApiArg = void;
export type GetApiV1AdminFaspRemoteBackfillsApiResponse =
  /** status 200 Backfills retrieved successfully */ FaspBackfillsResponse;
export type GetApiV1AdminFaspRemoteBackfillsApiArg = void;
export type GetApiV1AdminFaspRemoteBlocklistApiResponse =
  /** status 200 Blocklist retrieved successfully */ FaspBlocklistResponse;
export type GetApiV1AdminFaspRemoteBlocklistApiArg = void;
export type DeleteApiV1AdminFaspRemoteBlocklistByDomainApiResponse =
  /** status 200 Domain removed from blocklist */ any;
export type DeleteApiV1AdminFaspRemoteBlocklistByDomainApiArg = {
  /** Domain to unblock */
  domain: string;
};
export type PostApiV1AdminFaspRemoteBlocklistByDomainApiResponse =
  /** status 200 Domain added to blocklist */ any;
export type PostApiV1AdminFaspRemoteBlocklistByDomainApiArg = {
  /** Domain to block */
  domain: string;
};
export type DeleteApiV1AdminFaspRemoteConfigApiResponse =
  /** status 200 Configuration removed successfully */ any;
export type DeleteApiV1AdminFaspRemoteConfigApiArg = void;
export type GetApiV1AdminFaspRemoteConfigApiResponse =
  /** status 200 Configuration retrieved successfully */ FaspRemoteConfigResponse;
export type GetApiV1AdminFaspRemoteConfigApiArg = void;
export type PostApiV1AdminFaspRemoteConfigApiResponse =
  /** status 200 Configuration saved successfully */ FaspRemoteConfigResponse;
export type PostApiV1AdminFaspRemoteConfigApiArg = {
  /** Configuration details */
  configureFaspRemoteRequest: ConfigureFaspRemoteRequest;
};
export type PostApiV1AdminFaspRemoteRecoverStateApiResponse =
  /** status 200 State recovery triggered successfully */ any;
export type PostApiV1AdminFaspRemoteRecoverStateApiArg = void;
export type GetApiV1AdminFaspRemoteRegistrationsApiResponse =
  /** status 200 Registrations retrieved successfully */ FaspRegistrationsResponse;
export type GetApiV1AdminFaspRemoteRegistrationsApiArg = {
  /** Sort field: createdAt, domain, email, status */
  sortBy?: string | null;
  /** Sort order: asc or desc */
  sortOrder?: string | null;
  /** Filter by status (pending, approved, blocked) */
  status?: FaspServerStatus | null;
};
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdApproveApiResponse =
  /** status 200 Server approved successfully */ any;
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdApproveApiArg = {
  /** Server ID to approve */
  serverId: string;
};
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdBackfillApiResponse =
  /** status 200 Backfill triggered successfully */ any;
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdBackfillApiArg = {
  /** Server ID to backfill */
  serverId: string;
  /** Backfill parameters */
  backfillRequest1: BackfillRequest1;
};
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdBlockApiResponse =
  /** status 200 Server blocked successfully */ any;
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdBlockApiArg = {
  /** Server ID to block */
  serverId: string;
};
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdDeclineApiResponse =
  /** status 200 Server declined successfully */ any;
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdDeclineApiArg = {
  /** Server ID to decline */
  serverId: string;
};
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdRecoverStateApiResponse =
  /** status 200 State recovery triggered successfully */ any;
export type PostApiV1AdminFaspRemoteRegistrationsByServerIdRecoverStateApiArg =
  {
    /** Server ID to recover state for */
    serverId: string;
  };
export type PostApiV1AdminFaspRemoteRotateTokenConfirmApiResponse =
  /** status 200 Token rotated successfully */ TokenRotationConfirmResponse;
export type PostApiV1AdminFaspRemoteRotateTokenConfirmApiArg = {
  /** Verification code */
  tokenRotationConfirmRequest: TokenRotationConfirmRequest;
};
export type PostApiV1AdminFaspRemoteRotateTokenRequestApiResponse =
  /** status 200 Rotation request sent successfully */ any;
export type PostApiV1AdminFaspRemoteRotateTokenRequestApiArg = void;
export type GetApiV1AdminFaspRemoteStatsApiResponse =
  /** status 200 Statistics retrieved successfully */ any;
export type GetApiV1AdminFaspRemoteStatsApiArg = void;
export type GetApiV1AdminFaspRemoteSubscriptionsApiResponse =
  /** status 200 Subscriptions retrieved successfully */ FaspSubscriptionsResponse;
export type GetApiV1AdminFaspRemoteSubscriptionsApiArg = void;
export type PostApiV1AdminFaspRemoteTokenRecoverApiResponse =
  /** status 200 Recovery code sent to admin email */ any;
export type PostApiV1AdminFaspRemoteTokenRecoverApiArg = {
  /** Admin email for recovery */
  tokenRecoverRequest: TokenRecoverRequest;
};
export type PostApiV1AdminFaspRemoteTokenRecoverConfirmApiResponse =
  /** status 200 Token recovery confirmed */ TokenRotationConfirmResponse;
export type PostApiV1AdminFaspRemoteTokenRecoverConfirmApiArg = {
  /** Email and verification code */
  tokenRecoverConfirmRequest: TokenRecoverConfirmRequest;
};
export type GetApiV1AdminFaspRemoteUpdateApiResponse =
  /** status 200 Update check completed */ FaspUpdateCheckResponse;
export type GetApiV1AdminFaspRemoteUpdateApiArg = void;
export type GetApiV1AdminFaspDefaultsApiResponse =
  /** status 200 Successfully retrieved default providers */ FaspDefaultsResponse;
export type GetApiV1AdminFaspDefaultsApiArg = void;
export type PutApiV1AdminFaspDefaultsByCapabilityApiResponse =
  /** status 200 Default provider successfully set */ FaspDefaultProviderView;
export type PutApiV1AdminFaspDefaultsByCapabilityApiArg = {
  /** Capability name */
  capability: string;
  /** Provider ID to set as default */
  setDefaultRequest: SetDefaultRequest;
};
export type DeleteApiV1AdminFaspDefaultsByCapabilityApiResponse =
  /** status 200 Default provider successfully removed */ any;
export type DeleteApiV1AdminFaspDefaultsByCapabilityApiArg = {
  /** Capability name */
  capability: string;
};
export type GetApiV1AdminFaspDefaultsByCapabilityApiResponse =
  /** status 200 Successfully retrieved default provider */ FaspDefaultProviderView;
export type GetApiV1AdminFaspDefaultsByCapabilityApiArg = {
  /** Capability name */
  capability: string;
};
export type GetApiV1AdminFaspProvidersApiResponse =
  /** status 200 Successfully retrieved list of FASP providers */ FaspProvidersResponse;
export type GetApiV1AdminFaspProvidersApiArg = {
  /** Sort field: createdAt, name, state */
  sortBy?: string | null;
  /** Sort order: asc or desc */
  sortOrder?: string | null;
  /** Filter by single state */
  state?: FaspProviderState | null;
  /** Filter by multiple states */
  states?: FaspProviderState[] | null;
};
export type GetApiV1AdminFaspProvidersByFaspIdApiResponse =
  /** status 200 Successfully retrieved FASP provider */ FaspProviderView;
export type GetApiV1AdminFaspProvidersByFaspIdApiArg = {
  /** FASP provider ID */
  faspId: number;
};
export type PostApiV1AdminFaspProvidersByFaspIdAcceptApiResponse =
  /** status 200 Provider successfully accepted */ FaspProviderView;
export type PostApiV1AdminFaspProvidersByFaspIdAcceptApiArg = {
  /** FASP provider ID */
  faspId: number;
};
export type PostApiV1AdminFaspProvidersByFaspIdBackfillApiResponse =
  /** status 200 Backfill request successfully sent */ any;
export type PostApiV1AdminFaspProvidersByFaspIdBackfillApiArg = {
  /** FASP provider ID */
  faspId: number;
  /** Backfill request with category */
  backfillRequest: BackfillRequest;
};
export type PostApiV1AdminFaspProvidersByFaspIdBlockApiResponse =
  /** status 200 Provider successfully blocked */ FaspProviderView;
export type PostApiV1AdminFaspProvidersByFaspIdBlockApiArg = {
  /** FASP provider ID */
  faspId: number;
};
export type PostApiV1AdminFaspProvidersByFaspIdCapabilitiesApiResponse =
  /** status 200 Capabilities successfully updated */ FaspProviderView;
export type PostApiV1AdminFaspProvidersByFaspIdCapabilitiesApiArg = {
  /** FASP provider ID */
  faspId: number;
  /** List of capabilities to update */
  body: Capability[];
};
export type PostApiV1AdminFaspProvidersByFaspIdDeclineApiResponse =
  /** status 200 Provider successfully declined and deleted */ any;
export type PostApiV1AdminFaspProvidersByFaspIdDeclineApiArg = {
  /** FASP provider ID */
  faspId: number;
};
export type GetApiV1AdminFederationApiResponse =
  /** status 200 Successfully retrieved list of federated domains */ ServersResult;
export type GetApiV1AdminFederationApiArg = {
  /** Filter by blocking state(s) - accepts single state or comma-separated list (LIMITED, SUSPENDED, NOOP) */
  blockState?: DomainBlockState[] | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Filter domains by name */
  search?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Filter only unavailable domains (7+ days not responding) */
  unavailable?: boolean | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Filter only failing domains (1+ days not responding) */
  warning?: boolean | null;
};
export type PutApiV1AdminFederationConfigApiResponse =
  /** status 200 Federation config updated successfully */ FederationConfigResponse;
export type PutApiV1AdminFederationConfigApiArg = {
  federationConfigRequest: FederationConfigRequest;
};
export type GetApiV1AdminFederationConfigApiResponse =
  /** status 200 Federation config retrieved successfully */ FederationConfigResponse;
export type GetApiV1AdminFederationConfigApiArg = void;
export type GetApiV1AdminFederationMetricsOperationsApiResponse =
  /** status 200 Successfully retrieved list of tracked operations */ string[];
export type GetApiV1AdminFederationMetricsOperationsApiArg = {
  /** Time window to check for operations (defaults to 24h) */
  window?: WindowSize | null;
};
export type GetApiV1AdminFederationMetricsRunningAverageSingleApiResponse =
  /** status 200 Successfully retrieved operation metrics */ SlidingWindowMetrics;
export type GetApiV1AdminFederationMetricsRunningAverageSingleApiArg = {
  /** The ActivityPub operation to get metrics for */
  operation: string;
  /** Time window for metric calculation (e.g., ONE_HOUR, SIX_HOURS, TWENTY_FOUR_HOURS) */
  window: WindowSize;
};
export type GetApiV1AdminFederationMetricsRunningAveragesAllApiResponse =
  /** status 200 Map of operation names to their corresponding metrics */ {
    [key: string]: SlidingWindowMetrics;
  };
export type GetApiV1AdminFederationMetricsRunningAveragesAllApiArg = {
  /** Comma-separated list of specific operations to get metrics for. If omitted, returns all operations. */
  operations?: string[] | null;
  /** Time window for metric calculation */
  window: WindowSize;
};
export type PutApiV1AdminFederationModeApiResponse =
  /** status 200 Federation mode changed successfully */ FederationModeResponse;
export type PutApiV1AdminFederationModeApiArg = {
  federationModeRequest: FederationModeRequest;
};
export type GetApiV1AdminFederationModeApiResponse =
  /** status 200 Current federation mode */ FederationModeResponse;
export type GetApiV1AdminFederationModeApiArg = void;
export type GetApiV1AdminFederationByDomainApiResponse =
  /** status 200 Successfully retrieved domain federation information */ ServerInfo;
export type GetApiV1AdminFederationByDomainApiArg = {
  /** Domain name to get federation details for */
  domain: string;
};
export type PostApiV1AdminFeedClearUserFeedApiResponse =
  /** status 200 Number of Redis cache keys deleted */ any;
export type PostApiV1AdminFeedClearUserFeedApiArg = {
  /** User ID to clear feed cache for (default: all users) */
  userId?: TypeId | null;
  /** Username to clear feed cache for (alternative to userId) */
  username?: string | null;
};
export type GetApiV1AdminFeedCountUserFeedApiResponse =
  /** status 200 Exact cached post count for the selected user */ UserFeedCountResponse;
export type GetApiV1AdminFeedCountUserFeedApiArg = {
  /** User ID to count cached feed posts for */
  userId?: TypeId | null;
  /** Username to count cached feed posts for (alternative to userId) */
  username?: string | null;
};
export type GetApiV1AdminFeedDiagnoseApiResponse =
  /** status 200 Map of userIds to their diagnosed results */ {
    [key: string]: FeedCompareResult;
  };
export type GetApiV1AdminFeedDiagnoseApiArg = {
  /** Number of posts to compare from home feed against DB (default: 20) */
  limit?: number | null;
  /** Exclude feeds with exact match from results (default: true) */
  skipExactMatch?: boolean | null;
  /** Omit full post ID lists from response to reduce payload size */
  skipFull?: boolean | null;
  /** Exclude feeds with only order mismatches from results (default: true) */
  skipOrderMismatch?: boolean | null;
  /** User ID to diagnose feed for */
  userId?: TypeId | null;
  /** Username to diagnose feed for (alternative to userId) */
  username?: string | null;
};
export type GetApiV1AdminFeedMetricsGlobalAllOperationApiResponse =
  /** status 200 List of global aggregated metrics for all operations */ GlobalAggregatedMetrics[];
export type GetApiV1AdminFeedMetricsGlobalAllOperationApiArg = {
  /** Time window for aggregation */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsGlobalSingleApiResponse =
  /** status 200 Global aggregated metrics for the specified operation */ GlobalAggregatedMetrics;
export type GetApiV1AdminFeedMetricsGlobalSingleApiArg = {
  /** Feed operation type (populate, merge, unmerge, redis, redisLex, cache, idsDb, db, add, remove) */
  operation: FeedOperation;
  /** Time window for aggregation (TEN_MINUTES, ONE_HOUR, TWENTY_FOUR_HOURS or 10m, 1h, 24h) */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsHistoryApiResponse =
  /** status 200 Feed metrics history retrieved successfully */ FeedMetrics[];
export type GetApiV1AdminFeedMetricsHistoryApiArg = {
  /** Maximum number of historical entries to return (default: 100) */
  limit?: number;
  /** Feed operation type to filter metrics (e.g., populate, merge, redis, cache) */
  operation: FeedOperation;
  /** User ID to retrieve metrics for */
  userId: TypeId;
};
export type GetApiV1AdminFeedMetricsHistoryAllApiResponse =
  /** status 200 Map of operation types to feed metrics lists */ object;
export type GetApiV1AdminFeedMetricsHistoryAllApiArg = {
  /** Maximum number of historical entries per operation (default: 100) */
  limit?: number;
  /** User ID to retrieve comprehensive metrics for */
  userId: TypeId;
};
export type GetApiV1AdminFeedMetricsRunningAverageSingleApiResponse =
  /** status 200 Running average metrics for the specified operation */ SlidingWindowMetrics;
export type GetApiV1AdminFeedMetricsRunningAverageSingleApiArg = {
  /** Feed operation to analyze */
  operation: FeedOperation;
  /** User ID to analyze */
  userId: TypeId;
  /** Sliding window size for averaging */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsRunningAveragesAllApiResponse =
  /** status 200 Map of operations to running average metrics */ object;
export type GetApiV1AdminFeedMetricsRunningAveragesAllApiArg = {
  /** User ID to analyze */
  userId: TypeId;
  /** Sliding window size for averaging */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsSlowestOperationsApiResponse =
  /** status 200 Slowest operations data with analysis results */ SlowestOperationsResponse;
export type GetApiV1AdminFeedMetricsSlowestOperationsApiArg = {
  /** Maximum number of operations to return (default: 10) */
  limit?: number;
  /** Time window for analysis */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsSlowestUsersApiResponse =
  /** status 200 Slowest users data with detailed performance analysis */ SlowestUsersResponse;
export type GetApiV1AdminFeedMetricsSlowestUsersApiArg = {
  /** Maximum number of users to return (default: 10) */
  limit?: number;
  /** Optional specific operation to analyze */
  operation?: FeedOperation | null;
  /** Time window for analysis */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsSlowestUsersAllApiResponse =
  /** status 200 Map of operations to lists of users ranked by performance */ object;
export type GetApiV1AdminFeedMetricsSlowestUsersAllApiArg = {
  /** Maximum number of users per operation (default: 10) */
  limit?: number;
  /** Sort in descending order - true for fastest users first, false for slowest users first (default: true) */
  sortDesc?: boolean;
  /** Time window for performance analysis */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsSlowestUsersSingleApiResponse =
  /** status 200 List of users ranked by performance metrics */ UserPerformanceMetrics[];
export type GetApiV1AdminFeedMetricsSlowestUsersSingleApiArg = {
  /** Maximum number of users to return (default: 10) */
  limit?: number;
  /** Feed operation to analyze */
  operation: FeedOperation;
  /** Sort in descending order - true for fastest users first, false for slowest users first (default: true) */
  sortDesc?: boolean;
  /** Time window for performance analysis */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsSummaryApiResponse =
  /** status 200 Comprehensive metrics summary with operation metrics and totals */ MetricsSummary;
export type GetApiV1AdminFeedMetricsSummaryApiArg = {
  /** Include user counts in summary (may impact performance, default: false) */
  includeUserCounts?: boolean;
  /** Time window for metrics aggregation */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsUserCountAllApiResponse =
  /** status 200 Map of operations to user counts */ {
    [key: string]: number;
  };
export type GetApiV1AdminFeedMetricsUserCountAllApiArg = {
  /** Time window to count active users within */
  window: WindowSize;
};
export type GetApiV1AdminFeedMetricsUserCountSingleApiResponse =
  /** status 200 User count data for the specified operation */ UserCountResponse;
export type GetApiV1AdminFeedMetricsUserCountSingleApiArg = {
  /** Feed operation to count users for */
  operation: FeedOperation;
  /** Time window to count active users within */
  window: WindowSize;
};
export type PostApiV1AdminFeedRegenerateUserFeedApiResponse =
  /** status 200 Number of user feeds queued for regeneration */ any;
export type PostApiV1AdminFeedRegenerateUserFeedApiArg = {
  /** Clear before */
  clear?: boolean | null;
  /** User ID to regenerate feed for */
  userId?: TypeId | null;
  /** Username to regenerate feed for (alternative to userId) */
  username?: string | null;
};
export type GetApiV1AdminGroupsSearchApiResponse =
  /** status 200 List of groups matching filters */ Group[];
export type GetApiV1AdminGroupsSearchApiArg = {
  /** Account ID of any group member */
  accountId?: TypeId | null;
  /** Display name of the group */
  displayName?: string | null;
  /** Group domain (remote groups) */
  domain?: string | null;
  /** Member account email */
  email?: string | null;
  /** Group join mode */
  joinMode?: GroupJoinMode | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Group privacy */
  privacy?: GroupPrivacy | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** User ID of any group member */
  userId?: TypeId | null;
  /** Group username (groupname) */
  username?: string | null;
  /** Group visibility */
  visibility?: GroupVisibility | null;
};
export type GetApiV1AdminGroupsUserByUserIdApiResponse =
  /** status 200 List of groups with user's role information */ Group[];
export type GetApiV1AdminGroupsUserByUserIdApiArg = {
  /** The user ID to query groups for */
  userId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** List of group roles to filter by */
  roles: string[];
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1AdminGroupsByAccountIdApiResponse =
  /** status 200 OK */ Group[];
export type GetApiV1AdminGroupsByAccountIdApiArg = {
  /** The account id */
  accountId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1AdminGroupsByGroupIdCategoriesApiResponse =
  /** status 200 List of forum categories */ Category[];
export type GetApiV1AdminGroupsByGroupIdCategoriesApiArg = {
  /** Group ID */
  groupId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1AdminGroupsByGroupIdChannelsApiResponse =
  /** status 200 List of group channels */ User[];
export type GetApiV1AdminGroupsByGroupIdChannelsApiArg = {
  /** Group ID */
  groupId: TypeId;
};
export type GetApiV1AdminGroupsByGroupIdEventsApiResponse =
  /** status 200 List of group-owned events */ Event[];
export type GetApiV1AdminGroupsByGroupIdEventsApiArg = {
  /** Group ID */
  groupId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Include translation */
  withTranslation?: Language | null;
};
export type GetApiV1AdminImpersonateApiResponse =
  /** status 200 Session key */ Token;
export type GetApiV1AdminImpersonateApiArg = {
  /** Username of the bot user to impersonate. Must be a bot account, not a regular user. Case-insensitive. */
  username: string;
};
export type GetApiV1AdminLinkServiceApiResponse =
  /** status 200 Current configuration returned */ any;
export type GetApiV1AdminLinkServiceApiArg = void;
export type PostApiV1AdminLinkServiceConfigureApiResponse =
  /** status 200 Configuration saved successfully */ any;
export type PostApiV1AdminLinkServiceConfigureApiArg = {
  configureRequest: ConfigureRequest;
};
export type PostApiV1AdminPostsDeleteApiResponse =
  /** status 200 Post(s) successfully deleted and audit logged */ any;
export type PostApiV1AdminPostsDeleteApiArg = {
  /** Post deletion request. Must provide either postId (for single post) or reportId (for all posts in report). The reason is required and will be recorded in the audit log. */
  postDelete: PostDelete;
};
export type DeleteApiV1AdminPurgeApiResponse =
  /** status 200 Account successfully purged from the system */ any;
export type DeleteApiV1AdminPurgeApiArg = {
  /** Id of the account to purge */
  id: TypeId;
};
export type PostApiV1AdminRegenerateKeysApiResponse =
  /** status 200 Keys successfully regenerated */ string;
export type PostApiV1AdminRegenerateKeysApiArg = {
  /** User ID whose cryptographic keys to regenerate. Must be a valid USER type ID. Either username or userId must be provided. */
  userId?: TypeId | null;
  /** Username of the user whose keys to regenerate. Case-insensitive. Either username or userId must be provided. */
  username?: string | null;
};
export type PostApiV1AdminRegenerateKeysAllApiResponse =
  /** status 200 Background job initiated, returns job UUID */ Uuid;
export type PostApiV1AdminRegenerateKeysAllApiArg = {
  batch?: number | null;
};
export type PostApiV1AdminReleaseUsernameApiResponse =
  /** status 200 Username successfully released */ string;
export type PostApiV1AdminReleaseUsernameApiArg = {
  /** username */
  username: string;
};
export type GetApiV1AdminReportsEligibleAssigneesApiResponse =
  /** status 200 List of eligible assignees */ User[];
export type GetApiV1AdminReportsEligibleAssigneesApiArg = {
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type GetApiV1AdminReportsListApiResponse =
  /** status 200 Paginated list of reports */ ReportsPaginatedResponse;
export type GetApiV1AdminReportsListApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Filter by resolution status. true = open reports only, false = resolved reports only, omit = all reports. Note: This is a convenience filter - open=true includes 'OPEN' and 'UNDER_REVIEW' states, open=false includes 'DISMISSED' and 'RESOLVED' states. */
  open?: boolean | null;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Filter by report state (OPEN, UNDER_REVIEW, DISMISSED, RESOLVED) */
  state?: ReportState | null;
  /** Filter by specific target ID (post, user, or group) */
  targetId?: TypeId | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1AdminReportsReportedGroupsApiResponse =
  /** status 200 Paginated list of reported groups */ ReportedGroupsPaginatedResponse;
export type GetApiV1AdminReportsReportedGroupsApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Filter by resolution status. true = groups with open reports, false = groups with all reports resolved, omit = all reported groups */
  open?: boolean | null;
  /** Sort by: TARGET_UPDATED (group update date), REPORTED_DATE (latest report), LAST_NOTE_DATE (latest admin note) */
  sortBy?: ReportSortBy | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1AdminReportsReportedPostsApiResponse =
  /** status 200 Paginated list of reported posts */ ReportedPostsPaginatedResponse;
export type GetApiV1AdminReportsReportedPostsApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Filter by resolution status. true = posts with open reports, false = posts with all reports resolved, omit = all reported posts */
  open?: boolean | null;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
  /** Sort by: TARGET_UPDATED (post update date), REPORTED_DATE (latest report), LAST_NOTE_DATE (latest admin note) */
  sortBy?: ReportSortBy | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1AdminReportsReportedUsersApiResponse =
  /** status 200 Paginated list of reported users */ ReportedUsersPaginatedResponse;
export type GetApiV1AdminReportsReportedUsersApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Filter by resolution status. true = users with open reports, false = users with all reports resolved, omit = all reported users */
  open?: boolean | null;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
  /** Sort by: TARGET_UPDATED (user update date), REPORTED_DATE (latest report), LAST_NOTE_DATE (latest admin note) */
  sortBy?: ReportSortBy | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1AdminReportsByReportIdApiResponse =
  /** status 200 Report details successfully retrieved */ Report;
export type GetApiV1AdminReportsByReportIdApiArg = {
  reportId: TypeId;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type PostApiV1AdminReportsByReportIdAddNoteApiResponse =
  /** status 200 Note successfully added to report */ Report;
export type PostApiV1AdminReportsByReportIdAddNoteApiArg = {
  reportId: TypeId;
  note: string;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type PostApiV1AdminReportsByReportIdAssignApiResponse =
  /** status 200 Report successfully assigned */ Report;
export type PostApiV1AdminReportsByReportIdAssignApiArg = {
  reportId: TypeId;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
  userId: TypeId;
};
export type DeleteApiV1AdminReportsByReportIdDeleteApiResponse =
  /** status 200 Report successfully deleted from the system */ string;
export type DeleteApiV1AdminReportsByReportIdDeleteApiArg = {
  reportId: TypeId;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type PostApiV1AdminReportsByReportIdDismissApiResponse =
  /** status 200 Report successfully dismissed */ Report;
export type PostApiV1AdminReportsByReportIdDismissApiArg = {
  reportId: TypeId;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type PostApiV1AdminReportsByReportIdRemoveNoteApiResponse =
  /** status 200 Note successfully removed from report */ Report;
export type PostApiV1AdminReportsByReportIdRemoveNoteApiArg = {
  reportId: TypeId;
  index: number;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type PostApiV1AdminReportsByReportIdReopenApiResponse =
  /** status 200 Report successfully reopened */ Report;
export type PostApiV1AdminReportsByReportIdReopenApiArg = {
  reportId: TypeId;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type PostApiV1AdminReportsByReportIdResolveApiResponse =
  /** status 200 Report successfully resolved */ Report;
export type PostApiV1AdminReportsByReportIdResolveApiArg = {
  reportId: TypeId;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type PostApiV1AdminReportsByReportIdUnassignApiResponse =
  /** status 200 Report successfully unassigned */ Report;
export type PostApiV1AdminReportsByReportIdUnassignApiArg = {
  reportId: TypeId;
  /** Group scope. Omit for server scope */
  scope?: TypeId | null;
};
export type PostApiV1AdminRestartApDeliveryApiResponse =
  /** status 200 Delivery restarted successfully */ any;
export type PostApiV1AdminRestartApDeliveryApiArg = {
  /** Remote domain to restart delivery for */
  domain: string;
};
export type GetApiV1AdminSearchApiResponse =
  /** status 200 List of users, number of users found and total number of users on server */ SearchDetails;
export type GetApiV1AdminSearchApiArg = {
  /** Account id */
  accountId?: TypeId | null;
  /** Actor type to filter by (Application, Group, Organization, Person, Service). Defaults to Person. */
  actorType?: ActorType | null;
  /** Country */
  country?: string | null;
  /** Display name */
  displayName?: string | null;
  /** Domain */
  domain?: string | null;
  /** Email */
  email?: string | null;
  /** IP address */
  ip?: string | null;
  /** Result kind: CHANNEL for only global channels, USER for only users, ALL for both. Default ALL */
  kind?: Kind | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Role */
  role?: RoleId | null;
  /** Mixed search across username, display name or email */
  search?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** State */
  state?: UserState | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** userId */
  userId?: TypeId | null;
  /** Username */
  username?: string | null;
};
export type PutApiV1AdminSignupRequestsApproveByHashApiResponse =
  /** status 200 Signup request approved and account created successfully */ any;
export type PutApiV1AdminSignupRequestsApproveByHashApiArg = {
  hash: string;
};
export type DeleteApiV1AdminSignupRequestsDeleteByHashApiResponse =
  /** status 200 Signup request successfully deleted */ any;
export type DeleteApiV1AdminSignupRequestsDeleteByHashApiArg = {
  hash: string;
};
export type GetApiV1AdminSignupRequestsListApiResponse =
  /** status 200 Paginated list of signup requests with total count */ SignupRequestResult;
export type GetApiV1AdminSignupRequestsListApiArg = {
  /** Filter by email address. Returns requests with matching email. */
  email?: string | null;
  /** Filter by request hash. Returns the specific request with this hash. */
  hash?: string | null;
  /** Filter by IP address. Returns requests from this originating IP. */
  ip?: string | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PutApiV1AdminSignupRequestsRejectByHashApiResponse =
  /** status 200 Signup request rejected and user notified */ any;
export type PutApiV1AdminSignupRequestsRejectByHashApiArg = {
  hash: string;
  /** Optional reason for rejection to include in the notification email. Helps users understand why their request was denied. */
  reason?: string | null;
};
export type GetApiV1AdminUploadsJobsQueueByQueueNameApiResponse =
  /** status 200 Upload jobs list retrieved successfully */ {
    list: ProcessJob[];
    /** Total number of jobs in the queue. */
    total: number;
    /** Total number of jobs in the queue with specified filter. */
    totalJobs: number;
  };
export type GetApiV1AdminUploadsJobsQueueByQueueNameApiArg = {
  /** Queue name to retrieve jobs from (submitted, in_progress, completed) */
  queueName: string;
  /** Maximum number of jobs to return. Default is 10. */
  limit?: number;
  /** Pagination offset for results. Default is 0. */
  offset?: number;
  /** Field to sort by (submission_time, processing_duration, etc.) */
  sortBy?: string | null;
  /** Sort order direction. Values: 'asc' or 'desc'. Default is ascending. */
  sortOrder?: string | null;
  /** Filter by upload type (IMAGE, VIDEO, AUDIO, DOCUMENT) */
  uploadType?: string | null;
};
export type GetApiV1AdminUploadsJobsSummaryApiResponse =
  /** status 200 Queue summaries retrieved successfully */ QueueSummary[];
export type GetApiV1AdminUploadsJobsSummaryApiArg = void;
export type GetApiV1AdminUploadsSearchApiResponse =
  /** status 200 Upload search results retrieved successfully */ {
    list: Upload[];
    total: number;
  };
export type GetApiV1AdminUploadsSearchApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Filter by upload tag (Avatar, Header, Post, etc.). Omit to include all tags. */
  tag?: UploadsTags | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Filter by upload type (IMAGE, VIDEO, AUDIO, DOCUMENT). Omit to include all types. */
  uploadType?: UploadType | null;
  /** User ID whose uploads to search. Must be a valid USER type TypeId. */
  userId: TypeId;
};
export type GetApiV1AdminUploadsStorageByUserIdApiResponse =
  /** status 200 User storage information retrieved successfully */ UserStorage;
export type GetApiV1AdminUploadsStorageByUserIdApiArg = {
  userId: TypeId;
};
export type GetApiV1AdminUploadsByUploadIdLogsApiResponse =
  /** status 200 Upload logs retrieved successfully */ UploadLog[];
export type GetApiV1AdminUploadsByUploadIdLogsApiArg = {
  /** Upload ID. Must be a valid UPLOAD type TypeId. */
  uploadId: TypeId;
};
export type PostApiV1AdminUserChangeStateApiResponse =
  /** status 200 User state successfully updated */ any;
export type PostApiV1AdminUserChangeStateApiArg = {
  changeUserState: ChangeUserState;
};
export type PostApiV1AdminUserChangeStateBulkApiResponse =
  /** status 200 Bulk user states updated */ ChangeUsersStateResult;
export type PostApiV1AdminUserChangeStateBulkApiArg = {
  changeUserStateBulk: ChangeUserStateBulk;
};
export type GetApiV1AdminUserByUserIdApiResponse =
  /** status 200 User details successfully retrieved */ UserDetails;
export type GetApiV1AdminUserByUserIdApiArg = {
  userId: TypeId;
};
export type GetApiV1AiAgentsApiResponse =
  /** status 200 Array of bots */ AiAgent[];
export type GetApiV1AiAgentsApiArg = {
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type PostApiV1AiAgentsApiResponse =
  /** status 200 Created bot with profile */ AiAgent;
export type PostApiV1AiAgentsApiArg = {
  /** Scope: 'global' or group TypeId */
  scope: string;
  aiAgentCreate: AiAgentCreate;
};
export type GetApiV1AiAgentsPostsApiResponse =
  /** status 200 Posts list */ Post[];
export type GetApiV1AiAgentsPostsApiArg = {
  /** Maximum number of items to return (page size). Defaults to 100. */
  limit?: number | null;
  /** Owner id. Accepts a group channel (USER) or forum category (CATEGORY) id */
  ownerId?: TypeId | null;
  /** Timestamp to retrieve posts strictly newer than this (by createdAt) */
  since?: Instant | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1AiAgentsByAgentIdApiResponse =
  /** status 200 Bot with profile */ AiAgent;
export type GetApiV1AiAgentsByAgentIdApiArg = {
  agentId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type DeleteApiV1AiAgentsByAgentIdApiResponse =
  /** status 200 Bot deleted */ any;
export type DeleteApiV1AiAgentsByAgentIdApiArg = {
  agentId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type PutApiV1AiAgentsByAgentIdDisableApiResponse =
  /** status 200 Bot disabled */ any;
export type PutApiV1AiAgentsByAgentIdDisableApiArg = {
  agentId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type PutApiV1AiAgentsByAgentIdEnableApiResponse =
  /** status 200 Bot enabled */ any;
export type PutApiV1AiAgentsByAgentIdEnableApiArg = {
  agentId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
  /** Optional profile version to set as current before enabling */
  version?: number | null;
};
export type PutApiV1AiAgentsByAgentIdProfileApiResponse =
  /** status 200 Bot updated */ AiAgentProfileVersionCreated;
export type PutApiV1AiAgentsByAgentIdProfileApiArg = {
  agentId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
  aiAgentProfileUpdate: AiAgentProfileUpdate;
};
export type PutApiV1AiAgentsByAgentIdUserApiResponse =
  /** status 200 Bot user profile updated */ any;
export type PutApiV1AiAgentsByAgentIdUserApiArg = {
  agentId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
  userUpdate: UserUpdate;
};
export type GetApiV1AiAgentsByAgentIdVersionsApiResponse =
  /** status 200 Version history records */ AiAgentProfile[];
export type GetApiV1AiAgentsByAgentIdVersionsApiArg = {
  agentId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type GetApiV1AiAgentsByAgentIdVersionsAndVersionApiResponse =
  /** status 200 Bot with requested profile version */ AiAgent;
export type GetApiV1AiAgentsByAgentIdVersionsAndVersionApiArg = {
  agentId: TypeId;
  version: number;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type GetApiV1AiModelsApiResponse =
  /** status 200 Paginated list of models with scoped state */ AiModelPagedResponse;
export type GetApiV1AiModelsApiArg = {
  /** Supported sortBy values for this endpoint: model_name, provider_name, family, release_date, enabled */
  sortBy?: string | null;
  /** Filter by built-in tools (comma-separated: WEB_SEARCH,CODE_EXECUTION,etc) */
  builtInTools?: AiBuiltInTool[] | null;
  /** Filter by capabilities (comma-separated: CHAT,TOOLS,VISION,etc) */
  capabilities?: AiModelCapabilityFilter[] | null;
  /** Filter by deprecated status */
  deprecated?: boolean | null;
  /** Filter by enablement state in the requested scope (true=enabled only, false=disabled/unconfigured, omit for all) */
  enabled?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  /** Maximum context window size */
  maxContextWindow?: number | null;
  /** Maximum input price per 1M tokens (USD) */
  maxInputPrice?: number | null;
  /** Maximum max output tokens (for embedding models, this is the vector dimension) */
  maxMaxOutputTokens?: number | null;
  /** Maximum output price per 1M tokens (USD) */
  maxOutputPrice?: number | null;
  /** Minimum context window size */
  minContextWindow?: number | null;
  /** Minimum max output tokens (for embedding models, this is the vector dimension) */
  minMaxOutputTokens?: number | null;
  /** Filter by modalities (comma-separated: TEXT,IMAGE,AUDIO,VIDEO,PDF) */
  modalities?: AiModality[] | null;
  offset?: number | null;
  /** Filter by open weights status */
  openWeights?: boolean | null;
  /** Filter by provider ID */
  providerId?: TypeId | null;
  /** Scope: 'global' or group TypeId */
  scope: string;
  /** Search in name, family, and external ID (case-insensitive partial match) */
  search?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1AiModelsByModelIdApiResponse =
  /** status 200 Model details with scoped state */ AiModel;
export type GetApiV1AiModelsByModelIdApiArg = {
  modelId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope?: string | null;
};
export type GetApiV1AiModelsByModelIdAgentsApiResponse =
  /** status 200 List of AI agents using this scoped model configuration */ AiAgent[];
export type GetApiV1AiModelsByModelIdAgentsApiArg = {
  modelId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type DeleteApiV1AiModelsByModelIdConfigureApiResponse =
  /** status 200 Scoped model configuration removed successfully */ any;
export type DeleteApiV1AiModelsByModelIdConfigureApiArg = {
  modelId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type PutApiV1AiModelsByModelIdDisableApiResponse =
  /** status 200 Model disabled successfully */ AiModel;
export type PutApiV1AiModelsByModelIdDisableApiArg = {
  modelId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type PutApiV1AiModelsByModelIdEnableApiResponse =
  /** status 200 Model enabled successfully */ AiModel;
export type PutApiV1AiModelsByModelIdEnableApiArg = {
  modelId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type GetApiV1AiModelsByModelIdMigrationPathApiResponse =
  /** status 200 Migration path */ AiModel[];
export type GetApiV1AiModelsByModelIdMigrationPathApiArg = {
  modelId: TypeId;
};
export type GetApiV1AiModelsByModelIdResolveApiResponse =
  /** status 200 Resolved model */ AiModel;
export type GetApiV1AiModelsByModelIdResolveApiArg = {
  modelId: TypeId;
};
export type GetApiV1AiProvidersApiResponse =
  /** status 200 List of providers with scoped state */ AiProvider[];
export type GetApiV1AiProvidersApiArg = {
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type GetApiV1AiProvidersByProviderIdApiResponse =
  /** status 200 Provider details with scoped state */ AiProvider;
export type GetApiV1AiProvidersByProviderIdApiArg = {
  providerId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type GetApiV1AiProvidersByProviderIdAgentsApiResponse =
  /** status 200 List of AI agents using this scoped provider configuration */ AiAgent[];
export type GetApiV1AiProvidersByProviderIdAgentsApiArg = {
  providerId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type DeleteApiV1AiProvidersByProviderIdConfigureApiResponse =
  /** status 200 Configuration removed successfully */ any;
export type DeleteApiV1AiProvidersByProviderIdConfigureApiArg = {
  providerId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type PutApiV1AiProvidersByProviderIdConfigureApiResponse =
  /** status 200 Provider configured successfully */ AiProvider;
export type PutApiV1AiProvidersByProviderIdConfigureApiArg = {
  providerId: TypeId;
  /** Scope: 'global' or group TypeId */
  scope: string;
  aiScopedProviderConfigure: AiScopedProviderConfigure;
};
export type GetApiV1AiProvidersByProviderIdModelsApiResponse =
  /** status 200 List of models with scoped state */ AiModel[];
export type GetApiV1AiProvidersByProviderIdModelsApiArg = {
  providerId: TypeId;
  /** Filter by enablement state in the requested scope (true=enabled only, false=disabled/unconfigured, omit for all) */
  enabled?: boolean | null;
  /** Include deprecated models */
  includeDeprecated?: boolean;
  /** Scope: 'global' or group TypeId */
  scope: string;
};
export type PostApiV1AppsApiResponse = /** status 200 OK */ Application;
export type PostApiV1AppsApiArg = {
  /** Automatically enable the application after successful installation. Default is false. */
  enable?: boolean | null;
  body: {
    file: Blob;
  };
};
export type GetApiV1AppsApiResponse = /** status 200 OK */ Application[];
export type GetApiV1AppsApiArg = void;
export type GetApiV1AppsEnabledApiResponse = /** status 200 OK */ Application[];
export type GetApiV1AppsEnabledApiArg = void;
export type GetApiV1AppsInstalledApiResponse =
  /** status 200 OK */ Application[];
export type GetApiV1AppsInstalledApiArg = void;
export type GetApiV1AppsUserApiResponse = /** status 200 OK */ Application[];
export type GetApiV1AppsUserApiArg = void;
export type DeleteApiV1AppsUserByAppIdApiResponse = /** status 200 OK */ any;
export type DeleteApiV1AppsUserByAppIdApiArg = {
  appId: TypeId;
};
export type PutApiV1AppsUserByAppIdApiResponse =
  /** status 200 Returns app */ Application;
export type PutApiV1AppsUserByAppIdApiArg = {
  appId: TypeId;
};
export type PutApiV1AppsByAppIdApiResponse = /** status 200 OK */ Application;
export type PutApiV1AppsByAppIdApiArg = {
  appId: TypeId;
  /** Automatically enable the application after successful update. Default is false. */
  enable?: boolean | null;
  body: {
    file: Blob;
  };
};
export type GetApiV1AppsByAppIdApiResponse = /** status 200 OK */ Application;
export type GetApiV1AppsByAppIdApiArg = {
  appId: TypeId;
};
export type DeleteApiV1AppsByAppIdApiResponse = /** status 200 OK */ any;
export type DeleteApiV1AppsByAppIdApiArg = {
  appId: TypeId;
};
export type GetApiV1AppsByAppIdDataApiResponse =
  /** status 200 List of matching application data entries */ AppData[];
export type GetApiV1AppsByAppIdDataApiArg = {
  /** Application ID to query data for. Must be a valid APP type TypeId. */
  appId: TypeId;
  /** Filter by owner ID (user, group, user:group, or 'platform'). Requires read permission. */
  owner?: string | null;
  /** Filter by tags. Comma-separated list. Returns entries that have ALL specified tags. */
  tags?: string[];
  /** Filter by data type. Returns only entries with this exact type. */
  type?: string | null;
};
export type PostApiV1AppsByAppIdDataApiResponse =
  /** status 200 Application data successfully created */ AppData;
export type PostApiV1AppsByAppIdDataApiArg = {
  /** Application ID that owns this data. Must be a valid APP type TypeId. */
  appId: TypeId;
  dataCreate: DataCreate;
};
export type PutApiV1AppsByAppIdDataAndIdApiResponse =
  /** status 200 Application data successfully updated */ AppData;
export type PutApiV1AppsByAppIdDataAndIdApiArg = {
  /** Application ID that owns this data. Must match the data's application. */
  appId: TypeId;
  /** Data entry ID to update. Must be a valid APP_DATA type TypeId. */
  id: TypeId;
  dataCreate: DataCreate;
};
export type DeleteApiV1AppsByAppIdDataAndIdApiResponse =
  /** status 200 Application data successfully deleted */ any;
export type DeleteApiV1AppsByAppIdDataAndIdApiArg = {
  /** Application ID that owns this data. Must match the data's application. */
  appId: TypeId;
  /** Data entry ID to delete. Must be a valid APP_DATA type TypeId. */
  id: TypeId;
};
export type PutApiV1AppsByAppIdDefaultApiResponse = /** status 200 OK */ any;
export type PutApiV1AppsByAppIdDefaultApiArg = {
  appId: TypeId;
};
export type PutApiV1AppsByAppIdDisableApiResponse = /** status 200 OK */ any;
export type PutApiV1AppsByAppIdDisableApiArg = {
  appId: TypeId;
};
export type PutApiV1AppsByAppIdEnableApiResponse = /** status 200 OK */ any;
export type PutApiV1AppsByAppIdEnableApiArg = {
  appId: TypeId;
};
export type GetApiV1AppsByAppIdStatsApiResponse =
  /** status 200 OK */ ApplicationWithStats;
export type GetApiV1AppsByAppIdStatsApiArg = {
  appId: TypeId;
};
export type PutApiV1AppsByAppIdUserDefaultApiResponse =
  /** status 200 OK */ any;
export type PutApiV1AppsByAppIdUserDefaultApiArg = {
  appId: TypeId;
};
export type DeleteApiV1AppsByAppIdUserDefaultApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1AppsByAppIdUserDefaultApiArg = {
  appId: TypeId;
};
export type GetApiV1AsyncRefreshesByIdApiResponse =
  /** status 200 Async refresh status */ AsyncRefreshResponse;
export type GetApiV1AsyncRefreshesByIdApiArg = {
  /** Async refresh ID */
  id: TypeId;
};
export type GetApiV1BlockApiResponse = /** status 200 OK */ User[];
export type GetApiV1BlockApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1BlockByApiResponse = /** status 200 OK */ User[];
export type GetApiV1BlockByApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type DeleteApiV1BlockByUserIdApiResponse = /** status 200 OK */ any;
export type DeleteApiV1BlockByUserIdApiArg = {
  /** User ID to unblock. Must be a valid USER type TypeId that is currently blocked. */
  userId: TypeId;
};
export type PostApiV1BlockByUserIdApiResponse = /** status 200 OK */ any;
export type PostApiV1BlockByUserIdApiArg = {
  /** User ID to block. Must be a valid USER type TypeId. */
  userId: TypeId;
};
export type GetApiV1CustomEmojisApiResponse =
  /** status 200 Paginated emoji results */ EmojiPaginatedResponse;
export type GetApiV1CustomEmojisApiArg = {
  /** Exact category name(s). Multiple values comma-separated */
  category?: string[] | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Exact shortcode(s) of emoji. Multiple values comma-separated */
  shortcode?: string[] | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type DeleteApiV1CustomEmojisApiResponse =
  /** status 200 Number of deleted emojis */ Blob;
export type DeleteApiV1CustomEmojisApiArg = {
  /** You can provide multiple categories as comma-separated values */
  category?: string[] | null;
  /** You can provide multiple shortcodes as comma-separated values */
  shortcode?: string[] | null;
};
export type PostApiV1CustomEmojisApiResponse =
  /** status 200 json object with the emoji data */ Emoji;
export type PostApiV1CustomEmojisApiArg = {
  /** Should existing emojis be overwritten if shortcode matches */
  overwrite?: boolean;
  /** Json object with the emoji data: shortcode, category, url, staticUrl, visibleInPicker */
  emoji: Emoji;
};
export type GetApiV1CustomEmojisCategoriesApiResponse =
  /** status 200 List of categories */ string[];
export type GetApiV1CustomEmojisCategoriesApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Filter categories by substring */
  q?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1CustomEmojisExportApiResponse =
  /** status 200 Zip file with the emojis */ Blob;
export type GetApiV1CustomEmojisExportApiArg = {
  /** Category of the emojis to export */
  category?: string;
};
export type PostApiV1CustomEmojisImportApiResponse =
  /** status 200 Array of json objects with the emoji data */ Emoji[];
export type PostApiV1CustomEmojisImportApiArg = {
  /** Category of the imported emojis */
  category: string;
  domain?: string | null;
  /** Should existing emojis be overwritten if any of the shortcodes match */
  overwrite?: boolean;
  /** Whether the imported emojis should be visible in the picker */
  visible: boolean;
  /** Zip file with the emojis. */
  body: {
    file: Blob;
  };
};
export type PostApiV1CustomEmojisImportUploadApiResponse =
  /** status 200 Array of json objects with the emoji data */ Emoji[];
export type PostApiV1CustomEmojisImportUploadApiArg = {
  /** Category of the imported emojis */
  category: string;
  domain?: string | null;
  /** Should existing emojis be overwritten if any of the shortcodes match */
  overwrite?: boolean;
  /** ID of the previously created upload containing the ZIP archive */
  uploadId: TypeId;
  /** Whether the imported emojis should be visible in the picker */
  visible: boolean;
};
export type GetApiV1CustomEmojisSearchApiResponse =
  /** status 200 Paginated emoji search results */ EmojiPaginatedResponse;
export type GetApiV1CustomEmojisSearchApiArg = {
  /** Category substring(s) to search. Comma-separated */
  category?: string[] | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Shortcode substring(s) to search. Comma-separated */
  shortcode?: string[] | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PostApiV1CustomEmojisUploadApiResponse =
  /** status 200 json object with the emoji data */ Emoji;
export type PostApiV1CustomEmojisUploadApiArg = {
  /** Category of the emoji */
  category: string;
  domain?: string | null;
  /** Should existing emojis be overwritten if shortcode matches */
  overwrite?: boolean;
  /** Shortcode of the emoji */
  shortcode: string;
  /** ID of the previously created upload containing the emoji file */
  uploadId: TypeId;
  /** Whether the emoji should be visible in the picker */
  visible: boolean;
};
export type PatchApiV1CustomEmojisByShortcodeApiResponse =
  /** status 200 Updated emoji */ Emoji;
export type PatchApiV1CustomEmojisByShortcodeApiArg = {
  /** Emoji shortcode */
  shortcode: string;
  emojiPatchRequest: EmojiPatchRequest;
};
export type GetApiV1DataApiResponse =
  /** status 200 List of matching platform data entries */ AppData[];
export type GetApiV1DataApiArg = {
  /** Filter by owner ID (user, group, user:group, or 'platform'). Requires manage permission. */
  owner?: string | null;
  /** Filter by tags. Comma-separated list. Returns entries that have ALL specified tags. */
  tags?: string[];
  /** Filter by data type. Returns only entries with this exact type. */
  type?: string | null;
};
export type PostApiV1DataApiResponse =
  /** status 200 Data entry successfully created */ AppData;
export type PostApiV1DataApiArg = {
  dataCreate: DataCreate;
};
export type PutApiV1DataByIdApiResponse =
  /** status 200 Data entry successfully updated */ AppData;
export type PutApiV1DataByIdApiArg = {
  /** Data entry ID to update. Must be a valid APP_DATA type TypeId. */
  id: TypeId;
  dataCreate: DataCreate;
};
export type DeleteApiV1DataByIdApiResponse =
  /** status 200 Data entry successfully deleted */ any;
export type DeleteApiV1DataByIdApiArg = {
  /** Data entry ID to delete. Must be a valid APP_DATA type TypeId. */
  id: TypeId;
};
export type PutApiV1DevicesApiResponse = /** status 200 Device stored */ any;
export type PutApiV1DevicesApiArg = {
  deviceRegistrationRequest: DeviceRegistrationRequest;
};
export type GetApiV1DevicesApiResponse =
  /** status 200 List of devices */ UserDevice[];
export type GetApiV1DevicesApiArg = void;
export type DeleteApiV1DevicesAllApiResponse = unknown;
export type DeleteApiV1DevicesAllApiArg = void;
export type GetApiV1DevicesVapidPublicKeyApiResponse =
  /** status 200 VAPID public key returned */ VapidPublicKeyResponse;
export type GetApiV1DevicesVapidPublicKeyApiArg = void;
export type DeleteApiV1DevicesByDeviceIdApiResponse = unknown;
export type DeleteApiV1DevicesByDeviceIdApiArg = {
  deviceId: string;
};
export type GetApiV1DomainBlockApiResponse =
  /** status 200 Successfully retrieved public list of blocked domains */ BlockedDomain[];
export type GetApiV1DomainBlockApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1DraftsApiResponse =
  /** status 200 List of drafts */ Draft[];
export type GetApiV1DraftsApiArg = {
  /** Scope owner to filter drafts by context (user, category, forum, or event) */
  ownerId?: TypeId | null;
};
export type PostApiV1DraftsApiResponse =
  /** status 200 The created draft */ Draft;
export type PostApiV1DraftsApiArg = {
  /** Scope owner to resolve the draft context (user, category, or event) */
  ownerId?: TypeId | null;
  createDraftRequest: CreateDraftRequest;
};
export type GetApiV1DraftsPostByPostIdApiResponse =
  /** status 200 The draft */ Draft;
export type GetApiV1DraftsPostByPostIdApiArg = {
  postId: TypeId;
};
export type PutApiV1DraftsByDraftIdApiResponse =
  /** status 200 The updated draft */ Draft;
export type PutApiV1DraftsByDraftIdApiArg = {
  draftId: TypeId;
  updateDraftRequest: UpdateDraftRequest;
};
export type GetApiV1DraftsByDraftIdApiResponse =
  /** status 200 The draft */ Draft;
export type GetApiV1DraftsByDraftIdApiArg = {
  draftId: TypeId;
};
export type DeleteApiV1DraftsByDraftIdApiResponse =
  /** status 200 Success response */ any;
export type DeleteApiV1DraftsByDraftIdApiArg = {
  draftId: TypeId;
};
export type PostApiV1DraftsByDraftIdPublishApiResponse =
  /** status 200 The published post */ Post;
export type PostApiV1DraftsByDraftIdPublishApiArg = {
  draftId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1EventsApiResponse = /** status 200 OK */ Event[];
export type GetApiV1EventsApiArg = {
  /** List specific group's events */
  groupId?: TypeId | null;
  /** Show no more than the given number of events */
  limit?: number | null;
  /** An offset to show events starting from */
  offset?: number | null;
  /** List specific user's events */
  organizerId?: TypeId | null;
  /** List specific user's events */
  username?: string | null;
  /** Include translation */
  withTranslation?: Language | null;
};
export type PostApiV1EventsApiResponse =
  /** status 200 Event object just created */ Event;
export type PostApiV1EventsApiArg = {
  createEvent: CreateEvent;
};
export type GetApiV1EventsCalendarGByGroupnameIcsApiResponse =
  /** status 200 Calendar in ICS format */ Blob;
export type GetApiV1EventsCalendarGByGroupnameIcsApiArg = {
  /** Group name of the group of public calendar */
  groupname: string;
};
export type GetApiV1EventsCalendarPByIdIcsApiResponse =
  /** status 200 Calendar in ICS format */ Blob;
export type GetApiV1EventsCalendarPByIdIcsApiArg = {
  /** Private calendar id */
  id: string;
};
export type GetApiV1EventsCalendarUByUsernameIcsApiResponse =
  /** status 200 Calendar in ICS format */ Blob;
export type GetApiV1EventsCalendarUByUsernameIcsApiArg = {
  /** Public calendar user's username */
  username: string;
};
export type GetApiV1EventsMyApiResponse = /** status 200 OK */ Event[];
export type GetApiV1EventsMyApiArg = {
  /** Show no more than the given number of events */
  limit?: number | null;
  /** List not yet responded events only */
  notRespondedOnly?: boolean | null;
  /** An offset to show events starting from */
  offset?: number | null;
  /** List events current user has organized */
  organizedOnly?: boolean | null;
  /** List current user's past events only */
  past?: boolean | null;
  /** Include translation */
  withTranslation?: Language | null;
};
export type GetApiV1EventsSearchApiResponse = /** status 200 OK */ Event[];
export type GetApiV1EventsSearchApiArg = {
  /** Include cancelled events in results */
  cancelled?: boolean;
  /** Geo search radius in meters (requires latitude and longitude) */
  distanceMeters?: number | null;
  /** End of event start-time range (inclusive), ISO-8601 */
  endTime?: string | null;
  /** For mode=fasp, request hydrated events from providers */
  faspHydrate?: boolean;
  /** Filter by group. If absent includes events from all scopes */
  groupId?: TypeId | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  /** Latitude for geo search (requires longitude and distanceMeters) */
  latitude?: number | null;
  limit?: number | null;
  /** Longitude for geo search (requires latitude and distanceMeters) */
  longitude?: number | null;
  /** Search mode: following, local, fasp */
  mode: EventSearchMode;
  offset?: number | null;
  /** Sort order by event start time: ASC or DESC */
  order?: SortOrder | null;
  /** Search query */
  q?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Start of event start-time range (inclusive), ISO-8601. If both startTime and endTime are omitted, default is upcoming events (from now). */
  startTime?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1EventsSettingsApiResponse =
  /** status 200 OK */ EventsSettings;
export type GetApiV1EventsSettingsApiArg = {
  /** Group ID for groups */
  ownerId?: TypeId | null;
};
export type PostApiV1EventsSettingsRegeneratePrivateIdApiResponse =
  /** status 200 Newly generated unique ID for private calendar */ string;
export type PostApiV1EventsSettingsRegeneratePrivateIdApiArg = {
  /** Group ID for groups */
  ownerId?: TypeId | null;
};
export type PostApiV1EventsSettingsUpdateApiResponse =
  /** status 200 OK */ EventsSettings;
export type PostApiV1EventsSettingsUpdateApiArg = {
  /** Group ID for groups */
  ownerId?: TypeId | null;
  updateEventsSettings: UpdateEventsSettings;
};
export type PutApiV1EventsByEventIdApiResponse = /** status 200 OK */ Event;
export type PutApiV1EventsByEventIdApiArg = {
  eventId: TypeId;
  updateEvent: UpdateEvent;
};
export type GetApiV1EventsByEventIdApiResponse = /** status 200 OK */ Event;
export type GetApiV1EventsByEventIdApiArg = {
  eventId: TypeId;
  /** Include translation */
  withTranslation?: Language | null;
};
export type DeleteApiV1EventsByEventIdApiResponse =
  /** status 200 Event has been deleted successfully */ any;
export type DeleteApiV1EventsByEventIdApiArg = {
  eventId: TypeId;
};
export type GetApiV1EventsByEventIdIcsApiResponse =
  /** status 200 Calendar in ICS format */ Blob;
export type GetApiV1EventsByEventIdIcsApiArg = {
  eventId: TypeId;
};
export type PostApiV1EventsByEventIdAcceptApiResponse =
  /** status 200 OK */ any;
export type PostApiV1EventsByEventIdAcceptApiArg = {
  eventId: TypeId;
};
export type GetApiV1EventsByEventIdAttendeesApiResponse =
  /** status 200 OK */ EventAttendee[];
export type GetApiV1EventsByEventIdAttendeesApiArg = {
  eventId: TypeId;
  /** Show no more than the given number of attendees */
  limit?: number | null;
  /** An offset to show attendees starting from */
  offset?: number | null;
};
export type DeleteApiV1EventsByEventIdAttendeesAndUserIdApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1EventsByEventIdAttendeesAndUserIdApiArg = {
  eventId: TypeId;
  userId: TypeId;
};
export type PostApiV1EventsByEventIdAttendeesAndUserIdApiResponse =
  /** status 200 OK */ any;
export type PostApiV1EventsByEventIdAttendeesAndUserIdApiArg = {
  eventId: TypeId;
  userId: TypeId;
};
export type PostApiV1EventsByEventIdCancelApiResponse =
  /** status 200 OK */ Event;
export type PostApiV1EventsByEventIdCancelApiArg = {
  eventId: TypeId;
};
export type PostApiV1EventsByEventIdInterestedApiResponse =
  /** status 200 OK */ EventStats;
export type PostApiV1EventsByEventIdInterestedApiArg = {
  eventId: TypeId;
};
export type PostApiV1EventsByEventIdJoinApiResponse =
  /** status 200 OK */ EventStats;
export type PostApiV1EventsByEventIdJoinApiArg = {
  eventId: TypeId;
};
export type DeleteApiV1EventsByEventIdJoinOrInterestedApiResponse =
  /** status 200 OK */ EventStats;
export type DeleteApiV1EventsByEventIdJoinOrInterestedApiArg = {
  eventId: TypeId;
};
export type PostApiV1EventsByEventIdMaybeApiResponse = /** status 200 OK */ any;
export type PostApiV1EventsByEventIdMaybeApiArg = {
  eventId: TypeId;
};
export type GetApiV1EventsByEventIdMutualApiResponse =
  /** status 200 OK */ User[];
export type GetApiV1EventsByEventIdMutualApiArg = {
  eventId: TypeId;
  /** Show no more than the given number of items */
  limit?: number | null;
  /** An offset to show items starting from */
  offset?: number | null;
};
export type PostApiV1EventsByEventIdRejectApiResponse =
  /** status 200 OK */ any;
export type PostApiV1EventsByEventIdRejectApiArg = {
  eventId: TypeId;
};
export type PostApiV1EventsByEventIdTranslateApiResponse =
  /** status 200 Event translation */ EventTranslation;
export type PostApiV1EventsByEventIdTranslateApiArg = {
  eventId: TypeId;
  lang: Language;
};
export type PostApiV1FaspClearApiResponse = /** status 200 OK */ any;
export type PostApiV1FaspClearApiArg = void;
export type PostApiV1FaspRegistrationApiResponse = /** status 200 OK */ any;
export type PostApiV1FaspRegistrationApiArg = {
  registrationRequest: RegistrationRequest;
};
export type PostApiV1FaspByProviderIdCapabilitiesApiResponse =
  /** status 200 OK */ any;
export type PostApiV1FaspByProviderIdCapabilitiesApiArg = {
  /** ID of the FASP provider */
  providerId: number;
  body: Capability[];
};
export type PostApiV1FaspByProviderIdDebugCallApiResponse =
  /** status 200 OK */ any;
export type PostApiV1FaspByProviderIdDebugCallApiArg = {
  /** ID of the FASP provider */
  providerId: number;
  body: string | null;
};
export type PostApiV1FaspByProviderIdRequestBackfillApiResponse =
  /** status 200 OK */ any;
export type PostApiV1FaspByProviderIdRequestBackfillApiArg = {
  /** ID of the FASP provider */
  providerId: number;
  /** Content category to backfill (content, account, or group) */
  category: Category1;
};
export type PostApiV1FederationTokensApiResponse =
  /** status 200 Token issued successfully */ Token;
export type PostApiV1FederationTokensApiArg = {
  groupFederationTokenRequest: GroupFederationTokenRequest;
};
export type GetApiV1GeoApiResponse =
  /** status 200 The formatted address string corresponding to the provided coordinates */ string;
export type GetApiV1GeoApiArg = {
  /** Latitude coordinate in decimal degrees */
  latitude: number;
  /** Longitude coordinate in decimal degrees */
  longitude: number;
};
export type GetApiV1GroupsApiResponse =
  /** status 200 List of groups the current user is a member of */ Group[];
export type GetApiV1GroupsApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PostApiV1GroupsApiResponse =
  /** status 200 Successfully created the new group */ Group;
export type PostApiV1GroupsApiArg = {
  groupCreate: GroupCreate;
};
export type GetApiV1GroupsAppsApiResponse = /** status 200 OK */ Application[];
export type GetApiV1GroupsAppsApiArg = void;
export type GetApiV1GroupsInvitesApiResponse =
  /** status 200 List of user's group invitations */ GroupInvite[];
export type GetApiV1GroupsInvitesApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Filter invitations by status. If omitted, returns all. */
  status?: GroupInviteStatus | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1GroupsMemberByUserIdApiResponse =
  /** status 200 List of group memberships for the user */ GroupMember[];
export type GetApiV1GroupsMemberByUserIdApiArg = {
  /** The ID of the user whose memberships to retrieve */
  userId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1GroupsMemberByUserIdGroupsApiResponse =
  /** status 200 List of groups the user is a member of */ Group[];
export type GetApiV1GroupsMemberByUserIdGroupsApiArg = {
  /** The ID of the user whose groups to retrieve */
  userId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1GroupsMyGroupsApiResponse =
  /** status 200 List of user's groups with sorting information and viewer context */ Group[];
export type GetApiV1GroupsMyGroupsApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1GroupsNameByGroupnameApiResponse =
  /** status 200 Group details retrieved successfully */ Group;
export type GetApiV1GroupsNameByGroupnameApiArg = {
  /** The unique group name (slug) */
  groupname: string;
};
export type GetApiV1GroupsOwnedApiResponse =
  /** status 200 List of groups owned by the current user */ Group[];
export type GetApiV1GroupsOwnedApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1GroupsPinnedApiResponse =
  /** status 200 List of pinned groups with full group details */ Group[];
export type GetApiV1GroupsPinnedApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1GroupsSearchApiResponse =
  /** status 200 List of matching groups */ Group[];
export type GetApiV1GroupsSearchApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Substring to search for in group names. Case-insensitive partial match. */
  substring?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1GroupsUsersByUserIdMutualApiResponse =
  /** status 200 List of groups both users belong to */ Group[];
export type GetApiV1GroupsUsersByUserIdMutualApiArg = {
  /** The unique identifier of the user to find mutual groups with */
  userId: TypeId;
};
export type PutApiV1GroupsByGroupIdApiResponse =
  /** status 200 Successfully updated the group */ Group;
export type PutApiV1GroupsByGroupIdApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  groupUpdate: GroupUpdate;
};
export type GetApiV1GroupsByGroupIdApiResponse =
  /** status 200 Group details retrieved successfully */ Group;
export type GetApiV1GroupsByGroupIdApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdApiResponse =
  /** status 200 Group successfully deleted */ boolean;
export type DeleteApiV1GroupsByGroupIdApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdAppsApiResponse =
  /** status 200 OK */ Application[];
export type GetApiV1GroupsByGroupIdAppsApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdAppsAndAppIdApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1GroupsByGroupIdAppsAndAppIdApiArg = {
  /** The unique identifier of the application to remove */
  appId: TypeId;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdAppsAndAppIdApiResponse =
  /** status 200 Returns app */ Application;
export type PutApiV1GroupsByGroupIdAppsAndAppIdApiArg = {
  /** The unique identifier of the application to install */
  appId: TypeId;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdBlocksApiResponse =
  /** status 200 List of blocks */ Blob;
export type GetApiV1GroupsByGroupIdBlocksApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdBlocksApiResponse =
  /** status 200 Block removed successfully */ Blob;
export type DeleteApiV1GroupsByGroupIdBlocksApiArg = {
  /** Block type (URI, EMAIL, DOMAIN, USERNAME, USERID) */
  type: GroupBlockType;
  /** Block value */
  value: string;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdBlocksApiResponse =
  /** status 200 Block created successfully */ Blob;
export type PostApiV1GroupsByGroupIdBlocksApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  /** Block creation request with exactly one block type specified */
  groupBlockCreateRequest: GroupBlockCreateRequest;
};
export type PutApiV1GroupsByGroupIdBrandingApiResponse =
  /** status 200 Successfully updated group branding */ Group;
export type PutApiV1GroupsByGroupIdBrandingApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  groupBrandingUpdate: GroupBrandingUpdate;
};
export type GetApiV1GroupsByGroupIdCategoriesApiResponse =
  /** status 200 OK */ Category[];
export type GetApiV1GroupsByGroupIdCategoriesApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdCategoriesApiResponse =
  /** status 200 OK */ Category;
export type PostApiV1GroupsByGroupIdCategoriesApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  /** Category creation details including name, display name, and optional metadata */
  categoryCreate: CategoryCreate;
};
export type GetApiV1GroupsByGroupIdCategoriesNameAndCategoryNameApiResponse =
  /** status 200 OK */ Category;
export type GetApiV1GroupsByGroupIdCategoriesNameAndCategoryNameApiArg = {
  /** The unique name identifier of the category within this forum */
  categoryName: string;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdCategoriesAndCategoryIdApiResponse =
  /** status 200 OK */ Category;
export type PutApiV1GroupsByGroupIdCategoriesAndCategoryIdApiArg = {
  /** The unique identifier of the category to update */
  categoryId: TypeId;
  /** The unique identifier of the group */
  groupId: TypeId;
  /** Category update details including optional fields to modify */
  categoryUpdate: CategoryUpdate;
};
export type GetApiV1GroupsByGroupIdCategoriesAndCategoryIdApiResponse =
  /** status 200 OK */ Category;
export type GetApiV1GroupsByGroupIdCategoriesAndCategoryIdApiArg = {
  /** The unique identifier of the category to retrieve */
  categoryId: TypeId;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdCategoriesAndCategoryIdApiResponse =
  /** status 200 OK */ Category;
export type DeleteApiV1GroupsByGroupIdCategoriesAndCategoryIdApiArg = {
  /** The unique identifier of the category to delete */
  categoryId: TypeId;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdChannelsApiResponse =
  /** status 200 Complete list of group channels successfully retrieved */ UserFull[];
export type GetApiV1GroupsByGroupIdChannelsApiArg = {
  /** If true return also summary, stats, header and fields. Default false. */
  full?: boolean | null;
  /** Filter by user type: CHANNEL (default) or CATEGORY. If not specified, returns CHANNEL type only for backward compatibility. */
  userType?: UserType | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdChannelsApiResponse =
  /** status 200 Channel created successfully with all configured properties */ UserFull;
export type PostApiV1GroupsByGroupIdChannelsApiArg = {
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
  body: GroupChannelCreateRequest;
};
export type GetApiV1GroupsByGroupIdChannelsAutoSubscribeApiResponse =
  /** status 200 List of auto-subscribe channels successfully retrieved */ User[];
export type GetApiV1GroupsByGroupIdChannelsAutoSubscribeApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdChannelsLookupApiResponse =
  /** status 200 Channel information successfully retrieved */ User | UserFull;
export type GetApiV1GroupsByGroupIdChannelsLookupApiArg = {
  /** If true return also summary, stats, header and fields. Default false. */
  full?: boolean | null;
  username: string;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdChannelsPrimaryApiResponse =
  /** status 200 Primary channel information successfully retrieved */ UserFull;
export type GetApiV1GroupsByGroupIdChannelsPrimaryApiArg = {
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdChannelsPublicApiResponse =
  /** status 200 OK */ User[];
export type GetApiV1GroupsByGroupIdChannelsPublicApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdChannelsAndChannelIdApiResponse =
  /** status 200 Channel properties updated successfully */ UserFull;
export type PutApiV1GroupsByGroupIdChannelsAndChannelIdApiArg = {
  /** The unique identifier of the channel to update */
  channelId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
  body: GroupChannelUpdateRequest;
};
export type GetApiV1GroupsByGroupIdChannelsAndChannelIdApiResponse =
  /** status 200 Channel information successfully retrieved */ User | UserFull;
export type GetApiV1GroupsByGroupIdChannelsAndChannelIdApiArg = {
  /** The unique identifier of the channel to retrieve */
  channelId: TypeId;
  /** If true return also summary, stats, header and fields. Default false. */
  full?: boolean | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdChannelsAndChannelIdApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1GroupsByGroupIdChannelsAndChannelIdApiArg = {
  /** The unique identifier of the channel to delete */
  channelId: TypeId;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdChannelsAndChannelIdAutoSubscribeApiResponse =
  /** status 200 Auto-subscribe channel status successfully updated */ UserFull;
export type PutApiV1GroupsByGroupIdChannelsAndChannelIdAutoSubscribeApiArg = {
  channelId: TypeId;
  isAutoSubscribe?: boolean | null;
  subscribeExistingMembers?: boolean | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdChannelsAndChannelIdPrimaryApiResponse =
  /** status 200 Channel successfully designated as primary, previous primary channel designation removed */ UserFull;
export type PutApiV1GroupsByGroupIdChannelsAndChannelIdPrimaryApiArg = {
  /** The unique identifier of the channel to designate as primary */
  channelId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdChannelsAndChannelIdUsernameApiResponse =
  /** status 200 OK */ UserFull;
export type PutApiV1GroupsByGroupIdChannelsAndChannelIdUsernameApiArg = {
  /** The unique identifier of the channel */
  channelId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** The unique identifier of the group */
  groupId: TypeId;
  body: AssignGlobalUsernameRequest;
};
export type GetApiV1GroupsByGroupIdDetailsApiResponse =
  /** status 200 Group details with membership info retrieved successfully */ GroupWithMembership;
export type GetApiV1GroupsByGroupIdDetailsApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdFederationTokenApiResponse =
  /** status 200 Token issued successfully */ Token;
export type PostApiV1GroupsByGroupIdFederationTokenApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdForumApiResponse =
  /** status 200 OK */ Forum;
export type PutApiV1GroupsByGroupIdForumApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  /** Forum update details including visibility, policy, and metadata */
  forumUpdate: ForumUpdate;
};
export type GetApiV1GroupsByGroupIdForumApiResponse =
  /** status 200 OK */ Forum;
export type GetApiV1GroupsByGroupIdForumApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdForumApiResponse =
  /** status 200 OK */ Forum;
export type DeleteApiV1GroupsByGroupIdForumApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdForumHardApiResponse =
  /** status 200 OK */ Forum;
export type DeleteApiV1GroupsByGroupIdForumHardApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdForumStatsApiResponse =
  /** status 200 OK */ ForumStats;
export type GetApiV1GroupsByGroupIdForumStatsApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdForumTagsApiResponse =
  /** status 200 OK */ Tag[];
export type GetApiV1GroupsByGroupIdForumTagsApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdForumTagsSearchApiResponse =
  /** status 200 OK */ Tag[];
export type GetApiV1GroupsByGroupIdForumTagsSearchApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Search query */
  q?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdInviteApiResponse =
  /** status 200 The group invitation details */ GroupInvite;
export type GetApiV1GroupsByGroupIdInviteApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdInvitesApiResponse =
  /** status 200 List of group invitations */ GroupInvite[];
export type GetApiV1GroupsByGroupIdInvitesApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Filters invitations by status. If omitted, returns all. */
  status?: GroupInviteStatus | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdInvitesApiResponse =
  /** status 200 Invitation created successfully or email sent */ GroupInviteCreateResult;
export type PostApiV1GroupsByGroupIdInvitesApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  /** Invitation details */
  groupInviteCreate: GroupInviteCreate;
};
export type PostApiV1GroupsByGroupIdInvitesAcceptApiResponse =
  /** status 200 Invitation accepted, user is now a group member */ {
    /** Group name */
    groupName: string;
    /** Group display name */
    groupDisplayName: string;
    /** User name (username) */
    userName: string;
    /** User display name */
    userDisplayName: string;
    /** User domain */
    userDomain?: string | null;
    /** Group avatar upload object */
    groupAvatar?: Upload | null;
    /** User avatar upload object */
    userAvatar?: Upload | null;
    /** Group ID */
    groupId: TypeId;
    /** User who is a member of the group */
    memberId: TypeId;
    /**
                All role identifiers for this member in the group.
                Includes both predefined roles (owner, admin, moderator, member, viewer)
                and custom roles.
             */
    roles?: string[];
    /** Additional metadata about this membership */
    meta?: GroupMemberMeta | null;
    createdAt?: Instant | null;
    updatedAt?: Instant | null;
  };
export type PostApiV1GroupsByGroupIdInvitesAcceptApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdInvitesRejectApiResponse =
  /** status 200 Invitation rejected successfully */ boolean;
export type PostApiV1GroupsByGroupIdInvitesRejectApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdInvitesAndGroupInviteIdApiResponse =
  /** status 200 Invitation cancelled successfully */ boolean;
export type DeleteApiV1GroupsByGroupIdInvitesAndGroupInviteIdApiArg = {
  /** The unique identifier of the group invitation */
  groupInviteId: TypeId;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdJoinApiResponse =
  /** status 200 Successfully joined the group (OPEN mode) or join request submitted (APPROVAL mode) */ {
    /** The current state of the user's relationship with the group */
    state: MembershipState;
    /** The membership object, present if state is MEMBER */
    member?: GroupMember | null;
    /** The join request object, present if state is PENDING_JOIN */
    joinRequest?: GroupJoinRequest | null;
    /** The invite object, present if state is PENDING_INVITE */
    invite?: GroupInvite | null;
  };
export type PostApiV1GroupsByGroupIdJoinApiArg = {
  /**
                    Token received after successfully answering group entry questions.
                    Required only for groups with entry questions when joinQuestions.show is true.
                 */
  answerToken?: string | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdJoinApiResponse =
  /** status 200 Successfully canceled join request */ boolean;
export type DeleteApiV1GroupsByGroupIdJoinApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdJoinRequestsApiResponse =
  /** status 200 OK */ {
    /** Array of group join request objects */
    requests: GroupJoinRequest[];
    /** Total number of join requests for the specified group (no filters applied) */
    grandTotal: number;
    /** Total number of join requests matching the applied filters */
    total: number;
  };
export type GetApiV1GroupsByGroupIdJoinRequestsApiArg = {
  /** Filter by creation date (start, like: 2025-01-01), inclusive */
  createdFrom?: LocalDate | null;
  /** Filter by creation date (end, like: 2025-01-01), inclusive */
  createdTo?: LocalDate | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Filter requests by status. If omitted, returns all requests. */
  status?: GroupJoinRequestStatus | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Filter by username (case-insensitive exact match) */
  username?: string | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdApiResponse =
  /** status 200 Successfully rejected or deleted join request */ boolean;
export type DeleteApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdApiArg =
  {
    /** The unique identifier of the join request to reject */
    groupJoinRequestId: TypeId;
    /** If true, permanently delete the request */
    purge?: boolean;
    /** Optional reason for rejecting the request */
    reason?: string | null;
    /** The unique identifier of the group */
    groupId: TypeId;
  };
export type PutApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdApiResponse =
  /** status 200 Successfully approved join request */ {
    /** Group name */
    groupName: string;
    /** Group display name */
    groupDisplayName: string;
    /** User name (username) */
    userName: string;
    /** User display name */
    userDisplayName: string;
    /** User domain */
    userDomain?: string | null;
    /** Group avatar upload object */
    groupAvatar?: Upload | null;
    /** User avatar upload object */
    userAvatar?: Upload | null;
    /** Group ID */
    groupId: TypeId;
    /** User who is a member of the group */
    memberId: TypeId;
    /**
                All role identifiers for this member in the group.
                Includes both predefined roles (owner, admin, moderator, member, viewer)
                and custom roles.
             */
    roles?: string[];
    /** Additional metadata about this membership */
    meta?: GroupMemberMeta | null;
    createdAt?: Instant | null;
    updatedAt?: Instant | null;
  };
export type PutApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdApiArg = {
  /** The unique identifier of the join request to approve */
  groupJoinRequestId: TypeId;
  /** Optional reason for approving the request */
  reason?: string | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdMemberSettingsApiResponse =
  /** status 200 Update confirmation with count of successfully updated settings */ Blob;
export type PutApiV1GroupsByGroupIdMemberSettingsApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  /** settings objects to be updated. complete objects must be provided - partial updates are not allowed. */
  groupMemberSettings: GroupMemberSettings;
};
export type GetApiV1GroupsByGroupIdMemberSettingsApiResponse =
  /** status 200 Response GroupMemberSettings */ GroupMemberSettings;
export type GetApiV1GroupsByGroupIdMemberSettingsApiArg = {
  /** Comma-separated list of setting keys to retrieve. Keys must be valid group member setting identifiers.
    
    Available keys are:
    
    ```group.member.display```
    
    ```group.member.preferences``` */
  keys: string[];
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdMemberSettingsApiResponse =
  /** status 200 Deletion confirmation with count of successfully deleted settings */ Blob;
export type DeleteApiV1GroupsByGroupIdMemberSettingsApiArg = {
  /** Comma-separated list of setting keys to delete. Keys must be valid group member setting identifiers.
    
    Available keys are:
    
    ```group.member.display```
    
    ```group.member.preferences``` */
  keys: string[];
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdMembersApiResponse =
  /** status 200 List of group members with their membership details */ GroupMember[];
export type GetApiV1GroupsByGroupIdMembersApiArg = {
  /** Actor type to filter by (Application, Group, Organization, Person, Service) */
  actorType?: ActorType | null;
  /** Filter members who joined after this date */
  createdAfter?: Instant | null;
  /** Display name to filter by (contains match) */
  displayName?: string | null;
  /** Domain to filter by (contains match) */
  domain?: string | null;
  /** Maximum number of members to return. Defaults to 100. */
  limit?: number | null;
  /** Number of members to skip (for pagination). Defaults to 0. */
  offset?: number | null;
  /** Sort order (case-insensitive) */
  order?: SortOrder | null;
  /** Role filter (case-insensitive) */
  role?: GroupMemberRoleFilter | null;
  /** Sort field (case-insensitive) */
  sort?: GroupMembersSortBy | null;
  /** Username to filter by (contains match) */
  username?: string | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdMembersApiResponse =
  /** status 200 Successfully added member to the group */ GroupMember;
export type PostApiV1GroupsByGroupIdMembersApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  groupMemberCreate: GroupMemberCreate;
};
export type GetApiV1GroupsByGroupIdMembersSearchApiResponse =
  /** status 200 Paginated list of group member search results with total count */ GroupMemberSearchDetails;
export type GetApiV1GroupsByGroupIdMembersSearchApiArg = {
  /** Actor type to filter by (Application, Group, Organization, Person, Service) */
  actorType?: ActorType | null;
  /** Country code to filter by (ISO 3166-1 alpha-2) */
  country?: string | null;
  /** Filter members who joined after this date */
  createdAfter?: Instant | null;
  /** Display name to filter by (contains match) */
  displayName?: string | null;
  /** Domain to filter by (contains match) */
  domain?: string | null;
  /** IP address to filter by */
  ip?: string | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Role filter: ADMIN for admin roles, MEMBER for regular members */
  role?: GroupMemberRoleFilter | null;
  /** List of roles to filter by (comma-separated) */
  roles?: string[] | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Username to filter by (contains match) */
  username?: string | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdMembersAndMemberIdApiResponse =
  /** status 200 Successfully updated the group member */ GroupMember;
export type PutApiV1GroupsByGroupIdMembersAndMemberIdApiArg = {
  /** The ID of the user whose membership is being updated */
  memberId: TypeId;
  /** The unique identifier of the group */
  groupId: TypeId;
  groupMemberUpdate: GroupMemberUpdate;
};
export type DeleteApiV1GroupsByGroupIdMembersAndMemberIdApiResponse =
  /** status 200 Member successfully removed from the group */ boolean;
export type DeleteApiV1GroupsByGroupIdMembersAndMemberIdApiArg = {
  /** The ID of the user to remove from the group */
  memberId: TypeId;
  /** Optional reason for removing the member. This will be recorded in the audit log for accountability and compliance purposes. */
  reason?: string | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdMembersAndNewOwnerIdTransferOwnershipApiResponse =
  /** status 200 Ownership transferred successfully. Returns the new owner's membership. */ GroupMember;
export type PostApiV1GroupsByGroupIdMembersAndNewOwnerIdTransferOwnershipApiArg =
  {
    /** The ID of the member to transfer ownership to */
    newOwnerId: TypeId;
    /** The unique identifier of the group */
    groupId: TypeId;
  };
export type DeleteApiV1GroupsByGroupIdMembershipApiResponse =
  /** status 200 OK */ boolean;
export type DeleteApiV1GroupsByGroupIdMembershipApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdMembershipApiResponse =
  /** status 200 OK */ MembershipInfo;
export type GetApiV1GroupsByGroupIdMembershipApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdPinApiResponse =
  /** status 200 Group successfully unpinned */ boolean;
export type DeleteApiV1GroupsByGroupIdPinApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type PutApiV1GroupsByGroupIdPinApiResponse =
  /** status 200 Group successfully pinned */ GroupPin;
export type PutApiV1GroupsByGroupIdPinApiArg = {
  /** Pin order number. If not provided, next available number will be used */
  pin?: number | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdQuestionsApiResponse =
  /** status 200 List of group questions sorted by ordering */ Question[];
export type GetApiV1GroupsByGroupIdQuestionsApiArg = {
  /** The identifier of the group whose questions to retrieve */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdQuestionsApiResponse =
  /** status 200 Successfully created the new question */ Question;
export type PostApiV1GroupsByGroupIdQuestionsApiArg = {
  /** The unique identifier of the group to add the question to */
  groupId: TypeId;
  questionCreate: QuestionCreate;
};
export type PostApiV1GroupsByGroupIdQuestionsAnswersApiResponse =
  /** status 200 Answer token generated successfully */ {
    /** Authentication token to be used with the group join endpoint. Has a limited validity period. */
    answerToken: string;
    /** ISO 8601 timestamp indicating when the answers were submitted */
    submittedAt: Instant;
  };
export type PostApiV1GroupsByGroupIdQuestionsAnswersApiArg = {
  /** The unique identifier of the group to submit answers for */
  groupId: TypeId;
  questionAnswerCreate: QuestionAnswerCreate;
};
export type PutApiV1GroupsByGroupIdQuestionsAndQuestionIdApiResponse =
  /** status 200 Successfully updated the question */ Question;
export type PutApiV1GroupsByGroupIdQuestionsAndQuestionIdApiArg = {
  /** The unique identifier of the group containing the question */
  groupId: TypeId;
  /** The unique identifier of the question to update */
  questionId: TypeId;
  questionUpdate: QuestionUpdate;
};
export type DeleteApiV1GroupsByGroupIdQuestionsAndQuestionIdApiResponse =
  /** status 200 Question successfully deleted */ any;
export type DeleteApiV1GroupsByGroupIdQuestionsAndQuestionIdApiArg = {
  /** The unique identifier of the group containing the question */
  groupId: TypeId;
  /** The unique identifier of the question to delete */
  questionId: TypeId;
};
export type GetApiV1GroupsByGroupIdRulesApiResponse =
  /** status 200 List of all group rules sorted by ordering value */ Rule[];
export type GetApiV1GroupsByGroupIdRulesApiArg = {
  /** The unique identifier of the group whose rules to retrieve */
  groupId: TypeId;
};
export type PostApiV1GroupsByGroupIdRulesApiResponse =
  /** status 200 Successfully created the new rule */ Rule;
export type PostApiV1GroupsByGroupIdRulesApiArg = {
  /** The unique identifier of the group to add the rule to */
  groupId: TypeId;
  /** Additional explanation or context for the rule (max 500 characters) */
  hint: string;
  /** Display order for the rule (lower values appear first) */
  ordering: number;
  /** The rule text that members must follow (max 500 characters) */
  text: string;
};
export type PostApiV1GroupsByGroupIdRulesReorderApiResponse =
  /** status 200 All group rules with updated ordering */ Rule[];
export type PostApiV1GroupsByGroupIdRulesReorderApiArg = {
  /** The unique identifier of the group whose rules to reorder */
  groupId: TypeId;
  body: RuleOrderingRequest[];
};
export type DeleteApiV1GroupsByGroupIdRulesAndIdApiResponse =
  /** status 200 Rule successfully deleted */ any;
export type DeleteApiV1GroupsByGroupIdRulesAndIdApiArg = {
  /** The unique identifier of the group containing the rule */
  groupId: TypeId;
  /** The unique identifier of the rule to delete */
  id: string;
};
export type PutApiV1GroupsByGroupIdRulesAndRuleIdApiResponse =
  /** status 200 Successfully updated the rule */ Rule;
export type PutApiV1GroupsByGroupIdRulesAndRuleIdApiArg = {
  /** The unique identifier of the group containing the rule */
  groupId: TypeId;
  /** The unique identifier of the rule to update */
  ruleId: TypeId;
  ruleUpdate: RuleUpdate;
};
export type PutApiV1GroupsByGroupIdSettingsApiResponse =
  /** status 200 number of updated settings */ Blob;
export type PutApiV1GroupsByGroupIdSettingsApiArg = {
  /** The unique identifier of the group */
  groupId: TypeId;
  /** settings objects to be updated. complete objects must be provided - partial updates are not allowed. */
  groupSettings: GroupSettings;
};
export type GetApiV1GroupsByGroupIdSettingsApiResponse =
  /** status 200 Response GroupSettings */ GroupSettings;
export type GetApiV1GroupsByGroupIdSettingsApiArg = {
  /** Comma-separated list of setting keys to retrieve. Each key must correspond to a valid group setting definition registered in the system.
    
    Available keys are:
    
    ```group.ai.agents.budgets```
    
    ```group.join.questions```
    
    ```group.membership```
    
    ```group.moderation```
    
    ```group.privacy``` */
  keys: string[];
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type DeleteApiV1GroupsByGroupIdSettingsApiResponse =
  /** status 200 number of deleted settings */ Blob;
export type DeleteApiV1GroupsByGroupIdSettingsApiArg = {
  /** Comma-separated list of setting keys to delete. Each key must correspond to a valid group setting that exists for this group.
    
    Available keys are:
    
    ```group.ai.agents.budgets```
    
    ```group.join.questions```
    
    ```group.membership```
    
    ```group.moderation```
    
    ```group.privacy``` */
  keys: string[];
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1GroupsByGroupIdUsersApiResponse =
  /** status 200 List of users who are members of the group */ User[];
export type GetApiV1GroupsByGroupIdUsersApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Sort order (case-insensitive) */
  order?: SortOrder | null;
  /** Role filter (case-insensitive) */
  role?: GroupMemberRoleFilter | null;
  /** Sort field (case-insensitive) */
  sort?: GroupMembersSortBy | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** The unique identifier of the group */
  groupId: TypeId;
};
export type GetApiV1ImportApiResponse = /** status 200 OK */ BulkImport[];
export type GetApiV1ImportApiArg = void;
export type PostApiV1ImportApiResponse =
  /** status 200 The ID of the created import job */ number;
export type PostApiV1ImportApiArg = {
  /** Whether to overwrite existing data. If true, replaces current data with imported data */
  overwrite?: boolean | null;
  /** Type of data being imported (e.g., followers, blocks, mutes) */
  type: BulkImportType;
  body: {
    file: Blob;
  };
};
export type PostApiV1ImportStartByIdApiResponse =
  /** status 200 Import job started successfully */ any;
export type PostApiV1ImportStartByIdApiArg = {
  /** Import job ID returned from the upload step */
  id: number;
};
export type GetApiV1ImportByIdApiResponse = /** status 200 OK */ BulkImport;
export type GetApiV1ImportByIdApiArg = {
  /** Import job ID */
  id: number;
};
export type GetApiV1InstanceApiResponse =
  /** status 200 Instance info */ Instance;
export type GetApiV1InstanceApiArg = void;
export type GetApiV1InstanceCountriesApiResponse =
  /** status 200 List of countries info about name, phone number and flag */ CountryInfo[];
export type GetApiV1InstanceCountriesApiArg = void;
export type GetApiV1InstanceDomainsApiResponse =
  /** status 200 Domains list */ string[];
export type GetApiV1InstanceDomainsApiArg = {
  /** Domain prefix to search for (autocomplete-style matching) */
  domain?: string | null;
  /** Maximum number of results to return. If omitted, all matching domains are returned. */
  limit?: number | null;
  /** Software name to filter by (e.g. 'mastodon', 'pleroma') */
  software?: string | null;
};
export type GetApiV1InstanceExtendedDescriptionApiResponse =
  /** status 200 Extended Instance info */ Instance;
export type GetApiV1InstanceExtendedDescriptionApiArg = void;
export type GetApiV1InstanceSupportedLanguagesApiResponse =
  /** status 200 List of supported languages */ SupportedLanguage[];
export type GetApiV1InstanceSupportedLanguagesApiArg = void;
export type GetApiV1InstanceTimezonesApiResponse =
  /** status 200 List of timezones */ TimezoneInfo[];
export type GetApiV1InstanceTimezonesApiArg = void;
export type DeleteApiV1JobsClearApiResponse =
  /** status 200 Jobs cleared */ any;
export type DeleteApiV1JobsClearApiArg = {
  /** Job list kind: submitted, finished, failed, or dlq */
  listKind: string;
  /** Queue name (required for submitted/finished/failed) */
  queue?: string | null;
};
export type GetApiV1JobsDlqApiResponse =
  /** status 200 Paginated DLQ listing */ RedisJobsResult;
export type GetApiV1JobsDlqApiArg = {
  /** Maximum number of jobs to return */
  limit?: number | null;
  /** Number of items to skip for pagination */
  offset?: number | null;
};
export type DeleteApiV1JobsJobApiResponse =
  /** status 200 Job deleted successfully */ any;
export type DeleteApiV1JobsJobApiArg = {
  /** Job hash UUID */
  jobHash: string;
  /** Job list kind: submitted, finished, failed, retries, schedule, or dlq */
  listKind: string;
  /** Queue name (required for submitted/finished/failed) */
  queue?: string | null;
};
export type GetApiV1JobsListJobsApiResponse =
  /** status 200 Paginated list of job types */ JobListResult;
export type GetApiV1JobsListJobsApiArg = {
  /** Maximum number of job types to return */
  limit?: number | null;
  /** Number of items to skip for pagination */
  offset?: number | null;
};
export type GetApiV1JobsListStatsApiResponse =
  /** status 200 Queue statistics with job counts by status */ object;
export type GetApiV1JobsListStatsApiArg = {
  /** Queue name to retrieve statistics for */
  queue: string;
};
export type GetApiV1JobsListStatsAllApiResponse =
  /** status 200 Aggregated statistics for all queues */ object;
export type GetApiV1JobsListStatsAllApiArg = void;
export type GetApiV1JobsListsApiResponse =
  /** status 200 List of jobs with the specified status */ RedisJobsResult;
export type GetApiV1JobsListsApiArg = {
  /** Maximum number of jobs to return */
  limit?: number | null;
  /** Job status category: finished, failed, active, submitted, retries, schedule, or dlq */
  listKind: string;
  /** Number of items to skip for pagination */
  offset?: number | null;
  /** Queue name to list jobs from (not required for dlq) */
  queue?: string | null;
};
export type GetApiV1JobsProcessesApiResponse =
  /** status 200 List of active process instances */ Blob;
export type GetApiV1JobsProcessesApiArg = void;
export type GetApiV1JobsRedisInfoApiResponse =
  /** status 200 Redis server information */ object;
export type GetApiV1JobsRedisInfoApiArg = void;
export type PostApiV1JobsRetryApiResponse =
  /** status 200 Job retried successfully */ any;
export type PostApiV1JobsRetryApiArg = {
  /** Job hash UUID */
  jobHash: string;
  /** Queue name */
  queue: string;
};
export type PostApiV1JobsRetryAllApiResponse =
  /** status 200 All failed jobs retried */ any;
export type PostApiV1JobsRetryAllApiArg = {
  /** Queue name */
  queue: string;
};
export type GetApiV1JobsStatsApiResponse = /** status 200 OK */ OverallStats;
export type GetApiV1JobsStatsApiArg = void;
export type GetApiV1JobsStatsPerDayApiResponse =
  /** status 200 Daily statistics for finished and failed jobs */ object;
export type GetApiV1JobsStatsPerDayApiArg = {
  /** Number of past days to include (1-100) */
  lastDays: number;
  /** Optional queue name to filter by. If omitted, aggregates across all queues. */
  queue?: string | null;
};
export type GetApiV1JobsSummaryApiResponse =
  /** status 200 List of queue summaries with counts, latency and config */ Blob;
export type GetApiV1JobsSummaryApiArg = void;
export type GetApiV1JobsWorkersApiResponse =
  /** status 200 List of worker configurations */ Blob;
export type GetApiV1JobsWorkersApiArg = void;
export type GetApiV1LinksApiResponse =
  /** status 200 Link preview card with extracted metadata */ Card;
export type GetApiV1LinksApiArg = {
  /** The fully qualified URL to fetch metadata from */
  url: string;
};
export type GetApiV1ListsApiResponse = /** status 200 OK */ UsersList[];
export type GetApiV1ListsApiArg = void;
export type PostApiV1ListsApiResponse = /** status 200 OK */ UsersList;
export type PostApiV1ListsApiArg = {
  userListCreate: UserListCreate;
};
export type PutApiV1ListsByListIdApiResponse = /** status 200 OK */ UsersList;
export type PutApiV1ListsByListIdApiArg = {
  /** ID of the list to update. Must be a valid USER_LIST type TypeId. */
  listId: TypeId;
  userListCreate: UserListCreate;
};
export type GetApiV1ListsByListIdApiResponse = /** status 200 OK */ UsersList;
export type GetApiV1ListsByListIdApiArg = {
  /** ID of the list to retrieve. Must be a valid USER_LIST type TypeId. */
  listId: TypeId;
};
export type DeleteApiV1ListsByListIdApiResponse = /** status 200 OK */ string;
export type DeleteApiV1ListsByListIdApiArg = {
  /** ID of the list to delete. Must be a valid USER_LIST type TypeId. */
  listId: TypeId;
};
export type GetApiV1ListsByListIdUsersApiResponse = /** status 200 OK */ User[];
export type GetApiV1ListsByListIdUsersApiArg = {
  /** ID of the list to retrieve users from. Must be a valid USER_LIST type TypeId. */
  listId: TypeId;
};
export type DeleteApiV1ListsByListIdUsersAndUserIdApiResponse =
  /** status 200 OK */ UsersList;
export type DeleteApiV1ListsByListIdUsersAndUserIdApiArg = {
  /** ID of the list to remove the user from. Must be a valid USER_LIST type TypeId. */
  listId: TypeId;
  /** ID of the user to remove from the list. Must be a valid USER type TypeId. */
  userId: TypeId;
};
export type PostApiV1ListsByListIdUsersAndUserIdApiResponse =
  /** status 200 OK */ UsersList;
export type PostApiV1ListsByListIdUsersAndUserIdApiArg = {
  /** ID of the list to add the user to. Must be a valid USER_LIST type TypeId. */
  listId: TypeId;
  /** ID of the user to add to the list. Must be a valid USER type TypeId. */
  userId: TypeId;
};
export type PutApiV1MarkdownApiResponse = /** status 200 OK */ string;
export type PutApiV1MarkdownApiArg = {
  /** Allows to skip formatting of tags, mentions and emojis if needed. */
  skipAutolink?: boolean | null;
  body: string;
};
export type GetApiV1MetricsApiResponse = /** status 200 OK */ MetricsData[];
export type GetApiV1MetricsApiArg = {
  /** Start time for custom date range (ISO 8601 format). Use with 'to' parameter. */
  from?: Instant | null;
  /** Predefined time period. Options: LAST_DAY, LAST_WEEK, LAST_MONTH */
  period?: MetricsPeriod | null;
  /** End time for custom date range (ISO 8601 format). Use with 'from' parameter. */
  to?: Instant | null;
};
export type GetApiV1MetricsTotalsApiResponse =
  /** status 200 OK */ ServerTotals;
export type GetApiV1MetricsTotalsApiArg = void;
export type GetApiV1MuteApiResponse = /** status 200 OK */ User[];
export type GetApiV1MuteApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type DeleteApiV1MuteByUserIdApiResponse = /** status 200 OK */ any;
export type DeleteApiV1MuteByUserIdApiArg = {
  /** ID of the user to unmute. Must be a valid USER type TypeId. */
  userId: TypeId;
};
export type PostApiV1MuteByUserIdApiResponse = /** status 200 OK */ any;
export type PostApiV1MuteByUserIdApiArg = {
  /** ID of the user to mute. Must be a valid USER type TypeId. */
  userId: TypeId;
  /** Seconds after which mute should expire */
  duration?: number | null;
};
export type GetApiV1NamesCheckApiResponse =
  /** status 200 Name availability check result */ NameCheckResult;
export type GetApiV1NamesCheckApiArg = {
  /** The name to check for availability */
  name: string;
  /** The scope of the name check: USER for users and channels, GROUP for groups, CATEGORY for forum categories */
  nameScope: NameScope;
  /** Group ID for checking channel username or category within a group. Required for CATEGORY scope. Optional for USER (if omitted, checks global namespace). Not allowed for GROUP scope. */
  scope?: TypeId | null;
};
export type PutApiV1NotesApiResponse =
  /** status 200 Note has been updated successfully */ UserNote;
export type PutApiV1NotesApiArg = {
  noteUpdate: NoteUpdate;
};
export type GetApiV1NotesApiResponse =
  /** status 200 Notes have been fetched successfully */ UserNote[];
export type GetApiV1NotesApiArg = {
  /** Comma-separated list of user IDs to retrieve notes for */
  userIds: TypeId[];
};
export type DeleteApiV1NotesByUserIdApiResponse =
  /** status 200 Note has been deleted successfully */ any;
export type DeleteApiV1NotesByUserIdApiArg = {
  /** The user ID whose note should be deleted */
  userId: TypeId;
};
export type GetApiV1NotificationsApiResponse =
  /** status 200 Notifications */ Notification[];
export type GetApiV1NotificationsApiArg = {
  /** Exclude these notification types from results. Comma-separated values are supported. Applied after 'types' filter. */
  excludeTypes?: NotificationType[] | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Filter by notification status: READ or UNREAD. If omitted, returns all statuses. */
  status?: NotificationStatus | null;
  /** Include only these notification types. Comma-separated values are supported. If omitted, all types are included. */
  types?: NotificationType[] | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1NotificationsCountApiResponse = /** status 200 OK */ number;
export type GetApiV1NotificationsCountApiArg = {
  /** Exclude these notification types from the count. Comma-separated values are supported. */
  excludeTypes?: NotificationType[] | null;
  /** Filter by notification status: READ or UNREAD. If omitted, counts all statuses. */
  status?: NotificationStatus | null;
  /** Include only these notification types in the count. Comma-separated values are supported. If omitted, all types are counted. */
  types?: NotificationType[] | null;
};
export type PostApiV1NotificationsMarkAllApiResponse =
  /** status 200 Number of notifications changed */ number;
export type PostApiV1NotificationsMarkAllApiArg = {
  /** New status for all notifications: READ or UNREAD */
  status: NotificationStatus;
  /** Only mark notifications of this type. If omitted, marks all notifications. */
  type?: NotificationType | null;
};
export type GetApiV1NotificationsByIdApiResponse =
  /** status 200 Notification */ Notification;
export type GetApiV1NotificationsByIdApiArg = {
  /** Notification id */
  id: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PostApiV1NotificationsByIdMarkApiResponse =
  /** status 200 Notification */ Notification;
export type PostApiV1NotificationsByIdMarkApiArg = {
  /** Notification ID to mark. Must be a valid NOTIFICATION type TypeId. */
  id: TypeId;
  /** New status for the notification: READ or UNREAD */
  status: NotificationStatus;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PasskeysApiResponse =
  /** status 200 List of credentials */ Passkey;
export type GetApiV1PasskeysApiArg = void;
export type GetApiV1PasskeysBeginAuthApiResponse =
  /** status 200 Request options */ PublicKeyCredentialRequestOptions;
export type GetApiV1PasskeysBeginAuthApiArg = {
  username?: string | null;
};
export type GetApiV1PasskeysBeginRegisterApiResponse =
  /** status 200 Creation options */ PublicKeyCredentialCreationOptions;
export type GetApiV1PasskeysBeginRegisterApiArg = void;
export type PostApiV1PasskeysFinishAuthApiResponse =
  /** status 200 Session key */ Token;
export type PostApiV1PasskeysFinishAuthApiArg = {
  jsonObject: JsonObject;
};
export type PostApiV1PasskeysFinishRegisterApiResponse =
  /** status 200 OK */ Passkey;
export type PostApiV1PasskeysFinishRegisterApiArg = {
  jsonObject: JsonObject;
};
export type DeleteApiV1PasskeysByCredentialIdApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1PasskeysByCredentialIdApiArg = {
  credentialId: string;
};
export type PostApiV1PollsByPollIdRefreshApiResponse =
  /** status 200 OK */ Poll;
export type PostApiV1PollsByPollIdRefreshApiArg = {
  pollId: TypeId;
};
export type PostApiV1PollsByPollIdVoteApiResponse = /** status 200 OK */ any;
export type PostApiV1PollsByPollIdVoteApiArg = {
  pollId: TypeId;
  /** List of zero-based option indices to vote for */
  body: number[];
};
export type GetApiV1PostsApiResponse = /** status 200 OK */ Post[];
export type GetApiV1PostsApiArg = {
  /** Return results across all scopes when using bookmarkedOnly */
  all?: boolean | null;
  /** Return bookmarked only */
  bookmarkedOnly?: boolean | null;
  /** Filter posts by forum tags (comma-separated, AND logic - posts must have ALL tags) */
  forumTags?: string[] | null;
  /** Include bookmark field */
  includeBookmarkStatus?: boolean | null;
  /** Include comments */
  includeComments?: boolean | null;
  /** Include follow status */
  includeFollowStatus?: boolean | null;
  /** Include pinned status */
  includePinnedStatus?: boolean | null;
  /** Include direct reply if present */
  includeReply?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  /** Limit first level comment paging count */
  limitFirstLevelComments?: number | null;
  /** Limit comments per level (applies to each parent). Overrides level-specific limits. */
  limitPerLevelComments?: number | null;
  /** Limit second level comment paging count */
  limitSecondLevelComments?: number | null;
  /** List posts by a user list */
  listId?: TypeId | null;
  /** Max comment level depth */
  maxLevel?: number | null;
  /** Min comment level depth */
  minLevel?: number | null;
  offset?: number | null;
  /** List specific owner's posts */
  ownerId?: TypeId | null;
  /** Filter by pinned status. Applied only if ?userId is present */
  pinned?: PinnedParam | null;
  /** Filter by repost kind */
  repostKind?: RepostParam | null;
  /** List only reposts of specified post */
  repostOf?: TypeId | null;
  /** Return reposts only */
  repostsOnly?: boolean | null;
  /** Search posts by text */
  search?: string | null;
  /** If false - force showing reposts non-aggregated */
  skipReposts?: boolean | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Search posts by a tag */
  tag?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** List specific user's posts. Used for User/Profile feed */
  userId?: TypeId | null;
  /** List specific user's posts */
  username?: string | null;
  /** Include repostedBy. Default true */
  withRepostedBy?: boolean | null;
  /** Include translation */
  withTranslation?: boolean | null;
  /** Include trends */
  withTrends?: boolean | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PostApiV1PostsApiResponse =
  /** status 200 Post object just created */ Post;
export type PostApiV1PostsApiArg = {
  /** Scope owner to resolve the post context */
  ownerId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  createPost: CreatePost;
};
export type GetApiV1PostsBookmarkedApiResponse = /** status 200 OK */ Post[];
export type GetApiV1PostsBookmarkedApiArg = {
  /** Include comments. Default true */
  includeComments?: boolean | null;
  /** Include publisher context with group info (avatar, name, slug) */
  includePublisher?: boolean | null;
  /** Include reply-to post in originalPost field. Default true */
  includeReply?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  /** Return only the user's own bookmarked posts */
  my?: boolean | null;
  offset?: number | null;
  /** Scope owner to resolve the post context */
  ownerId?: TypeId | null;
  /** Search posts by text */
  search?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsFeedsFollowingApiResponse =
  /** status 200 OK */ Post[];
export type GetApiV1PostsFeedsFollowingApiArg = {
  /** Load from database */
  ignoreCache?: boolean | null;
  /** Include bookmark field */
  includeBookmarkStatus?: boolean | null;
  /** Include follow status */
  includeFollowStatus?: boolean | null;
  /** Include publisher context with group info (avatar, name, slug) */
  includePublisher?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Include repostedBy. Default true */
  withRepostedBy?: boolean | null;
  /** Include translation */
  withTranslation?: boolean | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsFeedsPublicApiResponse = /** status 200 OK */ Post[];
export type GetApiV1PostsFeedsPublicApiArg = {
  /** Include bookmark field */
  includeBookmarkStatus?: boolean | null;
  /** Include follow status */
  includeFollowStatus?: boolean | null;
  /** Include publisher context with group info (avatar, name, slug) */
  includePublisher?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  /** List only local posts (if true). Remote only if false. Any if null */
  local?: boolean | null;
  offset?: number | null;
  /** If false - force showing reposts */
  skipReposts?: boolean | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Include repostedBy. Default true */
  withRepostedBy?: boolean | null;
  /** Include translation */
  withTranslation?: boolean | null;
  /** Include trends */
  withTrends?: boolean | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsLikedApiResponse = /** status 200 OK */ Post[];
export type GetApiV1PostsLikedApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Scope owner to resolve the post context */
  ownerId?: TypeId | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsMentionedApiResponse = /** status 200 OK */ Post[];
export type GetApiV1PostsMentionedApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Scope owner to resolve the post context */
  ownerId?: TypeId | null;
  /** Filter posts by DIRECT only */
  private?: boolean | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsMyApiResponse = /** status 200 OK */ Post[];
export type GetApiV1PostsMyApiArg = {
  /** Return bookmarked only */
  bookmarkedOnly?: boolean | null;
  /** Include bookmark field */
  includeBookmarkStatus?: boolean | null;
  /** Include comments */
  includeComments?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Scope owner to resolve the post context */
  ownerId?: TypeId | null;
  /** Return reposts only */
  repostsOnly?: boolean | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsPinsApiResponse =
  /** status 200 List of pinned posts ids */ TypeId[];
export type GetApiV1PostsPinsApiArg = {
  /** Optional scope owner ID used to list pins in a specific scope (supported: USER, CATEGORY, EVENT, FORUM). */
  ownerId?: TypeId | null;
  /** If true (default), return only top-level pins. If false, return both top-level pins and reply highlights. */
  postOnly?: boolean | null;
};
export type DeleteApiV1PostsPinsByPostIdApiResponse = /** status 200 OK */ any;
export type DeleteApiV1PostsPinsByPostIdApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsPinsByPostIdApiResponse = /** status 200 OK */ any;
export type PostApiV1PostsPinsByPostIdApiArg = {
  postId: TypeId;
};
export type GetApiV1PostsRepliesApiResponse = /** status 200 OK */ Post[];
export type GetApiV1PostsRepliesApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Scope owner to resolve the post context */
  ownerId?: TypeId | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** List specific user's posts */
  userId?: TypeId | null;
  /** List specific user's posts */
  username?: string | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsSubscriptionsApiResponse = /** status 200 OK */ Post[];
export type GetApiV1PostsSubscriptionsApiArg = {
  /** Return all subscriptions */
  all?: boolean | null;
  /** Scope owner to resolve the post context */
  ownerId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PutApiV1PostsByPostIdApiResponse = /** status 200 OK */ Post;
export type PutApiV1PostsByPostIdApiArg = {
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  createPost: CreatePost;
};
export type GetApiV1PostsByPostIdApiResponse = /** status 200 OK */ Post;
export type GetApiV1PostsByPostIdApiArg = {
  postId: TypeId;
  /** Include bookmark field */
  includeBookmarkStatus?: boolean | null;
  /** Include publisher context with group info (avatar, name, slug) */
  includePublisher?: boolean | null;
  /** Limit first level comment paging count */
  limitFirstLevelComments?: number | null;
  /** Limit comments per level (applies to each parent). Overrides level-specific limits. */
  limitPerLevelComments?: number | null;
  /** Limit second level comment paging count */
  limitSecondLevelComments?: number | null;
  /** Max comment level depth */
  maxLevel?: number | null;
  /** Min comment level depth */
  minLevel?: number | null;
  /** Load post with comments */
  withComments?: boolean | null;
  /** If comment, load it with parents.
                   In such a case returns root with request `postId` comment inside replies */
  withParents?: boolean | null;
  /** Include repostedBy. Default true */
  withRepostedBy?: boolean | null;
  /** If comment, load it with root parent.
                   In such a case returns root with request `postId` comment inside replies */
  withRootParent?: boolean | null;
  /** Include translation */
  withTranslation?: boolean | null;
  /** Include trends */
  withTrends?: boolean | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type DeleteApiV1PostsByPostIdApiResponse =
  /** status 200 Post has been deleted successfully */ any;
export type DeleteApiV1PostsByPostIdApiArg = {
  postId: TypeId;
};
export type GetApiV1PostsByPostIdActiveUsersApiResponse =
  /** status 200 OK */ ConversationActiveUsersResult;
export type GetApiV1PostsByPostIdActiveUsersApiArg = {
  /** Post ID in the conversation (navigates to thread root automatically) */
  postId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Sort order: REPLY_COUNT (by number of replies) or LAST_POST (by most recent post) */
  sortBy?: ConversationActiveUserSortBy | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type DeleteApiV1PostsByPostIdBookmarkApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1PostsByPostIdBookmarkApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsByPostIdBookmarkApiResponse =
  /** status 200 OK */ any;
export type PostApiV1PostsByPostIdBookmarkApiArg = {
  postId: TypeId;
};
export type GetApiV1PostsByPostIdCommentersApiResponse =
  /** status 200 OK */ PostActivity[];
export type GetApiV1PostsByPostIdCommentersApiArg = {
  postId: TypeId;
  /** Include followed status */
  includeFollowedStatus?: boolean | null;
  /** Include following status */
  includeFollowingStatus?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Deduplicate comments by same user (default: true) */
  skipDuplicates?: boolean | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsByPostIdCommentsApiResponse =
  /** status 200 OK */ Post[];
export type GetApiV1PostsByPostIdCommentsApiArg = {
  postId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  /** Limit for direct replies (first level). For root posts: limits all first-level comments. For comments: limits direct replies only. Returns X-Total-Count header with total. */
  limitFirstLevelComments?: number | null;
  /** Limit for nested comments (per parent). For root posts: same as limitFirstLevelComments if not set. For comments: limits deeper nested levels (not direct replies). */
  limitPerLevelComments?: number | null;
  maxLevel?: number | null;
  minLevel?: number | null;
  offset?: number | null;
  /** Filter by pinned status: ONLY (pinned only), SKIP (exclude pinned), ALL (both) */
  pinned?: PinnedParam | null;
  /** If true, return only the first comment per unique user */
  skipDuplicates?: boolean | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PostApiV1PostsByPostIdCommentsApiResponse =
  /** status 200 OK */ Post;
export type PostApiV1PostsByPostIdCommentsApiArg = {
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  createPost: CreatePost;
};
export type PutApiV1PostsByPostIdCommentsAndCommentIdApiResponse =
  /** status 200 OK */ Post;
export type PutApiV1PostsByPostIdCommentsAndCommentIdApiArg = {
  commentId: TypeId;
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  createPost: CreatePost;
};
export type DeleteApiV1PostsByPostIdCommentsAndCommentIdApiResponse =
  /** status 200 Comment has been deleted successfully */ any;
export type DeleteApiV1PostsByPostIdCommentsAndCommentIdApiArg = {
  commentId: TypeId;
  postId: TypeId;
};
export type PostApiV1PostsByPostIdDetachApiResponse = /** status 200 OK */ any;
export type PostApiV1PostsByPostIdDetachApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsByPostIdDownvoteApiResponse =
  /** status 200 A summary of votes for the post */ PostVotesSummary;
export type PostApiV1PostsByPostIdDownvoteApiArg = {
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsByPostIdEditsApiResponse =
  /** status 200 OK */ PostEdit[];
export type GetApiV1PostsByPostIdEditsApiArg = {
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PutApiV1PostsByPostIdInteractionPolicyApiResponse =
  /** status 200 Updated post */ Post;
export type PutApiV1PostsByPostIdInteractionPolicyApiArg = {
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  updateInteractionPolicy: UpdateInteractionPolicy;
};
export type GetApiV1PostsByPostIdLikesApiResponse =
  /** status 200 OK */ PostActivity[];
export type GetApiV1PostsByPostIdLikesApiArg = {
  postId: TypeId;
  /** Include followed status */
  includeFollowedStatus?: boolean | null;
  /** Include following status */
  includeFollowingStatus?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type DeleteApiV1PostsByPostIdLikesApiResponse =
  /** status 200 New number of likes */ number;
export type DeleteApiV1PostsByPostIdLikesApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsByPostIdLikesApiResponse =
  /** status 200 New number of likes */ number;
export type PostApiV1PostsByPostIdLikesApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsByPostIdMuteApiResponse = /** status 200 OK */ any;
export type PostApiV1PostsByPostIdMuteApiArg = {
  postId: TypeId;
};
export type GetApiV1PostsByPostIdQuotesApiResponse =
  /** status 200 List of quoting posts */ Post[];
export type GetApiV1PostsByPostIdQuotesApiArg = {
  postId: TypeId;
  limit?: number | null;
  offset?: number | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PostApiV1PostsByPostIdQuotesAndQuoteAuthIdRevokeApiResponse =
  /** status 200 OK */ any;
export type PostApiV1PostsByPostIdQuotesAndQuoteAuthIdRevokeApiArg = {
  postId: TypeId;
  quoteAuthId: TypeId;
};
export type PostApiV1PostsByPostIdRefreshCardApiResponse =
  /** status 200 Updated card data */ Card;
export type PostApiV1PostsByPostIdRefreshCardApiArg = {
  postId: TypeId;
};
export type DeleteApiV1PostsByPostIdRepostApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1PostsByPostIdRepostApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsByPostIdRepostApiResponse =
  /** status 200 Post object just created */ Post;
export type PostApiV1PostsByPostIdRepostApiArg = {
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** Optional param, omit for repost or specify with 'text' to create a quote */
  createPost: CreatePost;
};
export type GetApiV1PostsByPostIdRepostsApiResponse =
  /** status 200 OK */ PostActivity[];
export type GetApiV1PostsByPostIdRepostsApiArg = {
  postId: TypeId;
  /** Include followed status */
  includeFollowedStatus?: boolean | null;
  /** Include following status */
  includeFollowingStatus?: boolean | null;
  /** Filter by repost type: REPOST, QUOTE, or ALL */
  kind?: RepostParam | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** If true, deduplicate multiple reposts by the same user */
  skipDuplicates?: boolean | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PutApiV1PostsByPostIdSubscriptionApiResponse =
  /** status 200 OK */ any;
export type PutApiV1PostsByPostIdSubscriptionApiArg = {
  postId: TypeId;
};
export type GetApiV1PostsByPostIdSubscriptionApiResponse =
  /** status 200 User is subscribed to this post */ any;
export type GetApiV1PostsByPostIdSubscriptionApiArg = {
  postId: TypeId;
};
export type DeleteApiV1PostsByPostIdSubscriptionApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1PostsByPostIdSubscriptionApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsByPostIdTrackViewApiResponse =
  /** status 200 OK */ any;
export type PostApiV1PostsByPostIdTrackViewApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsByPostIdTranslateApiResponse =
  /** status 200 Post translation */ PostTranslation;
export type PostApiV1PostsByPostIdTranslateApiArg = {
  postId: TypeId;
  /** If true, returns HTML-formatted translation instead of plain text */
  htmlContent?: boolean | null;
  /** Target language code for translation */
  lang: Language;
};
export type PostApiV1PostsByPostIdUnmuteApiResponse = /** status 200 OK */ any;
export type PostApiV1PostsByPostIdUnmuteApiArg = {
  postId: TypeId;
};
export type PostApiV1PostsByPostIdUpvoteApiResponse =
  /** status 200 A summary of votes for the post */ PostVotesSummary;
export type PostApiV1PostsByPostIdUpvoteApiArg = {
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1PostsByPostIdVotesApiResponse =
  /** status 200 OK */ PostVotesSummary;
export type GetApiV1PostsByPostIdVotesApiArg = {
  postId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1RbacApiResponse =
  /** status 200 List of all RBAC-guarded resources and their access lists */ ResourceModel[];
export type GetApiV1RbacApiArg = void;
export type GetApiV1RbacActorsByActorIdPermissionsApiResponse =
  /** status 200 Actor's permissions within the specified scope */ {
    [key: string]: object;
  };
export type GetApiV1RbacActorsByActorIdPermissionsApiArg = {
  /** ID of the actor */
  actorId: TypeId;
  /** Optional scope to filter permissions, if ommitted assumes GlobalScope */
  scope?: string | null;
};
export type GetApiV1RbacActorsByActorIdRolesApiResponse =
  /** status 200 Actor's roles within the specified scope */ RbacRole[];
export type GetApiV1RbacActorsByActorIdRolesApiArg = {
  /** ID of the actor */
  actorId: TypeId;
  /** Optional scope to filter roles, defaults to GlobalScope ('System') if omitted */
  scope?: string | null;
};
export type GetApiV1RbacRolesApiResponse =
  /** status 200 Successfully retrieved scope roles */ RbacRole[];
export type GetApiV1RbacRolesApiArg = {
  /** Scope: 'System' for global roles, or a group ID. */
  scope: string;
};
export type PostApiV1RbacRolesApiResponse =
  /** status 200 The created role */ RbacRole;
export type PostApiV1RbacRolesApiArg = {
  /** Scope: 'System' for global roles, or a group ID. */
  scope: string;
  /** Role details */
  rbacRoleTemplate: RbacRoleTemplate;
};
export type PutApiV1RbacRolesByRoleIdApiResponse =
  /** status 200 Successfully updated role */ RbacRole;
export type PutApiV1RbacRolesByRoleIdApiArg = {
  /** ID of the role to update */
  roleId: string;
  /** Scope: 'System' for global roles, or a group ID. */
  scope: string;
  /** Updated role details */
  rbacRoleTemplate: RbacRoleTemplate;
};
export type DeleteApiV1RbacRolesByRoleNameApiResponse =
  /** status 200 Successfully deleted role */ any;
export type DeleteApiV1RbacRolesByRoleNameApiArg = {
  /** The role's name to delete */
  roleName: string;
  /** Scope: 'System' for global roles, or a group ID. */
  scope: string;
};
export type GetApiV1RbacByResourceApiResponse =
  /** status 200 The description and the access list for the specified resource */ ResourceModel;
export type GetApiV1RbacByResourceApiArg = {
  /** The resource of interest */
  resource: string;
};
export type PostApiV1ReportsApiResponse = /** status 200 OK */ Report;
export type PostApiV1ReportsApiArg = {
  /** Report details including target (post, user, or group), comment, type, and whether to forward to the remote instance */
  createReport: CreateReport;
};
export type PostApiV1ReportsByReportIdEditCommentApiResponse =
  /** status 200 OK */ Report;
export type PostApiV1ReportsByReportIdEditCommentApiArg = {
  reportId: TypeId;
  /** Updated report comment details */
  editReportComment: EditReportComment;
};
export type PutApiV1RulesApiResponse =
  /** status 200 Updated Rule object */ Rule;
export type PutApiV1RulesApiArg = {
  rule: Rule;
};
export type GetApiV1RulesApiResponse =
  /** status 200 List of all rules */ Rule[];
export type GetApiV1RulesApiArg = void;
export type PostApiV1RulesApiResponse =
  /** status 200 Created Rule object */ Rule;
export type PostApiV1RulesApiArg = {
  ruleCreate: RuleCreate;
};
export type PostApiV1RulesReorderApiResponse =
  /** status 200 List of updated rules */ Rule[];
export type PostApiV1RulesReorderApiArg = {
  body: RuleOrderingRequest[];
};
export type DeleteApiV1RulesByIdApiResponse = /** status 200 OK */ any;
export type DeleteApiV1RulesByIdApiArg = {
  /** The unique identifier of the rule to delete */
  id: string;
};
export type GetApiV1SearchApiResponse =
  /** status 200 Search result */ SearchResult;
export type GetApiV1SearchApiArg = {
  /** Actor Type: Person or Service. If not provided, searches for both Person and Service actors */
  actorType?: ActorType | null;
  /** Search only in fasp providers */
  fasp?: boolean;
  /** Search only in fasp providers, returning hydrated results */
  faspHydrated?: boolean;
  /** Only include specific types of results. Like posts, users, tags */
  filter?: SearchFilter[] | null;
  /** following/follower status. Default ACCEPTED */
  followStatus?: FollowingStatus & any;
  /** Only include accounts that follows the user */
  followers?: boolean | null;
  /** Only include accounts that the user is following */
  following?: boolean | null;
  /** Filter results by groupId */
  groupId?: TypeId | null;
  /** Filter group members by role. MEMBER returns regular members, ADMIN returns admins and moderators. Only applies when groupId is provided and filter=users */
  groupMemberRole?: GroupMemberRoleFilter | null;
  /** Include relationship data (following/followed) for user results. Default true. */
  includeRelations?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Filter results by ownerId */
  ownerId?: TypeId | null;
  /** Search query */
  q?: string | null;
  /** Attempt to resolve remote users (WebFinger lookup) */
  resolve?: boolean;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Load post with comments. Default false */
  withComments?: boolean | null;
  /** If comment, load it with direct parent (in originalPost field) */
  withParent?: boolean | null;
  /** If comment, load it with root parent (top-level post of the thread) */
  withRootParent?: boolean | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type DeleteApiV1SessionsAllApiResponse = /** status 200 OK */ any;
export type DeleteApiV1SessionsAllApiArg = void;
export type GetApiV1SessionsListApiResponse =
  /** status 200 Sessions */ SessionInfo[];
export type GetApiV1SessionsListApiArg = void;
export type PutApiV1SessionsRevokeAllApiResponse = /** status 200 OK */ any;
export type PutApiV1SessionsRevokeAllApiArg = void;
export type PutApiV1SessionsRevokeBySessionKeyApiResponse =
  /** status 200 OK */ any;
export type PutApiV1SessionsRevokeBySessionKeyApiArg = {
  /** Session key of the session to revoke */
  sessionKey: string;
};
export type DeleteApiV1SessionsBySessionKeyApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1SessionsBySessionKeyApiArg = {
  /** Session key of the session to delete */
  sessionKey: string;
};
export type PutApiV1SettingsApiResponse =
  /** status 200 number of updated settings */ Blob;
export type PutApiV1SettingsApiArg = {
  /** settings objects to be updated. complete objects must be provided - partial updates are not allowed. */
  platformSettings: PlatformSettings;
};
export type GetApiV1SettingsApiResponse =
  /** status 200 Response PlatformSettings */ PlatformSettings;
export type GetApiV1SettingsApiArg = {
  /** Comma-separated list of platform setting keys to retrieve. Each key must correspond to a valid platform setting definition registered in the system.
    
    Available keys are:
    
    ```wellesley.access```
    
    ```wellesley.admin.ai.agents.budgets```
    
    ```wellesley.uploads.policy.audio```
    
    ```wellesley.branding```
    
    ```wellesley.admin.captcha```
    
    ```wellesley.captcha```
    
    ```wellesley.confirmationCode```
    
    ```wellesley.uploads.policy.doc```
    
    ```wellesley.instance.domainBlocks```
    
    ```wellesley.admin.embedding_model```
    
    ```wellesley.uploads.policy.emoji```
    
    ```wellesley.admin.fasp_remote```
    
    ```wellesley.admin.federation.mode```
    
    ```wellesley.uploads.policy.image```
    
    ```wellesley.instance.admin```
    
    ```wellesley.instance.contacts```
    
    ```wellesley.instance.legal```
    
    ```wellesley.admin.language```
    
    ```wellesley.admin.mediacache```
    
    ```wellesley.posts```
    
    ```wellesley.registration```
    
    ```wellesley.admin.link_service```
    
    ```wellesley.admin.sms```
    
    ```wellesley.admin.sms.aws```
    
    ```wellesley.admin.sms.sinch```
    
    ```wellesley.admin.sms.twilio```
    
    ```wellesley.translation```
    
    ```wellesley.admin.translation```
    
    ```wellesley.admin.uploads```
    
    ```wellesley.username.release```
    
    ```wellesley.uploads.policy.video``` */
  keys: string[];
};
export type DeleteApiV1SettingsApiResponse =
  /** status 200 number of deleted settings */ Blob;
export type DeleteApiV1SettingsApiArg = {
  /** Comma-separated list of platform setting keys to delete. Each key must correspond to a valid platform setting that exists and can be safely removed.
    
    Available keys are:
    
    ```wellesley.access```
    
    ```wellesley.admin.ai.agents.budgets```
    
    ```wellesley.uploads.policy.audio```
    
    ```wellesley.branding```
    
    ```wellesley.admin.captcha```
    
    ```wellesley.captcha```
    
    ```wellesley.confirmationCode```
    
    ```wellesley.uploads.policy.doc```
    
    ```wellesley.instance.domainBlocks```
    
    ```wellesley.admin.embedding_model```
    
    ```wellesley.uploads.policy.emoji```
    
    ```wellesley.admin.fasp_remote```
    
    ```wellesley.admin.federation.mode```
    
    ```wellesley.uploads.policy.image```
    
    ```wellesley.instance.admin```
    
    ```wellesley.instance.contacts```
    
    ```wellesley.instance.legal```
    
    ```wellesley.admin.language```
    
    ```wellesley.admin.mediacache```
    
    ```wellesley.posts```
    
    ```wellesley.registration```
    
    ```wellesley.admin.link_service```
    
    ```wellesley.admin.sms```
    
    ```wellesley.admin.sms.aws```
    
    ```wellesley.admin.sms.sinch```
    
    ```wellesley.admin.sms.twilio```
    
    ```wellesley.translation```
    
    ```wellesley.admin.translation```
    
    ```wellesley.admin.uploads```
    
    ```wellesley.username.release```
    
    ```wellesley.uploads.policy.video``` */
  keys: string[];
};
export type GetApiV1SettingsNamesApiResponse =
  /** status 200 Array of setting key names */ any;
export type GetApiV1SettingsNamesApiArg = {
  /** Namespace to list keys for. One of: Platform, User, Group, GroupMember. */
  type: Namespace;
};
export type PutApiV1SettingsUserApiResponse =
  /** status 200 number of updated settings */ Blob;
export type PutApiV1SettingsUserApiArg = {
  /** settings objects to be updated. complete objects must be provided - partial updates are not allowed. */
  userSettings: UserSettings;
};
export type GetApiV1SettingsUserApiResponse =
  /** status 200 Response UserSettings */ UserSettings;
export type GetApiV1SettingsUserApiArg = {
  /** Comma-separated list of user setting keys to retrieve. Each key must correspond to a valid user setting definition registered in the system.
    
    Available keys are:
    
    ```user.discoverFeed```
    
    ```user.follow```
    
    ```user.notifications.policy```
    
    ```user.notifications.prefs```
    
    ```user.privacy```
    
    ```user.quotePolicy```
    
    ```user.translation``` */
  keys: string[];
};
export type DeleteApiV1SettingsUserApiResponse =
  /** status 200 number of deleted settings */ Blob;
export type DeleteApiV1SettingsUserApiArg = {
  /** Comma-separated list of user setting keys to delete. Each key must correspond to a valid user setting that exists for the authenticated user.
    
    Available keys are:
    
    ```user.discoverFeed```
    
    ```user.follow```
    
    ```user.notifications.policy```
    
    ```user.notifications.prefs```
    
    ```user.privacy```
    
    ```user.quotePolicy```
    
    ```user.translation``` */
  keys: string[];
};
export type GetApiV1SuggestionsApiResponse =
  /** status 200 Suggested users */ User[];
export type GetApiV1SuggestionsApiArg = {
  /** Preferred language hint for recommendation providers (for example: en, fr). */
  language?: string | null;
  /** Maximum number of suggestions to return after filtering. Values below 0 are clamped to 0. */
  limit?: number;
};
export type GetApiV1TagsFeaturedApiResponse = /** status 200 OK */ Tag[];
export type GetApiV1TagsFeaturedApiArg = {
  /** Scope id: 'global' or TypeId */
  scope: string;
  /** List specific user's featured tags */
  userId?: TypeId | null;
};
export type DeleteApiV1TagsFeaturedByNameApiResponse = /** status 200 OK */ any;
export type DeleteApiV1TagsFeaturedByNameApiArg = {
  name: string;
  /** Scope id: 'global' or TypeId */
  scope: string;
};
export type PostApiV1TagsFeaturedByNameApiResponse = /** status 200 OK */ any;
export type PostApiV1TagsFeaturedByNameApiArg = {
  name: string;
  /** Scope id: 'global' or TypeId */
  scope: string;
};
export type PostApiV1TagsFollowByNameApiResponse = /** status 200 OK */ any;
export type PostApiV1TagsFollowByNameApiArg = {
  name: string;
  /** Scope id: 'global' or TypeId */
  scope: string;
};
export type GetApiV1TagsFollowedApiResponse = /** status 200 OK */ Tag[];
export type GetApiV1TagsFollowedApiArg = {
  /** Scope id: 'global' or TypeId */
  scope: string;
};
export type PutApiV1TagsListApiResponse = /** status 200 OK */ any;
export type PutApiV1TagsListApiArg = {
  /** Scope id */
  scope: string;
  /** Soft flag (blacklist only) */
  soft?: boolean | null;
  /** List type */
  type: TagPolicyMode;
  body: string[];
};
export type PatchApiV1TagsListApiResponse = /** status 200 OK */ any;
export type PatchApiV1TagsListApiArg = {
  /** Scope id */
  scope: string;
  /** Soft flag (blacklist only) */
  soft?: boolean | null;
  /** List type */
  type: TagPolicyMode;
  body: string[];
};
export type GetApiV1TagsListApiResponse = /** status 200 OK */ string[];
export type GetApiV1TagsListApiArg = {
  /** Scope id */
  scope: string;
  /** Soft flag (blacklist only) */
  soft?: boolean | null;
  /** List type */
  type: TagPolicyMode;
};
export type DeleteApiV1TagsListApiResponse = /** status 200 OK */ any;
export type DeleteApiV1TagsListApiArg = {
  /** Scope id */
  scope: string;
  /** Soft flag (blacklist only) */
  soft?: boolean | null;
  /** List type */
  type: TagPolicyMode;
  body: string[];
};
export type PutApiV1TagsPolicyApiResponse =
  /** status 200 Policy mode set successfully */ any;
export type PutApiV1TagsPolicyApiArg = {
  /** Scope id */
  scope: string;
  /** Policy mode request */
  setTagPolicyRequest: SetTagPolicyRequest;
};
export type GetApiV1TagsPolicyApiResponse = /** status 200 OK */ TagPolicyMode;
export type GetApiV1TagsPolicyApiArg = {
  scope: string;
};
export type PostApiV1TagsReportApiResponse = /** status 200 OK */ any;
export type PostApiV1TagsReportApiArg = {
  /** Canonical tag name */
  name: string;
  /** Scope id */
  scope: string;
  /** Tag report request */
  createTagReportRequest: CreateTagReportRequest;
};
export type GetApiV1TagsReportsApiResponse = /** status 200 OK */ Blob;
export type GetApiV1TagsReportsApiArg = {
  scope: string;
};
export type GetApiV1TagsSearchApiResponse = /** status 200 OK */ string[];
export type GetApiV1TagsSearchApiArg = {
  /** Max results */
  limit?: number | null;
  /** Partial tag name */
  name?: string | null;
  /** Offset */
  offset?: number | null;
  /** Scope id: 'global' or TypeId */
  scope?: string | null;
};
export type GetApiV1TagsTrendingApiResponse = /** status 200 OK */ Tag[];
export type GetApiV1TagsTrendingApiArg = {
  /** Max results */
  limit?: number | null;
  /** Offset for pagination */
  offset?: number | null;
  /** Scope id: 'global' or TypeId */
  scope: string;
  /** Sort by field: 'uses' (default) or 'date' (tag created_at) */
  sortBy?: string | null;
  /** Sort order: ASC or DESC */
  sortOrder?: string | null;
};
export type PostApiV1TagsUnfollowByNameApiResponse = /** status 200 OK */ any;
export type PostApiV1TagsUnfollowByNameApiArg = {
  name: string;
  /** Scope id: 'global' or TypeId */
  scope: string;
};
export type GetApiV1TagsByNameApiResponse = /** status 200 OK */ Tag;
export type GetApiV1TagsByNameApiArg = {
  name: string;
  /** Filter history since. 2 weeks by default */
  historySince?: LocalDate | null;
  /** Scope id: 'global' or TypeId */
  scope: string;
};
export type PostApiV1TranslateTextApiResponse =
  /** status 200 OK */ TranslationResponse;
export type PostApiV1TranslateTextApiArg = {
  translationRequest: TranslationRequest;
};
export type GetApiV1TrendsEventsApiResponse = /** status 200 OK */ Event[];
export type GetApiV1TrendsEventsApiArg = void;
export type GetApiV1TrendsLinksApiResponse = /** status 200 OK */ Card[];
export type GetApiV1TrendsLinksApiArg = void;
export type GetApiV1TrendsPostsApiResponse = /** status 200 OK */ Post[];
export type GetApiV1TrendsPostsApiArg = {
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1TrendsTagsApiResponse = /** status 200 OK */ Tag[];
export type GetApiV1TrendsTagsApiArg = {
  /** Scope id: 'global' or TypeId */
  scope?: string | null;
};
export type PostApiV1UploadsApiResponse =
  /** status 200 Upload successfully created */ CreateUploadResult;
export type PostApiV1UploadsApiArg = {
  createUpload: CreateUpload;
};
export type GetApiV1UploadsAttachedByEntityIdApiResponse =
  /** status 200 Operation is successful */ ListUploadsResult;
export type GetApiV1UploadsAttachedByEntityIdApiArg = {
  entityId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PostApiV1UploadsBatchApiResponse =
  /** status 200 Delete multiple upload is successful */ TypeId[];
export type PostApiV1UploadsBatchApiArg = {
  body: TypeId[];
};
export type PostApiV1UploadsListApiResponse =
  /** status 200 Operation is successful */ Upload[];
export type PostApiV1UploadsListApiArg = {
  uploadList: UploadList;
};
export type GetApiV1UploadsOwnerByOwnerIdApiResponse =
  /** status 200 Operation is successful */ ListUploadsResult;
export type GetApiV1UploadsOwnerByOwnerIdApiArg = {
  ownerId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1UploadsOwnerByOwnerIdStandaloneApiResponse =
  /** status 200 Operation is successful */ ListUploadsResult;
export type GetApiV1UploadsOwnerByOwnerIdStandaloneApiArg = {
  ownerId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1UploadsSearchApiResponse =
  /** status 200 Operation is successful */ ListUploadsResult;
export type GetApiV1UploadsSearchApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Search uploads by a tag */
  tag?: UploadsTags | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
  /** Search uploads by upload type */
  uploadType?: UploadType | null;
};
export type GetApiV1UploadsUsagesApiResponse =
  /** status 200 Json with usages for specified upload ids */ UploadUsages;
export type GetApiV1UploadsUsagesApiArg = {
  /** Comma-separated list of upload IDs to find usages for */
  ids?: string[] | null;
};
export type GetApiV1UploadsByIdApiResponse =
  /** status 200 Gets upload data with file info */ Upload;
export type GetApiV1UploadsByIdApiArg = {
  id: TypeId;
};
export type DeleteApiV1UploadsByIdApiResponse =
  /** status 200 Delete upload is successful */ DeleteUploadResponse;
export type DeleteApiV1UploadsByIdApiArg = {
  id: TypeId;
};
export type PostApiV1UploadsByIdMetaApiResponse =
  /** status 200 Operation is successful */ Upload;
export type PostApiV1UploadsByIdMetaApiArg = {
  id: TypeId;
  body: {
    [key: string]: any;
  };
};
export type PutApiV1UploadsByIdMetaApiResponse =
  /** status 200 Operation is successful */ Upload;
export type PutApiV1UploadsByIdMetaApiArg = {
  id: TypeId;
  body: {
    [key: string]: any;
  };
};
export type PostApiV1UploadsByIdPrivacyApiResponse =
  /** status 200 Operation is successful */ Upload;
export type PostApiV1UploadsByIdPrivacyApiArg = {
  id: TypeId;
  updateUploadPrivacy: UpdateUploadPrivacy;
};
export type PostApiV1UploadsByIdTagsApiResponse =
  /** status 200 Operation is successful */ Upload;
export type PostApiV1UploadsByIdTagsApiArg = {
  id: TypeId;
  body: UploadsTags[];
};
export type PutApiV1UploadsByIdTagsApiResponse =
  /** status 200 Operation is successful */ Upload;
export type PutApiV1UploadsByIdTagsApiArg = {
  id: TypeId;
  body: UploadsTags[];
};
export type PostApiV1UploadsByIdThumbnailApiResponse =
  /** status 200 Operation is successful */ Upload;
export type PostApiV1UploadsByIdThumbnailApiArg = {
  id: TypeId;
  changeVideoThumbnail: ChangeVideoThumbnail;
};
export type PutApiV1UploadsByUploadIdOwnerApiResponse =
  /** status 200 Owner updated */ Upload;
export type PutApiV1UploadsByUploadIdOwnerApiArg = {
  uploadId: TypeId;
  updateUploadOwner: UpdateUploadOwner;
};
export type GetApiV1UserAliasApiResponse = unknown;
export type GetApiV1UserAliasApiArg = void;
export type DeleteApiV1UserAliasApiResponse = /** status 200 OK */ any;
export type DeleteApiV1UserAliasApiArg = {
  /** ActivityPub URI of the alias to remove */
  uri: string;
};
export type PostApiV1UserAliasApiResponse = /** status 200 OK */ any;
export type PostApiV1UserAliasApiArg = {
  /** Remote account address in user@domain format */
  acct: string;
};
export type GetApiV1UserDomainBlockApiResponse = /** status 200 OK */ string[];
export type GetApiV1UserDomainBlockApiArg = void;
export type DeleteApiV1UserDomainBlockByDomainApiResponse =
  /** status 200 OK */ any;
export type DeleteApiV1UserDomainBlockByDomainApiArg = {
  /** The domain to unblock */
  domain: string;
};
export type PostApiV1UserDomainBlockByDomainApiResponse =
  /** status 200 OK */ any;
export type PostApiV1UserDomainBlockByDomainApiArg = {
  /** The domain to block (e.g. 'example.com') */
  domain: string;
};
export type DeleteApiV1UsersApiResponse = /** status 200 User deleted */ any;
export type DeleteApiV1UsersApiArg = {
  /** User ID to delete. */
  id: TypeId;
};
export type PostApiV1UsersApiResponse = /** status 200 OK */ UserFull;
export type PostApiV1UsersApiArg = {
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  /** Json object with the users data */
  userCreate: UserCreate;
};
export type GetApiV1UsersApiResponse = /** status 200 OK */ User | UserFull;
export type GetApiV1UsersApiArg = {
  /** If true return also summary, stats, header and fields. Default false. */
  full?: boolean | null;
  /** Include blocked_by status (target blocked viewer) */
  includeBlockedByStatus?: boolean | null;
  /** Include blocked status (viewer blocked target) */
  includeBlockedStatus?: boolean | null;
  /** Include followed status */
  includeFollowedStatus?: boolean | null;
  /** Include following status */
  includeFollowingStatus?: boolean | null;
  /** Include muted status */
  includeMutedStatus?: boolean | null;
  /** Include all relationship statuses (following, followed, blocked, blocked_by, muted) */
  relations?: boolean | null;
  /** Username to look up. Supports local ('alice') or federated ('alice@remote.social') format. */
  username: string;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1UsersConnectionsApiResponse = /** status 200 OK */ User[];
export type GetApiV1UsersConnectionsApiArg = {
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** The target Follow status like: ACCEPTED/REJECTED/PENDING */
  status?: FollowingStatus & any;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PostApiV1UsersFollowByUsernameApiResponse =
  /** status 200 Follow result */ FollowResult;
export type PostApiV1UsersFollowByUsernameApiArg = {
  /** Username of the followee */
  username: string;
  /** Followee's domain.  If omitted assumed to be local */
  domain?: string | null;
  /** 'false' for regular Follow, 'true' for bidirectional Connect */
  mutual?: boolean;
  /** http vs. https.  For testing ONLY */
  scheme?: AppScheme & any;
};
export type PostApiV1UsersFollowByUsernameAcceptApiResponse =
  /** status 200 OK */ any;
export type PostApiV1UsersFollowByUsernameAcceptApiArg = {
  /** The URI of the prospective follower */
  username: string;
};
export type PostApiV1UsersFollowByUsernamePendApiResponse =
  /** status 200 OK */ any;
export type PostApiV1UsersFollowByUsernamePendApiArg = {
  /** The URI of the prospective follower */
  username: string;
};
export type PostApiV1UsersFollowByUsernameRejectApiResponse =
  /** status 200 OK */ any;
export type PostApiV1UsersFollowByUsernameRejectApiArg = {
  /** The URI of the prospective follower */
  username: string;
};
export type PostApiV1UsersFollowByUsernameUndoApiResponse =
  /** status 200 Follow result */ FollowResult;
export type PostApiV1UsersFollowByUsernameUndoApiArg = {
  /** Username of the followee */
  username: string;
  /** Followee's domain.  If omitted assumed to be local */
  domain?: string | null;
  /** 'false' for regular Follow, 'true' for bidirectional Connect */
  mutual?: boolean;
  /** http vs. https.  For testing ONLY */
  scheme?: AppScheme & any;
};
export type GetApiV1UsersFolloweesApiResponse = /** status 200 OK */ User[];
export type GetApiV1UsersFolloweesApiArg = {
  /** When true, returns followees in all statuses regardless of the 'status' parameter */
  anyStatus?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Search followees by username/display name/domain. Example: q=alice */
  q?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** The target Follow status like: ACCEPTED/REJECTED/PENDING */
  status?: FollowingStatus & any;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1UsersFollowersApiResponse = /** status 200 OK */ User[];
export type GetApiV1UsersFollowersApiArg = {
  /** When true, returns followers in all statuses regardless of the 'status' parameter */
  anyStatus?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Search followers by username/display name/domain. Example: q=alice */
  q?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** The target Follow status like: ACCEPTED/REJECTED/PENDING */
  status?: FollowingStatus & any;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1UsersInviteLinksApiResponse =
  /** status 200 OK */ SignupInviteLinkList;
export type GetApiV1UsersInviteLinksApiArg = {
  /** Filter by active state */
  active?: boolean | null;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PostApiV1UsersInviteLinksApiResponse =
  /** status 200 OK */ SignupInviteLink;
export type PostApiV1UsersInviteLinksApiArg = {
  signupInviteLinkCreate: SignupInviteLinkCreate;
};
export type PutApiV1UsersInviteLinksDeactivateByCodeApiResponse =
  /** status 200 OK */ any;
export type PutApiV1UsersInviteLinksDeactivateByCodeApiArg = {
  /** Invite code */
  code: string;
};
export type GetApiV1UsersProfileApiResponse = /** status 200 OK */ UserFull;
export type GetApiV1UsersProfileApiArg = {
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type GetApiV1UsersRelationshipsApiResponse =
  /** status 200 If userId is missing from response, no relationships found, no one follows anyone */ {
    [key: string]: Relationship;
  };
export type GetApiV1UsersRelationshipsApiArg = {
  /** Include additional relationships, like following/followed/blocked/blocked_by/muted/note.
                                 If no 'filter' is provided, following and followed are enabled */
  filter?: string[] | null;
  /** Target users to get relationship with */
  targets: TypeId[];
};
export type GetApiV1UsersRemoteByUserNameFullFollowersApiResponse =
  /** status 200 OK */ User[];
export type GetApiV1UsersRemoteByUserNameFullFollowersApiArg = {
  /** Username with the domain */
  userNameFull: string;
  /** Show no more than the given number of users */
  limit?: number;
  /** An offset to show users starting from */
  offset?: number;
};
export type GetApiV1UsersRemoteByUserNameFullFollowingApiResponse =
  /** status 200 OK */ User[];
export type GetApiV1UsersRemoteByUserNameFullFollowingApiArg = {
  /** Username with the domain */
  userNameFull: string;
  /** Show no more than the given number of users */
  limit?: number;
  /** An offset to show users starting from */
  offset?: number;
};
export type GetApiV1UsersRenameHistoryApiResponse =
  /** status 200 OK */ UsernameHistories;
export type GetApiV1UsersRenameHistoryApiArg = void;
export type PutApiV1UsersByUserIdApiResponse = /** status 200 OK */ UserFull;
export type PutApiV1UsersByUserIdApiArg = {
  userId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  userUpdate: UserUpdate;
};
export type GetApiV1UsersByUserIdApiResponse = /** status 200 OK */
  | User
  | UserFull;
export type GetApiV1UsersByUserIdApiArg = {
  /** The unique user ID (TypeID with USER prefix) */
  userId: TypeId;
  /** If true return also summary, stats, header and fields. Default false. */
  full?: boolean | null;
  /** Include blocked_by status (target blocked viewer) */
  includeBlockedByStatus?: boolean | null;
  /** Include blocked status (viewer blocked target) */
  includeBlockedStatus?: boolean | null;
  /** Include followed status */
  includeFollowedStatus?: boolean | null;
  /** Include following status */
  includeFollowingStatus?: boolean | null;
  /** Include muted status */
  includeMutedStatus?: boolean | null;
  /** Include all relationship statuses (following, followed, blocked, blocked_by, muted) */
  relations?: boolean | null;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
};
export type PostApiV1UsersByUserIdDeepSyncApiResponse =
  /** status 200 Deep sync submitted */ DeepSyncResponse;
export type PostApiV1UsersByUserIdDeepSyncApiArg = {
  userId: TypeId;
};
export type GetApiV1UsersByUserIdFollowersApiResponse =
  /** status 200 List of followers as User objects */ User[];
export type GetApiV1UsersByUserIdFollowersApiArg = {
  userId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Search followers by username/display name/domain. Example: q=alice */
  q?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type GetApiV1UsersByUserIdFollowingApiResponse =
  /** status 200 List of following as User objects */ User[];
export type GetApiV1UsersByUserIdFollowingApiArg = {
  userId: TypeId;
  /** Get older records (records with IDs less than this value) Alias maxId/max_id */
  lastId?: TypeId | null;
  limit?: number | null;
  offset?: number | null;
  /** Search followees by username/display name/domain. Example: q=alice */
  q?: string | null;
  sortBy?: string | null;
  /** Sort order. Supported values: ASC or DESC */
  sortOrder?: string | null;
  /** Get newer records (records with IDs greater than this value) Alias minId/min_id */
  untilId?: TypeId | null;
};
export type PutApiV1UsersByUserIdMediaApiResponse =
  /** status 200 OK */ UserFull;
export type PutApiV1UsersByUserIdMediaApiArg = {
  userId: TypeId;
  /** Returns text as html if true or original text if false. Applicable only to local posts and users. Default is true. */
  htmlContent?: any;
  userUpdateMedia: UserUpdateMedia;
};
export type GetAuthorizeInteractionApiResponse = /** status 200 OK */ any;
export type GetAuthorizeInteractionApiArg = {
  uri?: string | null;
};
export type GetRootApiResponse = /** status 200 Page data */ RootPageData;
export type GetRootApiArg = {
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetUserApiResponse = /** status 200 Page data */ UserPageData;
export type GetUserApiArg = {
  /** Username */
  username: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetUserEventApiResponse =
  /** status 200 Page data */ UserEventPageData;
export type GetUserEventApiArg = {
  /** Username */
  username: string;
  /** Event ID */
  eventId: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetUserPostApiResponse =
  /** status 200 Page data */ UserPostPageData;
export type GetUserPostApiArg = {
  /** Username */
  username: string;
  /** Post ID */
  postId: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetAboutApiResponse = /** status 200 Page data */ AboutPageData;
export type GetAboutApiArg = {
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetFeedApiResponse = /** status 200 Page data */ FeedPageData;
export type GetFeedApiArg = {
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetFeedDiscoverApiResponse =
  /** status 200 Page data */ FeedDiscoverPageData;
export type GetFeedDiscoverApiArg = {
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetFeedFollowingApiResponse =
  /** status 200 Page data */ FeedFollowingPageData;
export type GetFeedFollowingApiArg = {
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetGroupApiResponse = /** status 200 Page data */ GroupPageData;
export type GetGroupApiArg = {
  /** Group name */
  groupName: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetGroupChannelApiResponse =
  /** status 200 Page data */ GroupChannelPageData;
export type GetGroupChannelApiArg = {
  /** Group name */
  groupName: string;
  /** Channel name */
  channelName: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetGroupChannelPostApiResponse =
  /** status 200 Page data */ GroupChannelPostPageData;
export type GetGroupChannelPostApiArg = {
  /** Group name */
  groupName: string;
  /** Channel name */
  channelName: string;
  /** Post ID */
  postId: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetGroupBotApiResponse =
  /** status 200 Page data */ GroupBotPageData;
export type GetGroupBotApiArg = {
  /** Group name */
  groupName: string;
  /** Bot name */
  botName: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetGroupEventApiResponse =
  /** status 200 Page data */ GroupEventPageData;
export type GetGroupEventApiArg = {
  /** Group name */
  groupName: string;
  /** Event ID */
  eventId: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetGroupForumCategoryApiResponse =
  /** status 200 Page data */ GroupForumCategoryPageData;
export type GetGroupForumCategoryApiArg = {
  /** Group name */
  groupName: string;
  /** Category slug */
  categoryName: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetGroupForumPostApiResponse =
  /** status 200 Page data */ GroupForumPostPageData;
export type GetGroupForumPostApiArg = {
  /** Group name */
  groupName: string;
  /** Post ID */
  postId: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetForumTagApiResponse =
  /** status 200 Page data */ ForumTagPageData;
export type GetForumTagApiArg = {
  /** Group name */
  groupName: string;
  /** Tag name */
  tagName: string;
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetPrivacyApiResponse = /** status 200 Page data */ PrivacyPageData;
export type GetPrivacyApiArg = {
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type GetTermsApiResponse = /** status 200 Page data */ TermsPageData;
export type GetTermsApiArg = {
  /** Response format. Set to 'json' to get JSON response (HTML is returned by default) */
  format: string;
};
export type CompatResponse = {
  /** Current backend breaking generation. Monotonically increasing integer that is incremented whenever a breaking API change is introduced. */
  breaking_generation: number;
  /** Minimum generation that clients must have been compiled against to be allowed to operate. Clients compiled against a lower generation must update. */
  min_supported_generation: number;
  /** Informational string indicating the latest API surface version. */
  api_surface: string;
};
export type SignupRequestStep =
  | "EMAIL"
  | "PHONE"
  | "CAPTCHA"
  | "REASON"
  | "ADMIN"
  | "USER";
export type RegistrationResponse = {
  hash: string;
  nextStep: SignupRequestStep;
};
export type ApiError = {
  /** Error code */
  errorCode: string;
  /** Error message */
  message: string;
  /** Link to documentation */
  docUrl?: string;
};
export type SignupReasonParams = {
  /** Registration hash */
  hash: string;
  /** Reason for signing up for admin approval */
  reason: string;
};
export type Token = {
  /** Persistent Token */
  sessionKey: string;
};
export type AuthRequest = {
  /** Email or username */
  login: string;
  /** Account's password */
  password: string;
};
export type AuthPhoneRequest = {
  /** Phone number */
  phone: string;
  /** Confirmation code */
  code?: number | null;
};
export type TypeId = string;
export type Instant = string;
export type Account = {
  /** Internal account id */
  id: TypeId;
  /** Account email */
  email?: string | null;
  password: string | null;
  /** Account phone */
  phone?: string | null;
  createdAt: Instant;
  updatedAt: Instant;
};
export type UploadType = "VIDEO" | "IMAGE" | "AUDIO" | "DOCUMENT" | "OTHER";
export type Meta = {
  blurhash?: string | null;
  name?: string | null;
  altText?: string | null;
};
export type Meta1 = {
  /** Video duration in seconds */
  duration?: number | null;
  /** Media width */
  width?: number | null;
  /** Media height */
  height?: number | null;
  /** Video codec */
  codec?: string | null;
  /** Rotation in degrees */
  rotate?: number | null;
};
export type FileDesc = {
  /** Full url of the file */
  uri: string | null;
  /** File id */
  fileId: TypeId;
  /** File extension */
  extension: string;
  /** true if this file is original, false if it is a derivative */
  original: boolean;
  /** File metadata. Contains optional values for width, height etc. */
  meta: Meta1;
  /** File size in bytes */
  size: number;
  createdAt: Instant;
  updatedAt: Instant;
  /** File type */
  type: UploadType;
};
export type UploadsTags =
  | "Post"
  | "Avatar"
  | "Header"
  | "Album"
  | "Emoji"
  | "Event";
export type Upload = {
  /** Internal id */
  uploadId: TypeId;
  /** User id this upload belongs to. Null for platform-owned uploads (e.g., default covers). */
  userId?: TypeId | null;
  /** Entity that owns this upload (user, channel/group, category, or event). TypeID prefix indicates the owner type. */
  ownerId?: TypeId | null;
  /** Entity this upload is attached to (e.g., a post or event). NULL for standalone uploads like avatars, covers, or media library items. */
  attachedToId?: TypeId | null;
  /** Type of the upload */
  uploadType: UploadType;
  /** Meta data */
  meta?: Meta;
  /** Size in bytes of all the files in this upload */
  size: number;
  /** List of all the files this upload has */
  files: FileDesc[];
  /** List of tags attached to upload */
  tags: UploadsTags[];
  /** Upload processing error */
  error?: string | null;
  /** true if cached */
  cached?: boolean;
  /** Logs */
  logs?: string | null;
  /** true if this upload is remote */
  remote?: boolean;
  createdAt: Instant;
  updatedAt: Instant;
};
export type UserState = "REGULAR" | "SENSITIVE" | "LIMITED" | "SUSPENDED";
export type FollowingStatus = "PENDING" | "ACCEPTED" | "REJECTED";
export type MuteState = {
  state: boolean;
  expiresAt?: Instant | null;
};
export type Relationship = {
  /** Does the viewer follow the target? */
  following?: FollowingStatus | null;
  /** Does the target follow the viewer? */
  followed?: FollowingStatus | null;
  /** Viewer blocked the target */
  blocked?: boolean | null;
  /** Target blocked the viewer */
  blockedBy?: boolean | null;
  /** Viewer mutes the target */
  muted?: MuteState | null;
  /** Viewer's private note about the target */
  note?: string | null;
};
export type UserType = "USER" | "CHANNEL" | "CATEGORY";
export type GroupChannelPrivacy = "PUBLIC" | "PRIVATE";
export type UserStats = {
  /** Total number of posts */
  posts: number;
  /** Posts created in the last 24 hours */
  postsLast24h: number;
  /** Total uploaded bytes */
  totalStorageBytes: number;
  /** Total number of comments */
  comments: number;
  /** Average posts per day over the last 30 days */
  avgPostsPerDay: number;
  /** Average uploaded bytes per day over the last 30 days */
  avgBytesPerDay: number;
  /** number of followers */
  followers: number;
  /** number of following */
  following: number;
  /** privacy setting to hide followings */
  followingHidden: boolean;
  /** total number of events (group/user) emitted */
  totalEvents: number;
};
export type UserStatsWrite = {
  /** Total number of posts */
  posts: number;
  /** Posts created in the last 24 hours */
  postsLast24h: number;
  /** Total uploaded bytes */
  totalStorageBytes: number;
  /** Total number of comments */
  comments: number;
  /** Average posts per day over the last 30 days */
  avgPostsPerDay: number;
  /** Average uploaded bytes per day over the last 30 days */
  avgBytesPerDay: number;
  lastFlushVersion?: number | null;
  /** number of followers */
  followers: number;
  /** number of following */
  following: number;
  /** privacy setting to hide followings */
  followingHidden: boolean;
  /** total number of events (group/user) emitted */
  totalEvents: number;
};
export type UserField = {
  value: string;
  verifiedAt?: Instant | null;
};
export type Emoji = {
  shortcode: string;
  category: string | null;
  url: string;
  staticUrl: string;
  visibleInPicker: boolean;
};
export type Geo = {
  latitude: number;
  longitude: number;
  altitude?: number | null;
  accuracy?: number | null;
  verticalAccuracy?: number | null;
  speed?: number | null;
  bearing?: number | null;
  timestamp?: number | null;
};
export type Location = {
  geo: Geo | null;
  name: string | null;
  autoUpdate: boolean;
  show: boolean;
};
export type TimeZone = {
  ianaTimezone: string | null;
  autoUpdate: boolean;
  show: boolean;
};
export type BirthdayShowOptions = "NONE" | "YEAR" | "FULL" | "DATE";
export type Birthday = {
  date: Instant | null;
  show: BirthdayShowOptions;
};
export type UserMeta = {
  /** Color in HEX format for UI display */
  color?: string | null;
};
export type ActorType =
  | "Application"
  | "Group"
  | "Organization"
  | "Person"
  | "Service";
export type SyncState =
  | "SHALLOW_SYNCED"
  | "SYNC_IN_PROGRESS"
  | "DEEP_SYNCED"
  | "DEEP_SYNC_FAILED";
export type UserFull = {
  /** internal id of this user */
  id: TypeId;
  /** unique user name */
  username: string;
  /** User's domain */
  domain: string;
  /** Whether this user is local to this server */
  local: boolean;
  /** full name of the user */
  displayName: string;
  /** URI of this user */
  uri: string;
  /** User's avatar */
  avatar?: Upload | null;
  /** User's creation time */
  createdAt: Instant;
  /** User's moderation state */
  state: UserState;
  /** Relationship with this user */
  relationship?: Relationship | null;
  /** Type of user entity: USER, CHANNEL, or CATEGORY */
  type?: UserType | null;
  /** Whether this is a channel or a user. Deprecated: use 'type' instead. */
  channel: boolean;
  /** Group ID if this is a group channel, group user or category. */
  groupId?: TypeId | null;
  /** Privacy of this channel/category in a group. */
  groupPrivacy?: GroupChannelPrivacy | null;
  /** Name of the channel inside a group */
  groupUserName?: string | null;
  /** true if this is primary group channel. */
  groupPrimary?: boolean | null;
  /** true if this is auto-subscribe group channel. */
  groupAutoSubscribe?: boolean | null;
  /** User's summary or bio */
  summary: string;
  /** User stats */
  stats?: UserStats;
  /** User fields */
  fields?: {
    [key: string]: UserField;
  };
  /** User's header */
  header?: Upload | null;
  deleted?: boolean | null;
  emojis?: Emoji[] | null;
  /** User's location, geo and name */
  location?: Location | null;
  /** User's timezone */
  timezone?: TimeZone | null;
  /** User's birthday */
  birthday?: Birthday | null;
  /** Software platform type (wellesley, mastodon, threads.net) */
  software: string;
  /** Additional metadata (color, styling) */
  meta?: UserMeta | null;
  /** Group avatar (only present for group channels) */
  groupAvatar?: Upload | null;
  /** Group name (only present for group channels) */
  groupName?: string | null;
  /** Group display name (only present for group channels) */
  groupDisplayName?: string | null;
  /** Whether this user is a person, application or a service */
  actorType?: ActorType | null;
  /** Sync state for remote users (null for local users). SHALLOW_SYNCED = profile fetched, SYNC_IN_PROGRESS = deep sync running, DEEP_SYNCED = full outbox fetched, DEEP_SYNC_FAILED = deep sync failed */
  syncState?: SyncState | null;
  /** When the last deep sync completed (null if never deep-synced) */
  deepSyncedAt?: Instant | null;
};
export type UserFullWrite = {
  /** internal id of this user */
  id: TypeId;
  /** unique user name */
  username: string;
  /** User's domain */
  domain: string;
  /** Whether this user is local to this server */
  local: boolean;
  /** full name of the user */
  displayName: string;
  /** URI of this user */
  uri: string;
  /** User's avatar */
  avatar?: Upload | null;
  /** User's creation time */
  createdAt: Instant;
  /** User's moderation state */
  state: UserState;
  /** Relationship with this user */
  relationship?: Relationship | null;
  /** Type of user entity: USER, CHANNEL, or CATEGORY */
  type?: UserType | null;
  /** Whether this is a channel or a user. Deprecated: use 'type' instead. */
  channel: boolean;
  /** Group ID if this is a group channel, group user or category. */
  groupId?: TypeId | null;
  /** Privacy of this channel/category in a group. */
  groupPrivacy?: GroupChannelPrivacy | null;
  /** Name of the channel inside a group */
  groupUserName?: string | null;
  /** true if this is primary group channel. */
  groupPrimary?: boolean | null;
  /** true if this is auto-subscribe group channel. */
  groupAutoSubscribe?: boolean | null;
  /** User's summary or bio */
  summary: string;
  /** User stats */
  stats?: UserStatsWrite;
  /** User fields */
  fields?: {
    [key: string]: UserField;
  };
  /** User's header */
  header?: Upload | null;
  deleted?: boolean | null;
  emojis?: Emoji[] | null;
  /** User's location, geo and name */
  location?: Location | null;
  /** User's timezone */
  timezone?: TimeZone | null;
  /** User's birthday */
  birthday?: Birthday | null;
  /** Software platform type (wellesley, mastodon, threads.net) */
  software: string;
  /** Additional metadata (color, styling) */
  meta?: UserMeta | null;
  /** Group avatar (only present for group channels) */
  groupAvatar?: Upload | null;
  /** Group name (only present for group channels) */
  groupName?: string | null;
  /** Group display name (only present for group channels) */
  groupDisplayName?: string | null;
  /** Whether this user is a person, application or a service */
  actorType?: ActorType | null;
  /** Sync state for remote users (null for local users). SHALLOW_SYNCED = profile fetched, SYNC_IN_PROGRESS = deep sync running, DEEP_SYNCED = full outbox fetched, DEEP_SYNC_FAILED = deep sync failed */
  syncState?: SyncState | null;
  /** When the last deep sync completed (null if never deep-synced) */
  deepSyncedAt?: Instant | null;
};
export type AccountWithUser = {
  /** Account details including email, login type, and creation date */
  account: Account;
  /** Non-empty list of users associated with this account. Most accounts have one user, but multiple users are supported. */
  users: UserFull[];
  /** ID of currently selected user. If not provided, the first user is selected */
  selectedUserId?: TypeId | null;
};
export type AccountWithUserWrite = {
  /** Account details including email, login type, and creation date */
  account: Account;
  /** Non-empty list of users associated with this account. Most accounts have one user, but multiple users are supported. */
  users: UserFullWrite[];
  /** ID of currently selected user. If not provided, the first user is selected */
  selectedUserId?: TypeId | null;
};
export type CaptchaVerificationParams = {
  /** Registration hash */
  hash: string;
  /** Captcha token */
  captchaToken: string;
};
export type CodeVerificationParams = {
  /** Registration hash */
  hash: string;
  /** Confirmation code */
  code: number;
};
export type ConfirmationCodeRequest = {
  /** Confirmation code */
  code: number;
};
export type EmailChangeRequest = {
  /** New email */
  newEmail: string;
  /** Current account password */
  password: string;
};
export type AccountWithUserAndToken = {
  account: Account;
  users: UserFull[];
  token: Token;
};
export type AccountWithUserAndTokenWrite = {
  account: Account;
  users: UserFullWrite[];
  token: Token;
};
export type FinishCreatingAccountParams = {
  /** Registration hash */
  hash: string;
  /** Another username */
  username?: string | null;
};
export type AddEmailRequest = {
  /** New email */
  email: string;
  /** New password, enforced by password policy */
  password: string;
};
export type AddPhoneRequest = {
  /** Phone number */
  phone: string;
  /** Confirmation code */
  code?: number | null;
};
export type PasswordChangeRequest = {
  /** Current account password */
  currentPassword: string;
  /** New password, enforced by password policy */
  newPassword: string;
};
export type PasswordRecoveryRequest = {
  /** Email or username */
  login: string;
};
export type PasswordRecoveryChange = {
  /** Email or username */
  login: string;
  /** New password, enforced by password policy */
  newPassword: string;
};
export type PasswordRecoveryCode = {
  /** Email or username */
  login: string;
  /** Confirmation code */
  code: number;
};
export type AccountCreate = {
  /** Username of the main user */
  username: string;
  /** Display Name of the main user */
  displayName: string;
  /** Accounts' email */
  email: string;
  /** Account password, enforced by password policy */
  password: string;
  /** Optional invite code */
  inviteCode?: string | null;
};
export type PhoneSignup = {
  /** Phone number */
  phone: string;
  /** Username of the main user */
  username: string;
  /** Display Name of the main user */
  displayName: string;
  /** Optional invite code */
  inviteCode?: string | null;
};
export type GroupStats = {
  /** Total number of posts */
  posts: number;
  /** Posts created in the last 24 hours */
  postsLast24h: number;
  /** Total number of comments */
  comments: number;
  /** Total uploaded bytes */
  totalStorageBytes: number;
  /** Average posts per day over the last 30 days */
  avgPostsPerDay: number;
  /** Average uploaded bytes per day over the last 30 days */
  avgBytesPerDay: number;
  /** Count of active members in the group */
  members: number;
  /** Total group events recorded */
  totalEvents: number;
};
export type GroupStatsWrite = {
  /** Total number of posts */
  posts: number;
  /** Posts created in the last 24 hours */
  postsLast24h: number;
  /** Total number of comments */
  comments: number;
  /** Total uploaded bytes */
  totalStorageBytes: number;
  /** Average posts per day over the last 30 days */
  avgPostsPerDay: number;
  /** Average uploaded bytes per day over the last 30 days */
  avgBytesPerDay: number;
  lastFlushVersion?: number | null;
  /** Count of active members in the group */
  members: number;
  /** Total group events recorded */
  totalEvents: number;
};
export type GroupMeta = {
  /** Group color in HEX format */
  color: string;
};
export type GroupPrivacy = "PUBLIC" | "PRIVATE";
export type GroupVisibility = "VISIBLE" | "UNLISTED" | "HIDDEN";
export type GroupJoinMode = "OPEN" | "APPROVAL" | "INVITE_ONLY";
export type GroupType = "CHANNEL" | "INTEREST_GROUP" | "ORGANIZATION";
export type Group = {
  /** Group statistics */
  stats?: GroupStats;
  /** group metadata including color */
  meta: GroupMeta;
  /** who can access the group's content */
  privacy: GroupPrivacy;
  /** how discoverable the group is */
  visibility: GroupVisibility;
  /** how users can join the group */
  joinMode: GroupJoinMode;
  /** group's location */
  location?: Location | null;
  /** group's timezone */
  timezone?: TimeZone | null;
  /** Whether the current viewer is a member of the group */
  isMember?: boolean | null;
  /** Pin order number if group is pinned by viewer (null if not pinned) */
  pin?: number | null;
  /** Whether the current viewer can manage this group (owner, admin, or moderator) */
  canManage?: boolean | null;
  /** Whether the current viewer is an owner or admin of this group */
  isOwner?: boolean | null;
  /** Viewer's roles in this group. Only populated in admin endpoints. */
  roles?: string[] | null;
  /** internal id of this group */
  groupId: TypeId;
  /** unique group name */
  groupName: string;
  /** Group's domain */
  domain: string;
  /** Whether this group is local to this server */
  local: boolean;
  /** full name of the group */
  displayName: string;
  /** Group description */
  summary: string;
  /** URI of this group */
  uri: string;
  /** Group's public key for ActivityPub */
  publicKey: string;
  /** ID of the forum associated with this group */
  forumId?: TypeId | null;
  /** Custom fields for the group */
  fields?: {
    [key: string]: UserField;
  };
  /** the type of this group */
  type: GroupType;
  /** URL to group members */
  membersUrl: string;
  /** Group's header/banner upload */
  banner?: Upload | null;
  /** Group's avatar */
  avatar?: Upload | null;
  /** Group deletion timestamp */
  deletedAt?: Instant | null;
  /** Group's creation timestamp */
  createdAt?: Instant;
  /** Group's last update timestamp */
  updatedAt?: Instant;
  /** Group's last refresh timestamp */
  refreshedAt?: Instant;
  secret?: boolean;
};
export type GroupWrite = {
  /** Group statistics */
  stats?: GroupStatsWrite;
  /** group metadata including color */
  meta: GroupMeta;
  /** who can access the group's content */
  privacy: GroupPrivacy;
  /** how discoverable the group is */
  visibility: GroupVisibility;
  /** how users can join the group */
  joinMode: GroupJoinMode;
  /** group's location */
  location?: Location | null;
  /** group's timezone */
  timezone?: TimeZone | null;
  /** Whether the current viewer is a member of the group */
  isMember?: boolean | null;
  /** Pin order number if group is pinned by viewer (null if not pinned) */
  pin?: number | null;
  /** Whether the current viewer can manage this group (owner, admin, or moderator) */
  canManage?: boolean | null;
  /** Whether the current viewer is an owner or admin of this group */
  isOwner?: boolean | null;
  /** Viewer's roles in this group. Only populated in admin endpoints. */
  roles?: string[] | null;
  /** internal id of this group */
  groupId: TypeId;
  /** unique group name */
  groupName: string;
  /** Group's domain */
  domain: string;
  /** Whether this group is local to this server */
  local: boolean;
  /** full name of the group */
  displayName: string;
  /** Group description */
  summary: string;
  /** URI of this group */
  uri: string;
  /** Group's public key for ActivityPub */
  publicKey: string;
  /** Group's private key for ActivityPub */
  privateKey?: string | null;
  /** ID of the forum associated with this group */
  forumId?: TypeId | null;
  /** Custom fields for the group */
  fields?: {
    [key: string]: UserField;
  };
  /** the type of this group */
  type: GroupType;
  /** URL to group members */
  membersUrl: string;
  /** Group's header/banner upload */
  banner?: Upload | null;
  /** Group's avatar */
  avatar?: Upload | null;
  /** Group deletion timestamp */
  deletedAt?: Instant | null;
  /** Group's creation timestamp */
  createdAt?: Instant;
  /** Group's last update timestamp */
  updatedAt?: Instant;
  /** Group's last refresh timestamp */
  refreshedAt?: Instant;
  secret?: boolean;
};
export type UserWithOwnedGroups = {
  /** User details */
  user: UserFull;
  /** Groups owned by this user */
  ownedGroups: Group[];
};
export type UserWithOwnedGroupsWrite = {
  /** User details */
  user: UserFullWrite;
  /** Groups owned by this user */
  ownedGroups: GroupWrite[];
};
export type AccountUsersWithOwnedGroups = {
  /** Account details */
  account: Account;
  /** Users under this account with their owned groups */
  users: UserWithOwnedGroups[];
  /** Currently selected user ID for this account */
  selectedUserId?: TypeId | null;
};
export type AccountUsersWithOwnedGroupsWrite = {
  /** Account details */
  account: Account;
  /** Users under this account with their owned groups */
  users: UserWithOwnedGroupsWrite[];
  /** Currently selected user ID for this account */
  selectedUserId?: TypeId | null;
};
export type AddressData = {
  /** Formatted address */
  formatted: string;
  /** Name */
  name?: string | null;
  /** Country */
  country?: string | null;
  /** Country two letter name */
  countryCode?: string | null;
  /** Region */
  region?: string | null;
  /** Region Code */
  regionCode?: string | null;
  /** Sub-region */
  subRegion?: string | null;
  /** Locality */
  locality?: string | null;
  /** Street */
  street?: string | null;
  /** Address postal code */
  postalCode?: string | null;
  /** House number */
  houseNumber?: string | null;
  /** Longitude */
  longitude?: number | null;
  /** Latitude */
  latitude?: number | null;
  /** Time zone name */
  timeZone?: string | null;
  /** Short code */
  plusCode?: string | null;
  /** Service ID */
  serviceId?: string | null;
  /** Service place id */
  placeId?: string | null;
};
export type Language =
  | "BG"
  | "CS"
  | "DA"
  | "DE"
  | "EL"
  | "EN"
  | "ES"
  | "ET"
  | "FI"
  | "FR"
  | "HU"
  | "ID"
  | "IT"
  | "JA"
  | "KO"
  | "LT"
  | "LV"
  | "NB"
  | "NL"
  | "PL"
  | "PT"
  | "RO"
  | "RU"
  | "SK"
  | "SL"
  | "SV"
  | "TR"
  | "UK"
  | "ZH";
export type AuditLogGroup =
  | "ACCOUNT"
  | "USER"
  | "APP"
  | "RULE"
  | "SIGNUP"
  | "POST"
  | "DOMAIN_BLOCK"
  | "EMAIL_BLOCK"
  | "EMAIL_ALLOW"
  | "GROUP"
  | "GROUP_MEMBER"
  | "GROUP_QUESTION"
  | "GROUP_BLOCK"
  | "REPORT"
  | "SERVICE"
  | "AIAGENT"
  | "AIAGENT_JOB"
  | "AIAGENT_SIGNAL"
  | "FASP"
  | "FASP_REMOTE"
  | "EMBEDDING"
  | "FEDERATION";
export type AuditLogAction =
  | "CREATE"
  | "UPDATE"
  | "DELETE"
  | "PURGE"
  | "ROLE_CHANGE"
  | "USERNAME_CHANGE"
  | "EMAIL_CHANGE"
  | "PHONE_CHANGE"
  | "STATE_CHANGE"
  | "APPROVE"
  | "REJECT"
  | "BLOCK"
  | "DEPLOY"
  | "INSTALL"
  | "ENABLE"
  | "DISABLE"
  | "IMPERSONATE_REQUEST"
  | "IMPERSONATE"
  | "ACTION"
  | "JOIN"
  | "LEAVE"
  | "INVITE"
  | "JOIN_REQUEST"
  | "TOKEN_ROTATE";
export type InetAddress = {
  multicastAddress?: boolean;
  anyLocalAddress?: boolean;
  loopbackAddress?: boolean;
  linkLocalAddress?: boolean;
  siteLocalAddress?: boolean;
  MCGlobal?: boolean;
  MCNodeLocal?: boolean;
  MCLinkLocal?: boolean;
  MCSiteLocal?: boolean;
  MCOrgLocal?: boolean;
  hostName?: string;
  address?: Blob;
  hostAddress?: string;
};
export type Executor = {
  /** ID of the account that performed the action */
  accountId?: TypeId | null;
  /** ID of the user that performed the action */
  userId?: TypeId | null;
  /** Username of the user that performed the action */
  username?: string | null;
  /** Name of the service that performed the action */
  serviceName?: string | null;
};
export type AuditLogRecord = {
  /** Group of the audit log */
  logGroup: AuditLogGroup;
  /** Action performed in the audit log */
  logAction: AuditLogAction;
  /** Timestamp when the action happened */
  happenedAt: Instant;
  /** IP address from which the action was performed */
  ip: InetAddress;
  /** Entity that executed the action */
  executor: Executor;
  /** Additional data related to the action */
  data: {
    [key: string]: any;
  };
};
export type AuditLogResult = {
  /** List of audit log records */
  list: AuditLogRecord[];
  /** Total number of records matching the query */
  total: number;
};
export type RoleId = string;
export type UserCreate = {
  /** Username */
  username: string;
  /** Display Name */
  displayName: string;
  /** User's bio */
  summary?: string | null;
  /** Avatar upload id or null to remove */
  avatarId?: TypeId | null;
  /** Header upload id or null to remove */
  headerId?: TypeId | null;
  /** User's role */
  actorType?: ActorType | null;
  /** Type of user entity: USER, CHANNEL, or CATEGORY */
  userType?: UserType;
};
export type AllowedDomain = {
  /** The domain name that is allowed to federate with this instance */
  domain: string;
  /** Timestamp when the domain was added to the allowlist */
  createdAt: Instant;
};
export type AllowedDomainReq = {
  /** The domain name to add to the allowlist */
  domain: string;
};
export type DomainBlockState = "SUSPEND" | "LIMIT" | "NOOP";
export type BlockDomainReq = {
  /** Domain to block. Can be subdomain, i.e. example.com will block sub.example.com */
  domain: string;
  /** A comment visible to the general public */
  publicComment: string;
  state?: DomainBlockState;
  /** Rejects any media coming from the domain and removes already downloaded. Ignored for SUSPEND */
  rejectMedia?: boolean;
  /** Ignore all reports coming from this domain. Ignored for SUSPEND */
  rejectReports?: boolean;
  /** Comment available only for moderators */
  privateComment?: string;
  /** Partially obfuscate the domain name in the list */
  obfuscate?: boolean;
};
export type BlockedDomain = {
  /** The blocked domain name. May be obfuscated in public endpoints if obfuscate flag is set. */
  domain: string;
  /** Public-facing comment explaining why the domain was blocked */
  publicComment: string;
  /** The severity level of the domain block */
  state: "SUSPEND" | "LIMIT" | "NOOP";
  /** Whether to reject and remove media files from this domain */
  rejectMedia: boolean;
  /** Whether to ignore reports coming from this domain */
  rejectReports: boolean;
  /** Internal comment visible only to moderators and administrators */
  privateComment: string;
  /** Whether to partially obfuscate the domain name in public listings */
  obfuscate: boolean;
  /** Timestamp when the domain block was created */
  createdAt: Instant;
  /** Timestamp when the domain block was last updated */
  updatedAt: Instant;
};
export type EmailBlock = {
  /** The normalized email pattern that is blocked. Can be a specific email or a domain */
  pattern: string;
  /** The reason why this email pattern was blocked */
  reason: string;
  /** Timestamp when the email block was created */
  createdAt: Instant;
};
export type BlockEmailRequest = {
  /** Email pattern to block (can be full email or domain) */
  pattern: string;
  /** Reason for blocking this email pattern */
  reason: string;
};
export type RecalculationStatus =
  | "IDLE"
  | "PENDING"
  | "RUNNING"
  | "COMPLETED"
  | "CANCELLED"
  | "FAILED";
export type RecalculationInfo = {
  /** Job status */
  status: RecalculationStatus;
  /** Posts processed so far */
  processedPosts: number;
  /** Total posts to process in this job */
  totalToProcess: number;
  /** When the job started */
  startedAt: Instant | null;
  /** Estimated seconds remaining (null if not calculable) */
  estimatedSecondsRemaining: number | null;
  /** Error message if job failed */
  errorMessage: string | null;
};
export type EmbeddingStatus = {
  /** Whether embeddings are enabled */
  enabled: boolean;
  /** Current model ID (null if not configured) */
  modelId: TypeId | null;
  /** Current model external ID (e.g., text-embedding-3-small) */
  modelExternalId: string | null;
  /** Current model name */
  modelName: string | null;
  /** Current vector dimensions */
  vectorDimensions: number | null;
  /** Total posts in the system */
  totalPosts: number;
  /** Posts that have embeddings */
  postsWithEmbeddings: number;
  /** Posts that need embeddings generated */
  postsNeedingEmbeddings: number;
  /** Current recalculation job progress (null if no job running) */
  recalculation: RecalculationInfo | null;
};
export type EmbeddingCostEstimate = {
  /** Model ID used for estimation */
  modelId: TypeId;
  /** Model external ID (e.g., text-embedding-3-small) */
  modelExternalId: string;
  /** Model name */
  modelName: string;
  /** Number of posts to process */
  postsToProcess: number;
  /** Estimated total tokens */
  estimatedTokens: number;
  /** Estimated cost in USD */
  estimatedCostUsd: number;
  /** Price per 1M input tokens in USD */
  inputPer1MTokens: number | null;
  /** Vector dimensions for this model */
  vectorDimensions: number;
  /** Whether this is a full recalculation (new model) or partial (only missing embeddings) */
  isFullRecalculation: boolean;
};
export type FaspBackfill = {
  /** Server ID on the FASP system */
  serverId: string;
  /** Domain of the server */
  serverDomain: string;
  /** Remote backfill ID */
  remoteId: string;
  /** Backfill category (content, account, group) */
  category: string;
  /** Maximum count of items to backfill */
  maxCount: number;
  /** Whether the backfill has been fulfilled */
  fulfilled: boolean;
  /** Number of items synced during the backfill */
  syncedCount: number;
  /** When the backfill was created */
  createdAt: string;
  /** When the backfill was last updated */
  updatedAt: string;
};
export type FaspBackfillsResponse = {
  /** List of backfill requests */
  backfills: FaspBackfill[];
};
export type FaspBlocklistResponse = {
  /** List of blocked domains */
  domains: string[];
};
export type FaspRemoteConfigResponse = {
  /** Whether FASP remote is configured */
  configured: boolean;
  /** Base URL of the FASP server */
  baseUrl?: string | null;
  /** Friendly name for the FASP server */
  serverName?: string | null;
  /** Masked admin token (first 8 chars + ...) */
  adminTokenMasked?: string | null;
  /** When this configuration was set */
  configuredAt?: Instant | null;
};
export type ConfigureFaspRemoteRequest = {
  /** Base URL of the FASP server */
  baseUrl: string;
  /** Admin token for authentication */
  adminToken: string;
  /** Friendly name for the FASP server */
  serverName?: string | null;
};
export type FaspServerStatus = "pending" | "approved" | "blocked";
export type FaspServerRegistration = {
  /** Server ID on the FASP system */
  id: string;
  /** Base URL of the registered server */
  baseUrl: string;
  /** Domain of the registered server */
  domain: string;
  /** Registration status */
  status: FaspServerStatus;
  /** Contact email for the server */
  email?: string | null;
  /** Server capabilities */
  capabilities?: string[];
};
export type FaspRegistrationsResponse = {
  /** List of server registrations */
  registrations: FaspServerRegistration[];
};
export type BackfillRequest1 = {
  /** Category to backfill (content/account/group; aliases: posts/users/groups) */
  category: string;
};
export type TokenRotationConfirmResponse = {
  /** Whether the token rotation was successful */
  success: boolean;
  /** Masked new admin token */
  newTokenMasked?: string | null;
};
export type TokenRotationConfirmRequest = {
  /** Verification code received via email */
  code: string;
};
export type FaspSubscriptionThreshold = {
  /** Timeframe in minutes */
  timeframe?: number | null;
  /** Share count threshold */
  shares?: number | null;
  /** Like count threshold */
  likes?: number | null;
  /** Reply count threshold */
  replies?: number | null;
};
export type FaspRemoteSubscription = {
  /** Server ID on the FASP system */
  serverId: string;
  /** Domain of the server */
  serverDomain: string;
  /** Remote subscription ID */
  remoteId: string;
  /** Subscription category (content, account, group) */
  category: string;
  /** Subscription type (lifecycle, trends) */
  subscriptionType: string;
  /** Maximum batch size for notifications */
  maxBatchSize?: number | null;
  /** Threshold configuration */
  threshold?: FaspSubscriptionThreshold | null;
};
export type FaspSubscriptionsResponse = {
  /** List of subscriptions */
  subscriptions: FaspRemoteSubscription[];
};
export type TokenRecoverRequest = {
  /** Admin email address for recovery */
  email: string;
};
export type TokenRecoverConfirmRequest = {
  /** Admin email address */
  email: string;
  /** Verification code received via email */
  code: string;
};
export type FaspUpdateCheckResponse = {
  /** Current app version */
  currentVersion?: string | null;
  /** Build number */
  buildNumber?: string | null;
  /** Docker image repository */
  imageRepo?: string | null;
  /** Current image tag */
  currentImageTag?: string | null;
  /** Tag used for update checking */
  updateCheckTag?: string | null;
  /** Current FASP server image digest (nullable when unavailable) */
  currentDigest?: string | null;
  /** Latest available image digest (nullable when unavailable) */
  latestDigest?: string | null;
  /** Latest version tag from the registry */
  latestTag?: string | null;
  /** Whether an update is available (nullable when unknown) */
  updateAvailable?: boolean | null;
  /** When the update was last checked */
  checkedAt?: string | null;
  /** Error message from update check */
  error?: string | null;
};
export type FaspProviderState = "PENDING" | "ACCEPTED" | "BLOCKED";
export type FaspDefaultProviderView = {
  /** Capability name */
  capability: string;
  /** Provider ID */
  providerId: number;
  /** Provider name */
  providerName: string;
  /** Provider state */
  providerState: FaspProviderState;
  /** When the default was created */
  createdAt: Instant;
  /** When the default was last updated */
  updatedAt: Instant;
};
export type FaspDefaultsResponse = {
  /** List of default providers */
  defaults: FaspDefaultProviderView[];
};
export type SetDefaultRequest = {
  /** Provider ID to set as default */
  providerId: number;
};
export type CapabilityView = {
  /** Capability ID */
  id: string;
  /** Capability version */
  version: string;
  /** Whether capability is enabled */
  enabled: boolean;
};
export type Category1 = "content" | "account" | "group" | "unknown";
export type SubscriptionType = "lifecycle" | "trends";
export type SubscriptionView = {
  /** Subscription ID */
  id: number;
  /** Content category */
  category: Category1;
  /** Subscription type */
  subscriptionType: SubscriptionType;
  /** When the subscription was created */
  createdAt: Instant;
  /** When the subscription was last updated */
  updatedAt: Instant;
};
export type BackfillView = {
  /** Backfill request ID */
  id: number;
  /** Content category */
  category: Category1;
  /** Whether backfill is fulfilled */
  fulfilled: boolean;
  /** Number of items processed */
  processedCount: number;
  /** When the backfill was requested */
  createdAt: Instant;
  /** When the backfill was last updated */
  updatedAt: Instant;
};
export type FaspProviderView = {
  /** Provider ID */
  id: number;
  /** Provider state */
  state: FaspProviderState;
  /** Provider name */
  name: string;
  /** Provider base URL */
  baseUrl: string;
  /** Provider sign-in URL */
  signInUrl: string | null;
  /** Provider capabilities */
  capabilities: CapabilityView[];
  /** Contact email */
  contactEmail: string | null;
  /** Fediverse account */
  fediverseAccount: string | null;
  /** Active subscriptions for this provider */
  subscriptions: SubscriptionView[];
  /** Backfill requests for this provider */
  backfills: BackfillView[];
  /** When the last client error occurred (null = healthy) */
  lastErrorAt: Instant | null;
  /** When the provider was registered */
  createdAt: Instant;
  /** When the provider was last updated */
  updatedAt: Instant;
};
export type FaspProvidersResponse = {
  /** List of FASP providers */
  providers: FaspProviderView[];
};
export type BackfillRequest = {
  /** Content category to backfill */
  category: Category1;
};
export type Capability = {
  id: string;
  version: string;
  enabled?: boolean;
};
export type ServersResultInfo = {
  domain: string;
  users: number;
  /** N of days federation has been unavailable for this domain */
  failureDays: number;
  available: boolean;
  /** Whether it's whitelisted when limited federation mode is on */
  allowed: boolean;
  blocked: DomainBlockState | null;
  reports: number;
  /** Whether media files from this domain are rejected */
  rejectMedia?: boolean | null;
  /** Whether reports from this domain are rejected */
  rejectReports?: boolean | null;
};
export type Duration = number;
export type ServersResult = {
  list: ServersResultInfo[];
  total: number;
  /** Duration in seconds */
  failureThreshold: Duration;
};
export type FederationMode = "OPEN" | "LIMITED" | "CLOSED";
export type FederationConfigResponse = {
  /** Current federation mode */
  mode: FederationMode;
  /** Current allowlist */
  allowlist: string[];
};
export type FederationConfigRequest = {
  /** Target federation mode */
  mode: FederationMode;
  /** Full allowlist to apply */
  allowlist: string[];
  /** Whether to purge all non-allowlisted content after applying updates */
  purgeNonAllowlisted?: boolean;
};
export type WindowSize = "TEN_MINUTES" | "ONE_HOUR" | "TWENTY_FOUR_HOURS";
export type SlidingWindowMetrics = {
  /** Average duration in milliseconds for operations in this window */
  average: number;
  /** Total number of operations recorded in this window */
  count: number;
  /** Sum of all operation durations in milliseconds */
  totalTime: number;
  /** When the last metric was added to this window */
  lastUpdated: Instant;
  /** The operation name being tracked */
  operation: string;
  /** When this window was created (first metric timestamp) */
  windowCreated: Instant;
};
export type FederationModeResponse = {
  /** Current federation mode */
  mode: FederationMode;
};
export type FederationModeRequest = {
  /** Target federation mode */
  mode: FederationMode;
};
export type ServerInfo = {
  users: number;
  posts: number;
  /** N of remote users who are being followed from this server */
  followers: number;
  /** N of local users who follow users on this domain */
  followings: number;
  /** N of reports against users of this domain */
  reports: number;
  /** Whether it's whitelisted when limited federation mode is on */
  available: boolean;
  /** N of days federation has been unavailable for this domain */
  failureDays: number;
  /** Duration in seconds */
  failureThreshold: Duration;
  blocked?: BlockedDomain | null;
};
export type FeedType = "home";
export type UserFeedCountResponse = {
  userId: TypeId;
  username: string;
  cachedPostCount: number;
  feedType: FeedType;
};
export type FeedCompareResult = {
  redisIds: TypeId[];
  dbIds: TypeId[];
  onlyInRedis: TypeId[];
  onlyInDb: TypeId[];
  orderMismatch: boolean;
  matchesExact: boolean;
  redisCount: number;
  dbCount: number;
};
export type FeedOperation =
  | "populate"
  | "merge"
  | "unmerge"
  | "redis"
  | "redisLex"
  | "cache"
  | "idsDb"
  | "db"
  | "add"
  | "remove";
export type GlobalAggregatedMetrics = {
  globalAverage: number;
  totalMeasurements: number;
  totalTime: number;
  userCount: number;
  lastUpdated: Instant;
  operation: FeedOperation;
};
export type FeedMetrics = {
  time: number;
  count: number;
  op: FeedOperation;
  ts: Instant;
};
export type SlowestOperationsResponse = {
  slowestOperations: GlobalAggregatedMetrics[];
  totalOperationsAnalyzed: number;
};
export type UserMetrics = object;
export type SlowestUsersResponse = {
  slowestUsers: UserMetrics[];
  operation: FeedOperation | null;
  limit: number;
};
export type UserPerformanceMetrics = {
  userId: TypeId;
  averageTime: number;
  totalMeasurements: number;
};
export type MetricsSummaryTotals = {
  totalMeasurements: number;
  totalTime: number;
  overallAverage: number;
  operationCount: number;
};
export type MetricsSummary = {
  operationMetrics: GlobalAggregatedMetrics[];
  totals: MetricsSummaryTotals;
};
export type UserCountResponse = {
  operation: FeedOperation;
  userCount: number;
};
export type CategoryMeta = {
  /** Category color in HEX format */
  color: string;
};
export type Category = {
  id: TypeId;
  forumId: TypeId;
  name: string;
  displayName: string;
  description: string;
  meta?: CategoryMeta;
  tagsAllowed: string[];
  /** Aggregated stats for this category */
  stats: UserStats;
};
export type CategoryWrite = {
  id: TypeId;
  forumId: TypeId;
  name: string;
  displayName: string;
  description: string;
  meta?: CategoryMeta;
  tagsAllowed: string[];
  /** Aggregated stats for this category */
  stats: UserStatsWrite;
};
export type User = {
  /** internal id of this user */
  id: TypeId;
  /** unique user name */
  username: string;
  /** User's domain */
  domain: string;
  /** Whether this user is local to this server */
  local: boolean;
  /** full name of the user */
  displayName: string;
  /** URI of this user */
  uri: string;
  /** User's avatar */
  avatar?: Upload | null;
  /** User's creation time */
  createdAt: Instant;
  /** User's moderation state */
  state: UserState;
  /** Relationship with this user */
  relationship?: Relationship | null;
  /** Type of user entity: USER, CHANNEL, or CATEGORY */
  type?: UserType | null;
  /** Whether this is a channel or a user. Deprecated: use 'type' instead. */
  channel: boolean;
  /** Group ID if this is a group channel, group user or category. */
  groupId?: TypeId | null;
  /** Privacy of this channel/category in a group. */
  groupPrivacy?: GroupChannelPrivacy | null;
  /** Name of the channel inside a group */
  groupUserName?: string | null;
  /** true if this is primary group channel. */
  groupPrimary?: boolean | null;
  /** true if this is auto-subscribe group channel. */
  groupAutoSubscribe?: boolean | null;
  /** Whether this user is a person, application or a service */
  actorType?: ActorType | null;
  deleted?: boolean | null;
  /** Additional metadata (color, styling) */
  meta?: UserMeta | null;
  /** Group avatar (only present for group channels) */
  groupAvatar?: Upload | null;
  /** Group name (only present for group channels) */
  groupName?: string | null;
  /** Group display name (only present for group channels) */
  groupDisplayName?: string | null;
};
export type EventStats = {
  interests: number;
  joins: number;
};
export type EventStatus = "CONFIRMED" | "CANCELLED";
export type EventAttendeeStatus =
  | "INVITED"
  | "JOINED"
  | "JOINED_TENTATIVELY"
  | "REJECTED";
export type PostPrivacy =
  | "PUBLIC"
  | "UNLISTED"
  | "PRIVATE"
  | "DIRECT"
  | "FOLLOW_POST"
  | "HIDDEN";
export type EventTranslation = {
  name: string;
  descriptionHtml: string | null;
};
export type Event = {
  /** Internal event id */
  id: TypeId;
  /** Unique event uri */
  uri: string;
  /** Group id */
  groupId?: TypeId | null;
  /** Event's name */
  name: string;
  /** Event's start time */
  startTime: Instant;
  /** Event's end time */
  endTime?: Instant | null;
  /** Event's IANA time zone */
  ianaTimeZone?: string | null;
  /** Event's time zone offset (in seconds) */
  timeZoneOffsetSeconds: number;
  /** Event's Markdown description (absent for non-local events) */
  description?: string | null;
  /** Event's HTML description */
  descriptionHtml?: string | null;
  /** Event's virtual location URL */
  url?: string | null;
  /** Event's address id */
  addressId?: number | null;
  /** Event's tags */
  tags?: string[] | null;
  /** Event's mentions */
  mentions?: string[] | null;
  /** Stats */
  stats: EventStats;
  /** Event status */
  status: EventStatus;
  /** Viewer user's event attendance status */
  attendeeStatus?: EventAttendeeStatus | null;
  /** Event comment count */
  commentCount?: number | null;
  privacy: PostPrivacy;
  translation: EventTranslation | null;
  createdAt: Instant;
  updatedAt: Instant;
  deletedAt: Instant | null;
  lang: Language | null;
  organizer: User;
  cover: Upload | null;
  address: AddressData | null;
  emojis?: Emoji[] | null;
};
export type ConfigureRequest = {
  /** Base URL of the remote link provider (must include http:// or https://) */
  url: string;
};
export type PostDelete = {
  /** ID of a specific post to delete. Mutually exclusive with reportId. */
  postId?: TypeId | null;
  /** ID of a report whose associated posts should be deleted. Mutually exclusive with postId. */
  reportId?: TypeId | null;
  /** Reason for deleting the post(s). Will be recorded in audit logs and report notes. */
  reason: string;
};
export type Uuid = string;
export type ReportState = "OPEN" | "UNDER_REVIEW" | "DISMISSED" | "RESOLVED";
export type ReportNote = {
  /** User who added the note */
  userId: TypeId;
  /** Note text */
  note: string;
  /** When the note was added */
  createdAt: Instant;
  /** User who added the note (populated) */
  user?: User | null;
};
export type PostKind = "Note" | "Article";
export type PostOwnerType = "USER" | "EVENT" | "CATEGORY";
export type PostStats = {
  likes?: number;
  reposts?: number;
  quotes?: number;
  comments?: number;
  views?: number;
  bookmarks?: number;
  reactions?: {
    [key: string]: number;
  };
  watchTime?: number | null;
  secondsToFirstAnswer?: number | null;
  secondsToAccepted?: number | null;
  lastActivity?: Instant;
  lastViewTimestamp?: Instant;
};
export type PostSettings = {
  commentsEnabled?: boolean;
  sensitive?: boolean;
  hiddenFrom?: PostPrivacy | null;
};
export type PollOption = {
  title: string;
  votesCount: number;
};
export type Poll = {
  /** Internal poll id */
  id: TypeId;
  /** Time when poll starts. Poll is valid from startedAt until expiresAt. */
  startedAt: Instant;
  expiresAt: Instant | null;
  multiple: boolean;
  votersCount: number;
  options: PollOption[];
  hideTotals: boolean;
  ownVotes?: number[] | null;
  emojis?: Emoji[] | null;
};
export type Publisher = {
  name: string | null;
  url: string | null;
  logo?: string | null;
  type?: string | null;
};
export type Card = {
  /** URL being referenced */
  url: string | null;
  /** Title of the linked resource */
  title: string | null;
  /** Description of the linked resource */
  description: string | null;
  /** Favicon URL */
  icon: string | null;
  /** Preview image URL */
  image: string | null;
  /** Alt text for the preview image */
  imageAlt: string | null;
  /** Information about the website/provider */
  publisher: Publisher | null;
  /** HTML snippet to embed the link (from oEmbed), e.g., an iframe */
  oembedHtml?: string | null;
  /** When the card data was fetched/created */
  createdAt: Instant;
  /** When the card data should be considered stale */
  expiresAt: Instant | null;
};
export type PostMediaType = "TEXT_PLAIN" | "MARKDOWN";
export type UserLite = {
  id: TypeId;
  displayName: string;
  username: string;
  domain: string;
};
export type PostVotesSummary = {
  /** upvotes count */
  upvotes: number;
  /** downvotes count */
  downvotes: number;
  /** current user's vote, if any */
  ownVote?: number | null;
};
export type Type =
  | "USER"
  | "ACCOUNT"
  | "APP"
  | "APP_DATA"
  | "POST"
  | "POLL"
  | "FORUM"
  | "CATEGORY"
  | "TAG"
  | "TAG_REPORT"
  | "USER_LIST"
  | "NOTIFICATION"
  | "REPORT"
  | "REPORT_COMMENT"
  | "RULE"
  | "QUESTION"
  | "ANSWER"
  | "GROUP"
  | "DRAFT"
  | "UPLOAD"
  | "FILE"
  | "UPLOAD_ACTION"
  | "UPLOAD_JOB"
  | "EXECUTION"
  | "EMPLOYEE_PROFILE"
  | "EMPLOYER_PROFILE"
  | "JOB_POSTING"
  | "JOB_APPLICATION"
  | "MEMBER_LIST"
  | "RBAC_ROLE"
  | "JOIN_REQUEST"
  | "GROUP_INVITE"
  | "EVENT"
  | "AI_PROVIDER"
  | "AI_MODEL"
  | "AI_JOB"
  | "AI_SIGNAL"
  | "AI_SCOPED_PROVIDER"
  | "AI_SCOPED_MODEL"
  | "EMBEDDING_RECALC"
  | "ASYNC_REFRESH"
  | "QUOTE_AUTH"
  | "EMPTY";
export type PostPublisher = {
  /** Publisher id (user id for channels, group id for groups) */
  id: TypeId;
  /** Publisher type (USER or GROUP) */
  type: Type;
  /** Publisher username (channel username or group name) */
  username: string;
  /** Publisher display name */
  displayName: string;
  /** Publisher domain */
  domain: string;
  /** Publisher avatar (channel avatar or group avatar) */
  avatar?: Upload | null;
  /** Group avatar (only present for group channels) */
  groupAvatar?: Upload | null;
  /** Group name (only present for group channels) */
  groupName?: string | null;
  /** Group display name (only present for group channels) */
  groupDisplayName?: string | null;
  /** Channel privacy within a group (PUBLIC or PRIVATE) */
  groupPrivacy?: GroupChannelPrivacy | null;
  /** Channel username within a group (only present for group channels) */
  groupUserName?: string | null;
};
export type QuotePolicyLevel = "PUBLIC" | "FOLLOWERS" | "NOBODY";
export type QuoteApproval = {
  /** Effective quote policy for this post */
  policy: QuotePolicyLevel;
  /** Categories that get automatic approval (e.g. 'public', 'followers') */
  automatic: string[];
  /** Categories that require manual approval */
  manual: string[];
  /** Current user's approval status: 'automatic', 'manual', or null */
  currentUser?: string | null;
};
export type Post = {
  /** internal post id */
  id: TypeId;
  /** unique post uri */
  uri: string;
  /** post text, raw or html depending on how it was requested */
  text: string;
  /** replies path */
  path: TypeId[];
  /** post privacy level */
  privacy: PostPrivacy;
  /** Resolved privacy that never contains FOLLOW_POST. For FOLLOW_POST posts, this is the root post's privacy. For all other posts, this equals privacy. */
  effectivePrivacy: PostPrivacy;
  /** Article or Note */
  kind: PostKind;
  /** post software */
  software: string;
  /** id of a post this one was reposted from */
  repostOf?: TypeId | null;
  ownerId: TypeId;
  ownerType: PostOwnerType;
  groupId: TypeId | null;
  title: string | null;
  /** Subject or summary line, below which post content is collapsed until expanded. */
  summary?: string | null;
  /** List of tags */
  tags: string[];
  /** List of mentions */
  mentions: string[];
  /** Stats */
  stats: PostStats;
  /** Settings */
  settings: PostSettings;
  lang: Language | null;
  poll: Poll | null;
  /** Preview card for any links in the post */
  card: Card | null;
  /** Post media type. Default for Note is text/plain, for Article text/markdown */
  mediaType: PostMediaType;
  translations: {
    [key: string]: string;
  } | null;
  createdAt: Instant;
  updatedAt: Instant;
  author: User;
  uploads: Upload[];
  /** Whether the current user liked it or not */
  liked?: boolean | null;
  /** Whether the current user reposted it or not */
  reposted?: boolean | null;
  /** Whether the current user quoted it or not */
  quoted?: boolean | null;
  /** Whether the current user muted the author of the post */
  muted?: boolean | null;
  /** Whether the current user blocked the author of the post */
  blocked?: boolean | null;
  /** Whether the current user can see it or not (e.g. FOLLOWERS_ONLY */
  visible?: boolean | null;
  /** Whether the current user pinned it or not */
  pinned?: boolean | null;
  /** Timestamp when the post was pinned/highlighted (from post_pins) */
  pinnedAt?: Instant | null;
  /** Whether the current user bookmarked it or not */
  bookmarked?: boolean | null;
  /** Whether the current user is subscribed to post updates */
  subscribed?: boolean | null;
  /** Whether the post was edited */
  edited?: boolean | null;
  deleted: boolean | null;
  emojis?: Emoji[] | null;
  replies?: Post[] | null;
  /** List of users who reposted this post */
  repostedBy?: UserLite[] | null;
  /** Original post of repost/quote (the post being reposted or quoted). Related to repostOf field. */
  originalPost?: Post | null;
  /** Parent post for comments/replies. Related to replyTo (last element in path). */
  parent?: Post | null;
  /** Votes summary */
  votes?: PostVotesSummary | null;
  /** Publisher context for mixed-scope lists (e.g. search). Contains channel or group branding. */
  publisher?: PostPublisher | null;
  /** Whether this is a copy of a highlighted (pinned) reply
                    (used to surface deep (2nd+ lvl) highlights under the root post). */
  isHighlightCopy?: boolean | null;
  /** Quote approval policy info, including viewer's approval status */
  quoteApproval?: QuoteApproval | null;
  /** Post location */
  address?: AddressData | null;
  replyTo?: TypeId | null;
  conversationId?: TypeId;
};
export type ReportType =
  | "SPAM"
  | "SERVER_RULES"
  | "GROUP_RULES"
  | "ILLEGAL"
  | "OTHER";
export type ReportComment = {
  /** Comment ID */
  id: TypeId;
  /** Report this comment belongs to */
  reportId: TypeId;
  /** User who submitted this report (local or remote) */
  userId: TypeId;
  /** The report comment/reason text */
  comment: string;
  /** Type/reason for the report */
  type: ReportType;
  /** Attachment upload IDs */
  uploadIds?: TypeId[];
  /** When this comment was created */
  createdAt: Instant;
  /** User who submitted this report (populated) */
  user?: User | null;
  /** Attachments (populated) */
  uploads?: Upload[] | null;
};
export type Report = {
  /** Internal report ID */
  id: TypeId;
  /** Report URI */
  uri: string;
  /** Target being reported (post, user, or group TypeId) */
  targetId: TypeId;
  /**
                Report scope.
                If null the scope is global (server admins handle it).
                If set the scope is group (group admins handle it).
             */
  groupId: TypeId | null;
  /** Current state of the report */
  state: ReportState;
  /** Moderator assigned to handle the report */
  assignedUserId: TypeId | null;
  /** Moderator who took action on the report */
  actionTakenBy: TypeId | null;
  /** When action was taken on the report */
  actionTakenAt: Instant | null;
  /** Whether this report was forwarded via ActivityPub */
  forwarded: boolean;
  /** Internal admin notes */
  notes?: ReportNote[];
  /** When the report was created */
  createdAt: Instant;
  /** When the report was last updated */
  updatedAt: Instant;
  /** Target post (if targetId is a post) */
  post?: Post | null;
  /** Target user (if targetId is a user) */
  targetUser?: User | null;
  /** Target group (if targetId is a group) */
  targetGroup?: Group | null;
  /** Assigned admin (populated) */
  assignedUser?: User | null;
  /** Report comments/submissions from users */
  comments?: ReportComment[] | null;
};
export type ReportWrite = {
  /** Internal report ID */
  id: TypeId;
  /** Report URI */
  uri: string;
  /** Target being reported (post, user, or group TypeId) */
  targetId: TypeId;
  /**
                Report scope.
                If null the scope is global (server admins handle it).
                If set the scope is group (group admins handle it).
             */
  groupId: TypeId | null;
  /** Current state of the report */
  state: ReportState;
  /** Moderator assigned to handle the report */
  assignedUserId: TypeId | null;
  /** Moderator who took action on the report */
  actionTakenBy: TypeId | null;
  /** When action was taken on the report */
  actionTakenAt: Instant | null;
  /** Whether this report was forwarded via ActivityPub */
  forwarded: boolean;
  /** Internal admin notes */
  notes?: ReportNote[];
  /** When the report was created */
  createdAt: Instant;
  /** When the report was last updated */
  updatedAt: Instant;
  /** Target post (if targetId is a post) */
  post?: Post | null;
  /** Target user (if targetId is a user) */
  targetUser?: User | null;
  /** Target group (if targetId is a group) */
  targetGroup?: GroupWrite | null;
  /** Assigned admin (populated) */
  assignedUser?: User | null;
  /** Report comments/submissions from users */
  comments?: ReportComment[] | null;
};
export type ReportsPaginatedResponse = {
  list: Report[];
  total: number;
  offset?: number | null;
};
export type ReportsPaginatedResponseWrite = {
  list: ReportWrite[];
  total: number;
  offset?: number | null;
};
export type ReportedGroup = {
  /** The reported group */
  group: Group;
  /** The report for this group */
  report: Report;
  /** Most recent report timestamp */
  latestReportDate: Instant;
  /** Most recent admin note timestamp */
  latestNoteDate: Instant | null;
  /** Number of open reports */
  openReportCount: number;
  /** Total number of reports */
  totalReportCount: number;
};
export type ReportedGroupWrite = {
  /** The reported group */
  group: GroupWrite;
  /** The report for this group */
  report: ReportWrite;
  /** Most recent report timestamp */
  latestReportDate: Instant;
  /** Most recent admin note timestamp */
  latestNoteDate: Instant | null;
  /** Number of open reports */
  openReportCount: number;
  /** Total number of reports */
  totalReportCount: number;
};
export type ReportedGroupsPaginatedResponse = {
  list: ReportedGroup[];
  total: number;
  offset?: number | null;
};
export type ReportedGroupsPaginatedResponseWrite = {
  list: ReportedGroupWrite[];
  total: number;
  offset?: number | null;
};
export type ReportSortBy =
  | "TARGET_UPDATED"
  | "REPORTED_DATE"
  | "LAST_NOTE_DATE";
export type ReportedPost = {
  /** The reported post */
  post: Post;
  /** The report for this post */
  report: Report;
  /** Most recent report timestamp */
  latestReportDate: Instant;
  /** Most recent admin note timestamp */
  latestNoteDate: Instant | null;
  /** Number of open reports */
  openReportCount: number;
  /** Total number of reports */
  totalReportCount: number;
};
export type ReportedPostWrite = {
  /** The reported post */
  post: Post;
  /** The report for this post */
  report: ReportWrite;
  /** Most recent report timestamp */
  latestReportDate: Instant;
  /** Most recent admin note timestamp */
  latestNoteDate: Instant | null;
  /** Number of open reports */
  openReportCount: number;
  /** Total number of reports */
  totalReportCount: number;
};
export type ReportedPostsPaginatedResponse = {
  list: ReportedPost[];
  total: number;
  offset?: number | null;
};
export type ReportedPostsPaginatedResponseWrite = {
  list: ReportedPostWrite[];
  total: number;
  offset?: number | null;
};
export type ReportedUser = {
  /** The reported user */
  user: User;
  /** The report for this user */
  report: Report;
  /** Most recent report timestamp */
  latestReportDate: Instant;
  /** Most recent admin note timestamp */
  latestNoteDate: Instant | null;
  /** Number of open reports */
  openReportCount: number;
  /** Total number of reports */
  totalReportCount: number;
};
export type ReportedUserWrite = {
  /** The reported user */
  user: User;
  /** The report for this user */
  report: ReportWrite;
  /** Most recent report timestamp */
  latestReportDate: Instant;
  /** Most recent admin note timestamp */
  latestNoteDate: Instant | null;
  /** Number of open reports */
  openReportCount: number;
  /** Total number of reports */
  totalReportCount: number;
};
export type ReportedUsersPaginatedResponse = {
  list: ReportedUser[];
  total: number;
  offset?: number | null;
};
export type ReportedUsersPaginatedResponseWrite = {
  list: ReportedUserWrite[];
  total: number;
  offset?: number | null;
};
export type GeoData = {
  /** ISO country code */
  countryCode?: string | null;
  /** Country name */
  country?: string | null;
  /** Subdivision or state/province name */
  subdivision?: string | null;
  /** City name */
  city?: string | null;
  /** IANA timezone identifier */
  timeZone?: string | null;
};
export type UserRole = {
  /** Internal ID of this role */
  roleId: string;
  /** Name of the role */
  name: string;
  /** The description of the role */
  description?: string | null;
};
export type UserDetails = {
  /** Internal ID of this user */
  userId: TypeId;
  /** ID of the account this user belongs to, empty for remote users */
  accountId?: TypeId | null;
  /** Unique username */
  username: string;
  /** Full name of the user */
  displayName: string;
  /** User's email address */
  email?: string | null;
  /** User's domain */
  domain?: string | null;
  /** Whether this user is local to this server */
  local: boolean;
  /** Number of posts by this user */
  numPosts: number;
  /** Number of followers this user has */
  numFollowers: number;
  /** When this user was created */
  createdAt: Instant;
  /** When this user was deleted, if applicable */
  deletedAt?: Instant | null;
  /** When this user was last active */
  lastActive?: Instant | null;
  /** Last IP address used by this user */
  lastIP?: InetAddress | null;
  /** Last geo data from which this user accessed the system */
  lastGeoData?: GeoData | null;
  /** User's moderation state */
  state: UserState;
  /** Actor type for this user (Application, Group, Organization, Person, Service) */
  actorType: ActorType;
  /** Type of user entity: USER, CHANNEL, or CATEGORY */
  userType?: UserType;
  /** Whether this is a channel. Deprecated: use 'type' field instead. */
  channel?: boolean;
  /** Group id if this user is a group channel */
  groupId?: TypeId | null;
  /** Roles assigned to this user */
  roles?: UserRole[];
  /** User's avatar */
  avatar?: Upload | null;
};
export type SearchDetails = {
  /** List of user details matching the search criteria */
  list: UserDetails[];
  /** Total number of results for the current search */
  total: number;
  /** Total number of users in the system */
  totalUsers: number;
};
export type Kind = "CHANNEL" | "USER" | "ALL";
export type SignupRequest = {
  /** Unique hash for the signup request */
  hash: string;
  /** Email address for the account */
  email?: string | null;
  /** Phone number for the account */
  phone?: string | null;
  /** Username for the first user */
  username: string;
  /** Display name for the first user */
  displayName: string;
  /** Account password, enforced by password policy */
  password: string | null;
  /** Current step in the signup flow */
  confirmationType: SignupRequestStep;
  /** Reason for creating account */
  reason: string;
  /** IP address of the user */
  ip: InetAddress;
  /** User agent of the user */
  userAgent: string;
  /** Geolocation data of the user */
  geoData?: GeoData | null;
  /** Creation timestamp of the request */
  createdAt: Instant;
  /** Invite code if provided */
  inviteCode?: string | null;
};
export type SignupRequestResult = {
  /** List of signup requests */
  list: SignupRequest[];
  /** Total number of signup requests matching the query */
  total: number;
};
export type ActionProperties = {
  extension: string;
  width?: number | null;
  height?: number | null;
  rotation?: number;
  thumbnailSecond?: number | null;
};
export type ProcessJob = {
  jobId?: TypeId;
  uploadId: TypeId;
  uploadType: UploadType;
  originalFileSize?: number;
  attempts?: number;
  progress?: number;
  properties: ActionProperties[];
  deleteOriginal?: boolean;
  error?: string | null;
  startedAt?: Instant | null;
  finishedAt?: Instant | null;
  createdAt?: Instant;
  updatedAt?: Instant;
  upload?: Upload | null;
};
export type UploadJobsQueue = "Submitted" | "InProgress" | "Completed";
export type QueueSummary = {
  queue: UploadJobsQueue;
  count: number;
  averageTimeInQueueMillis: number;
  oldestTimeInQueueMillis: number;
  averageProcessingTimeMillis?: number;
  averageWaitingTimeMillis?: number;
  p95TimeInQueueMillis?: number;
  successCount?: number;
  failureCount?: number;
};
export type UserStorage = {
  video: number;
  image: number;
  audio: number;
  document: number;
  other: number;
};
export type UploadLog = {
  createdAt?: Instant;
  message: string;
};
export type ChangeUserState = {
  /** New moderation state for the user(s). */
  newState: UserState;
  /** Optional report ID if this action is in response to a moderation report. */
  reportId?: TypeId | null;
  /** Optional reason for the state change. Limited to 120 characters. Logged in audit trail. */
  reason?: string | null;
  /** User ID to change state for. Must be a valid USER type TypeId. */
  userId: TypeId;
};
export type ChangeUsersStateResult = {
  /** Total number of user IDs requested */
  totalRequested: number;
  /** Total number of users updated in DB */
  totalUpdated: number;
  /** User IDs that were not found or already deleted */
  notFound: TypeId[];
};
export type ChangeUserStateBulk = {
  /** New moderation state for the user(s). */
  newState: UserState;
  /** Optional report ID if this action is in response to a moderation report. */
  reportId?: TypeId | null;
  /** Optional reason for the state change. Limited to 120 characters. Logged in audit trail. */
  reason?: string | null;
  /** List of user IDs to change state for. Must be valid USER TypeIds. Maximum 50. */
  userIds: TypeId[];
};
export type AiAgentTool =
  | "VECTOR_SEARCH"
  | "REGULAR_SEARCH"
  | "ENTITY_SEARCH"
  | "WEB_SEARCH"
  | "POSTS_SINCE_LAST_INVOCATION"
  | "POSTS_IN_TIME_RANGE"
  | "LIST_GROUP_STRUCTURE"
  | "REPLY"
  | "LIKE"
  | "REPORT"
  | "QUOTE"
  | "CREATE_OR_UPDATE_POST"
  | "GENERATE_IMAGES"
  | "REPORT_CONTENT"
  | "ADD_REPORT_NOTE"
  | "API_ACCESS";
export type AiAgentTriggerType =
  | "POST_CREATED"
  | "REPLY_CREATED"
  | "POST_EDITED"
  | "MENTIONED"
  | "QUESTION_DETECTED"
  | "KEYWORD_MATCH"
  | "INTENT_MATCH"
  | "REPORTED_CONTENT"
  | "THRESHOLD"
  | "UNANSWERED"
  | "CRON"
  | "NEW_GROUP_MEMBER";
export type AiAgentTriggerPostCreated = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
};
export type AiAgentTriggerReplyCreated = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
};
export type AiAgentTriggerPostEdited = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
};
export type AiAgentTriggerMentioned = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
};
export type AiAgentTriggerQuestionDetected = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
};
export type AiAgentTriggerKeywordMatch = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
  /** Keywords to match. */
  keywords: string[];
};
export type AiAgentTriggerIntentMatch = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
  /** Intent match string. */
  match: string;
};
export type AiAgentTriggerReportedContent = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
};
export type AiAgentTriggerThreshold = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
  /** Metric to evaluate */
  metric: "LIKES" | "REPOSTS" | "THREAD_LENGTH";
  /** Threshold value */
  threshold: number;
};
export type AiAgentTriggerUnanswered = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
  /** Minutes before unanswered trigger fires */
  minutes: number;
};
export type AiAgentTriggerCron = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
  /** Cron expression in '<minute> <hour> <day-of-month> <month> <day-of-week>' format. */
  schedule: string;
  /** IANA timezone identifier. */
  timeZone: string;
};
export type AiAgentTriggerNewGroupMember = {
  /** Trigger type */
  type: AiAgentTriggerType;
  /** Optional trigger-level prompt appended to instructions when this trigger matches */
  prompt?: string | null;
};
export type AiAgentTrigger =
  | AiAgentTriggerPostCreated
  | AiAgentTriggerReplyCreated
  | AiAgentTriggerPostEdited
  | AiAgentTriggerMentioned
  | AiAgentTriggerQuestionDetected
  | AiAgentTriggerKeywordMatch
  | AiAgentTriggerIntentMatch
  | AiAgentTriggerReportedContent
  | AiAgentTriggerThreshold
  | AiAgentTriggerUnanswered
  | AiAgentTriggerCron
  | AiAgentTriggerNewGroupMember;
export type AiAgentProfile = {
  /** Group scope resource ids (channels/categories/forums). Empty means whole group. */
  resourceIds?: TypeId[];
  /** List of tools enabled for this bot */
  tools?: AiAgentTool[];
  /** Configured triggers for this bot */
  triggers?: AiAgentTrigger[];
  /** Model identifier (ai_models.model_id); must be enabled in this scope */
  modelId?: TypeId | null;
  /** List of uploads (documents) attached to the bot */
  uploadIds?: TypeId[];
  /** Daily budget (tokens or cents, see platform configuration) */
  dailyBudget?: number | null;
  /** Monthly budget (tokens or cents, see platform configuration) */
  monthlyBudget?: number | null;
  /** Maximum invocations per hour (null = unlimited) */
  rateLimitHourly?: number | null;
  /** Maximum invocations per day (null = unlimited) */
  rateLimitDaily?: number | null;
  /** Role/instruction directives for the agent */
  role?: string[];
  /** Personality traits used when building agent instructions */
  personality?: string[];
  /** Writing/response style directives */
  style?: string[];
  /** Behavior directives */
  behavior?: string[];
  /** Additional free-form prompt/instructions */
  prompt?: string | null;
  /** Bot user id */
  agentId: TypeId;
  /** Group id for group-scoped bots */
  groupId?: TypeId | null;
  /** Immutable profile version number for this agent */
  version: number;
  /** Whether this bot is enabled */
  enabled: boolean;
  /** When this profile version became current (null for non-current versions) */
  currentAt?: Instant | null;
  /** Whether this profile version is currently active */
  isCurrent: boolean;
  /** ISO 8601 timestamp when this profile was created */
  createdAt: Instant;
};
export type AiAgentAssignedModel = {
  /** Assigned model identifier */
  modelId: TypeId;
  /** Assigned model name from catalog */
  name?: string | null;
  /** Whether assigned model is currently enabled in this scope */
  enabled: boolean;
};
export type AiAgentAssignedProvider = {
  /** Provider type for the assigned model */
  type?: ("OPENAI" | "OPENROUTER" | "GOOGLE" | "ANTHROPIC") | null;
  /** Provider display name */
  name?: string | null;
  /** Provider logo URL */
  logoUrl?: string | null;
};
export type AiAgent = {
  /** Bot user profile */
  user: UserFull;
  /** Bot configuration profile */
  profile: AiAgentProfile;
  /** Assigned model details, if profile has model */
  model?: AiAgentAssignedModel | null;
  /** Assigned provider details, if profile has model */
  provider?: AiAgentAssignedProvider | null;
  /** Latest profile version number for this agent */
  latestVersion: number;
  /** True if current profile is the latest profile version */
  isLatest: boolean;
};
export type AiAgentWrite = {
  /** Bot user profile */
  user: UserFullWrite;
  /** Bot configuration profile */
  profile: AiAgentProfile;
  /** Assigned model details, if profile has model */
  model?: AiAgentAssignedModel | null;
  /** Assigned provider details, if profile has model */
  provider?: AiAgentAssignedProvider | null;
  /** Latest profile version number for this agent */
  latestVersion: number;
  /** True if current profile is the latest profile version */
  isLatest: boolean;
};
export type AiAgentCreate = {
  /** List of tools enabled for this bot */
  tools?: AiAgentTool[];
  /** Configured triggers for this bot */
  triggers?: AiAgentTrigger[];
  /** Model identifier (ai_models.model_id); must be enabled in this scope */
  modelId?: TypeId | null;
  /** List of uploads (documents) attached to the bot */
  uploadIds?: TypeId[];
  /** Daily budget (tokens or cents, see platform configuration) */
  dailyBudget?: number | null;
  /** Monthly budget (tokens or cents, see platform configuration) */
  monthlyBudget?: number | null;
  /** Maximum invocations per hour (null = unlimited) */
  rateLimitHourly?: number | null;
  /** Maximum invocations per day (null = unlimited) */
  rateLimitDaily?: number | null;
  /** Role/instruction directives for the agent */
  role?: string[];
  /** Personality traits used when building agent instructions */
  personality?: string[];
  /** Writing/response style directives */
  style?: string[];
  /** Behavior directives */
  behavior?: string[];
  /** Additional free-form prompt/instructions */
  prompt?: string | null;
  /** Group scope resource ids (channels/categories/forums). Empty means whole group. */
  resourceIds?: TypeId[];
  /** Bot username (without group prefix) */
  username: string;
  /** Bot display name */
  displayName: string;
  /** Bot bio */
  summary?: string | null;
  /** Avatar upload id */
  avatarId?: TypeId | null;
  /** Header upload id */
  headerId?: TypeId | null;
};
export type AiAgentProfileVersionCreated = {
  /** Newly created profile version number */
  version: number;
};
export type AiAgentProfileUpdate = {
  /** List of tools enabled for this bot */
  tools?: AiAgentTool[];
  /** Configured triggers for this bot */
  triggers?: AiAgentTrigger[];
  /** Model identifier (ai_models.model_id); must be enabled in this scope */
  modelId?: TypeId | null;
  /** List of uploads (documents) attached to the bot */
  uploadIds?: TypeId[];
  /** Daily budget (tokens or cents, see platform configuration) */
  dailyBudget?: number | null;
  /** Monthly budget (tokens or cents, see platform configuration) */
  monthlyBudget?: number | null;
  /** Maximum invocations per hour (null = unlimited) */
  rateLimitHourly?: number | null;
  /** Maximum invocations per day (null = unlimited) */
  rateLimitDaily?: number | null;
  /** Role/instruction directives for the agent */
  role?: string[];
  /** Personality traits used when building agent instructions */
  personality?: string[];
  /** Writing/response style directives */
  style?: string[];
  /** Behavior directives */
  behavior?: string[];
  /** Additional free-form prompt/instructions */
  prompt?: string | null;
  /** Group scope resource ids (channels/categories/forums). Empty means whole group. */
  resourceIds?: TypeId[];
};
export type UserUpdate = {
  /** Display Name */
  displayName: string;
  /** User's bio */
  summary: string;
  /** Avatar upload id or null to remove */
  avatarId?: TypeId | null;
  /** Header upload id or null to remove */
  headerId?: TypeId | null;
  /** User fields */
  fields: {
    [key: string]: UserField;
  };
  /** Username */
  username?: string | null;
  location?: Location | null;
  timezone?: TimeZone | null;
  birthday?: Birthday | null;
  /** Type of user entity: USER, CHANNEL, or CATEGORY */
  userType?: UserType;
  /** Additional metadata (e.g., color for category channels) */
  meta?: UserMeta | null;
  /** Actor type - if not specified, actor type is not changed */
  actorType?: ActorType | null;
};
export type AiModelCapabilities = {
  /** Supports chat completions */
  supportsChat?: boolean;
  /** Supports embeddings generation */
  supportsEmbeddings?: boolean;
  /** Supports tool/function calling */
  supportsTools?: boolean;
  /** Supports JSON schema response format */
  supportsJsonSchema?: boolean;
  /** Supports image input (vision) */
  supportsVision?: boolean;
  /** Supports streaming responses */
  supportsStreaming?: boolean;
  /** Supports reasoning/chain-of-thought */
  supportsReasoning?: boolean;
  /** Supports file attachments (images, PDFs, etc.) */
  supportsAttachments?: boolean;
  /** Supports temperature parameter */
  supportsTemperature?: boolean;
};
export type AiModality = "TEXT" | "IMAGE" | "AUDIO" | "VIDEO" | "PDF";
export type AiBuiltInTool =
  | "WEB_SEARCH"
  | "CODE_EXECUTION"
  | "FILE_SEARCH"
  | "COMPUTER_USE"
  | "IMAGE_GENERATION"
  | "TEXT_EDITOR"
  | "BASH"
  | "URL_CONTEXT"
  | "MCP";
export type AiModelLimits = {
  /** Maximum input tokens */
  maxInputTokens?: number | null;
  /** Maximum output tokens */
  maxOutputTokens?: number | null;
  /** Total context window size */
  contextWindow?: number | null;
};
export type AiModelPricing = {
  /** Cost per 1M input tokens in USD */
  inputPer1MTokens?: number | null;
  /** Cost per 1M output tokens in USD */
  outputPer1MTokens?: number | null;
  /** Cost per 1M cached read tokens in USD */
  cacheReadPer1MTokens?: number | null;
  /** Cost per 1M cached write tokens in USD */
  cacheWritePer1MTokens?: number | null;
};
export type AiModel = {
  /** Model unique identifier */
  modelId: TypeId;
  /** Provider this model belongs to */
  providerId: TypeId;
  /** External model ID used by the provider (e.g., 'gpt-4.1') */
  externalId: string;
  /** Display name for the model */
  name: string;
  /** Whether the model is enabled in the requested scope (null if no scoped record) */
  enabled: boolean | null;
  /** Whether the model is deprecated */
  deprecated: boolean;
  /** Successor model ID if deprecated */
  successorModelId: TypeId | null;
  /** Model capabilities */
  capabilities: AiModelCapabilities;
  /** Supported input/output modalities */
  modalities: AiModality[];
  /** Built-in tools supported natively by the provider for this model */
  builtInTools: AiBuiltInTool[];
  /** Token limits */
  limits: AiModelLimits;
  /** Pricing information */
  pricing: AiModelPricing | null;
  /** Model family (e.g., 'gpt-4o', 'claude-opus') */
  family: string | null;
  /** Model release date */
  releaseDate: string | null;
  /** Knowledge cutoff date */
  knowledgeCutoff: string | null;
  /** Whether model has open weights */
  openWeights: boolean;
  /** When the model was created */
  createdAt: Instant;
  /** When the model was last updated */
  updatedAt: Instant;
};
export type AiModelPagedResponse = {
  /** List of AI models matching the filter criteria */
  models: AiModel[];
  /** Total number of models matching the filter (before pagination) */
  totalCount: number;
  /** Total number of pages */
  pageCount: number;
  /** Current page number (0-indexed) */
  page: number;
  /** Number of items per page */
  pageSize: number;
};
export type AiModelCapabilityFilter =
  | "CHAT"
  | "EMBEDDINGS"
  | "TOOLS"
  | "JSON_SCHEMA"
  | "VISION"
  | "STREAMING"
  | "REASONING"
  | "ATTACHMENTS"
  | "TEMPERATURE";
export type AiProviderType = "OPENAI" | "OPENROUTER" | "GOOGLE" | "ANTHROPIC";
export type ApiKeyFormatHint = {
  /** Accepted key prefixes */
  prefixes: string[];
  /** Masked key example */
  exampleMasked: string;
  /** Human-readable format guidance */
  rule: string;
  /** Documentation URL for obtaining and managing keys */
  docsUrl: string;
  /** Loose validation regex hint */
  regexHint: string;
};
export type AiProvider = {
  /** Provider unique identifier (catalog) */
  providerId: TypeId;
  /** Type of the AI provider */
  providerType: AiProviderType;
  /** Display name for the provider */
  name: string;
  /** Whether provider is configured (has a scoped record) in this scope */
  configured: boolean;
  /** Whether this provider has an API key configured in this scope */
  hasApiKey: boolean;
  /** Masked preview of the stored API key (provider prefix + first few unique chars) */
  apiKeyPreview: string | null;
  /** Lightweight API key format hint for this provider type */
  apiKeyFormatHint: ApiKeyFormatHint;
  /** URL to provider logo */
  logoUrl: string | null;
  /** When the provider was created */
  createdAt: Instant;
  /** When the provider was last updated */
  updatedAt: Instant;
};
export type AiAuthType = "API_KEY" | "OAUTH2" | "NONE";
export type AiScopedProviderConfigure = {
  /** Authentication type */
  authType?: AiAuthType;
  /** API key or secret (will be encrypted) */
  authSecret?: string | null;
  /** Clear stored auth secret */
  clearAuthSecret?: boolean;
};
export type ApplicationDeveloper = {
  name: string;
  website: string;
};
export type EntryPoint = "GLOBAL" | "USER" | "GROUP";
export type RbacResource =
  | "AIAgents"
  | "AIModels"
  | "AIProviders"
  | "AdminSettings"
  | "AppData"
  | "Apps"
  | "Audit"
  | "Data"
  | "Emojis"
  | "Federation"
  | "Group"
  | "GroupAIAgents"
  | "GroupAIModels"
  | "GroupAIProviders"
  | "GroupApps"
  | "GroupChannels"
  | "GroupData"
  | "GroupForum"
  | "GroupMembers"
  | "GroupQuestions"
  | "GroupReports"
  | "GroupRoles"
  | "GroupSettings"
  | "Integrations"
  | "Jobs"
  | "Reports"
  | "Roles"
  | "Rules"
  | "Signups"
  | "Uploads"
  | "Users";
export type RbacAction =
  | "Delete"
  | "Impersonate"
  | "Invite"
  | "Manage"
  | "Moderate"
  | "Post"
  | "PostAsChannel"
  | "PostsRead"
  | "Read";
export type RbacResourceAccess = {
  /** The type-safe resource being controlled */
  resource: RbacResource;
  /** List of allowed type-safe actions for this resource */
  actions: RbacAction[];
};
export type RoutePermissions = {
  anyOf?: RbacResourceAccess[] | null;
  allOf?: RbacResourceAccess[] | null;
};
export type Route = {
  path: string;
  handler: string | null;
  description: string | null;
  entryPointFor?: EntryPoint | null;
  order?: number;
  permissions?: RoutePermissions | null;
};
export type ApplicationVisibility = "PUBLIC" | "UNLISTED";
export type ApplicationType = "REGULAR" | "ERROR" | "TOOLBAR";
export type ApplicationTrustLevel = "STANDARD" | "TRUSTED" | "SYSTEM";
export type Manifest = {
  id: string;
  name: string;
  description: string;
  version: string;
  releasedOn: Instant;
  developer: ApplicationDeveloper;
  icons?: string[];
  previews?: string[];
  routes?: Route[];
  visibility?: ApplicationVisibility;
  type?: ApplicationType;
  "trust-level"?: ApplicationTrustLevel;
  standard?: boolean;
};
export type Application = {
  id: TypeId;
  name: string;
  manifest: Manifest;
  enabled?: boolean;
  updatedAt: Instant;
};
export type AppData = {
  /** Unique identifier for the app data */
  id: TypeId;
  /** Optional application ID that this data belongs to */
  applicationId?: TypeId | null;
  /** Owner identifier of the data. Can be a user ID, group ID, user-in-group format userId:groupId, or 'platform' */
  ownerId: string;
  /** Type identifier for categorizing the data */
  type: string;
  /** Optional list of tags for additional categorization */
  tags?: string[] | null;
  /** JSON string containing the actual data payload */
  data: string;
  /** Timestamp when the data was created */
  createdAt: Instant;
  /** Timestamp when the data was last updated */
  updatedAt: Instant;
};
export type DataCreate = {
  /** Owner identifier of the data. Can be a user ID, group ID, user-in-group format userId:groupId, or 'platform' */
  ownerId: string;
  /** Type identifier for categorizing the data */
  type: string;
  /** Optional list of tags for additional categorization */
  tags?: string[] | null;
  /** JSON string containing the actual data payload */
  data: string;
};
export type ApplicationWithStats = {
  id: TypeId;
  name: string;
  manifest: Manifest;
  enabled?: boolean;
  updatedAt: Instant;
  usersCount: number;
};
export type AsyncRefreshCategory = "HOME_FEED_REGENERATION" | "FASP_SEARCH";
export type AsyncRefreshStatus =
  | "PENDING"
  | "IN_PROGRESS"
  | "COMPLETED"
  | "FAILED";
export type AsyncRefreshResponse = {
  /** Unique identifier for this async refresh */
  id: TypeId;
  /** Category of the async operation */
  category: AsyncRefreshCategory;
  /** Current status of the operation */
  status: AsyncRefreshStatus;
  /** When the operation was created */
  createdAt: Instant;
  /** When the operation status was last updated */
  updatedAt: Instant;
  /** When the operation completed (null if not yet completed) */
  completedAt?: Instant | null;
  /** Error message if the operation failed */
  error?: string | null;
};
export type EmojiPaginatedResponse = {
  /** Paginated list of emojis for the current page */
  items: Emoji[];
  /** Total number of emojis that satisfy the filter */
  total: number;
  /** Total number of all emojis in the system */
  totalItems: number;
};
export type EmojiPatchRequest = {
  /** New category for the emoji */
  category?: string | null;
  /** Visibility in emoji picker */
  visibleInPicker?: boolean | null;
  /** Domain for federated emoji metadata */
  domain?: string | null;
};
export type DeviceKeys = {
  /** Base64url-encoded P-256 ECDH public key */
  p256dh: string;
  /** Base64url-encoded auth secret (16 bytes) */
  auth: string;
};
export type DevicePlatform = "android" | "ios" | "web";
export type DeviceRegistrationRequest = {
  /** Unique device identifier from client (FID) */
  deviceId: string;
  /** Firebase Cloud Messaging token */
  fcmToken: string;
  /** Push service endpoint URL */
  endpoint: string;
  /** Encryption keys for push messages */
  keys: DeviceKeys;
  /** Device platform */
  platform: DevicePlatform;
  /** Optional device description */
  device?: string | null;
};
export type UserDevice = {
  /** User ID owning this device */
  userId: TypeId;
  /** Unique device identifier from client (fid) */
  deviceId: string;
  /** FCM token for the device */
  fcmToken: string;
  /** Relay endpoint to deliver to FCM */
  endpoint: string;
  /** User public key for encrypted push */
  p256dh: string;
  /** User auth secret for encrypted push */
  auth: string;
  /** Device platform */
  platform: DevicePlatform;
  /** Optional device description */
  device?: string | null;
  createdAt: Instant;
  updatedAt: Instant;
};
export type VapidPublicKeyResponse = {
  /** Base64url-encoded VAPID public key (uncompressed P-256 point) */
  publicKey: string;
};
export type Draft = {
  /** internal draft id */
  id: TypeId;
  /** ID of the user who owns this draft */
  userId: TypeId;
  /** Draft text */
  text: string;
  /** ID of the entity this draft is for (user channel, forum category, or event) */
  ownerId: TypeId;
  /** Post owner type that determines routing: USER, CATEGORY, or EVENT */
  ownerType: PostOwnerType;
  /** Optional title for forum/article drafts */
  title?: string | null;
  /** Whether the draft is local to this server */
  local: boolean;
  /** Draft privacy level for the resulting post */
  privacy: PostPrivacy;
  /** List of tags associated with the draft */
  tags: string[];
  /** If this draft edits an existing post, its ID */
  postId?: TypeId | null;
  /** When the draft was created */
  createdAt: Instant;
  /** When the draft was last updated */
  updatedAt: Instant;
  /** Upload IDs attached to this draft */
  attachments: TypeId[];
  /** Post as owner */
  postAsOwner: boolean;
  /** Whether comments are enabled on the resulting post */
  commentsEnabled: boolean;
  /** Whether the content is marked as sensitive */
  sensitive: boolean;
  /** Content warning text if the post has sensitive content */
  contentWarning?: string | null;
  /** Whether to generate link previews for the post */
  withPreview: boolean;
};
export type CreateDraftRequest = {
  text: string;
  title?: string | null;
  privacy?: PostPrivacy | null;
  tags?: string[] | null;
  postId?: TypeId | null;
  postAsOwner?: boolean;
  attachments?: TypeId[] | null;
  commentsEnabled?: boolean;
  sensitive?: boolean;
  contentWarning?: string | null;
  withPreview?: boolean;
};
export type UpdateDraftRequest = {
  text?: string | null;
  title?: string | null;
  privacy?: PostPrivacy | null;
  tags?: string[] | null;
  postId?: TypeId | null;
  postAsOwner?: boolean | null;
  attachments?: TypeId[] | null;
  commentsEnabled?: boolean | null;
  sensitive?: boolean | null;
  contentWarning?: string | null;
  withPreview?: boolean | null;
};
export type CreateEvent = {
  /** Group id, not required for personal events */
  groupId?: TypeId | null;
  /** Event name */
  name: string;
  /** Event start time in UTC */
  startTime: Instant;
  /** Event end time in UTC */
  endTime?: Instant | null;
  /** Event IANA time zone name */
  ianaTimeZone: string;
  /** Event's description */
  description?: string | null;
  /** Event URL */
  url?: string | null;
  /** Event address */
  address?: AddressData | null;
  /** Event cover image */
  imageId?: TypeId | null;
  /** Event status */
  status?: EventStatus;
  /** Event visibility: PUBLIC, UNLISTED or DIRECT */
  privacy?: PostPrivacy;
  /** Users to invite to an invite-only event */
  invitees?: TypeId[] | null;
};
export type EventSearchMode = "following" | "local" | "fasp";
export type SortOrder = "ASC" | "DESC";
export type ExportCalendarEvents = "OWN" | "JOINED" | "INTERESTED";
export type EventsSettings = {
  /** Owner ID */
  ownerId: TypeId;
  /** Enable public calendar export */
  exportPublicCalendar: boolean;
  /** Enable public calendar export with full event details */
  exportPublicDetails: boolean;
  /** Events to export in public calendar */
  exportPublicEvents: ExportCalendarEvents;
  /** Enable private calendar export */
  exportPrivateCalendar: boolean;
  /** Events to export in private calendar */
  exportPrivateEvents: ExportCalendarEvents;
  /** Private calendar unique id */
  exportPrivateCalendarUniqueId?: string | null;
};
export type UpdateEventsSettings = {
  /** Enable public calendar export */
  exportPublicCalendar: boolean;
  /** Enable public calendar export with full event details */
  exportPublicDetails: boolean;
  /** Events to export in public calendar */
  exportPublicEvents: ExportCalendarEvents;
  /** Enable private calendar export */
  exportPrivateCalendar: boolean;
  /** Events to export in private calendar */
  exportPrivateEvents: ExportCalendarEvents;
  /** Private calendar unique id */
  exportPrivateCalendarUniqueId?: string | null;
};
export type UpdateEvent = {
  /** Event name */
  name?: string | null;
  /** Event start time in UTC */
  startTime?: Instant | null;
  /** Event end time in UTC. */
  endTime?: Instant | null;
  /** Event IANA time zone name */
  ianaTimeZone?: string | null;
  /** Event's description */
  description?: string | null;
  /** Event URL */
  url?: string | null;
  /** Event address */
  address?: AddressData | null;
  /** Event cover image id. */
  imageId?: TypeId | null;
  /** Remove event's endTime. */
  removeEndTime?: boolean;
  /** Remove event's image. */
  removeImage?: boolean;
  /** Remove event's address. */
  removeAddress?: boolean;
  /** Remove event's description. */
  removeDescription?: boolean;
};
export type EventAttendee = {
  user?: User | null;
  uri: string;
  status: EventAttendeeStatus;
};
export type PublicPoint = {
  data?: number[];
};
export type Ed25519PublicKeyParameters = {
  privateKey?: boolean;
  private?: boolean;
  publicPoint?: PublicPoint;
  encoded?: Blob;
};
export type Ed25519PublicKey = {
  key: Ed25519PublicKeyParameters;
  encoded?: Blob;
};
export type RegistrationRequest = {
  name: string;
  baseUrl: string;
  serverId: string;
  publicKey: Ed25519PublicKey;
};
export type GroupFederationTokenRequest = {
  /** ID of the group to access */
  groupId: TypeId;
};
export type GroupCreate = {
  /** who can access the group's content */
  privacy: GroupPrivacy;
  /** how discoverable the group is */
  visibility: GroupVisibility;
  /** how users can join the group */
  joinMode: GroupJoinMode;
  /** Banner upload id or null to remove */
  bannerId?: TypeId | null;
  /** Avatar upload id or null to remove */
  avatarId?: TypeId | null;
  /** group's location */
  location?: Location | null;
  /** group's timezone */
  timezone?: TimeZone | null;
  /** Unique group name used in URLs. Must be alphanumeric with underscores/hyphens, 3-30 characters. */
  name: string;
  /** Human-readable display name for the group. Can contain spaces and special characters. */
  displayName: string;
  /** Detailed description of the group's purpose and activities. Supports markdown formatting. */
  description?: string | null;
  /** Custom fields for the group */
  fields?: {
    [key: string]: UserField;
  };
  /** Additional metadata for the group including rules, guidelines, and custom fields */
  meta?: GroupMeta;
  /** The type/category of the group (ORGANIZATION, COMMUNITY, PROJECT, etc.) */
  type: GroupType;
  secret?: boolean;
};
export type GroupInviteStatus = "PENDING" | "ACCEPTED" | "REJECTED";
export type GroupInvite = {
  /** Unique identifier for this invitation */
  groupInviteId: TypeId;
  /** ID of the group */
  groupId: TypeId;
  /** ID of the user who sent the invitation */
  inviterId: TypeId;
  /** ID of the user being invited (null for email-only invites) */
  inviteeId?: TypeId | null;
  /** Current status of the invitation */
  status: GroupInviteStatus;
  /** Optional message from the inviter */
  message?: string | null;
  /** Email address of the invitee (present for email-based invites) */
  email?: string | null;
  /** Username of the inviter */
  inviterName: string;
  /** Display name of the inviter */
  inviterDisplayName: string;
  /** Avatar of the inviter */
  inviterAvatar?: Upload | null;
  /** Username of the invitee (null for unclaimed email-only invites) */
  inviteeName?: string | null;
  /** Display name of the invitee (null for unclaimed email-only invites) */
  inviteeDisplayName?: string | null;
  /** Avatar of the invitee */
  inviteeAvatar?: Upload | null;
  /** Name of the group */
  groupName: string;
  /** Display name of the group */
  groupDisplayName: string;
  /** Avatar of the group */
  groupAvatar?: Upload | null;
  /** When the invitation was created */
  createdAt: Instant;
  /** When the invitation was last updated */
  updatedAt: Instant;
};
export type GroupMemberMeta = {
  /** Optional description or note about this member's role or participation in the group */
  description?: string;
};
export type GroupMember = {
  /** Group name */
  groupName: string;
  /** Group display name */
  groupDisplayName: string;
  /** User name (username) */
  userName: string;
  /** User display name */
  userDisplayName: string;
  /** User domain */
  userDomain?: string | null;
  /** Group avatar upload object */
  groupAvatar?: Upload | null;
  /** User avatar upload object */
  userAvatar?: Upload | null;
  /** Group ID */
  groupId: TypeId;
  /** User who is a member of the group */
  memberId: TypeId;
  /**
                All role identifiers for this member in the group.
                Includes both predefined roles (owner, admin, moderator, member, viewer)
                and custom roles.
             */
  roles?: string[];
  /** Additional metadata about this membership */
  meta?: GroupMemberMeta | null;
  createdAt?: Instant | null;
  updatedAt?: Instant | null;
};
export type GroupUpdate = {
  /** New unique group name. This will update the group's URL. Must be unique across the platform. Null to keep existing name. */
  name?: string | null;
  /** Updated display name for the group. This is what users see in the UI. Null to keep existing. */
  displayName?: string | null;
  /** Updated group description. Null to keep existing description. */
  description?: string | null;
  /** Custom fields for the group; processed like user's fields. Null to keep existing. */
  fields?: {
    [key: string]: UserField;
  } | null;
  /** Group's last refresh timestamp. Null to keep existing. */
  refreshedAt?: Instant | null;
  /** Group metadata including color. Null to keep existing. */
  meta?: GroupMeta | null;
  /** Who can access the group's content. Null to keep existing. */
  privacy?: GroupPrivacy | null;
  /** How discoverable the group is. Null to keep existing. */
  visibility?: GroupVisibility | null;
  /** How users can join the group. Null to keep existing. */
  joinMode?: GroupJoinMode | null;
  /** Banner upload id. Null to keep existing. */
  bannerId?: TypeId | null;
  /** Avatar upload id. Null to keep existing. */
  avatarId?: TypeId | null;
  /** Group's location. Null to keep existing. */
  location?: Location | null;
  /** Group's timezone. Null to keep existing. */
  timezone?: TimeZone | null;
};
export type GroupBlockType = "URI" | "EMAIL" | "DOMAIN" | "USERNAME" | "USERID";
export type GroupBlockCreateRequest = {
  /** Block by URI (ActivityPub actor URI) */
  uri?: string | null;
  /** Block by email address */
  email?: string | null;
  /** Block by username (local or username@domain format) */
  username?: string | null;
  /** Block by domain */
  domain?: string | null;
  /** Block by user ID */
  userId?: string | null;
  /** Reason for the block */
  reason?: string | null;
  /** Preflight mode - preview affected users without applying changes */
  preflight?: boolean;
};
export type GroupBrandingUpdate = {
  /** Theme color for the group in 6-character HEX format with # prefix. Used for UI theming. Null to keep existing color. */
  color?: string | null;
  /** Upload ID of the banner image. Must be a previously uploaded image. Null to keep existing banner. */
  bannerId?: TypeId | null;
  /** Upload ID of the avatar image. Must be a previously uploaded image. Null to keep existing avatar. */
  avatarId?: TypeId | null;
};
export type CategoryCreate = {
  name: string;
  displayName: string;
  description?: string;
  meta?: CategoryMeta;
  tagsAllowed?: string[] | null;
};
export type CategoryUpdate = {
  name: string;
  displayName: string;
  description?: string;
  meta?: CategoryMeta;
  tagsAllowed?: string[] | null;
};
export type GroupChannelCreateRequest = {
  /** Channel identifier scoped to the group. Must be unique within the group. Used to generate the channel's username in format 'groupname:channelname' for private channels. */
  username: string;
  /** Human-readable display name for the channel. Shown in channel listings and UI. */
  displayName: string;
  /** Brief description of the channel's purpose and content (max 1024 characters) */
  summary?: string;
  /** Channel privacy level. PUBLIC channels are visible to everyone, PRIVATE channels only to group members. Private groups can only have private channels. */
  privacy?: GroupChannelPrivacy;
  /** Whether this channel should be the primary channel for the group. Only one primary channel allowed per group. The first channel created is automatically made primary. */
  isPrimary?: boolean;
  /** Whether this channel should be an auto-subscribe channel. Auto-subscribe channels are automatically followed by new group members. The first channel created is automatically made auto-subscribe. */
  isAutoSubscribe?: boolean;
  /** Global username for public channels. Must be unique across the entire platform. Allows the channel to be accessed via '@globalUsername' in addition to the scoped username. Only available for public channels in public groups. */
  globalUsername?: string | null;
  /** Type of channel entity to create. CHANNEL (default) for regular group channels, CATEGORY for topic-based category channels. Only CHANNEL and CATEGORY are allowed. */
  userType?: UserType;
  /** Additional metadata for the channel (e.g., color for category channels) */
  meta?: UserMeta | null;
  /** When creating an auto-subscribe channel, whether to subscribe all existing group members. Default: true. */
  subscribeExistingMembers?: boolean | null;
};
export type GroupChannelUpdateRequest = {
  /** New display name for the channel. Updates how the channel appears in UI. */
  displayName?: string | null;
  /** New channel description (max 1024 characters) */
  summary?: string | null;
  /** New privacy level. Cannot make a channel public if the parent group is private. Changing from public to private affects visibility and access. */
  privacy?: GroupChannelPrivacy | null;
  /** Whether this channel should be an auto-subscribe channel (auto-followed by new members) */
  isAutoSubscribe?: boolean | null;
  /** Upload ID for the channel avatar image. Must be a previously uploaded image. Set to null to remove the avatar. */
  avatarId?: TypeId | null;
  /** Upload ID for the channel header/banner image. Must be a previously uploaded image. Set to null to remove the header. */
  headerId?: TypeId | null;
  /** Channel profile fields (key-value pairs for additional information) */
  fields?: {
    [key: string]: UserField;
  } | null;
  /** Channel location information */
  location?: Location | null;
  /** Channel timezone preferences */
  timezone?: TimeZone | null;
  /** New group-scoped username (channel slug). Must be unique within the group. Used to generate the channel's scoped username in format 'groupname:channelname'. This is the channel identifier within the group context. */
  groupUsername?: string | null;
  /** Global username for the channel. Must be unique platform-wide. Only available for public channels in public groups. Null or omitted means no change. To remove the global username, use the dedicated PUT /channels/{channelId}/username endpoint. */
  globalUsername?: string | null;
  /** Additional metadata for the channel (e.g., color for category channels) */
  meta?: UserMeta | null;
  /** When enabling auto-subscribe, whether to subscribe existing members. Only applies when isAutoSubscribe changes to true. Default: true when isAutoSubscribe is true. */
  subscribeExistingMembers?: boolean | null;
};
export type AssignGlobalUsernameRequest = {
  /** Global username to assign to the channel. Must be unique platform-wide. Set to null to remove the global username. Only available for public channels in public groups. */
  globalUsername?: string | null;
};
export type MembershipState =
  | "MEMBER"
  | "PENDING_JOIN"
  | "PENDING_INVITE"
  | "NONE";
export type GroupJoinRequestStatus = "PENDING" | "APPROVED" | "REJECTED";
export type GroupJoinRequest = {
  /** Unique identifier for this group join request */
  groupJoinRequestId: TypeId;
  /** ID of the user requesting to join */
  userId: TypeId;
  /** ID of the group being requested to join */
  groupId: TypeId;
  /** Username of the user requesting to join */
  username: string;
  /** Display name of the user requesting to join */
  userDisplayName: string;
  /** Avatar upload ID of the user */
  avatarId?: TypeId | null;
  /** Answer token from completing group questions (if questions were required) */
  answerToken?: string | null;
  /** Current status of the join request */
  status: GroupJoinRequestStatus;
  /** Reason provided for approval or rejection */
  reason?: string | null;
  /** When the join request was created */
  createdAt: Instant;
  /** When the join request was last updated (status change, etc) */
  updatedAt: Instant;
};
export type MembershipInfo = {
  /** The current state of the user's relationship with the group */
  state: MembershipState;
  /** The membership object, present if state is MEMBER */
  member?: GroupMember | null;
  /** The join request object, present if state is PENDING_JOIN */
  joinRequest?: GroupJoinRequest | null;
  /** The invite object, present if state is PENDING_INVITE */
  invite?: GroupInvite | null;
};
export type GroupWithMembership = {
  /** The group details */
  group: Group;
  /** Viewer's membership state and related info */
  membershipInfo: MembershipInfo;
};
export type GroupWithMembershipWrite = {
  /** The group details */
  group: GroupWrite;
  /** Viewer's membership state and related info */
  membershipInfo: MembershipInfo;
};
export type ForumPolicy = {
  dummy?: string | null;
};
export type ForumMeta = {
  dummy?: string | null;
};
export type ForumStats = {
  /** Total number of posts */
  posts: number;
  /** Posts created in the last 24 hours */
  postsLast24h: number;
  /** Total number of comments */
  comments: number;
  /** Total uploaded bytes */
  totalStorageBytes: number;
  /** Average posts per day over the last 30 days */
  avgPostsPerDay: number;
  /** Average uploaded bytes per day over the last 30 days */
  avgBytesPerDay: number;
  /** Total categories in this forum */
  categories: number;
  /** Total tags in this forum */
  tags: number;
};
export type ForumStatsWrite = {
  /** Total number of posts */
  posts: number;
  /** Posts created in the last 24 hours */
  postsLast24h: number;
  /** Total number of comments */
  comments: number;
  /** Total uploaded bytes */
  totalStorageBytes: number;
  /** Average posts per day over the last 30 days */
  avgPostsPerDay: number;
  /** Average uploaded bytes per day over the last 30 days */
  avgBytesPerDay: number;
  lastFlushVersion?: number | null;
  /** Total categories in this forum */
  categories: number;
  /** Total tags in this forum */
  tags: number;
};
export type Forum = {
  /** internal forum id */
  id: TypeId;
  /** forum policy settings */
  policy: ForumPolicy;
  /** additional forum metadata */
  meta: ForumMeta;
  /** when the forum was created */
  createdAt: Instant;
  /** when the forum was last updated */
  updatedAt: Instant;
  /** ID of the group that owns this forum */
  ownerId: TypeId;
  /** Aggregated activity stats for this forum */
  stats: ForumStats;
};
export type ForumWrite = {
  /** internal forum id */
  id: TypeId;
  /** forum policy settings */
  policy: ForumPolicy;
  /** additional forum metadata */
  meta: ForumMeta;
  /** when the forum was created */
  createdAt: Instant;
  /** when the forum was last updated */
  updatedAt: Instant;
  /** ID of the group that owns this forum */
  ownerId: TypeId;
  /** Aggregated activity stats for this forum */
  stats: ForumStatsWrite;
};
export type ForumUpdate = {
  policy?: ForumPolicy;
  meta?: ForumMeta;
};
export type LocalDate = string;
export type TagHistory = {
  uses: number;
  date: LocalDate;
};
export type Tag = {
  name: string;
  totalUses?: number | null;
  history?: TagHistory[] | null;
};
export type GroupInviteCreateResult = {
  /** The created invitation */
  invite: GroupInvite;
  /** Whether an invitation email was sent from this server */
  emailSent: boolean;
};
export type GroupInviteCreate = {
  /** ID of the user to invite */
  inviteeId?: TypeId | null;
  /** Email address to invite (local users only) */
  inviteeEmail?: string | null;
  /** Optional message to include with the invitation */
  message?: string | null;
};
export type MemberDisplaySettings = {
  customDisplayName?: string;
  showActivity?: boolean;
  showInMemberList?: boolean;
  showJoinDate?: boolean;
};
export type MemberPreferences = {
  emailNotifications?: boolean;
  notificationFrequency?: string;
  notifications?: boolean;
};
export type GroupMemberSettings = {
  "group.member.display"?: MemberDisplaySettings;
  "group.member.preferences"?: MemberPreferences;
};
export type GroupMemberRoleFilter = "MEMBER" | "ADMIN";
export type GroupMembersSortBy =
  | "JOIN"
  | "POSTS"
  | "FOLLOWERS"
  | "FOLLOWING"
  | "RELATIONS"
  | "DOMAIN"
  | "DISPLAY_NAME"
  | "USERNAME"
  | "CREATED_AT"
  | "ACTOR_TYPE";
export type GroupMemberCreate = {
  /** User who will be added as a member of the group */
  memberId: TypeId;
  /** The initial role to assign via RBAC. Defaults to GROUP_VIEWER if not specified */
  role?: string | null;
  /** Optional metadata to attach to this membership */
  meta?: GroupMemberMeta | null;
};
export type GroupMemberStats = {
  /** Number of posts in the group */
  posts: number;
  /** Number of comments in the group */
  comments: number;
  /** Number of likes in the group */
  likes: number;
  /** Number of votes in the group */
  votes: number;
  /** Number of uploads in the group */
  uploads: number;
  /** Total size of uploads by this user in the group (in bytes) */
  uploadsSize: number;
};
export type GroupMemberSearchResult = {
  /** Member user ID */
  memberId: TypeId;
  /** Roles in the group */
  roles: string[];
  /** Group member metadata */
  meta: GroupMemberMeta;
  /** User avatar */
  avatar?: Upload | null;
  /** User full username */
  username: string;
  /** User display name */
  displayName: string;
  /** Actor type */
  actorType: ActorType;
  /** When joined the group */
  createdAt: Instant;
  /** Last active in the group (timestamp of latest post, comment, like, repost etc) */
  lastActiveAt?: Instant | null;
  /** Member statistics in the group */
  stats: GroupMemberStats;
  /** Last login location from IP, not from user profile */
  location?: Location | null;
};
export type GroupMemberSearchDetails = {
  /** List of group member search results matching the search criteria */
  list: GroupMemberSearchResult[];
  /** Total number of results for the current search */
  total: number;
};
export type GroupMemberUpdate = {
  /** New role to assign to the member via RBAC. If null, role remains unchanged */
  role?: string | null;
  /** Updated metadata for this membership. If null, metadata remains unchanged */
  meta?: GroupMemberMeta | null;
};
export type LocalDateTime = string;
export type GroupPin = {
  /** ID of the user who pinned the group */
  userId: TypeId;
  /** ID of the pinned group */
  groupId: TypeId;
  /** Pin order number (positive integer for sorting) */
  pin: number;
  /** When the group was pinned */
  createdAt: LocalDateTime;
  /** When the pin was last updated */
  updatedAt: LocalDateTime;
};
export type QuestionType = "TEXT" | "MULTIPLE_CHOICE" | "SINGLE_CHOICE";
export type Choice = {
  /** The display text for this choice option (max 60 characters) */
  text: string;
  /** Display order for this choice (lower values appear first) */
  order: number;
};
export type Question = {
  /** The question text displayed to users (max 200 characters) */
  questionText: string;
  /** Question type determining the answer format (TEXT, SINGLE_CHOICE, MULTIPLE_CHOICE) */
  type: QuestionType;
  /** Available choices for SINGLE_CHOICE or MULTIPLE_CHOICE questions. Empty for TEXT questions. */
  choices?: Choice[];
  /** Display order position - questions with lower values appear first */
  ordering: number;
  /** Unique identifier for the question */
  id: TypeId;
};
export type QuestionCreate = {
  /** The question text displayed to users (max 200 characters) */
  questionText: string;
  /** Question type determining the answer format (TEXT, SINGLE_CHOICE, MULTIPLE_CHOICE) */
  type: QuestionType;
  /** Available choices for SINGLE_CHOICE or MULTIPLE_CHOICE questions. Empty for TEXT questions. */
  choices?: Choice[];
  /** Display order position - questions with lower values appear first */
  ordering: number;
};
export type Answer = {
  /** The unique identifier of the question being answered */
  questionId: TypeId;
  /** The type of the question - must match the actual question type */
  questionType: QuestionType;
  /** Free-form text answer for TEXT type questions (max 500 characters) */
  textAnswer?: string | null;
  /** Zero-based indices of selected choices for SINGLE_CHOICE or MULTIPLE_CHOICE questions */
  selectedChoices?: number[];
};
export type QuestionAnswerCreate = {
  /** Complete list of answers corresponding to all group questions */
  answers: Answer[];
};
export type QuestionUpdate = {
  /** The question text displayed to users (max 200 characters) */
  questionText: string;
  /** Question type determining the answer format (TEXT, SINGLE_CHOICE, MULTIPLE_CHOICE) */
  type: QuestionType;
  /** Available choices for SINGLE_CHOICE or MULTIPLE_CHOICE questions. Empty for TEXT questions. */
  choices?: Choice[];
  /** Display order position - questions with lower values appear first */
  ordering: number;
};
export type Rule = {
  /** The rule text that defines expected behavior or policy (max 500 characters) */
  text: string;
  /** Additional context or clarification for the rule (max 500 characters) */
  hint: string;
  /** Display order position - rules with lower values appear first */
  ordering: number;
  /** Unique identifier for the rule */
  id: TypeId;
};
export type RuleOrderingRequest = {
  /** The unique identifier of the rule to reorder */
  id: TypeId;
  /** New display order position (lower values appear first) */
  ordering: number;
};
export type RuleUpdate = {
  /** The rule text that defines expected behavior or policy (max 500 characters) */
  text: string;
  /** Additional context or clarification for the rule (max 500 characters) */
  hint: string;
  /** Display order position - rules with lower values appear first */
  ordering: number;
};
export type AiAgentBudgetLimits = {
  /** Daily token budget (null = unlimited) */
  dailyTokens?: number;
  /** Monthly token budget (null = unlimited) */
  monthlyTokens?: number;
};
export type GroupJoinQuestions = {
  show?: boolean;
};
export type MembershipConfig = {
  allowMemberInvites?: boolean;
  approveInvites?: boolean;
  maxMembers?: number;
};
export type ModerationConfig = {
  blockedWords?: string[];
  dailyPostLimit?: number;
  moderateLinks?: boolean;
  moderatePosts?: boolean;
  slowModeEnabled?: boolean;
  slowModeInterval?: number;
  spamFilter?: boolean;
};
export type GroupPrivacyConfig = {
  showMemberList?: boolean;
  showStats?: boolean;
};
export type GroupSettings = {
  "group.ai.agents.budgets"?: AiAgentBudgetLimits;
  "group.join.questions"?: GroupJoinQuestions;
  "group.membership"?: MembershipConfig;
  "group.moderation"?: ModerationConfig;
  "group.privacy"?: GroupPrivacyConfig;
};
export type BulkImportType =
  | "FOLLOWING"
  | "BLOCK"
  | "MUTE"
  | "DOMAIN_BLOCK"
  | "BOOKMARKS"
  | "LISTS";
export type BulkImportState =
  | "PENDING"
  | "SCHEDULED"
  | "IN_PROGRESS"
  | "COMPLETED";
export type BulkImport = {
  bulkImportId: number;
  userId: TypeId;
  type: BulkImportType;
  state: BulkImportState;
  overwrite: boolean;
  originalFilename: string | null;
  likelyMismatched: boolean;
  totalItems: number | null;
  importedItems: number | null;
  processedItems: number | null;
  createdAt: Instant;
  updatedAt: Instant;
};
export type InstanceStats = {
  /** Total number of local users on this day */
  user_count?: number | null;
  /** Total number of active local users in the last 30 days on this day */
  active30_user_count: number | null;
  /** Total number of active local users in the last 180 days on this day */
  active180_user_count: number | null;
  /** Total number of local groups on this day */
  group_count?: number | null;
  /** Local top-level posts created this day */
  post_count?: number | null;
  /** Cumulative local top-level posts up to this day */
  post_count_total?: number | null;
  /** Comments by local users created this day */
  comment_count?: number | null;
  /** Comments by remote users created this day */
  remote_comment_count?: number | null;
  /** Cumulative comments by local users up to this day */
  comment_count_total?: number | null;
  /** Cumulative comments by remote users up to this day */
  remote_comment_count_total?: number | null;
  /** Total number of external domains on this day */
  domain_count?: number | null;
};
export type InstanceRegistration = {
  /** Whether reason to join should be provided when signing up */
  ask_for_info: boolean;
  /** Whether captcha is shown to new users when signing up */
  captcha: boolean;
  /** Whether existing users can invite other users to join */
  invites: boolean;
  /** Message shown to guests when registration is closed */
  message: string;
  /** Registration mode on this instance */
  mode: "OPEN" | "APPROVAL" | "EMAIL_DOMAIN_ALLOWLIST" | "CLOSED";
};
export type PasswordPolicy = "ANY" | "STRICT";
export type InstanceAccess = {
  /** Whether the server is visible to the public */
  visibility: "PUBLIC" | "PRIVATE";
};
export type InstanceBranding = {
  /** Color theme of the homepage in HEX format */
  color: string;
  /** Server description shown on the homepage */
  description: string;
  /** Display name shown on the homepage */
  displayName: string;
  /** Image URL shown on the homepage */
  image: string;
  /** Thumbnail of the image URL shown on the homepage */
  imageThumbnail: string;
  /** Short description shown on the homepage */
  shortDescription: string;
};
export type InstanceDomainBlocksPolicy = {
  /** Who can see domains that are blocked by this instance */
  domainBlocksAccess: "NONE" | "USER" | "ALL";
  /** Who can see reasons for domain blocks by this instance */
  domainBlocksReasonAccess: "NONE" | "USER" | "ALL";
};
export type InstanceContacts = {
  /** Contact email for the server */
  email: string;
  /** Contact username for the server */
  username: string;
};
export type InstanceConfiguration = {
  /** Registration configuration */
  registrations: InstanceRegistration;
  /** Password policy configuration */
  passwordPolicy: PasswordPolicy;
  /** Access configuration */
  access: InstanceAccess;
  /** Branding configuration */
  branding: InstanceBranding;
  /** Domain blocks policy configuration */
  domainBlocksPolicy: InstanceDomainBlocksPolicy;
  /** Instance contacts configuration */
  contacts: InstanceContacts;
};
export type Instance = {
  /** URI of this instance */
  uri: string;
  title?: string;
  short_description?: string;
  description?: string;
  email?: string;
  /** Version of the platform */
  version: string;
  /** Build # of the platform */
  build: string;
  /** Build timestamp */
  buildTimestamp: number;
  urls?: {
    [key: string]: string;
  };
  stats?: InstanceStats;
  thumbnail?: string;
  languages?: string[];
  /** This instance configuration */
  configuration: InstanceConfiguration;
  contact_account?: User | null;
  /** List of instance rules */
  rules: Rule[];
};
export type Flags = {
  png: string;
  svg: string;
  alt: string;
};
export type NativeName = {
  official: string;
  common: string;
};
export type Name = {
  common: string;
  official: string;
  nativeName: {
    [key: string]: NativeName;
  };
};
export type Idd = {
  root: string;
  suffixes: string[];
};
export type CountryInfo = {
  flags: Flags;
  name: Name;
  idd: Idd;
};
export type SupportedLanguage = {
  code: string;
  nativeName: string;
};
export type TimezoneInfo = {
  value: string;
  abbr: string;
  offset: number;
  isdst: boolean;
  text: string;
  utc: string[];
};
export type RedisJob = {
  jobHash: Uuid;
  job: string;
  queueName: string;
  tries?: number;
  createdAt?: Instant | null;
  startTime?: Instant | null;
  lastTryAt?: Instant | null;
  lastError?: string | null;
  endTime?: Instant | null;
};
export type RedisJobsResult = {
  list: RedisJob[];
  total: number;
};
export type JobListResult = {
  list: string[];
  total: number;
};
export type OverallStats = {
  finished: {
    [key: string]: number;
  };
  failed: {
    [key: string]: number;
  };
};
export type UsersList = {
  /** Internal list id */
  id: TypeId;
  /** Owner of the list */
  userId: TypeId;
  name: string;
  description: string | null;
  icon: string | null;
  private: boolean;
  pinned: boolean;
  createdAt: Instant;
  updatedAt: Instant;
  users?: User[];
};
export type UserListCreate = {
  name: string;
  description: string | null;
  icon: string | null;
  private?: boolean;
  pinned?: boolean;
};
export type TimeGranularity = "HOUR" | "DAY" | "MONTH";
export type MetricsData = {
  /** Time granularity of the metrics */
  granularity: TimeGranularity;
  /** Time slot for which metrics are calculated */
  timeSlot: Instant;
  /** Number of new signups */
  newSignups?: number | null;
  /** Number of active users */
  activeUsers?: number | null;
  /** Number of users created */
  userCreations?: number | null;
  /** Number of users deleted */
  userDeletions?: number | null;
  /** Number of unique users who posted */
  usersWhoPosted?: number | null;
  /** Number of posts with media attachments */
  mediaPosts?: number | null;
  /** Number of likes */
  likes?: number | null;
  /** Number of reposts */
  reposts?: number | null;
  /** Number of quote posts */
  quotes?: number | null;
  /** Number of replies */
  replies?: number | null;
  /** Number of conversations */
  conversations?: number | null;
  /** Total number of local users on this day */
  users?: number | null;
  /** Total number of local groups (not deleted) on this day */
  groups?: number | null;
  /** Local top-level posts created this day */
  localPostsCreated?: number | null;
  /** Cumulative local top-level posts up to this day */
  localPostsTotal?: number | null;
  /** Remote top-level posts created this day */
  remotePostsCreated?: number | null;
  /** Cumulative remote top-level posts up to this day */
  remotePostsTotal?: number | null;
  /** Comments by local users created this day */
  localComments?: number | null;
  /** Comments by remote users created this day */
  remoteComments?: number | null;
  /** Cumulative comments by local users up to this day */
  localCommentsTotal?: number | null;
  /** Cumulative comments by remote users up to this day */
  remoteCommentsTotal?: number | null;
  /** Total number of external domains on this day */
  domains?: number | null;
};
export type MetricsPeriod = "LAST_DAY" | "LAST_WEEK" | "LAST_MONTH";
export type ServerTotals = {
  /** Total number of users on the server */
  users: number;
  /** Total number of local posts on the server */
  localPosts: number;
  /** Total number of remote posts on the server */
  remotePosts: number;
  /** Total number of groups on the server */
  groups: number;
  /** Total number of local comments on the server */
  localComments: number;
  /** Total number of remote comments on the server */
  remoteComments: number;
  /** Last updated timestamp */
  updatedAt: Instant;
};
export type NameCheckResult = {
  /** Whether the name is available for use (not reserved and not taken) */
  available: boolean;
  /** Whether the name is a reserved word that cannot be used */
  reserved: boolean;
  /** Whether the name is already in use by another entity */
  taken: boolean;
};
export type NameScope = "USER" | "GROUP" | "CATEGORY";
export type UserNote = {
  ownerId: TypeId;
  userId: TypeId;
  text: string;
};
export type NoteUpdate = {
  /** User id to set note for */
  userId: TypeId;
  /** Note text */
  text: string;
};
export type NotificationType =
  | "FOLLOW"
  | "FOLLOW_REQUEST"
  | "GROUP_INVITE"
  | "LIKE"
  | "COMMENT"
  | "MENTION"
  | "REPOST"
  | "LIST_POST_CREATE"
  | "POST_UPDATE"
  | "POLL"
  | "POLL_VOTE"
  | "POST_VOTE"
  | "EVENT_INVITE"
  | "EVENT_JOIN"
  | "EVENT_CANCEL"
  | "EVENT_UPDATE";
export type NotificationStatus = "UNREAD" | "READ" | "BLOCKED" | "HIDDEN";
export type NotificationAction = {
  action: string;
  text: string;
};
export type NotificationMeta = {
  actionsAvailable?: NotificationAction[] | null;
  actionsTaken?: NotificationAction[] | null;
  empty?: boolean;
};
export type Notification = {
  /** Internal notification id */
  id: TypeId;
  /** User receiving the notification */
  userId: TypeId;
  type: NotificationType;
  status: NotificationStatus;
  /** Related activity id (usually a post) */
  activityId: TypeId | null;
  /** User who triggered the notification */
  fromUserId: TypeId | null;
  meta: NotificationMeta;
  createdAt: Instant;
  updatedAt: Instant | null;
  fromUser?: User | null;
  post?: Post | null;
  event?: Event | null;
};
export type Passkey = {
  credentialId: string;
  accountId: TypeId;
  userId: TypeId;
  publicKeyCose: Blob;
  publicKeyAlg: number;
  aaguid: string | null;
  signCount: number;
};
export type PublicKeyCredentialDescriptor = {
  type: string | null;
  id: string | null;
  transports: string[] | null;
};
export type PublicKeyCredentialRequestOptions = {
  /** Base64url-encoded challenge */
  challenge: string;
  /** Timeout in milliseconds */
  timeout: number;
  /** Relying Party ID */
  rpId: string;
  /** List of allowed credentials for assertion (by descriptor) */
  allowCredentials: PublicKeyCredentialDescriptor[] | null;
  /** User verification requirement (preferred/required/discouraged) */
  userVerification: string | null;
  /** Extension inputs keyed by extension name */
  extensions: {
    [key: string]: any;
  } | null;
};
export type RpEntity = {
  id: string | null;
  name: string | null;
};
export type UserEntity = {
  id: string | null;
  name: string | null;
  displayName: string | null;
};
export type PubKeyCredParam = {
  type: string | null;
  alg: number | null;
};
export type AuthenticatorSelectionCriteria = {
  authenticatorAttachment: string | null;
  requireResidentKey: boolean | null;
  residentKey: string | null;
  userVerification: string | null;
};
export type PublicKeyCredentialCreationOptions = {
  /** Base64url-encoded server challenge */
  challenge: string;
  /** Relying Party entity (name and id) */
  rp: RpEntity | null;
  /** User entity; id is base64url-encoded */
  user: UserEntity | null;
  /** List of acceptable credential parameters (type and COSE alg) */
  pubKeyCredParams: PubKeyCredParam[] | null;
  /** Timeout in milliseconds */
  timeout: number | null;
  /** Attestation conveyance preference */
  attestation: string | null;
  /** Authenticator selection constraints */
  authenticatorSelection: AuthenticatorSelectionCriteria | null;
  /** Credentials to exclude from creation (by descriptor) */
  excludeCredentials: PublicKeyCredentialDescriptor[] | null;
  /** Extension inputs keyed by extension name */
  extensions: {
    [key: string]: any;
  } | null;
};
export type JsonObject = {
  key?: string;
  value?: any;
}[];
export type PinnedParam = "ONLY" | "SKIP" | "ALL";
export type RepostParam = "REPOST" | "QUOTE" | "ALL";
export type PollCreate = {
  /** List of poll options */
  options: string[];
  /** Duration in seconds */
  expiresIn: Duration;
  /** Allow multiple choices */
  multiple: boolean;
  /** Hide totals until poll finishes */
  hideTotals: boolean;
};
export type CreatePost = {
  /** Post text */
  text: string;
  /** Post privacy */
  privacy: PostPrivacy;
  /** Note or Article */
  kind: PostKind;
  /** List with upload ids of attachments */
  attachments?: TypeId[] | null;
  /** Poll parameters */
  poll?: PollCreate | null;
  /** Enable/disable comments for the post */
  commentsEnabled?: boolean;
  /** Mark status and attached media as sensitive. contentWarning should be provided when this flag is true. Defaults to false. */
  sensitive?: boolean;
  /** Content warning. The post content and media will be hidden under the warning. */
  contentWarning?: string | null;
  /** Null if regular post. category_id for Categories (Forum) and event_id for events */
  ownerId?: TypeId | null;
  /** Title of a post in forum */
  title?: string | null;
  /** List of tags. The other way to add tags is using '#' hashtags in text */
  tags?: string[] | null;
  /** Create Preview Card for for link in the post */
  withPreview?: boolean;
  /** Post media type. Default for Note is text/plain, for Article text/markdown */
  mediaType?: PostMediaType | null;
  /** Upload ID for the article image (will also be included in attachments) */
  imageUploadId?: TypeId | null;
  /** When true, the post is attributed to the group channel specified by ownerId. Only available to channel moderators/admins and only for top-level posts. */
  postAsOwner?: boolean;
  /** Quote approval policy for this post. Omit to use account default. Values: PUBLIC, FOLLOWERS, NOBODY */
  quoteApprovalPolicy?: QuotePolicyLevel | null;
  /** Location address for the post */
  address?: AddressData | null;
  /** Remove existing address from the post */
  removeAddress?: boolean;
};
export type ConversationActiveUser = {
  /** User ID */
  userId: TypeId;
  /** User's avatar upload */
  avatar?: Upload | null;
  /** Number of replies by this user in the thread */
  replyCount: number;
  /** Timestamp of user's most recent post in the thread */
  lastPostAt: Instant;
};
export type ConversationActiveUsersResult = {
  /** Active users in the thread */
  users: ConversationActiveUser[];
  /** Number of active users returned in this page */
  count: number;
  /** Total number of active users across all pages */
  totalCount: number;
};
export type ConversationActiveUserSortBy = "REPLY_COUNT" | "LAST_POST";
export type PostActivity = {
  user: User;
  createdAt: Instant;
};
export type PostEdit = {
  id: TypeId;
  text: string;
  summary: string | null;
  sensitive: boolean | null;
  uploads: Upload[];
  mentions: string[];
  pollOptions: string[];
  createdAt: Instant;
  card?: Card | null;
  emojis?: Emoji[] | null;
  ownerType: PostOwnerType;
  kind?: PostKind;
  mediaType?: PostMediaType;
};
export type UpdateInteractionPolicy = {
  /** Quote approval policy: PUBLIC, FOLLOWERS, or NOBODY */
  quoteApprovalPolicy: QuotePolicyLevel;
};
export type Attachment = {
  id: string;
  description: string | null;
};
export type Option = {
  title: string;
};
export type Poll1 = {
  id: string;
  options: Option[];
};
export type PostTranslation = {
  text: string;
  spoiler_text?: string | null;
  media_attachments?: Attachment[];
  poll?: Poll1 | null;
  detected_source_language?: string | null;
  provider?: string | null;
};
export type ActionModel = {
  name: string;
  description: string;
};
export type ResourceModel = {
  name: string;
  description: string;
  actions: ActionModel[];
};
export type RbacPermissions = {
  /** List of type-safe resource-specific access controls */
  resourceAccess: RbacResourceAccess[];
};
export type RbacRole = {
  /** Unique identifier for the role */
  roleId: RoleId;
  /** Name of the role, unique within its scope */
  name: string;
  /** Optional description of the role's purpose and responsibilities */
  description?: string | null;
  /** Set of permissions assigned to this role */
  permissions: RbacPermissions;
  /** Timestamp when the role was created */
  createdAt: Instant;
  /** Timestamp when the role was last updated */
  updatedAt: Instant;
};
export type RbacRoleTemplate = {
  /** Name of the role, unique within its scope */
  name: string;
  /** Optional description of the role's purpose and responsibilities */
  description?: string | null;
  /**
                The scope in which the role is valid.
                The scope can be Global (hardcoded), currently the only one is "global".
                Also the scope can be dynamic, currently we use Group Id, like "gr_05hxcvk1hjexere4pvtrj0hggt"
             */
  scope: string;
  /** Set of permissions to be assigned to this role */
  permissions: RbacPermissions;
};
export type CreateReport = {
  /** Report comment/reason text */
  comment: string;
  /** Type/reason for the report */
  type: ReportType;
  /** Group context for user reports (optional) */
  groupId?: TypeId | null;
  /** Target being reported (post, user, or group TypeId) */
  targetId: TypeId;
  /** Attachment upload IDs */
  uploadIds?: TypeId[];
  /** Whether to forward the report to the remote instance (ignored for group reports) */
  forward?: boolean;
};
export type EditReportComment = {
  /** Updated report comment/reason text */
  comment: string;
  /** Updated type/reason for the report */
  type: ReportType;
  /** Updated attachment upload IDs */
  uploadIds?: TypeId[];
};
export type RuleCreate = {
  /** The rule text that defines expected behavior or policy (max 500 characters) */
  text: string;
  /** Additional context or clarification for the rule (max 500 characters) */
  hint: string;
  /** Display order position - rules with lower values appear first */
  ordering: number;
};
export type SearchResult = {
  users?: UserFull[];
  posts?: Post[];
  tags?: string[];
  events?: Event[];
  groups?: Group[];
};
export type SearchResultWrite = {
  users?: UserFullWrite[];
  posts?: Post[];
  tags?: string[];
  events?: Event[];
  groups?: GroupWrite[];
};
export type SearchFilter = "users" | "posts" | "tags" | "events" | "groups";
export type SessionState = "ACTIVE" | "EXPIRED";
export type LoginType =
  | "EMAIL"
  | "USERNAME"
  | "PHONE"
  | "PASSKEY"
  | "IMPERSONATE"
  | "FEDERATION";
export type SessionExtra = {
  userAgent?: string | null;
  os?: string | null;
};
export type SessionInfo = {
  sessionKey: string;
  state: SessionState;
  accountId: TypeId;
  userId: TypeId;
  loginType: LoginType;
  ip: InetAddress;
  createdAt: Instant;
  countryCode: string | null;
  countryName: string | null;
  subdivision: string | null;
  city: string | null;
  extra: SessionExtra;
  lastUsed?: Instant | null;
};
export type AudioPolicy = {
  /** Allowed audio file extensions */
  extensions?: string[];
  /** Whether to keep the original audio file */
  keepOriginal?: boolean;
  /** Maximum allowed audio file size in bytes */
  maxSize?: number;
};
export type CaptchaConfig = {
  /** hCaptcha Account secret key */
  secretKey?: string;
  /** Sitekey if the same account is used on several sites */
  siteKey?: string;
};
export type CaptchaClientConfig = {
  /** Sitekey if the same account is used on several sites */
  siteKey?: string;
};
export type ConfirmationCodeConfigs = {
  /** Expiration time for confirmation code */
  codeExpirationMinutes?: number;
  /** Time duration after which the counter for unsuccessful attempts will be reset */
  counterExpirationMinutes?: number;
  /** Maximum number of attempts to check confirmation code */
  limitCheckAttempts?: number;
  /** Maximum number of attempts to request confirmation code */
  limitStoreAttempts?: number;
};
export type DocPolicy = {
  /** Allowed doc file extensions */
  extensions?: string[];
  /** Maximum allowed doc file size in bytes */
  maxSize?: number;
};
export type EmbeddingModelConfig = {
  /** Whether embeddings are enabled */
  enabled?: boolean;
  /** Embedding model ID to use for content embeddings */
  modelId?: string;
  /** Vector dimensions (set automatically from model) */
  vectorDimensions?: number;
};
export type EmojiPolicyConfig = {
  /** Maximum allowed single emoji image size in bytes */
  maxImageSize?: number;
  /** Maximum allowed ZIP size in bytes for emoji import */
  maxZipSize?: number;
};
export type FaspRemoteAdminConfig = {
  /** Admin token for authenticating with the FASP server */
  adminToken?: string;
  /** Base URL of the FASP server */
  baseUrl?: {
    scheme?: string;
    fragment?: string;
    authority?: string;
    userInfo?: string;
    host?: string;
    port?: number;
    path?: string;
    query?: string;
    schemeSpecificPart?: string;
    hash?: number;
    decodedUserInfo?: string;
    decodedAuthority?: string;
    decodedPath?: string;
    decodedQuery?: string;
    decodedFragment?: string;
    decodedSchemeSpecificPart?: string;
    string?: string;
  };
  /** Timestamp when this configuration was set */
  configuredAt?: string;
  isConfigured?: boolean;
  /** Friendly name for the FASP server */
  serverName?: string;
};
export type FederationModeConfig = {
  mode?: "OPEN" | "LIMITED" | "CLOSED";
};
export type ImagePolicy = {
  /** Allowed image file extensions */
  extensions?: string[];
  /** Whether to keep the original image file */
  keepOriginal?: boolean;
  /** Maximum allowed image matrix resolution (width * height) */
  maxMatrix?: number;
  /** Maximum allowed image resolution in pixels at the longest side */
  maxResolution?: number;
  /** Maximum allowed image file size in bytes */
  maxSize?: number;
  /** List of resolutions to convert the image to */
  resolutions?: number[];
};
export type InstanceAdmin = {
  /** Email of the server admin */
  email: string;
  /** Name of the server admin */
  name: string;
  /** Username of the server admin */
  username: string;
};
export type InstanceLegal = {
  /** Privacy policy text */
  privacyPolicy: string;
  /** Terms of use text */
  termsOfUse: string;
};
export type LanguageDetectionConfig = {
  /** Language detection key, depends on type */
  key?: string;
  /** Language detection service type */
  service?: "internal" | "detectlanguage" | "languagelayer" | "deepl";
};
export type MediaCacheConfig = {
  /** Whether media cache is enabled or not */
  enabled?: boolean;
  limitPerRun?: number;
  /** Maximum size of a single cached media file in bytes */
  maxFileSize?: number;
  /** Maximum total size of cached media in bytes */
  maxTotalSize?: number;
  singleRun?: boolean;
};
export type PostsConfig = {
  /** Whether posts are created in markdown format by default when not explicitly specified */
  default_markdown?: boolean;
  /** Maximum post size in characters */
  max_characters: number;
  /** Maximum number of attachments in post */
  max_media_attachments: number;
  /** Maximum number of pinned posts */
  max_pins: number;
};
export type RemoteLinkServiceConfig = {
  url?: {
    scheme?: string;
    fragment?: string;
    authority?: string;
    userInfo?: string;
    host?: string;
    port?: number;
    path?: string;
    query?: string;
    schemeSpecificPart?: string;
    hash?: number;
    decodedUserInfo?: string;
    decodedAuthority?: string;
    decodedPath?: string;
    decodedQuery?: string;
    decodedFragment?: string;
    decodedSchemeSpecificPart?: string;
    string?: string;
  };
};
export type SmsConfig = {
  /** List of supported countries */
  countries?: string[];
  /** Enable SMS service */
  enabled?: boolean;
  /** SMS service provider to use */
  provider?: string;
};
export type SmsConfigAwsSns = {
  accessKey?: string;
  fromUS?: string;
  region?: string;
  secretKey?: string;
  senderId?: string;
};
export type SmsConfigSinch = {
  accessKey?: string;
  accessSecret?: string;
  fromUS?: string;
  projectId?: string;
};
export type SmsConfigTwilio = {
  accountSid?: string;
  authToken?: string;
  serviceSid?: string;
};
export type TranslationConfig = {
  /** Whether translation is enabled on this server or not */
  enabled?: boolean;
};
export type TranslationServiceConfig = {
  /** Translation service key, depends on type */
  key?: string;
  /** Translation service type */
  service?: "none" | "deepl";
};
export type ProviderConfig = {
  baseUrl?: {
    scheme?: string;
    fragment?: string;
    authority?: string;
    userInfo?: string;
    host?: string;
    port?: number;
    path?: string;
    query?: string;
    schemeSpecificPart?: string;
    hash?: number;
    decodedUserInfo?: string;
    decodedAuthority?: string;
    decodedPath?: string;
    decodedQuery?: string;
    decodedFragment?: string;
    decodedSchemeSpecificPart?: string;
    string?: string;
  };
  cdn?: {
    media?: string;
    static?: string;
  };
  domain?: string;
  local?: {
    basePath?: string;
  };
  localBasePath?: object;
  provider?: object;
  s3?: {
    accessKey?: string;
    buckets?: {
      media?: string;
      static?: string;
    };
    endpoint?: string;
    presignedUrlExpiration?: number;
    region?: string;
    s3Region?: {
      isGlobalRegion?: boolean;
      id?: string;
    };
    secretKey?: string;
  };
  scheme?: "http" | "https";
  uploadsBasePath?: object;
};
export type UsernameReleaseConfig = {
  /** Whether username release is enabled */
  enabled?: boolean;
  /** Days after which deleted local users are completely purged, releasing their usernames */
  releasePeriodDays?: number;
};
export type VideoPolicy = {
  /** Allowed video file extensions */
  extensions?: string[];
  /** Whether to keep the original video file */
  keepOriginal?: boolean;
  /** Maximum allowed video duration in seconds */
  maxDuration?: number;
  /** Maximum allowed video matrix resolution (width * height) */
  maxMatrix?: number;
  /** Maximum allowed video resolution in pixels at the longest side */
  maxResolution?: number;
  /** Maximum allowed video file size in bytes */
  maxSize?: number;
  /** List of resolutions to convert the video to */
  resolutions?: number[];
  /** Threshold in seconds to convert video to m3u8 */
  streamingThreshold?: number;
};
export type PlatformSettings = {
  "wellesley.access"?: InstanceAccess;
  "wellesley.admin.ai.agents.budgets"?: AiAgentBudgetLimits;
  "wellesley.uploads.policy.audio"?: AudioPolicy;
  "wellesley.branding"?: InstanceBranding;
  "wellesley.admin.captcha"?: CaptchaConfig;
  "wellesley.captcha"?: CaptchaClientConfig;
  "wellesley.confirmationCode"?: ConfirmationCodeConfigs;
  "wellesley.uploads.policy.doc"?: DocPolicy;
  "wellesley.instance.domainBlocks"?: InstanceDomainBlocksPolicy;
  "wellesley.admin.embedding_model"?: EmbeddingModelConfig;
  "wellesley.uploads.policy.emoji"?: EmojiPolicyConfig;
  "wellesley.admin.fasp_remote"?: FaspRemoteAdminConfig;
  "wellesley.admin.federation.mode"?: FederationModeConfig;
  "wellesley.uploads.policy.image"?: ImagePolicy;
  "wellesley.instance.admin"?: InstanceAdmin;
  "wellesley.instance.contacts"?: InstanceContacts;
  "wellesley.instance.legal"?: InstanceLegal;
  "wellesley.admin.language"?: LanguageDetectionConfig;
  "wellesley.admin.mediacache"?: MediaCacheConfig;
  "wellesley.posts"?: PostsConfig;
  "wellesley.registration"?: InstanceRegistration;
  "wellesley.admin.link_service"?: RemoteLinkServiceConfig;
  "wellesley.admin.sms"?: SmsConfig;
  "wellesley.admin.sms.aws"?: SmsConfigAwsSns;
  "wellesley.admin.sms.sinch"?: SmsConfigSinch;
  "wellesley.admin.sms.twilio"?: SmsConfigTwilio;
  "wellesley.translation"?: TranslationConfig;
  "wellesley.admin.translation"?: TranslationServiceConfig;
  "wellesley.admin.uploads"?: ProviderConfig;
  "wellesley.username.release"?: UsernameReleaseConfig;
  "wellesley.uploads.policy.video"?: VideoPolicy;
};
export type Namespace = "Platform" | "User" | "Group" | "GroupMember";
export type UserDiscoverFeedConfig = {
  filter?: "ALL" | "LOCAL" | "REMOTE";
};
export type FollowConfig = {
  autoAccept?: boolean;
};
export type NotificationPolicy = {
  blockNewAccounts?: boolean;
  blockNonFollowers?: boolean;
  blockNonFollowing?: boolean;
  blockNonFollowingMessages?: boolean;
};
export type NotificationPrefs = {
  email?: {
    comment?: boolean;
    eventCancel?: boolean;
    eventInvite?: boolean;
    eventJoin?: boolean;
    eventUpdate?: boolean;
    follow?: boolean;
    followRequest?: boolean;
    groupInvite?: boolean;
    like?: boolean;
    listPostCreate?: boolean;
    mention?: boolean;
    mute?: {
      enabled?: boolean;
      expiresAt?: string;
    };
    pollVote?: boolean;
    postUpdate?: boolean;
    postVote?: boolean;
    repost?: boolean;
  };
  push?: {
    comment?: boolean;
    eventCancel?: boolean;
    eventInvite?: boolean;
    eventJoin?: boolean;
    eventUpdate?: boolean;
    follow?: boolean;
    followRequest?: boolean;
    groupInvite?: boolean;
    like?: boolean;
    listPostCreate?: boolean;
    mention?: boolean;
    mute?: {
      enabled?: boolean;
      expiresAt?: string;
    };
    pollVote?: boolean;
    postUpdate?: boolean;
    postVote?: boolean;
    repost?: boolean;
  };
  subscribeOnComment?: boolean;
  syncAcrossProfiles?: boolean;
};
export type PrivacyConfig = {
  discoverable?: boolean;
  showFollowers?: boolean;
  showGroups?: boolean;
  showProfilePage?: boolean;
  showPublicPosts?: boolean;
};
export type QuotePolicy = {
  canQuote?: "PUBLIC" | "FOLLOWERS" | "NOBODY";
};
export type UserTranslationConfig = {
  /** List of languages not offered for translation */
  excludedLanguages?: string[];
  /** Filter posts to show only in those languages */
  filter?: string[];
  /** Language to translate posts to */
  preferredLanguage?: string;
  /** Language to use in UI */
  primaryLanguage?: string;
};
export type UserSettings = {
  "user.discoverFeed"?: UserDiscoverFeedConfig;
  "user.follow"?: FollowConfig;
  "user.notifications.policy"?: NotificationPolicy;
  "user.notifications.prefs"?: NotificationPrefs;
  "user.privacy"?: PrivacyConfig;
  "user.quotePolicy"?: QuotePolicy;
  "user.translation"?: UserTranslationConfig;
};
export type TagPolicyMode = "WHITELIST" | "BLACKLIST";
export type SetTagPolicyRequest = {
  /** Policy mode: 'whitelist' or 'blacklist' */
  mode: "WHITELIST" | "BLACKLIST";
};
export type CreateTagReportRequest = {
  /** Reason for reporting the tag */
  reason: string;
};
export type TranslationResponse = {
  text: string;
};
export type TranslationRequest = {
  text: string;
  language: Language;
  isHtml?: boolean;
};
export type CreateUploadResult = {
  uri: string;
  upload: Upload;
};
export type UploadPrivacy = "Public" | "Private" | "Direct";
export type CreateUpload = {
  extension: string;
  isGzipped?: boolean;
  /** User meta attached to upload. Can contain information like name etc. */
  meta?: Meta | null;
  /** Tags attached to the upload */
  tags?: UploadsTags[];
  /** Privacy of the upload. Possible values: PUBLIC, PRIVATE, DIRECT. */
  privacy?: UploadPrivacy | null;
  /**
            Can contain a list of users who are allowed to access the upload.
            Works only for uploads with privacy set to DIRECT.
             */
  allowedUsers?: string[] | null;
  /** Optional owner entity for this upload. When not provided, defaults to the uploading user. Can be a channel, category, or event TypeID. The uploader must have permission to upload for this owner. */
  ownerId?: TypeId | null;
};
export type ListUploadsResult = {
  list: Upload[];
  total: number;
};
export type UploadList = {
  userId: TypeId;
  tags?: UploadsTags[];
  orderType?: string;
  page?: number;
  limit?: number;
};
export type PostAttachment = {
  postId: TypeId;
  uploadId: TypeId;
};
export type UploadUsages = {
  posts: PostAttachment[];
  avatars: TypeId[] | null;
  headers: TypeId[] | null;
};
export type DeleteUploadResponse = {
  /** ID of deleted upload */
  id: TypeId;
};
export type UpdateUploadPrivacy = {
  /** New privacy of the upload. Possible values: PUBLIC, PRIVATE, DIRECT. */
  privacy: UploadPrivacy;
  /**
            Can contain a list of users who are allowed to access the upload.
            Works only for uploads with privacy set to DIRECT.
             */
  allowedUsers?: string[] | null;
};
export type ChangeVideoThumbnail = {
  time: number;
};
export type UpdateUploadOwner = {
  /** New owner ID for the upload */
  newOwnerId: TypeId;
};
export type FollowResult = {
  result: string;
};
export type AppScheme = "http" | "https";
export type SignupInviteLink = {
  /** Unique invite code */
  code: string;
  /** Owner user id who created the link */
  ownerUserId: TypeId;
  /** Expiration timestamp (UTC) */
  expiresAt?: Instant | null;
  /** Maximum number of uses. Null means unlimited. */
  maxUses?: number | null;
  /** Number of uses so far */
  usedCount: number;
  /** Whether link is active (not deactivated) */
  active: boolean;
  /** Creation timestamp (UTC) */
  createdAt: Instant;
  /** Deactivation timestamp (UTC) */
  deactivatedAt?: Instant | null;
  /** List of account IDs created using this link */
  accounts: TypeId[];
};
export type SignupInviteLinkList = {
  links: SignupInviteLink[];
  total: number;
};
export type SignupInviteLinkCreate = {
  /** Expiration timestamp (UTC). Must be in the future if provided. */
  expiresAt?: Instant | null;
  /** Maximum number of uses. Use null or 0 for unlimited */
  maxUses?: number | null;
};
export type UsernameHistory = {
  username: string;
  domain: string;
  userId: TypeId | null;
  createdAt: Instant;
};
export type UsernameHistories = {
  history: UsernameHistory[];
  maxRenames: number;
};
export type DeepSyncResponse = {
  /** Current sync state of the remote user */
  syncState: SyncState | null;
};
export type UserUpdateMedia = {
  /** Avatar upload id or null to remove */
  avatarId?: TypeId | null;
  /** Header upload id or null to remove */
  headerId?: TypeId | null;
};
export type RootPageData = object;
export type UserPageData = {
  noindex?: boolean;
  user?: UserFull;
};
export type UserPageDataWrite = {
  noindex?: boolean;
  user?: UserFullWrite;
};
export type UserEventPageData = {
  event?: Event;
  noindex?: boolean;
  user?: UserFull;
};
export type UserEventPageDataWrite = {
  event?: Event;
  noindex?: boolean;
  user?: UserFullWrite;
};
export type UserPostPageData = {
  noindex?: boolean;
  post?: Post;
  user?: UserFull;
};
export type UserPostPageDataWrite = {
  noindex?: boolean;
  post?: Post;
  user?: UserFullWrite;
};
export type AboutPageData = {
  brandingSettings?: object;
};
export type FeedPageData = {
  feed?: Post[];
};
export type FeedDiscoverPageData = {
  feed?: Post[];
};
export type FeedFollowingPageData = {
  feed?: Post[];
};
export type GroupPageData = {
  currentUserGroupPermissions?: object;
  group?: Group;
  groupApps?: Application[];
};
export type GroupPageDataWrite = {
  currentUserGroupPermissions?: object;
  group?: GroupWrite;
  groupApps?: Application[];
};
export type UserView = {
  /** User's moderation state */
  state: UserState;
  /** Whether this user is a person, application or a service */
  actorType?: ActorType | null;
  /** Type of user entity: USER, CHANNEL, or CATEGORY */
  type?: UserType | null;
  /** Additional metadata (color, styling) */
  meta?: UserMeta | null;
  /** Whether this is a channel or a user. Deprecated: use 'type' instead. */
  channel: boolean;
  /** Group ID if this is a group channel, group user or category. */
  groupId?: TypeId | null;
  /** Privacy of this channel/category in a group. */
  groupPrivacy?: GroupChannelPrivacy | null;
  /** Name of the channel inside a group */
  groupUserName?: string | null;
  /** true if this is primary group channel. */
  groupPrimary?: boolean | null;
  /** true if this is auto-subscribe group channel. */
  groupAutoSubscribe?: boolean | null;
  deleted?: boolean | null;
  /** internal id of this user */
  id: TypeId;
  /** unique user name */
  username: string;
  /** User's domain */
  domain: string;
  /** Whether this user is local to this server */
  local: boolean;
  /** full name of the user */
  displayName: string;
  /** URI of this user */
  uri: string;
  /** User's creation time */
  createdAt: Instant;
  /** User's avatar */
  avatar?: Upload | null;
  /** Relationship with this user */
  relationship?: Relationship | null;
};
export type GroupChannelPageData = {
  channel?: UserView;
  currentUserGroupPermissions?: object;
  group?: Group;
  groupApps?: Application[];
};
export type GroupChannelPageDataWrite = {
  channel?: UserView;
  currentUserGroupPermissions?: object;
  group?: GroupWrite;
  groupApps?: Application[];
};
export type GroupChannelPostPageData = {
  channel?: UserView;
  currentUserGroupPermissions?: object;
  group?: Group;
  groupApps?: Application[];
  post?: Post;
};
export type GroupChannelPostPageDataWrite = {
  channel?: UserView;
  currentUserGroupPermissions?: object;
  group?: GroupWrite;
  groupApps?: Application[];
  post?: Post;
};
export type GroupBotPageData = {
  group?: Group;
  user?: UserFull;
};
export type GroupBotPageDataWrite = {
  group?: GroupWrite;
  user?: UserFullWrite;
};
export type GroupEventPageData = {
  currentUserGroupPermissions?: object;
  event?: Event;
  group?: Group;
  groupApps?: Application[];
};
export type GroupEventPageDataWrite = {
  currentUserGroupPermissions?: object;
  event?: Event;
  group?: GroupWrite;
  groupApps?: Application[];
};
export type GroupForumCategoryPageData = {
  category?: Category;
  currentUserGroupPermissions?: object;
  group?: Group;
  groupApps?: Application[];
};
export type GroupForumCategoryPageDataWrite = {
  category?: CategoryWrite;
  currentUserGroupPermissions?: object;
  group?: GroupWrite;
  groupApps?: Application[];
};
export type GroupForumPostPageData = {
  category?: Category;
  currentUserGroupPermissions?: object;
  group?: Group;
  groupApps?: Application[];
  post?: Post;
};
export type GroupForumPostPageDataWrite = {
  category?: CategoryWrite;
  currentUserGroupPermissions?: object;
  group?: GroupWrite;
  groupApps?: Application[];
  post?: Post;
};
export type ForumTagPageData = {
  currentUserGroupPermissions?: object;
  group?: Group;
  groupApps?: Application[];
  tag?: Tag;
};
export type ForumTagPageDataWrite = {
  currentUserGroupPermissions?: object;
  group?: GroupWrite;
  groupApps?: Application[];
  tag?: Tag;
};
export type PrivacyPageData = {
  legalSettings?: object;
};
export type TermsPageData = {
  legalSettings?: object;
};
export const {
  useGetApiMetaCompatQuery,
  usePostApiV1AccountsAddReasonMutation,
  usePostApiV1AccountsAuthenticateEmailMutation,
  usePostApiV1AccountsAuthenticatePhoneMutation,
  usePutApiV1AccountsChangeNameMutation,
  usePostApiV1AccountsCheckCaptchaMutation,
  usePostApiV1AccountsConfirmEmailMutation,
  usePostApiV1AccountsConfirmPhoneMutation,
  useDeleteApiV1AccountsDeleteMutation,
  usePostApiV1AccountsEmailChangeConfirmMutation,
  usePostApiV1AccountsEmailChangeRequestMutation,
  usePutApiV1AccountsEmailChangeResendCodeMutation,
  usePostApiV1AccountsFinishCreatingMutation,
  usePutApiV1AccountsGetTokenByHashMutation,
  usePostApiV1AccountsLoginsAddEmailPasswordMutation,
  usePostApiV1AccountsLoginsAddEmailPasswordConfirmMutation,
  usePutApiV1AccountsLoginsAddEmailPasswordResendCodeMutation,
  usePostApiV1AccountsLoginsAddPhoneMutation,
  useDeleteApiV1AccountsLoginsRemoveEmailPasswordMutation,
  useDeleteApiV1AccountsLoginsRemovePhoneMutation,
  usePostApiV1AccountsPasswordChangeConfirmMutation,
  usePostApiV1AccountsPasswordChangeRequestMutation,
  usePutApiV1AccountsPasswordChangeResendCodeMutation,
  usePostApiV1AccountsPasswordRecoverMutation,
  usePostApiV1AccountsPasswordRecoverChangeMutation,
  usePostApiV1AccountsPasswordRecoverCheckCodeMutation,
  usePostApiV1AccountsPhoneChangeConfirmAuthMutation,
  usePostApiV1AccountsPhoneChangeConfirmNewPhoneMutation,
  usePostApiV1AccountsPhoneChangeNewPhoneMutation,
  usePutApiV1AccountsPhoneChangeRequestMutation,
  usePutApiV1AccountsPhoneChangeResendCodeAuthMutation,
  usePutApiV1AccountsPhoneChangeResendCodeNewPhoneMutation,
  useGetApiV1AccountsProfileQuery,
  usePutApiV1AccountsResendCodeByHashMutation,
  usePutApiV1AccountsResendEmailByHashMutation,
  usePostApiV1AccountsSignupMutation,
  usePostApiV1AccountsSignupPhoneMutation,
  usePostApiV1AccountsUserReselectUserMutation,
  useGetApiV1AccountsUsersOwnedGroupsQuery,
  useGetApiV1AddressesSuggestQuery,
  useGetApiV1AdminAccountByAccountIdQuery,
  useGetApiV1AdminAuditLogQuery,
  usePutApiV1AdminChangeEmailMutation,
  usePutApiV1AdminChangePasswordMutation,
  usePutApiV1AdminChangeRoleAssignMutation,
  usePutApiV1AdminChangeRoleRevokeMutation,
  usePostApiV1AdminClearApErrorsMutation,
  usePostApiV1AdminCreateAccountMutation,
  usePostApiV1AdminCreateUserMutation,
  useDeleteApiV1AdminDeleteMutation,
  useDeleteApiV1AdminDeleteUserMutation,
  useGetApiV1AdminDomainAllowQuery,
  usePostApiV1AdminDomainAllowMutation,
  useDeleteApiV1AdminDomainAllowByDomainMutation,
  usePutApiV1AdminDomainBlockMutation,
  useGetApiV1AdminDomainBlockQuery,
  usePostApiV1AdminDomainBlockMutation,
  useDeleteApiV1AdminDomainBlockByDomainMutation,
  useGetApiV1AdminEmailAllowQuery,
  usePostApiV1AdminEmailAllowMutation,
  useDeleteApiV1AdminEmailAllowByDomainMutation,
  useGetApiV1AdminEmailBlockQuery,
  usePostApiV1AdminEmailBlockMutation,
  useDeleteApiV1AdminEmailBlockByPatternMutation,
  usePutApiV1AdminEmbeddingsDisableMutation,
  usePutApiV1AdminEmbeddingsEnableMutation,
  useGetApiV1AdminEmbeddingsEstimateCostQuery,
  useDeleteApiV1AdminEmbeddingsRecalculationMutation,
  useGetApiV1AdminEmbeddingsStatusQuery,
  useGetApiV1AdminFaspRemoteBackfillsQuery,
  useGetApiV1AdminFaspRemoteBlocklistQuery,
  useDeleteApiV1AdminFaspRemoteBlocklistByDomainMutation,
  usePostApiV1AdminFaspRemoteBlocklistByDomainMutation,
  useDeleteApiV1AdminFaspRemoteConfigMutation,
  useGetApiV1AdminFaspRemoteConfigQuery,
  usePostApiV1AdminFaspRemoteConfigMutation,
  usePostApiV1AdminFaspRemoteRecoverStateMutation,
  useGetApiV1AdminFaspRemoteRegistrationsQuery,
  usePostApiV1AdminFaspRemoteRegistrationsByServerIdApproveMutation,
  usePostApiV1AdminFaspRemoteRegistrationsByServerIdBackfillMutation,
  usePostApiV1AdminFaspRemoteRegistrationsByServerIdBlockMutation,
  usePostApiV1AdminFaspRemoteRegistrationsByServerIdDeclineMutation,
  usePostApiV1AdminFaspRemoteRegistrationsByServerIdRecoverStateMutation,
  usePostApiV1AdminFaspRemoteRotateTokenConfirmMutation,
  usePostApiV1AdminFaspRemoteRotateTokenRequestMutation,
  useGetApiV1AdminFaspRemoteStatsQuery,
  useGetApiV1AdminFaspRemoteSubscriptionsQuery,
  usePostApiV1AdminFaspRemoteTokenRecoverMutation,
  usePostApiV1AdminFaspRemoteTokenRecoverConfirmMutation,
  useGetApiV1AdminFaspRemoteUpdateQuery,
  useGetApiV1AdminFaspDefaultsQuery,
  usePutApiV1AdminFaspDefaultsByCapabilityMutation,
  useDeleteApiV1AdminFaspDefaultsByCapabilityMutation,
  useGetApiV1AdminFaspDefaultsByCapabilityQuery,
  useGetApiV1AdminFaspProvidersQuery,
  useGetApiV1AdminFaspProvidersByFaspIdQuery,
  usePostApiV1AdminFaspProvidersByFaspIdAcceptMutation,
  usePostApiV1AdminFaspProvidersByFaspIdBackfillMutation,
  usePostApiV1AdminFaspProvidersByFaspIdBlockMutation,
  usePostApiV1AdminFaspProvidersByFaspIdCapabilitiesMutation,
  usePostApiV1AdminFaspProvidersByFaspIdDeclineMutation,
  useGetApiV1AdminFederationQuery,
  usePutApiV1AdminFederationConfigMutation,
  useGetApiV1AdminFederationConfigQuery,
  useGetApiV1AdminFederationMetricsOperationsQuery,
  useGetApiV1AdminFederationMetricsRunningAverageSingleQuery,
  useGetApiV1AdminFederationMetricsRunningAveragesAllQuery,
  usePutApiV1AdminFederationModeMutation,
  useGetApiV1AdminFederationModeQuery,
  useGetApiV1AdminFederationByDomainQuery,
  usePostApiV1AdminFeedClearUserFeedMutation,
  useGetApiV1AdminFeedCountUserFeedQuery,
  useGetApiV1AdminFeedDiagnoseQuery,
  useGetApiV1AdminFeedMetricsGlobalAllOperationQuery,
  useGetApiV1AdminFeedMetricsGlobalSingleQuery,
  useGetApiV1AdminFeedMetricsHistoryQuery,
  useGetApiV1AdminFeedMetricsHistoryAllQuery,
  useGetApiV1AdminFeedMetricsRunningAverageSingleQuery,
  useGetApiV1AdminFeedMetricsRunningAveragesAllQuery,
  useGetApiV1AdminFeedMetricsSlowestOperationsQuery,
  useGetApiV1AdminFeedMetricsSlowestUsersQuery,
  useGetApiV1AdminFeedMetricsSlowestUsersAllQuery,
  useGetApiV1AdminFeedMetricsSlowestUsersSingleQuery,
  useGetApiV1AdminFeedMetricsSummaryQuery,
  useGetApiV1AdminFeedMetricsUserCountAllQuery,
  useGetApiV1AdminFeedMetricsUserCountSingleQuery,
  usePostApiV1AdminFeedRegenerateUserFeedMutation,
  useGetApiV1AdminGroupsSearchQuery,
  useGetApiV1AdminGroupsUserByUserIdQuery,
  useGetApiV1AdminGroupsByAccountIdQuery,
  useGetApiV1AdminGroupsByGroupIdCategoriesQuery,
  useGetApiV1AdminGroupsByGroupIdChannelsQuery,
  useGetApiV1AdminGroupsByGroupIdEventsQuery,
  useGetApiV1AdminImpersonateQuery,
  useGetApiV1AdminLinkServiceQuery,
  usePostApiV1AdminLinkServiceConfigureMutation,
  usePostApiV1AdminPostsDeleteMutation,
  useDeleteApiV1AdminPurgeMutation,
  usePostApiV1AdminRegenerateKeysMutation,
  usePostApiV1AdminRegenerateKeysAllMutation,
  usePostApiV1AdminReleaseUsernameMutation,
  useGetApiV1AdminReportsEligibleAssigneesQuery,
  useGetApiV1AdminReportsListQuery,
  useGetApiV1AdminReportsReportedGroupsQuery,
  useGetApiV1AdminReportsReportedPostsQuery,
  useGetApiV1AdminReportsReportedUsersQuery,
  useGetApiV1AdminReportsByReportIdQuery,
  usePostApiV1AdminReportsByReportIdAddNoteMutation,
  usePostApiV1AdminReportsByReportIdAssignMutation,
  useDeleteApiV1AdminReportsByReportIdDeleteMutation,
  usePostApiV1AdminReportsByReportIdDismissMutation,
  usePostApiV1AdminReportsByReportIdRemoveNoteMutation,
  usePostApiV1AdminReportsByReportIdReopenMutation,
  usePostApiV1AdminReportsByReportIdResolveMutation,
  usePostApiV1AdminReportsByReportIdUnassignMutation,
  usePostApiV1AdminRestartApDeliveryMutation,
  useGetApiV1AdminSearchQuery,
  usePutApiV1AdminSignupRequestsApproveByHashMutation,
  useDeleteApiV1AdminSignupRequestsDeleteByHashMutation,
  useGetApiV1AdminSignupRequestsListQuery,
  usePutApiV1AdminSignupRequestsRejectByHashMutation,
  useGetApiV1AdminUploadsJobsQueueByQueueNameQuery,
  useGetApiV1AdminUploadsJobsSummaryQuery,
  useGetApiV1AdminUploadsSearchQuery,
  useGetApiV1AdminUploadsStorageByUserIdQuery,
  useGetApiV1AdminUploadsByUploadIdLogsQuery,
  usePostApiV1AdminUserChangeStateMutation,
  usePostApiV1AdminUserChangeStateBulkMutation,
  useGetApiV1AdminUserByUserIdQuery,
  useGetApiV1AiAgentsQuery,
  usePostApiV1AiAgentsMutation,
  useGetApiV1AiAgentsPostsQuery,
  useGetApiV1AiAgentsByAgentIdQuery,
  useDeleteApiV1AiAgentsByAgentIdMutation,
  usePutApiV1AiAgentsByAgentIdDisableMutation,
  usePutApiV1AiAgentsByAgentIdEnableMutation,
  usePutApiV1AiAgentsByAgentIdProfileMutation,
  usePutApiV1AiAgentsByAgentIdUserMutation,
  useGetApiV1AiAgentsByAgentIdVersionsQuery,
  useGetApiV1AiAgentsByAgentIdVersionsAndVersionQuery,
  useGetApiV1AiModelsQuery,
  useGetApiV1AiModelsByModelIdQuery,
  useGetApiV1AiModelsByModelIdAgentsQuery,
  useDeleteApiV1AiModelsByModelIdConfigureMutation,
  usePutApiV1AiModelsByModelIdDisableMutation,
  usePutApiV1AiModelsByModelIdEnableMutation,
  useGetApiV1AiModelsByModelIdMigrationPathQuery,
  useGetApiV1AiModelsByModelIdResolveQuery,
  useGetApiV1AiProvidersQuery,
  useGetApiV1AiProvidersByProviderIdQuery,
  useGetApiV1AiProvidersByProviderIdAgentsQuery,
  useDeleteApiV1AiProvidersByProviderIdConfigureMutation,
  usePutApiV1AiProvidersByProviderIdConfigureMutation,
  useGetApiV1AiProvidersByProviderIdModelsQuery,
  usePostApiV1AppsMutation,
  useGetApiV1AppsQuery,
  useGetApiV1AppsEnabledQuery,
  useGetApiV1AppsInstalledQuery,
  useGetApiV1AppsUserQuery,
  useDeleteApiV1AppsUserByAppIdMutation,
  usePutApiV1AppsUserByAppIdMutation,
  usePutApiV1AppsByAppIdMutation,
  useGetApiV1AppsByAppIdQuery,
  useDeleteApiV1AppsByAppIdMutation,
  useGetApiV1AppsByAppIdDataQuery,
  usePostApiV1AppsByAppIdDataMutation,
  usePutApiV1AppsByAppIdDataAndIdMutation,
  useDeleteApiV1AppsByAppIdDataAndIdMutation,
  usePutApiV1AppsByAppIdDefaultMutation,
  usePutApiV1AppsByAppIdDisableMutation,
  usePutApiV1AppsByAppIdEnableMutation,
  useGetApiV1AppsByAppIdStatsQuery,
  usePutApiV1AppsByAppIdUserDefaultMutation,
  useDeleteApiV1AppsByAppIdUserDefaultMutation,
  useGetApiV1AsyncRefreshesByIdQuery,
  useGetApiV1BlockQuery,
  useGetApiV1BlockByQuery,
  useDeleteApiV1BlockByUserIdMutation,
  usePostApiV1BlockByUserIdMutation,
  useGetApiV1CustomEmojisQuery,
  useDeleteApiV1CustomEmojisMutation,
  usePostApiV1CustomEmojisMutation,
  useGetApiV1CustomEmojisCategoriesQuery,
  useGetApiV1CustomEmojisExportQuery,
  usePostApiV1CustomEmojisImportMutation,
  usePostApiV1CustomEmojisImportUploadMutation,
  useGetApiV1CustomEmojisSearchQuery,
  usePostApiV1CustomEmojisUploadMutation,
  usePatchApiV1CustomEmojisByShortcodeMutation,
  useGetApiV1DataQuery,
  usePostApiV1DataMutation,
  usePutApiV1DataByIdMutation,
  useDeleteApiV1DataByIdMutation,
  usePutApiV1DevicesMutation,
  useGetApiV1DevicesQuery,
  useDeleteApiV1DevicesAllMutation,
  useGetApiV1DevicesVapidPublicKeyQuery,
  useDeleteApiV1DevicesByDeviceIdMutation,
  useGetApiV1DomainBlockQuery,
  useGetApiV1DraftsQuery,
  usePostApiV1DraftsMutation,
  useGetApiV1DraftsPostByPostIdQuery,
  usePutApiV1DraftsByDraftIdMutation,
  useGetApiV1DraftsByDraftIdQuery,
  useDeleteApiV1DraftsByDraftIdMutation,
  usePostApiV1DraftsByDraftIdPublishMutation,
  useGetApiV1EventsQuery,
  usePostApiV1EventsMutation,
  useGetApiV1EventsCalendarGByGroupnameIcsQuery,
  useGetApiV1EventsCalendarPByIdIcsQuery,
  useGetApiV1EventsCalendarUByUsernameIcsQuery,
  useGetApiV1EventsMyQuery,
  useGetApiV1EventsSearchQuery,
  useGetApiV1EventsSettingsQuery,
  usePostApiV1EventsSettingsRegeneratePrivateIdMutation,
  usePostApiV1EventsSettingsUpdateMutation,
  usePutApiV1EventsByEventIdMutation,
  useGetApiV1EventsByEventIdQuery,
  useDeleteApiV1EventsByEventIdMutation,
  useGetApiV1EventsByEventIdIcsQuery,
  usePostApiV1EventsByEventIdAcceptMutation,
  useGetApiV1EventsByEventIdAttendeesQuery,
  useDeleteApiV1EventsByEventIdAttendeesAndUserIdMutation,
  usePostApiV1EventsByEventIdAttendeesAndUserIdMutation,
  usePostApiV1EventsByEventIdCancelMutation,
  usePostApiV1EventsByEventIdInterestedMutation,
  usePostApiV1EventsByEventIdJoinMutation,
  useDeleteApiV1EventsByEventIdJoinOrInterestedMutation,
  usePostApiV1EventsByEventIdMaybeMutation,
  useGetApiV1EventsByEventIdMutualQuery,
  usePostApiV1EventsByEventIdRejectMutation,
  usePostApiV1EventsByEventIdTranslateMutation,
  usePostApiV1FaspClearMutation,
  usePostApiV1FaspRegistrationMutation,
  usePostApiV1FaspByProviderIdCapabilitiesMutation,
  usePostApiV1FaspByProviderIdDebugCallMutation,
  usePostApiV1FaspByProviderIdRequestBackfillMutation,
  usePostApiV1FederationTokensMutation,
  useGetApiV1GeoQuery,
  useGetApiV1GroupsQuery,
  usePostApiV1GroupsMutation,
  useGetApiV1GroupsAppsQuery,
  useGetApiV1GroupsInvitesQuery,
  useGetApiV1GroupsMemberByUserIdQuery,
  useGetApiV1GroupsMemberByUserIdGroupsQuery,
  useGetApiV1GroupsMyGroupsQuery,
  useGetApiV1GroupsNameByGroupnameQuery,
  useGetApiV1GroupsOwnedQuery,
  useGetApiV1GroupsPinnedQuery,
  useGetApiV1GroupsSearchQuery,
  useGetApiV1GroupsUsersByUserIdMutualQuery,
  usePutApiV1GroupsByGroupIdMutation,
  useGetApiV1GroupsByGroupIdQuery,
  useDeleteApiV1GroupsByGroupIdMutation,
  useGetApiV1GroupsByGroupIdAppsQuery,
  useDeleteApiV1GroupsByGroupIdAppsAndAppIdMutation,
  usePutApiV1GroupsByGroupIdAppsAndAppIdMutation,
  useGetApiV1GroupsByGroupIdBlocksQuery,
  useDeleteApiV1GroupsByGroupIdBlocksMutation,
  usePostApiV1GroupsByGroupIdBlocksMutation,
  usePutApiV1GroupsByGroupIdBrandingMutation,
  useGetApiV1GroupsByGroupIdCategoriesQuery,
  usePostApiV1GroupsByGroupIdCategoriesMutation,
  useGetApiV1GroupsByGroupIdCategoriesNameAndCategoryNameQuery,
  usePutApiV1GroupsByGroupIdCategoriesAndCategoryIdMutation,
  useGetApiV1GroupsByGroupIdCategoriesAndCategoryIdQuery,
  useDeleteApiV1GroupsByGroupIdCategoriesAndCategoryIdMutation,
  useGetApiV1GroupsByGroupIdChannelsQuery,
  usePostApiV1GroupsByGroupIdChannelsMutation,
  useGetApiV1GroupsByGroupIdChannelsAutoSubscribeQuery,
  useGetApiV1GroupsByGroupIdChannelsLookupQuery,
  useGetApiV1GroupsByGroupIdChannelsPrimaryQuery,
  useGetApiV1GroupsByGroupIdChannelsPublicQuery,
  usePutApiV1GroupsByGroupIdChannelsAndChannelIdMutation,
  useGetApiV1GroupsByGroupIdChannelsAndChannelIdQuery,
  useDeleteApiV1GroupsByGroupIdChannelsAndChannelIdMutation,
  usePutApiV1GroupsByGroupIdChannelsAndChannelIdAutoSubscribeMutation,
  usePutApiV1GroupsByGroupIdChannelsAndChannelIdPrimaryMutation,
  usePutApiV1GroupsByGroupIdChannelsAndChannelIdUsernameMutation,
  useGetApiV1GroupsByGroupIdDetailsQuery,
  usePostApiV1GroupsByGroupIdFederationTokenMutation,
  usePutApiV1GroupsByGroupIdForumMutation,
  useGetApiV1GroupsByGroupIdForumQuery,
  useDeleteApiV1GroupsByGroupIdForumMutation,
  useDeleteApiV1GroupsByGroupIdForumHardMutation,
  useGetApiV1GroupsByGroupIdForumStatsQuery,
  useGetApiV1GroupsByGroupIdForumTagsQuery,
  useGetApiV1GroupsByGroupIdForumTagsSearchQuery,
  useGetApiV1GroupsByGroupIdInviteQuery,
  useGetApiV1GroupsByGroupIdInvitesQuery,
  usePostApiV1GroupsByGroupIdInvitesMutation,
  usePostApiV1GroupsByGroupIdInvitesAcceptMutation,
  usePostApiV1GroupsByGroupIdInvitesRejectMutation,
  useDeleteApiV1GroupsByGroupIdInvitesAndGroupInviteIdMutation,
  usePostApiV1GroupsByGroupIdJoinMutation,
  useDeleteApiV1GroupsByGroupIdJoinMutation,
  useGetApiV1GroupsByGroupIdJoinRequestsQuery,
  useDeleteApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdMutation,
  usePutApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdMutation,
  usePutApiV1GroupsByGroupIdMemberSettingsMutation,
  useGetApiV1GroupsByGroupIdMemberSettingsQuery,
  useDeleteApiV1GroupsByGroupIdMemberSettingsMutation,
  useGetApiV1GroupsByGroupIdMembersQuery,
  usePostApiV1GroupsByGroupIdMembersMutation,
  useGetApiV1GroupsByGroupIdMembersSearchQuery,
  usePutApiV1GroupsByGroupIdMembersAndMemberIdMutation,
  useDeleteApiV1GroupsByGroupIdMembersAndMemberIdMutation,
  usePostApiV1GroupsByGroupIdMembersAndNewOwnerIdTransferOwnershipMutation,
  useDeleteApiV1GroupsByGroupIdMembershipMutation,
  useGetApiV1GroupsByGroupIdMembershipQuery,
  useDeleteApiV1GroupsByGroupIdPinMutation,
  usePutApiV1GroupsByGroupIdPinMutation,
  useGetApiV1GroupsByGroupIdQuestionsQuery,
  usePostApiV1GroupsByGroupIdQuestionsMutation,
  usePostApiV1GroupsByGroupIdQuestionsAnswersMutation,
  usePutApiV1GroupsByGroupIdQuestionsAndQuestionIdMutation,
  useDeleteApiV1GroupsByGroupIdQuestionsAndQuestionIdMutation,
  useGetApiV1GroupsByGroupIdRulesQuery,
  usePostApiV1GroupsByGroupIdRulesMutation,
  usePostApiV1GroupsByGroupIdRulesReorderMutation,
  useDeleteApiV1GroupsByGroupIdRulesAndIdMutation,
  usePutApiV1GroupsByGroupIdRulesAndRuleIdMutation,
  usePutApiV1GroupsByGroupIdSettingsMutation,
  useGetApiV1GroupsByGroupIdSettingsQuery,
  useDeleteApiV1GroupsByGroupIdSettingsMutation,
  useGetApiV1GroupsByGroupIdUsersQuery,
  useGetApiV1ImportQuery,
  usePostApiV1ImportMutation,
  usePostApiV1ImportStartByIdMutation,
  useGetApiV1ImportByIdQuery,
  useGetApiV1InstanceQuery,
  useGetApiV1InstanceCountriesQuery,
  useGetApiV1InstanceDomainsQuery,
  useGetApiV1InstanceExtendedDescriptionQuery,
  useGetApiV1InstanceSupportedLanguagesQuery,
  useGetApiV1InstanceTimezonesQuery,
  useDeleteApiV1JobsClearMutation,
  useGetApiV1JobsDlqQuery,
  useDeleteApiV1JobsJobMutation,
  useGetApiV1JobsListJobsQuery,
  useGetApiV1JobsListStatsQuery,
  useGetApiV1JobsListStatsAllQuery,
  useGetApiV1JobsListsQuery,
  useGetApiV1JobsProcessesQuery,
  useGetApiV1JobsRedisInfoQuery,
  usePostApiV1JobsRetryMutation,
  usePostApiV1JobsRetryAllMutation,
  useGetApiV1JobsStatsQuery,
  useGetApiV1JobsStatsPerDayQuery,
  useGetApiV1JobsSummaryQuery,
  useGetApiV1JobsWorkersQuery,
  useGetApiV1LinksQuery,
  useGetApiV1ListsQuery,
  usePostApiV1ListsMutation,
  usePutApiV1ListsByListIdMutation,
  useGetApiV1ListsByListIdQuery,
  useDeleteApiV1ListsByListIdMutation,
  useGetApiV1ListsByListIdUsersQuery,
  useDeleteApiV1ListsByListIdUsersAndUserIdMutation,
  usePostApiV1ListsByListIdUsersAndUserIdMutation,
  usePutApiV1MarkdownMutation,
  useGetApiV1MetricsQuery,
  useGetApiV1MetricsTotalsQuery,
  useGetApiV1MuteQuery,
  useDeleteApiV1MuteByUserIdMutation,
  usePostApiV1MuteByUserIdMutation,
  useGetApiV1NamesCheckQuery,
  usePutApiV1NotesMutation,
  useGetApiV1NotesQuery,
  useDeleteApiV1NotesByUserIdMutation,
  useGetApiV1NotificationsQuery,
  useGetApiV1NotificationsCountQuery,
  usePostApiV1NotificationsMarkAllMutation,
  useGetApiV1NotificationsByIdQuery,
  usePostApiV1NotificationsByIdMarkMutation,
  useGetApiV1PasskeysQuery,
  useGetApiV1PasskeysBeginAuthQuery,
  useGetApiV1PasskeysBeginRegisterQuery,
  usePostApiV1PasskeysFinishAuthMutation,
  usePostApiV1PasskeysFinishRegisterMutation,
  useDeleteApiV1PasskeysByCredentialIdMutation,
  usePostApiV1PollsByPollIdRefreshMutation,
  usePostApiV1PollsByPollIdVoteMutation,
  useGetApiV1PostsQuery,
  usePostApiV1PostsMutation,
  useGetApiV1PostsBookmarkedQuery,
  useGetApiV1PostsFeedsFollowingQuery,
  useGetApiV1PostsFeedsPublicQuery,
  useGetApiV1PostsLikedQuery,
  useGetApiV1PostsMentionedQuery,
  useGetApiV1PostsMyQuery,
  useGetApiV1PostsPinsQuery,
  useDeleteApiV1PostsPinsByPostIdMutation,
  usePostApiV1PostsPinsByPostIdMutation,
  useGetApiV1PostsRepliesQuery,
  useGetApiV1PostsSubscriptionsQuery,
  usePutApiV1PostsByPostIdMutation,
  useGetApiV1PostsByPostIdQuery,
  useDeleteApiV1PostsByPostIdMutation,
  useGetApiV1PostsByPostIdActiveUsersQuery,
  useDeleteApiV1PostsByPostIdBookmarkMutation,
  usePostApiV1PostsByPostIdBookmarkMutation,
  useGetApiV1PostsByPostIdCommentersQuery,
  useGetApiV1PostsByPostIdCommentsQuery,
  usePostApiV1PostsByPostIdCommentsMutation,
  usePutApiV1PostsByPostIdCommentsAndCommentIdMutation,
  useDeleteApiV1PostsByPostIdCommentsAndCommentIdMutation,
  usePostApiV1PostsByPostIdDetachMutation,
  usePostApiV1PostsByPostIdDownvoteMutation,
  useGetApiV1PostsByPostIdEditsQuery,
  usePutApiV1PostsByPostIdInteractionPolicyMutation,
  useGetApiV1PostsByPostIdLikesQuery,
  useDeleteApiV1PostsByPostIdLikesMutation,
  usePostApiV1PostsByPostIdLikesMutation,
  usePostApiV1PostsByPostIdMuteMutation,
  useGetApiV1PostsByPostIdQuotesQuery,
  usePostApiV1PostsByPostIdQuotesAndQuoteAuthIdRevokeMutation,
  usePostApiV1PostsByPostIdRefreshCardMutation,
  useDeleteApiV1PostsByPostIdRepostMutation,
  usePostApiV1PostsByPostIdRepostMutation,
  useGetApiV1PostsByPostIdRepostsQuery,
  usePutApiV1PostsByPostIdSubscriptionMutation,
  useGetApiV1PostsByPostIdSubscriptionQuery,
  useDeleteApiV1PostsByPostIdSubscriptionMutation,
  usePostApiV1PostsByPostIdTrackViewMutation,
  usePostApiV1PostsByPostIdTranslateMutation,
  usePostApiV1PostsByPostIdUnmuteMutation,
  usePostApiV1PostsByPostIdUpvoteMutation,
  useGetApiV1PostsByPostIdVotesQuery,
  useGetApiV1RbacQuery,
  useGetApiV1RbacActorsByActorIdPermissionsQuery,
  useGetApiV1RbacActorsByActorIdRolesQuery,
  useGetApiV1RbacRolesQuery,
  usePostApiV1RbacRolesMutation,
  usePutApiV1RbacRolesByRoleIdMutation,
  useDeleteApiV1RbacRolesByRoleNameMutation,
  useGetApiV1RbacByResourceQuery,
  usePostApiV1ReportsMutation,
  usePostApiV1ReportsByReportIdEditCommentMutation,
  usePutApiV1RulesMutation,
  useGetApiV1RulesQuery,
  usePostApiV1RulesMutation,
  usePostApiV1RulesReorderMutation,
  useDeleteApiV1RulesByIdMutation,
  useGetApiV1SearchQuery,
  useDeleteApiV1SessionsAllMutation,
  useGetApiV1SessionsListQuery,
  usePutApiV1SessionsRevokeAllMutation,
  usePutApiV1SessionsRevokeBySessionKeyMutation,
  useDeleteApiV1SessionsBySessionKeyMutation,
  usePutApiV1SettingsMutation,
  useGetApiV1SettingsQuery,
  useDeleteApiV1SettingsMutation,
  useGetApiV1SettingsNamesQuery,
  usePutApiV1SettingsUserMutation,
  useGetApiV1SettingsUserQuery,
  useDeleteApiV1SettingsUserMutation,
  useGetApiV1SuggestionsQuery,
  useGetApiV1TagsFeaturedQuery,
  useDeleteApiV1TagsFeaturedByNameMutation,
  usePostApiV1TagsFeaturedByNameMutation,
  usePostApiV1TagsFollowByNameMutation,
  useGetApiV1TagsFollowedQuery,
  usePutApiV1TagsListMutation,
  usePatchApiV1TagsListMutation,
  useGetApiV1TagsListQuery,
  useDeleteApiV1TagsListMutation,
  usePutApiV1TagsPolicyMutation,
  useGetApiV1TagsPolicyQuery,
  usePostApiV1TagsReportMutation,
  useGetApiV1TagsReportsQuery,
  useGetApiV1TagsSearchQuery,
  useGetApiV1TagsTrendingQuery,
  usePostApiV1TagsUnfollowByNameMutation,
  useGetApiV1TagsByNameQuery,
  usePostApiV1TranslateTextMutation,
  useGetApiV1TrendsEventsQuery,
  useGetApiV1TrendsLinksQuery,
  useGetApiV1TrendsPostsQuery,
  useGetApiV1TrendsTagsQuery,
  usePostApiV1UploadsMutation,
  useGetApiV1UploadsAttachedByEntityIdQuery,
  usePostApiV1UploadsBatchMutation,
  usePostApiV1UploadsListMutation,
  useGetApiV1UploadsOwnerByOwnerIdQuery,
  useGetApiV1UploadsOwnerByOwnerIdStandaloneQuery,
  useGetApiV1UploadsSearchQuery,
  useGetApiV1UploadsUsagesQuery,
  useGetApiV1UploadsByIdQuery,
  useDeleteApiV1UploadsByIdMutation,
  usePostApiV1UploadsByIdMetaMutation,
  usePutApiV1UploadsByIdMetaMutation,
  usePostApiV1UploadsByIdPrivacyMutation,
  usePostApiV1UploadsByIdTagsMutation,
  usePutApiV1UploadsByIdTagsMutation,
  usePostApiV1UploadsByIdThumbnailMutation,
  usePutApiV1UploadsByUploadIdOwnerMutation,
  useGetApiV1UserAliasQuery,
  useDeleteApiV1UserAliasMutation,
  usePostApiV1UserAliasMutation,
  useGetApiV1UserDomainBlockQuery,
  useDeleteApiV1UserDomainBlockByDomainMutation,
  usePostApiV1UserDomainBlockByDomainMutation,
  useDeleteApiV1UsersMutation,
  usePostApiV1UsersMutation,
  useGetApiV1UsersQuery,
  useGetApiV1UsersConnectionsQuery,
  usePostApiV1UsersFollowByUsernameMutation,
  usePostApiV1UsersFollowByUsernameAcceptMutation,
  usePostApiV1UsersFollowByUsernamePendMutation,
  usePostApiV1UsersFollowByUsernameRejectMutation,
  usePostApiV1UsersFollowByUsernameUndoMutation,
  useGetApiV1UsersFolloweesQuery,
  useGetApiV1UsersFollowersQuery,
  useGetApiV1UsersInviteLinksQuery,
  usePostApiV1UsersInviteLinksMutation,
  usePutApiV1UsersInviteLinksDeactivateByCodeMutation,
  useGetApiV1UsersProfileQuery,
  useGetApiV1UsersRelationshipsQuery,
  useGetApiV1UsersRemoteByUserNameFullFollowersQuery,
  useGetApiV1UsersRemoteByUserNameFullFollowingQuery,
  useGetApiV1UsersRenameHistoryQuery,
  usePutApiV1UsersByUserIdMutation,
  useGetApiV1UsersByUserIdQuery,
  usePostApiV1UsersByUserIdDeepSyncMutation,
  useGetApiV1UsersByUserIdFollowersQuery,
  useGetApiV1UsersByUserIdFollowingQuery,
  usePutApiV1UsersByUserIdMediaMutation,
  useGetAuthorizeInteractionQuery,
  useGetRootQuery,
  useGetUserQuery,
  useGetUserEventQuery,
  useGetUserPostQuery,
  useGetAboutQuery,
  useGetFeedQuery,
  useGetFeedDiscoverQuery,
  useGetFeedFollowingQuery,
  useGetGroupQuery,
  useGetGroupChannelQuery,
  useGetGroupChannelPostQuery,
  useGetGroupBotQuery,
  useGetGroupEventQuery,
  useGetGroupForumCategoryQuery,
  useGetGroupForumPostQuery,
  useGetForumTagQuery,
  useGetPrivacyQuery,
  useGetTermsQuery,
} = injectedRtkApi;
